<!-- *ngIf="employeeTemplateBO.templateToOnboard" -->
<div>
    <div class="card" style=" overflow-x:hidden;  overflow-y:visible;height:800px;">
        <div class="mx-2">
            <!-- .....................Employee Application Cover................... -->
            <div class="row mb-2">
                <div class="col p-0">
                    <div class="card " style=" overflow-x:hidden;   height:auto;">

                        <div class="col ps-3">
                            <button class="btn btn-sm px-3 mt-2"
                                *ngIf="global.OnboardingLoginType !='onboardLogin' && emitemployeeBO.employeestatus =='Submitted'  && !emitemployeeBO.print"
                                (click)="saveAgreementcomplete()"
                                [disabled]="emitemployeeBO?.iscompleted">Complete</button>
                        </div>
                        <div class="col mt-4 text-end">
                            <button class="btn float-end btn-sm me-3" [disabled]="emitemployeeBO?.iscompleted ||isSaveorUpdateBoolean"
                                *ngIf="global.OnboardingLoginType !='onboardLogin' " (click)="saveAgreement()">Save
                                All</button>&nbsp;
                            <button class="btn btn-sm me-4"
                                *ngIf="global.LoginUserType != 'Onboard' &&   emitemployeeBO.employerstatus !='Submitted' && emitemployeeBO.employeestatus !='Submitted' && !emitemployeeBO.print"
                                data-bs-target="#sendToEmployer" data-bs-toggle="modal">Send To
                                Employer</button>&nbsp;&nbsp;


                            <button class="btn btn-sm me-5"
                                *ngIf="global.LoginUserType != 'Onboard' && emitemployeeBO.employeestatus !='Submitted' &&   emitemployeeBO.employerstatus !='Submitted' && !emitemployeeBO.print"
                                data-bs-target="#sendToEmployee" data-bs-toggle="modal">Send to Employee</button>
                            <button class="btn btn-sm me-5" *ngIf="emitemployeeBO.print"
                                (click)="GetEmpOnboardDeatalis('EMPAppCover')">Print</button>



                        </div>

                        <div class="col">
                            <button class="btn float-end me-3" [disabled]="emitemployeeBO?.iscompleted || isSaveorUpdateBoolean"
                                *ngIf="global.OnboardingLoginType =='onboardLogin' && !emitemployeeBO.print"
                                (click)="saveAgreement()">Save All</button>&nbsp;
                            <button class="btn float-end me-3"
                                [disabled]="emitemployeeBO.employeestatus == 'Submitted' || emitemployeeBO.employerstatus =='Submitted'"
                                *ngIf="global.OnboardingLoginType =='onboardLogin' && !emitemployeeBO.print"
                                (click)="submitAggrementDetails()">Submit</button>
                        </div>

                        <div class="card-body" style="padding:65px;">
                            <!-- <form [formGroup]=""> -->
                            <div class="row mt-2 mb-2 justify-content-center">
                                <h3 class="text-center"><b>Employee Application Cover</b></h3>
                            </div>
                            <div class="d-flex mt-3">
                                <p class="ms-4 mt-1">Thank you for completing </p>
                                <input id="scrollArea" [(ngModel)]="employeeApplicationBo.employeeName"
                                    [disabled]="emitemployeeBO.iscompleted" class="form-control mx-1"
                                    style="width:30rem;" type="text">
                                <p class="mt-lg-1"> Employee Application.</p>

                            </div>
                            <ul style="margin-left:30px">
                                <div class="row mt-4">
                                    <li>You are the applicant or employee in the following forms.</li>
                                </div>
                                <div class="row mt-4">
                                    <li>Please include a copy of your photo ID.</li>
                                </div>
                                <div class="row mt-4">
                                    <li>The Department of Human Services (DHS) does not accept an electronic
                                        signature on
                                        their Individual Support Worker Application. DHS accepts a copy of the
                                        completed form.
                                        DHS refers to the applicant or employee as the Individual Direct Support
                                        Worker</li>
                                </div>
                                <div class="row mt-4">
                                    <li>You cannot be scheduled until you have cleared a background study which
                                        includes
                                        fingerprinting.{{global.agencyName}} pays for the cost of the study and
                                        fingerprinting can only be
                                        completed at an approved location. We notify your employer of your start
                                        date. We
                                        cannot pay hours before you are cleared to work by DHS.</li>
                                </div>
                                <div class="row mt-4">
                                    <li>Your employer will provide your pay rate and signs your Pay Notice.</li>
                                </div>
                                <div class="row mt-4">
                                    <li>Your employer will verify your ID’s for the Employment Eligibility
                                        Verification (I-9) and
                                        sign under the Employer section of that form.</li>
                                </div>
                                <div class="row mt-4">
                                    <li>{{global.agencyName}} is your employer’s Fiscal/ Employer Agent (F/ EA).</li>

                                </div>

                            </ul>


                            <!-- </form> -->

                        </div>


                    </div>
                </div>
            </div>
            <!--Background Study Authorization  -->
            <div class="row mb-2 mt-2">
                <div class="col p-0">
                    <div class="card " style=" overflow-x:hidden; height:auto;">
                        <div class="col mt-4 text-end">
                            <button class="btn btn-sm me-5" *ngIf="emitemployeeBO.print"
                                (click)="GetEmpOnboardDeatalis('BackAuth')">Print</button>
                        </div>
                        <div class="card-body" style="padding:35px;">
                            <div class="row mt-2 mb-2 justify-content-center">
                                <h3 class="ms-lg-1 text-center"><b>Background Study Authorization</b></h3>
                            </div>
                            <!-- <div class="row mt-2">
                            <div class="col-lg-2">
                                <label clas="ms-lg-1">Participant/Employer
                                     

                                </label>
                            </div>
                            <div class="col-lg-3">
                                  <input        type="text"  [(ngModel)]="documentBO.backgroound_Study_Authorization.employer_name"
                                    class="form-control">
                            </div> -->
                            <!-- </div> -->
                            <div class="col p-0">
                                <h6 class=""><b>Participant/Employer</b></h6>
                            </div>
                            <div class="row mt-2">
                                <div class="col-lg-3">
                                    <input type="text" class="form-control" [(ngModel)]="backgroundBo.participantName"
                                        [disabled]="emitemployeeBO.iscompleted">
                                </div>
                            </div>
                            <div class="row mt-2 mb-3">
                                <div class="col">
                                    <div class="card ">
                                        <div class="card-body" style="padding:25px;">
                                            <div class="row">
                                                <div class="col-lg-12">
                                                    <div class="row">
                                                        <h6 class="ms-lg-1"><b>Applicant Information</b></h6>
                                                    </div>
                                                    <div class="row">
                                                        <div class="col-lg-3 col-md-6 col-sm-6">
                                                            <label class="label">
                                                                First Name

                                                            </label>
                                                            <input type="text" class="form-control"
                                                                [(ngModel)]="backgroundBo.firstName"
                                                                [disabled]="emitemployeeBO.iscompleted">
                                                        </div>
                                                        <div class="col-lg-3 col-md-6 col-sm-6">
                                                            <label class="label">Middle Name</label>
                                                            <input type="text" class="form-control"
                                                                [(ngModel)]="backgroundBo.middleName"
                                                                [disabled]="emitemployeeBO.iscompleted">
                                                        </div>
                                                        <div class="col-lg-3 col-md-6 col-sm-6">
                                                            <label class="label">Last Name </label>
                                                            <input type="text" class="form-control"
                                                                [(ngModel)]="backgroundBo.lastName"
                                                                [disabled]="emitemployeeBO.iscompleted">
                                                        </div>
                                                        <div class="col-lg-3 col-md-6 col-sm-6">
                                                            <label class="label">Gender </label>
                                                            <!-- <select class="form-control" disabled>
                                                                <option [value]="gen.id"
                                                                   
                                                                    *ngFor="let gen of genderlist ">
                                                                    {{gen.lovName}</option>
                                                            </select> -->
                                                            <ng-select [items]="genderlist" bindValue="id"
                                                                bindLabel="lovName" [(ngModel)]="backgroundBo.genderLid"
                                                                [disabled]="emitemployeeBO.iscompleted">

                                                            </ng-select>
                                                        </div>
                                                        <div class="col-lg-3 col-md-6 col-sm-6">
                                                            <label class="label">
                                                                Date of Birth </label>
                                                            <my-date-picker class="w-100" [selDate]="backgroundBo.dob"
                                                                (inputFieldChanged)="newdates($event,'inputchange','date1')"
                                                                (dateChanged)="newdates($event,'datechanged','date1')"
                                                                [options]="myDatePickerOptions" placeholder="mm/dd/yyyy"
                                                                [disabled]="emitemployeeBO.iscompleted">
                                                            </my-date-picker>
                                                        </div>
                                                        <div class="col-lg-3 col-md-6 col-sm-6">
                                                            <label class="label">SSN&nbsp;<sup
                                                                    class="super-script">&nbsp;*</sup>

                                                            </label>
                                                            <input (ngModelChange)="checkssn() " type="password"
                                                                minlength="9" maxlength="9"
                                                                [(ngModel)]="backgroundBo.ssn"
                                                                (keypress)="keyPress($event)" class="form-control"
                                                                [disabled]="emitemployeeBO.iscompleted">
                                                            <span class="ssn1" *ngIf="ssn4">{{ssnerror}}</span>
                                                        </div>

                                                        <div class="col-lg-3 col-md-6 col-sm-6">
                                                            <label class="label">Phone Number</label>
                                                            <input class=" form-control" type="text"
                                                                [(ngModel)]="backgroundBo.phone"
                                                                (ngModelChange)="DemographicPhoneFormat()"
                                                                (keypress)="keyPress($event)" minlength="14"
                                                                maxlength="14" [disabled]="emitemployeeBO.iscompleted">
                                                        </div>
                                                        <div class="col-lg-3 col-md-6 col-sm-6">
                                                            <label class="label">Email
                                                            </label>
                                                            <input type="text" class="form-control"
                                                                [(ngModel)]="backgroundBo.email"
                                                                [disabled]="emitemployeeBO.iscompleted">
                                                        </div>
                                                    </div>
                                                    <div class="row">
                                                        <div class="col-lg-3 col-md-6 col-sm-6">
                                                            <label class="label">Driver License</label>
                                                            <input class=" form-control" type="text"
                                                                [disabled]="emitemployeeBO.iscompleted"
                                                                [(ngModel)]="backgroundBo.driver_LicenseNo">
                                                        </div>

                                                        <div class="col-lg-3 col-md-6 col-sm-6">
                                                            <label class="label">State</label>
                                                            <ng-select [items]="stateList" class="width25"
                                                                [(ngModel)]="backgroundBo.state" [searchable]="true"
                                                                [clearable]="true" bindLabel="name"
                                                                bindValue="abbreviation"
                                                                [disabled]="emitemployeeBO.iscompleted">
                                                            </ng-select>
                                                        </div>

                                                        <div class="col-lg-3  col-md-6 col-sm-6">
                                                            <label class="label">
                                                                Place of Birth</label>
                                                            <input class=" form-control" type="text"
                                                                [disabled]="emitemployeeBO.iscompleted"
                                                                [(ngModel)]="backgroundBo.placeofBirth">
                                                        </div>
                                                    </div>

                                                    <div class="row mt-2">
                                                        <label class="label ms-lg-3"><b>Address</b> </label>
                                                    </div>
                                                    <div class="row">
                                                        <div class="col-lg-3 col-md-6 col-sm-6">
                                                            <label class="label">Street</label>
                                                            <input type="text" class="form-control"
                                                                [(ngModel)]="backgroundBo.address"
                                                                [disabled]="emitemployeeBO.iscompleted">
                                                        </div>
                                                        <div class="col-lg-3 col-md-6 col-sm-6">
                                                            <label class="label">City</label>
                                                            <input type="text" class="form-control"
                                                                [(ngModel)]="backgroundBo.city"
                                                                [disabled]="emitemployeeBO.iscompleted">
                                                        </div>
                                                        <div class="col-lg-3 col-md-6 col-sm-6">
                                                            <label class="label">State</label>
                                                            <ng-select [items]="stateList" class="width25"
                                                                [(ngModel)]="backgroundBo.state1" [searchable]="true"
                                                                [clearable]="true" bindLabel="name"
                                                                bindValue="abbreviation"
                                                                [disabled]="emitemployeeBO.iscompleted">
                                                            </ng-select>
                                                        </div>
                                                        <div class="col-lg-3 col-md-6 col-sm-6">
                                                            <label class="label">ZipCode</label>
                                                            <input (ngModelChange)="validZip() " class="form-control"
                                                                minlength="5" maxlength="11"
                                                                [(ngModel)]="backgroundBo.zip" type="text"
                                                                (keypress)="keyPress($event)"
                                                                [disabled]="emitemployeeBO.iscompleted" />
                                                            <span class="ssn1" *ngIf="zip1">{{ziperr}}</span>
                                                        </div>
                                                    </div>
                                                    <div class="row">
                                                        <div class="col-lg-3 col-md-6 col-sm-6">
                                                            <label class="label">County</label>
                                                            <input type="text" class="form-control"
                                                                [(ngModel)]="backgroundBo.county"
                                                                [disabled]="emitemployeeBO.iscompleted">
                                                        </div>
                                                    </div>
                                                    <div class="row mt-2">
                                                        <label class="label ml-lg-4 mt-lg-1"><b>Previous Names Used
                                                            </b></label>
                                                    </div>
                                                    <div class="d-flex">
                                                        <div class="col-lg-4">
                                                            <input type="text"
                                                                [(ngModel)]="backgroundBo.previousNamesUsed1"
                                                                class="form-control"
                                                                [disabled]="emitemployeeBO.iscompleted">
                                                        </div>
                                                        <div class="col-lg-2"></div>
                                                        <div class="col-lg-4 d-flex">
                                                            <label class=" col-lg-4 label mt-1">Date</label>
                                                            <my-date-picker class="w-100 col-lg-6"
                                                                [selDate]="backgroundBo.previousNamesUsedDate1"
                                                                (inputFieldChanged)="newdates($event,'inputchange','date2')"
                                                                (dateChanged)="newdates($event,'datechanged','date2')"
                                                                [options]="myDatePickerOptions" placeholder="mm/dd/yyyy"
                                                                [disabled]="emitemployeeBO.iscompleted">
                                                            </my-date-picker>
                                                        </div>
                                                    </div>
                                                    <div class="d-flex mt-1">
                                                        <div class="col-lg-4">
                                                            <input type="text" class="form-control"
                                                                [(ngModel)]="backgroundBo.previousNamesUsed2"
                                                                [disabled]="emitemployeeBO.iscompleted">
                                                        </div>
                                                        <div class=" col-lg-2">
                                                        </div>
                                                        <div class="col-lg-4 d-flex">
                                                            <label class=" col-lg-4 label mt-1">Date</label>
                                                            <my-date-picker class="w-100 col-lg-6"
                                                                [selDate]="backgroundBo.previousNamesUsedDate2"
                                                                (inputFieldChanged)="newdates($event,'inputchange','date3')"
                                                                (dateChanged)="newdates($event,'datechanged','date3')"
                                                                [options]="myDatePickerOptions" placeholder="mm/dd/yyyy"
                                                                [disabled]="emitemployeeBO.iscompleted">
                                                            </my-date-picker>
                                                        </div>
                                                    </div>
                                                    <div class="row mt-2">
                                                        <label class="label ml-lg-4"><b>Previous Addresses Used (within
                                                                the last 5 years)</b></label>
                                                    </div>
                                                    <div class="d-flex">
                                                        <div class="col-lg-4">
                                                            <textarea
                                                                [(ngModel)]="backgroundBo.previous_Addresses_Used1"
                                                                class="form-control"
                                                                [disabled]="emitemployeeBO.iscompleted"></textarea>
                                                        </div>
                                                        <div class="col-lg-2"></div>
                                                        <div class="col-lg-4 d-flex">
                                                            <label class="label col-lg-4 mt-1">Date</label>
                                                            <my-date-picker class="w-100 col-lg-6"
                                                                [selDate]="backgroundBo.previous_Addresses_UsedDate1"
                                                                (inputFieldChanged)="newdates($event,'inputchange','date4')"
                                                                (dateChanged)="newdates($event,'datechanged','date4')"
                                                                [options]="myDatePickerOptions" placeholder="mm/dd/yyyy"
                                                                [disabled]="emitemployeeBO.iscompleted">
                                                            </my-date-picker>
                                                        </div>
                                                    </div>
                                                    <div class="d-flex mt-2">
                                                        <div class="col-lg-4">
                                                            <textarea
                                                                [(ngModel)]="backgroundBo.previous_Addresses_Used2"
                                                                class="form-control"
                                                                [disabled]="emitemployeeBO.iscompleted"></textarea>
                                                        </div>
                                                        <div class="col-lg-2"></div>
                                                        <div class="col-lg-4 d-flex">
                                                            <label class="label col-lg-4 mt-1">Date</label>
                                                            <my-date-picker class="w-100 col-lg-6"
                                                                [selDate]="backgroundBo.previous_Addresses_UsedDate2"
                                                                (inputFieldChanged)="newdates($event,'inputchange','date5')"
                                                                (dateChanged)="newdates($event,'datechanged','date5')"
                                                                [options]="myDatePickerOptions" placeholder="mm/dd/yyyy"
                                                                [disabled]="emitemployeeBO.iscompleted">
                                                            </my-date-picker>
                                                        </div>
                                                    </div>
                                                    <div class="d-flex mt-2">
                                                        <div class="col-lg-4">
                                                            <textarea
                                                                [(ngModel)]="backgroundBo.previous_Addresses_Used3"
                                                                class="form-control"
                                                                [disabled]="emitemployeeBO.iscompleted"></textarea>
                                                        </div>
                                                        <div class="col-lg-2"></div>
                                                        <div class="col-lg-4 d-flex">
                                                            <label class="label col-lg-4 mt-1">Date</label>
                                                            <my-date-picker class="w-100 col-lg-6"
                                                                [selDate]="backgroundBo.previous_Addresses_UsedDate3"
                                                                (inputFieldChanged)="newdates($event,'inputchange','date6')"
                                                                (dateChanged)="newdates($event,'datechanged','date6')"
                                                                [options]="myDatePickerOptions" placeholder="mm/dd/yyyy"
                                                                [disabled]="emitemployeeBO.iscompleted">
                                                            </my-date-picker>
                                                        </div>
                                                    </div>
                                                    <div class="row mt-4 ms-2">
                                                        <p>By signing this authorization, I give {{global.agencyName}}
                                                            permission to submit a background study request
                                                            to DHS as part of my application as a direct support
                                                            worker on a self-direction program. I verify
                                                            that the information provided is accurate and
                                                            complete. The following checks will be run: </p>
                                                    </div>
                                                    <ul style="margin-left: 30px;">
                                                        <li>MN DHS NetStudy 2.0 Background Study</li>
                                                        <li>Office of Inspector General Exclusions Database</li>
                                                    </ul>
                                                    <div class="row mt-4">
                                                        <div class="col-lg-8">
                                                            <div class="row">
                                                                <div class="col-lg-7">
                                                                    <button type="button" class="btn blue-btn"
                                                                        data-bs-toggle="modal"
                                                                        data-bs-target="#authsign"
                                                                        [disabled]="global.OnboardingLoginType != 'onboardLogin'">Applicant
                                                                        Signature</button>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div class="col-lg-3">
                                                            <div class="row">
                                                                <div class="col-lg-3">
                                                                    <label for="cname">Date
                                                                    </label>
                                                                </div>
                                                                <div class="col-lg-7" [formGroup]="dateForm">
                                                                    <my-date-picker class="w-100"
                                                                        placeholder="mm/dd/yyyy"
                                                                        [options]="myDatePickerOptions"
                                                                        [selDate]="backgroundBo.applicantSignatureDate"
                                                                        (inputFieldChanged)="newdates($event,'inputchange','date7')"
                                                                        (dateChanged)="newdates($event,'datechanged','date7')"
                                                                        formControlName="signDate1">

                                                                        <!-- (dateChanged)="newdates($event,'datechanged','authsigndate')"
                                                                    (inputFieldChanged)="newdates($event,'inputchange','authsigndate')" -->
                                                                    </my-date-picker>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="row mt-2 mb-2">
                                                        <div class="col-lg-4">
                                                            <input *ngIf="appsign1!=''&& appsign1!=null " type="image"
                                                                src="{{appsign1}}" class="form-control"
                                                                style="width: 255px;height:120px;" alt="nurse"
                                                                width="48" height="48">
                                                        </div>
                                                    </div>
                                                    <div class="row mt-4 ms-2">
                                                        *If Applicant is under 18, the parent/guardian must sign
                                                        as well
                                                    </div>
                                                    <div class="row mt-4">
                                                        <div class="col-lg-8">
                                                            <div class="row">
                                                                <div class="col-lg-7">
                                                                    <button type="button" class="btn blue-btn"
                                                                        data-bs-toggle="modal"
                                                                        data-bs-target="#parentsign"
                                                                        [disabled]="global.OnboardingLoginType != 'onboardLogin'">Parent/Guardian
                                                                        Signature</button>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div class="col-lg-3">
                                                            <div class="row">
                                                                <div class="col-lg-3">
                                                                    <label for="cname">Date</label>
                                                                </div>
                                                                <div class="col-lg-7" [formGroup]="dateForm">
                                                                    <my-date-picker class="w-100"
                                                                        placeholder="mm/dd/yyyy"
                                                                        [options]="myDatePickerOptions"
                                                                        [selDate]="backgroundBo.parentSignatureDate"
                                                                        (inputFieldChanged)="newdates($event,'inputchange','date8')"
                                                                        (dateChanged)="newdates($event,'datechanged','date8')"
                                                                        formControlName="signDate2">
                                                                    </my-date-picker>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="row mt-2 mb-2">

                                                        <div class="col-lg-4">
                                                            <input *ngIf="sign4!=''&& sign4!=null " type="image"
                                                                src="{{sign4}}" class="form-control"
                                                                style="width: 255px;height:120px;" alt="nurse"
                                                                width="48" height="48">
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                            <div class="col-12  mb-3 mt-1">
                                <div class="text-end">
                                    <button class="btn"
                                        [disabled]="isSaveorUpdateBoolean|| backgroundBo.ssn == null || backgroundBo.ssn == undefined || backgroundBo.ssn == '' || emitemployeeBO?.iscompleted"
                                        *ngIf="global.OnboardingLoginType !='onboardLogin' && !emitemployeeBO.print"
                                        (click)="saveAgreement()">Save</button>
                                </div>

                            </div>
                        </div>

                    </div>
                </div>

            </div>

            <!--Pay Notice -->
            <div class="row mb-2 mt-2">
                <div class="col p-0">
                    <div class="card " style=" overflow-x:hidden;                                  
                                    height:auto;">
                        <div class="col mt-4 text-end">
                            <button class="btn btn-sm me-5" *ngIf="emitemployeeBO.print"
                                (click)="GetEmpOnboardDeatalis('PayNotice')">Print</button>
                        </div>
                        <div class="card-body" style="padding:65px;">

                            <div class="row mt-2 mb-3 mb-2 justify-content-center">
                                <h3 class="text-center"><b>Pay Notice</b></h3>
                            </div>
                            <div class="row mt-2">
                                <div class="col-lg-2">
                                    <label>
                                        Employee Name
                                    </label>
                                </div>
                                <div class="col-lg-4">
                                    <input type="text" class="form-control" [(ngModel)]="payNoticeBo.employeeName"
                                        [disabled]="emitemployeeBO.iscompleted">
                                </div>
                                <div class="col-lg-2">
                                    <label>Employer Name
                                    </label>
                                </div>
                                <div class="col-lg-4">
                                    <input type="text" class="form-control" [(ngModel)]="payNoticeBo.employerName"
                                        [disabled]="emitemployeeBO.iscompleted">
                                </div>
                            </div>

                            <div class="mt-3">
                                <table class="table-bordered col w-100">
                                    <tr style="height:30px;">
                                        <th>S.No</th>
                                        <th>Start Date</th>
                                        <th>End Date</th>
                                        <th>Service</th>
                                        <th>Pay Rate</th>
                                    </tr>
                                    <tr style="height:25px;" *ngFor="let val of payratelist;let i = index">
                                        <td>{{i+1}}</td>
                                        <td>{{val.startDate |date:'MM/dd/yyyy'}}</td>
                                        <td>{{val.endDate | date:'MM/dd/yyyy'}}</td>
                                        <td>{{val.serviceName}}</td>
                                        <td>{{val.rate}}</td>
                                    </tr>
                                </table>
                            </div>

                            <div class="row mt-2">
                                <p><b>Employee is non exempt (entitled to overtime, minimum wage, other
                                        protections under Minn.
                                        Stat. 177).</b></p>
                            </div>
                            <div class="row mt-2">
                                <p> Overtime is paid at 1.5 times the regular rate for hours worked over 40 per
                                    workweek</p>
                            </div>
                            <div class="row mt-2">
                                <p>The Collective Bargaining Agreement (SEIU/DHS) sets minimum wage, rules for
                                    Paid Time Off
                                    (PTO) accrual and designates Holiday pay:</p>
                            </div>
                            <ul style="margin-left: 30px;">
                                <li>1 hour of PTO is earned for every 30 hours worked and accrued per pay period
                                    unless
                                    PTO is declined.</li>
                                <li>Hours worked on the following Holidays are paid at 1.5 times the regular pay
                                    rate: New
                                    Year’s Day, Dr. Martin Luther King Jr. Day, Memorial Day, Labor Day, and
                                    Thanksgiving</li>
                                <li>Employees choose 2 Floating Holidays per year. Hours worked on these days
                                    are paid at
                                    1.5 times the regular rate</li>
                            </ul>
                            <div class="row mt-2">
                                <p>Sick and safe leave may apply for employees in Duluth, Minneapolis and St
                                    Paul. City Sick and
                                    Safe Time (SST) rules are available in the Employee Handbook.</p>
                            </div>
                            <div class="row mt-2">
                                <p>
                                    Pay is issued every other Friday for a 14-day pay period, if time is
                                    submitted according to {{global.agencyName}}’s payroll calendar.
                                </p>
                            </div>
                            <div class="row mt-2">
                                <p>Deductions that may be made from employee’s pay include:</p>
                            </div>
                            <ul style="margin-left:30px;">
                                <li>FICA (Social Security/Medicare)</li>
                                <li>Federal/State Income Withholding Taxes
                                </li>
                                <li> Garnishments/Wage Attachments/Union Deductions (if applicable, as required
                                    by law)
                                </li>
                            </ul>
                            <div class="row mt-4">
                                <div class="col-lg-7">
                                    <div class="row">
                                        <div class="col-lg-7">
                                            <button type="button" class="btn blue-btn" data-bs-toggle="modal"
                                                data-bs-target="#epe"
                                                [disabled]="global.OnboardingLoginType != 'onboardLogin'">Employee
                                                Signature</button>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-lg-4">
                                    <div class="row">
                                        <div class="col-lg-3">
                                            <label for="cname">Date </label>
                                        </div>
                                        <div class="col-lg-7" [formGroup]="dateForm">
                                            <my-date-picker class="w-100" placeholder="mm/dd/yyyy"
                                                [options]="myDatePickerOptions" [selDate]="payNoticeBo.employeeSignDate"
                                                (inputFieldChanged)="newdates($event,'inputchange','date9')"
                                                (dateChanged)="newdates($event,'datechanged','date9')"
                                                formControlName="signDate3">
                                            </my-date-picker>
                                        </div>

                                    </div>
                                </div>

                            </div>


                            <div class="row mt-2 mb-2">

                                <div class="col-lg-4">
                                    <input *ngIf="Gurdsign3!=''&& Gurdsign3!=null " type="image" src="{{Gurdsign3}}"
                                        class="form-control" style="width: 255px;height:120px;" alt="nurse" width="48"
                                        height="48">
                                </div>





                            </div>

                            <div class="row mt-4">
                                <div class="col-lg-7">
                                    <div class="row">
                                        <div class="col-lg-7">
                                            <button type="button" class="btn blue-btn" data-bs-toggle="modal"
                                                data-bs-target="#emp_signature"
                                                [disabled]="global.OnboardingLoginType != 'onboardLogin'">Employer
                                                Signature</button>
                                            <!-- employerSign -->
                                        </div>

                                    </div>

                                </div>
                                <div class="col-lg-4">
                                    <div class="row">
                                        <div class="col-lg-3">
                                            <label for="cname">Date </label>
                                        </div>
                                        <div class="col-lg-7" [formGroup]="dateForm">
                                            <my-date-picker class="w-100" placeholder="mm/dd/yyyy"
                                                [options]="myDatePickerOptions" [selDate]="payNoticeBo.employerSignDate"
                                                (inputFieldChanged)="newdates($event,'inputchange','date10')"
                                                (dateChanged)="newdates($event,'datechanged','date10')"
                                                formControlName="signDate4">

                                            </my-date-picker>
                                        </div>

                                    </div>
                                </div>

                            </div>
                            <div class="row mt-2 mb-2">

                                <div class="col-lg-4">
                                    <input *ngIf="employeesign2!=''&& employeesign2 !=null " type="image"
                                        src="{{employeesign2}}" class="form-control" style="width: 255px;height:120px;"
                                        alt="nurse" width="48" height="48">
                                </div>

                                <!-- </form> -->


                            </div>
                            <div class="col text-end">
                                <button class="btn btn-sm" [disabled]="emitemployeeBO?.iscompleted || isSaveorUpdateBoolean"
                                    *ngIf="global.OnboardingLoginType !='onboardLogin' && !emitemployeeBO.print"
                                    (click)="saveAgreement()">Save</button>
                            </div>
                        </div>

                    </div>
                </div>

            </div>

            <!-- Relationship Disclosure-->
            <div class="row mb-2 mt-2">
                <div class="col p-0">
                    <div class="card " style=" overflow-x:hidden; height:auto;">
                        <div class="col mt-4 text-end">
                            <button class="btn btn-sm me-5" *ngIf="emitemployeeBO.print"
                                (click)="GetEmpOnboardDeatalis('RelationDisclosure')">Print</button>
                        </div>
                        <div class="card-body" style="padding:65px;">
                            <!-- <form [formGroup]=""> -->
                            <div class="row mt-2 mb-3 mb-2 justify-content-center">
                                <h3 class="text-center"><b>Relationship Disclosure</b></h3>
                            </div>
                            <div class="row mt-2">
                                <div class="col-lg-2">
                                    <label>
                                        Applicant Name
                                    </label>
                                </div>
                                <div class="col-lg-4">
                                    <input type="text" class="form-control" [(ngModel)]="relationshipBo.employeeName"
                                        [disabled]="emitemployeeBO.iscompleted">
                                </div>
                                <div class="col-lg-2">
                                    <label>Applicant DOB

                                    </label>
                                </div>
                                <div class="col-lg-4">
                                    <my-date-picker class="w-100" [options]="myDatePickerOptions"
                                        [selDate]="relationshipBo.dob" [disabled]="true"
                                        (inputFieldChanged)="newdates($event,'inputchange','date11')"
                                        (dateChanged)="newdates($event,'datechanged','date11')" placeholder="mm/dd/yyyy"
                                        [disabled]="emitemployeeBO.iscompleted">
                                    </my-date-picker>
                                </div>
                            </div>
                            <div class="row mt-2">
                                <div class="col-lg-3">
                                    <label>Employer (EIN Holder) Name
                                    </label>
                                </div>
                                <div class="col-lg-3">
                                    <input type="text" class="form-control" [(ngModel)]="relationshipBo.employerName"
                                        [disabled]="emitemployeeBO.iscompleted">
                                </div>
                            </div>
                            <div class="row mt-2">
                                Employees providing household services may be exempt from paying certain federal
                                and state
                                taxes. If the employee qualifies, the exemptions must be applied.
                            </div>
                            <div class="row mt-2">
                                <p><b>Please check relationship to Employer (FEIN Holder): </b></p>
                            </div>
                            <div class="d-flex col-5 my-3">
                                <label class="me-4 fs-5"><b>Relationship</b></label>
                                <input class="form-control ps-3
                               " type="text" [(ngModel)]="reationshipname" [disabled]="emitemployeeBO.iscompleted">

                            </div>
                            <div class="row mt-2">
                                <table class="table-bordered table-responsive">
                                    <tr>
                                        <th style="width:5%">S.no</th>
                                        <th style="width:15%">TAX</th>
                                        <th style="width:20%">Taxable</th>

                                    </tr>
                                    <tr *ngFor="let tax of relationShipTaxName;let i=index">

                                        <td>{{i+1}}</td>
                                        <td>{{tax.taxName}}</td>
                                        <td>{{tax.isTaxble}}</td>

                                    </tr>



                                </table>
                            </div>
                            <div class="row mt-2">
                                <p>*According to IRS definition, parent is typically defined here as biological
                                    or adoptive. A stepparent is not necessarily considered
                                    a parent for the purposes of exemptions listed. The FMS Coordinator will
                                    verify exemption with additional questions as needed.</p>
                            </div>
                            <div class="row mt-2">
                                <p>** Minors include siblings and must be students. Federal and state labor
                                    restrictions are in place for hours a minor can work and
                                    job duties they can perform. <a
                                        href="https://www.dli.mn.gov/sites/default/files/pdf/child_labor.pdf"
                                        target="_blank">https://www.dli.mn.gov/sites/default/files/pdf/child_labor.pdf</a>
                                </p>
                            </div>
                            <div class="row mt-2">
                                <p>***General employees have no relationship to the employer or have a
                                    relationship that is not listed: child 21+, grandparents,
                                    sibling 18+, cousins, aunts, uncles, etc are general employees.</p>
                            </div>
                            <div class="row mt-2">
                                <p><b>Workers' Compensation (WC) is required for employees except spouse,
                                        parent, or child of the
                                        employer</b>. Coverage is billed to the participant employer’s budget.
                                </p>
                            </div>
                            <div class="row mt-2">
                                <div class="col-lg-1">
                                    <input type="radio" id="spouse1" name="spousess" [(ngModel)]="spouse"
                                        (ngModelChange)="strigToBooleanRadio()" value="true">
                                </div>
                                <!--  
                            [(ngModel)]="documentBO.relationship_Disclosure.want_worker"-->
                                <div class="col-lg-10">
                                    I am a spouse, parent, or child of the employer and want Workers’
                                    Compensation coverage
                                </div>
                            </div>
                            <div class="row mt-2">
                                <div class="col-lg-1">
                                    <input type="radio" id="spouse2" name="spousess" [(ngModel)]="spouse"
                                        (change)="strigToBooleanRadio()" value="false">
                                    <!-- [(ngModel)]="documentBO.relationship_Disclosure.decline_worker" -->
                                </div>
                                <div class="col-lg-10">
                                    I am a spouse, parent, or child of the employer and decline Workers'
                                    Compensation coverage.
                                </div>
                            </div>
                            <div class="row mt-4">
                                <div class="col-lg-7">
                                    <div class="row">
                                        <div class="col-lg-7">
                                            <button type="button" class="btn blue-btn" data-bs-toggle="modal"
                                                data-bs-target="#app_signature"
                                                [disabled]="global.OnboardingLoginType != 'onboardLogin'">Applicant
                                                Signature</button>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-lg-4">
                                    <div class="row">
                                        <div class="col-lg-3">
                                            <label for="cname">Date </label>
                                        </div>
                                        <div class="col-lg-7" [formGroup]="dateForm">
                                            <my-date-picker class="w-100" placeholder="mm/dd/yyyy"
                                                [options]="myDatePickerOptions"
                                                [selDate]="relationshipBo.applicantSignDate"
                                                (inputFieldChanged)="newdates($event,'inputchange','date12')"
                                                (dateChanged)="newdates($event,'datechanged','date12')"
                                                formControlName="signDate5">
                                            </my-date-picker>
                                        </div>

                                    </div>
                                </div>
                            </div>
                            <div class="row mt-2 mb-2">
                                <div class="col-lg-4">
                                    <input *ngIf="clientsign0!=''&& clientsign0!=null " type="image"
                                        src="{{clientsign0}}" class="form-control" style="width: 255px;height:120px;"
                                        alt="nurse" width="48" height="48">
                                </div>
                            </div>
                            <div class="row mt-4">
                                <div class="col-lg-7">
                                    <div class="row">
                                        <div class="col-lg-7">
                                            <button type="button" class="btn blue-btn" data-bs-toggle="modal"
                                                data-bs-target="#emp_signature2"
                                                [disabled]="global.OnboardingLoginType != 'onboardLogin'">Employer
                                                Signature</button>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-lg-4">
                                    <div class="row">
                                        <div class="col-lg-3">
                                            <label for="cname">Date</label>
                                        </div>
                                        <div class="col-lg-7" [formGroup]="dateForm">
                                            <my-date-picker class="w-100" placeholder="mm/dd/yyyy"
                                                [options]="myDatePickerOptions"
                                                [selDate]="relationshipBo.employersSignDate"
                                                (inputFieldChanged)="newdates($event,'inputchange','date13')"
                                                (dateChanged)="newdates($event,'datechanged','date13')"
                                                formControlName="signDate6">
                                            </my-date-picker>
                                        </div>

                                    </div>
                                </div>

                            </div>
                            <div class="row mt-2 mb-2">

                                <div class="col-lg-4">
                                    <input *ngIf="employeesign3!=''&& employeesign3!=null " type="image"
                                        src="{{employeesign3}}" class="form-control" style="width: 255px;height:120px;"
                                        alt="nurse" width="48" height="48">
                                </div>
                            </div>
                            <div class="col-12  mb-3 mt-1 ">


                                <div class="text-end">
                                    <button class="btn" [disabled]="emitemployeeBO?.iscompleted || isSaveorUpdateBoolean"
                                        *ngIf="global.OnboardingLoginType !='onboardLogin' && !emitemployeeBO.print"
                                        (click)="saveAgreement()">Save</button>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>

            </div>

            <!--Employee Agreement and Direct Deposit-->

            <div class="row mb-2 mt-2">
                <div class="col p-0">
                    <div class="card " style=" overflow-x:hidden;height:auto;">
                        <div class="col mt-4 text-end">
                            <button class="btn btn-sm me-5" *ngIf="emitemployeeBO.print"
                                (click)="GetEmpOnboardDeatalis('DirectDeposit')">Print</button>
                        </div>
                        <div class="card-body" style="padding:65px;">

                            <div class="row mt-2 mb-2 mb-2 justify-content-center">
                                <h3 class="text-center"><b>Employee Agreement and Direct Deposit</b></h3>
                            </div>

                            <div class="row mt-4">
                                <p>I acknowledge that I have reviewed the Employee Handbook, including Mandated
                                    Reporting,
                                    Fraud, Roles and Responsibilities and HIPAA Data Privacy.</p>
                            </div>
                            <div class="row mt-2">
                                <p>I understand I am an employee of the participant employer. My employer is
                                    responsible for
                                    hiring, training, establishing job duties, scheduling, supervising, and
                                    evaluating my
                                    performance. The participant employer sets my pay rate within program
                                    guidelines. If I am
                                    scheduled to work by my employer beyond budgeted funds, {{global.agencyName}} FMS
                                    will
                                    not pay. I
                                    understand that submitting time I did not work is fraud.</p>
                            </div>
                            <div class="row mt-2">
                                {{global.agencyName}} FMS acts as the Fiscal/Employer Agent (F/EA) and is responsible
                                for
                                payroll, filing
                                taxes, and W-2s. {{global.agencyName}} FMS uses CYMA for payroll processing. Pay
                                statements
                                and PTO
                                accrual are available through CYMA.
                            </div>
                            <div class="row mt-2">
                                I authorize {{global.agencyName}} FMS to initiate automatic deposits to my account and
                                initiate debit
                                entries to my account for the purpose of correcting an erroneous amount
                                previously
                                deposited in my account. If the designated account is closed or has an
                                insufficient balance for
                                withdrawal, I authorize {{global.agencyName}} FMS to withhold from payment owed to me by
                                {{global.agencyName}} FMS
                                until the erroneous amount is repaid.

                            </div>
                            <div class="row mt-2">
                                <p><b>Please include a voided check or bank letter for direct deposit</b></p>
                            </div>
                            <div class="row mt-2">
                                <div class="col-lg-3">
                                    <label>Routing #</label>
                                </div>
                                <div class="col-lg-3" *ngIf="global.OnboardingLoginType == 'onboardLogin'">
                                    <input type="text" class="form-control" [(ngModel)]="employeeAgreementBo.routing">
                                </div>
                                <div class="col-lg-3 d-flex" *ngIf="global.OnboardingLoginType != 'onboardLogin'">
                                    <div class="input-group my-group  mx-auto">
                                        <input [type]="bankRoutePassword" class="form-control"
                                            [(ngModel)]="employeeAgreementBo.routing"
                                            [disabled]="emitemployeeBO.iscompleted">
                                        <i class="fa fa-eye icon_settings" *ngIf="show_bankrout"
                                            (click)="show_bankrout=false; show_bankroutfun()"></i>
                                        <i class="fa fa-eye-slash icon_settings" *ngIf="!show_bankrout"
                                            (click)="show_bankrout=true;show_bankroutfun()"></i>
                                    </div>

                                    <!-- <button class="btn btn-edit-table text-center ms-2"  (click)="setfieldName('Bank Routing')"  data-bs-toggle="modal" data-bs-target="#showaccountnumberbankrouting"><i
                                        class="fa fa-eye"></i></button>     -->
                                </div>
                            </div>
                            <div class="row mt-2">
                                <div class="col-lg-3">
                                    <label>Account #</label>
                                </div>
                                <div class="col-lg-3" *ngIf="global.OnboardingLoginType == 'onboardLogin'">
                                    <input type="text" class="form-control" [(ngModel)]="employeeAgreementBo.account">
                                </div>
                                <div class="col-lg-3 d-flex" *ngIf="global.OnboardingLoginType != 'onboardLogin'">
                                    <div class="input-group my-group  mx-auto">
                                        <input [type]="Password" class="form-control"
                                            [(ngModel)]="employeeAgreementBo.account"
                                            [disabled]="emitemployeeBO.iscompleted">
                                        <i class="fa fa-eye icon_settings" *ngIf="show_pass"
                                            (click)="show_pass = false; showPass(); "></i>
                                        <i class="fa fa-eye-slash icon_settings" *ngIf="!show_pass"
                                            (click)="show_pass = true; showPass();"></i>
                                    </div>

                                    <!-- <button class="btn btn-edit-table text-center ms-2"  (click)="setfieldName('Account Number')" data-bs-toggle="modal" data-bs-target="#showaccountnumberbankrouting"><i
                                        class="fa fa-eye"></i></button>  -->
                                </div>
                            </div>
                            <div class="row mt-2">
                                <div class="col-lg-1">
                                    <input type="radio" id="checking" name="saveecheck" value="check"
                                        [(ngModel)]="employeeAgreementBo.checkingOrSaving">
                                    <!-- [(ngModel)]="documentBO.employees_Aggrement_Dir_DepositBO.checking_bool"> -->
                                </div>
                                <div class="col-lg-6">
                                    <label>Checking</label>
                                </div>
                            </div>
                            <div class="row mt-2">
                                <div class="col-lg-1">
                                    <input type="radio" id="saving" name="saveecheck" value="save"
                                        [(ngModel)]="employeeAgreementBo.checkingOrSaving">
                                    <!-- [(ngModel)]="documentBO.employees_Aggrement_Dir_DepositBO.savings_bool"> -->
                                </div>
                                <div class="col-lg-6">
                                    <label> Savings</label>
                                </div>
                            </div>
                            <div class="row mt-2">
                                {{global.agencyName}} FMS is not responsible for charges I incur from my financial
                                institution for writing
                                checks against my account before funds have been credited to my account.
                            </div>
                            <div class="row mt-2">
                                By signing this agreement, I verify that information I have provided is
                                accurate. {{global.agencyName}} uses
                                information on the Relationship Disclosure to set up the correct taxes for me
                                and if I have
                                submitted inaccurate information, I am liable for taxes owed.
                            </div>

                            <div class="row mt-2">
                                <div class="col-lg-3">
                                    <label>Applicant Name </label>
                                </div>
                                <div class="col-lg-3">
                                    <input type="text" class="form-control" [(ngModel)]="relationshipBo.employeeName"
                                        disabled>
                                </div>
                            </div>

                            <div class="row mt-4 mb-3">
                                <div class="col-lg-6">
                                    <button type="button" class="btn blut-btn" data-bs-toggle="modal"
                                        data-bs-target="#deposit"
                                        [disabled]="global.OnboardingLoginType != 'onboardLogin'">
                                        Applicant Signature
                                    </button>

                                </div>

                            </div>
                            <div class="row mb-2">

                                <div class="col">
                                    <input *ngIf="clientsign2!=''&& clientsign2!=null " type="image"
                                        src="{{clientsign2}}" class="form-control" style="width: 255px;height:120px;"
                                        alt="nurse" width="48" height="48">


                                </div>
                            </div>
                            <div class="col-12  mb-3 mt-1 ">


                                <div class="text-end">
                                    <button class="btn" [disabled]="emitemployeeBO?.iscompleted || isSaveorUpdateBoolean"
                                        *ngIf="global.OnboardingLoginType !='onboardLogin' && !emitemployeeBO.print"
                                        (click)="saveAgreement()">Save</button>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>

            </div>

            <!--  Individual Direct Support Worker Enrollment Application-->
            <div class="row mb-2 mt-2">
                <div class="col p-0">
                    <div class="card" style="height:auto;">
                        <div class="col mt-4 text-end">
                            <button class="btn btn-sm me-5" *ngIf="emitemployeeBO.print"
                                (click)="GetEmpOnboardDeatalis('IndividualDSWEA')">Print</button>
                        </div>
                        <div class="row">
                            <div class="col-lg-12">
                                <div class="card-body" style="padding: 45px;">
                                    <!-- <form [formGroup]="dh1form"> -->
                                    <div class="row mb-2">
                                        <div class="col-lg-12">
                                            <img src="..\assets\img\DHS_4469A.JPG" class="img-fluid"
                                                alt="Responsive image">
                                            <h3 class="mb-0" style="text-align: center;">
                                                <b>
                                                    Individual Direct Support Worker Enrollment Application
                                                    (Consumer Directed Community Supports [CDCS] and Consumer
                                                    Support Grant [CSG])
                                                </b>
                                            </h3>
                                            <p class="mb-2 mt-2">
                                                Complete all fields to enroll an individual direct support
                                                worker (DSW). Complete this form, print and then submit to
                                                Minnesota Health Care Programs (MHCP). An incomplete form will
                                                delay processing of this application. Check one of the
                                                following:
                                            </p>
                                        </div>
                                    </div>
                                    <div class=" ms-2">
                                        <div class="col-lg-5 d-flex">
                                            <!-- [value]="val.Key" -->
                                            <input type="radio" id="new_hire" name="hiree"
                                                (ngModelChange)="hire($event) "
                                                [(ngModel)]="individualDirectSupportBo.newHireOrReHire" value="newhire">
                                            <!-- [(ngModel)]="documentBO.individual_direct_support_worker_entrollment.newHire" -->
                                            <label class="ms-2 mt-lg-2">Newhire (requires new background study for CDCS
                                                only)</label>

                                        </div>

                                    </div>

                                    <div class="row mb-1 mt-1">
                                        <div class="col-lg-5 ms-2">
                                            <input type="radio" id="rehire" name="hiree"
                                                [(ngModel)]="individualDirectSupportBo.newHireOrReHire"
                                                value="rehire">&nbsp;
                                            <!-- [(ngModel)]="documentBO.individual_direct_support_worker_entrollment.reHire" -->
                                            <label class="ms-1">Rehire (requires new background study for CDCS
                                                only)</label>

                                        </div>
                                        <div class="col-lg-3">
                                            <label>PREVIOUS EMPLOYMENT END DATE:</label>

                                        </div>
                                        <div class="col-lg-3">
                                            <my-date-picker class="w-100 text-end"
                                                [selDate]="individualDirectSupportBo.previousEmployementEndDate"
                                                [options]="myDatePickerOptions"
                                                (inputFieldChanged)="newdates($event,'inputchange','date14')"
                                                (dateChanged)="newdates($event,'datechanged','date14')"
                                                placeholder="mm/dd/yyyy" [disabled]="emitemployeeBO.iscompleted">

                                            </my-date-picker>


                                        </div>

                                    </div>

                                    <div class="row mb-2 mt-2">
                                        <div class="col">
                                            <div class="card">
                                                <div class="card-body">
                                                    <b>
                                                        <h4>Individual DSW Information</h4>
                                                    </b>
                                                    <div class="row mb-2 mt-2">
                                                        <div class="col-lg-4">
                                                            <label>PROVIDER TYPE</label>
                                                            <input type="text" class="form-control"
                                                                [(ngModel)]="individualDirectSupportBo.providerType"
                                                                [disabled]="emitemployeeBO.iscompleted">


                                                        </div>
                                                        <div class="col-lg-3">
                                                            <label>SOCIAL SECURITY NUMBER
                                                            </label>
                                                            <input (ngModelChange)="checkssn() " type="password"
                                                                minlength="9" maxlength="9"
                                                                [(ngModel)]="backgroundBo.ssn"
                                                                (keypress)="keyPress($event)" class="form-control"
                                                                [disabled]="emitemployeeBO.iscompleted">
                                                            <span class="ssn1" *ngIf="ssn">{{ssnerror}}</span>
                                                        </div>
                                                        <div class="col-lg-5">
                                                            <label>NPI OR UMPI (IF REQUESTING
                                                                REINSTATEMENT)
                                                            </label>
                                                            <input maxlength="10" type="text" class="form-control"
                                                                [(ngModel)]="individualDirectSupportBo.npiOrUmpi"
                                                                [disabled]="emitemployeeBO.iscompleted">

                                                        </div>



                                                    </div>
                                                    <div class="row mb-2 mt-2">
                                                        <div class="col-lg-4">
                                                            <label>LEGAL NAME (FIRST)

                                                            </label>
                                                            <input type="text" class="form-control"
                                                                (ngModelChange)="supportname()"
                                                                [(ngModel)]="individualDirectSupportBo.firstName"
                                                                [disabled]="emitemployeeBO.iscompleted">

                                                        </div>
                                                        <div class="col-lg-4">
                                                            <label>FULL MIDDLE NAME</label>
                                                            <input type="text" class="form-control"
                                                                (ngModelChange)="supportname()"
                                                                [(ngModel)]="backgroundBo.middleName"
                                                                [disabled]="emitemployeeBO.iscompleted">

                                                        </div>
                                                        <div class="col-lg-4">
                                                            <label>LAST NAME</label>

                                                            <input type="text" class="form-control"
                                                                (ngModelChange)="supportname()"
                                                                [(ngModel)]="individualDirectSupportBo.lastName"
                                                                [disabled]="emitemployeeBO.iscompleted">

                                                        </div>

                                                    </div>
                                                    <div class="row mb-2 mt-2">
                                                        <div class="col-lg-4">
                                                            <label>Date of Birth </label>
                                                            <my-date-picker class="w-100 text-end"
                                                                [options]="myDatePickerOptions" placeholder="mm/dd/yyyy"
                                                                (inputFieldChanged)="newdates($event,'inputchange','date15')"
                                                                (dateChanged)="newdates($event,'datechanged','date15')"
                                                                [selDate]="individualDirectSupportBo.dob"
                                                                [disabled]="emitemployeeBO.iscompleted">
                                                            </my-date-picker>



                                                        </div>
                                                        <div class="col-lg-4">
                                                            <label>Phone Number</label>
                                                            <input type="text" class="form-control"
                                                                [(ngModel)]="individualDirectSupportBo.phone"
                                                                (ngModelChange)="DemographicPhoneFormat()"
                                                                (keypress)="keyPress($event)" minlength="14"
                                                                maxlength="14" [disabled]="emitemployeeBO.iscompleted">

                                                        </div>

                                                    </div>
                                                    <div class="row mb-2 mt-2">
                                                        <div class="col d-flex">
                                                            If individual has been working in a different
                                                            support position or was enrolled for MCO claims
                                                            only, has the
                                                            individual been continuously employed by your
                                                            agency? &nbsp;&nbsp;Yes &nbsp;
                                                            <!-- <div class="ms-5" *ngFor="let val of yes_or_no_lst"> -->
                                                            <input type="radio" class="me-1" value="true" name="yes1"
                                                                (change)="IDSWFormRadio1()"
                                                                [(ngModel)]="individualDirectSupportBoRadio1"
                                                                [disabled]="emitemployeeBO.iscompleted">
                                                            &nbsp; &nbsp; No &nbsp;
                                                            <!-- [(ngModel)]="documentBO.individual_direct_support_worker_entrollment.continuously_Employeed -->
                                                            <input type="radio" value="false" name="yes1"
                                                                (change)="IDSWFormRadio1()"
                                                                [(ngModel)]="individualDirectSupportBoRadio1"
                                                                [disabled]="emitemployeeBO.iscompleted">
                                                            <!-- {{val.Value}} -->
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <!-- </div> -->
                                    <div class="row mb-2 mt-2">
                                        <div class="col">
                                            <div class="card">
                                                <div class="card-body">
                                                    <h4><b>Individual DSW Background Study Information</b></h4>
                                                    <div class="row mb-2 mt-2">
                                                        <div class="col-lg-7">
                                                            <label>PROGRAM TYPE</label>
                                                            <input type="text" class="form-control"
                                                                placeholder="CDCS(C4)you must submit and have the individual pass a backgrounf check"
                                                                [(ngModel)]="individualDirectSupportBo.programType"
                                                                [disabled]="emitemployeeBO.iscompleted">

                                                        </div>

                                                    </div>
                                                    <div class="row mt-2 mb-2">
                                                        <div class="col">
                                                            <table class="table table table-bordered">
                                                                <thead>
                                                                    <tr>
                                                                        <th>BGS number
                                                                            (required only for CDCS)</th>
                                                                        <th>
                                                                            Application number
                                                                        </th>
                                                                        <th>Facility ID </th>
                                                                    </tr>
                                                                </thead>
                                                                <tbody>
                                                                    <tr
                                                                        *ngFor="let table of DSwstudyBolist ; let i=index">
                                                                        <td>
                                                                            <input (keypress)="keyPress($event)"
                                                                                [(ngModel)]="table.bsgNumber"
                                                                                class="form-control"
                                                                                [disabled]="emitemployeeBO.iscompleted">
                                                                        </td>
                                                                        <td>
                                                                            <input (keypress)="keyPress($event)"
                                                                                [(ngModel)]="table.applicationNumber"
                                                                                class="form-control"
                                                                                [disabled]="emitemployeeBO.iscompleted">
                                                                        </td>
                                                                        <td>
                                                                            <input (keypress)="keyPress($event)"
                                                                                [(ngModel)]="table.facilityId"
                                                                                class="form-control"
                                                                                [disabled]="emitemployeeBO.iscompleted">
                                                                        </td>
                                                                        <td>
                                                                            <button class="butn"
                                                                                (click)="clicktab(i,table)"
                                                                                *ngIf="table.isadd"
                                                                                [disabled]="emitemployeeBO.iscompleted">
                                                                                <i class="fa fa-plus"
                                                                                    aria-hidden="true"></i></button>
                                                                            <button class="butnred"
                                                                                (click)="removeTab(i)"
                                                                                *ngIf="!table.isadd"
                                                                                [disabled]="emitemployeeBO.iscompleted">
                                                                                <i class="fa fa-times"></i></button>

                                                                        </td>
                                                                    </tr>
                                                                </tbody>
                                                            </table>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row mb-2 mt-2">
                                        <div class="col">
                                            <div class="card">
                                                <div class="card-body">
                                                    <h4><b>Individual DSW Address</b></h4>
                                                    <div class="row mb-2 mt-2">
                                                        <div class="col-lg-7">
                                                            <label>STREET ADDRESS</label>
                                                            <textarea class="form-control"
                                                                placeholder="Residential address only - Do not enter PO Box"
                                                                [(ngModel)]="individualDirectSupportBo.street"
                                                                [disabled]="emitemployeeBO.iscompleted"></textarea>
                                                        </div>
                                                    </div>
                                                    <div class="row mb-2 mt-2">
                                                        <div class="col-lg-3">
                                                            <label>city</label>
                                                            <input type="text" class="form-control"
                                                                [(ngModel)]="individualDirectSupportBo.city"
                                                                [disabled]="emitemployeeBO.iscompleted">
                                                        </div>
                                                        <div class="col-lg-3">
                                                            <label>State</label>
                                                            <ng-select [items]="stateList" class="width25"
                                                                [searchable]="true" [clearable]="true" bindLabel="name"
                                                                [(ngModel)]="individualDirectSupportBo.state"
                                                                bindValue="abbreviation"
                                                                [disabled]="emitemployeeBO.iscompleted">
                                                            </ng-select>
                                                        </div>
                                                        <div class="col-lg-3">
                                                            <label>Zip Code</label>
                                                            <input (ngModelChange)="validZip() " type="text"
                                                                minlength="5" maxlength="11"
                                                                (keypress)="keyPress($event)" class="form-control"
                                                                [(ngModel)]="individualDirectSupportBo.zip"
                                                                [disabled]="emitemployeeBO.iscompleted">
                                                            <span class="ssn1" *ngIf="zip2">{{ziperr}}</span>
                                                        </div>
                                                        <div class="col-lg-3">
                                                            <label>COUNTY OF RESIDENCE</label>
                                                            <input type="text" class="form-control"
                                                                [(ngModel)]="individualDirectSupportBo.county"
                                                                [disabled]="emitemployeeBO.iscompleted">
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row mb-2 mt-2">
                                        <div class="col">
                                            <div class="card">
                                                <div class="card-body">
                                                    <h4><b>Individual DSW Training Information</b></h4>
                                                    <div class="row mb-2 mt-1">
                                                        <div class="col d-flex">
                                                            Did this worker take Qualified Enhanced Rate
                                                            training? (an optional training)
                                                            &nbsp;&nbsp;Yes &nbsp;
                                                            <input type="radio" class="me-1" name="rrd"
                                                                (change)="IDSWFormRadio2()" value="true"
                                                                [(ngModel)]="individualDirectSupportBoRadio2">
                                                            <!-- [(ngModel)]="documentBO.individual_direct_support_worker_entrollment.check_if_Qualified_Enhanced_Rate_Training"
                                                                    [(ngModel)]="documentBO.individual_direct_support_worker_entrollment.check_if_Qualified_Enhanced_Rate_Training" -->
                                                            &nbsp;&nbsp;No &nbsp;
                                                            <input type="radio" name="rrd" value="false"
                                                                (change)="IDSWFormRadio2()"
                                                                [(ngModel)]="individualDirectSupportBoRadio2"
                                                                [disabled]="emitemployeeBO.iscompleted">

                                                        </div>
                                                    </div>
                                                    <div class="row">
                                                        <div class="col-lg-6">
                                                            <label>OPTIONAL TRAINING COMPLETION DATE</label>
                                                            <my-date-picker class="w-100 text-end"
                                                                [selDate]="individualDirectSupportBo.optionalTrainingCompletionDate"
                                                                (inputFieldChanged)="newdates($event,'inputchange','date16')"
                                                                (dateChanged)="newdates($event,'datechanged','date16')"
                                                                [options]="myDatePickerOptions" placeholder="mm/dd/yyyy"
                                                                [disabled]="emitemployeeBO.iscompleted">
                                                            </my-date-picker>
                                                        </div>
                                                        <div class="col-lg-6">
                                                            <label>OPTIONAL TRAINING EXPIRATION DATE (if
                                                                applicable)</label>
                                                            <my-date-picker class="w-100 text-end"
                                                                [selDate]="individualDirectSupportBo.optionalTrainingExpirationDate"
                                                                (inputFieldChanged)="newdates($event,'inputchange','date17')"
                                                                (dateChanged)="newdates($event,'datechanged','date17')"
                                                                [options]="myDatePickerOptions" placeholder="mm/dd/yyyy"
                                                                [disabled]="emitemployeeBO.iscompleted">
                                                            </my-date-picker>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="row mb-2 mt-2">
                                        <div class="col">
                                            <div class="card">
                                                <div class="card-body">
                                                    <h4><b>Individual DSW Provider Statement</b></h4>
                                                    <div class="row">
                                                        <div class="col">
                                                            <p>
                                                                I have reviewed and certify the information
                                                                provided on this form is true and correct to the
                                                                best of my knowledge.
                                                                <b>I will notify MHCP Provider Eligibility and
                                                                    Compliance of any additions or ngModelChanges to
                                                                    the information.</b>
                                                                By signing this form, I acknowledge I have read
                                                                and understand the <a
                                                                    href="https://edocs.dhs.state.mn.us/lfserver/Public/DHS-6287-ENG"
                                                                    target="_blank">Data
                                                                    Privacy
                                                                    Notice (DHS-6287) (PDF).</a> I also
                                                                authorize MHCP to use the information you
                                                                collect about me according to the Privacy
                                                                Notice.
                                                                Check if signing electronically:
                                                            </p>
                                                            <p>Check if signing electronically:</p>
                                                            <p> <input type="checkbox"
                                                                    [(ngModel)]="individualDirectSupportBo.signelectronically"
                                                                    [disabled]="emitemployeeBO.iscompleted">I
                                                                am signing this form electronically. My name as
                                                                typed in the signature field is my legally
                                                                binding signature. I
                                                                understand that my electronic signature has the
                                                                same legal effect and can be enforced in the
                                                                same way as a
                                                                handwritten signature. (Minnesota Statutes
                                                                325L.02(h), 325L.05 and 325L.08)</p>
                                                        </div>
                                                    </div>
                                                    <div class="row">
                                                        <div class="col-lg-7">
                                                            <label>NAME OF INDIVIDUAL SUPPORT WORKER (PRINT OR
                                                                TYPE) </label>
                                                            <input type="text" class="form-control"
                                                                [(ngModel)]="individualSupportWorkerBo.nameofSupportWorkerNamePrint"
                                                                [disabled]="emitemployeeBO.iscompleted">
                                                        </div>
                                                    </div>
                                                    <div class="row mb-2 mt-2">
                                                        <div class="col-lg-7">
                                                            <div class="row">
                                                                <div class="col-lg-7">
                                                                    <button type="button" class="btn blue-btn"
                                                                        data-bs-toggle="modal"
                                                                        data-bs-target="#DHS_4469A_modal2"
                                                                        [disabled]="global.OnboardingLoginType != 'onboardLogin'">Support
                                                                        Worker
                                                                        Signature</button>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div class="col-lg-5" [formGroup]="dateForm">
                                                            <label>DATE SIGNED</label>
                                                            <my-date-picker class="w-100 text-end"
                                                                placeholder="mm/dd/yyyy" [options]="myDatePickerOptions"
                                                                [selDate]="individualDirectSupportBo.signDate"
                                                                (inputFieldChanged)="newdates($event,'inputchange','date36')"
                                                                (dateChanged)="newdates($event,'datechanged','date36')"
                                                                formControlName="signDate7"
                                                                [disabled]="emitemployeeBO.iscompleted">
                                                            </my-date-picker>
                                                            <!--   -->
                                                        </div>
                                                    </div>
                                                    <div class="row mt-2 mb-2">

                                                        <div class="col-lg-5">
                                                            <input *ngIf="individualsign!=''&& individualsign!=null "
                                                                type="image" src="{{individualsign}}"
                                                                class="form-control" style="width: 255px;height:120px;"
                                                                width="48" height="48">
                                                        </div>
                                                    </div>
                                                    <br>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row mb-2 mt-2">
                                        <div class="col">
                                            <div class="card">
                                                <div class="card-body">
                                                    <h4>Organization Affiliation Information</h4>
                                                    <div class="row mb-2 mt-2">
                                                        <div class="col d-flex">
                                                            <p class="col-lg-10">
                                                                You may affiliate or enroll the individual DSW
                                                                named on this form with another Fiscal Support
                                                                Entity (FSE) or
                                                                Financial Management Services (FMS) agency or
                                                                location you directly own without completing
                                                                another application
                                                                and agreement. Do you want to affiliate this
                                                                individual DSW with any <span class="col d-flex">other
                                                                    agency or location
                                                                    you own?
                                                                    <label for="radio1" class="me-1 ms-2">Yes</label>

                                                                    <!-- <div class="ms-2">
                                                            dSW_with_AnyOther_Agency_OR_Location_You_Own
                                                            <div class=" row">
                                                           [(ngModel)]="documentBO.individual_direct_support_worker_entrollment.dSW_with_AnyOther_Agency_OR_Location_You_Own"  
                                                                  [(ngModel)]="documentBO.individual_direct_support_worker_entrollment.dSW_with_AnyOther_Agency_OR_Location_You_Own"

                                                            -->

                                                                    <input type="radio" class="me-4 ms-1" id="radio1"
                                                                        value="true" name="yes3"
                                                                        [(ngModel)]="individualDirectSupportBoRadio3"
                                                                        (change)="IDSWFormRadio3()">
                                                                    <label class="me-1 ms-2">No</label>
                                                                    <input type="radio" value="false" class="ms-1"
                                                                        id="radio2" name="yes3"
                                                                        [(ngModel)]="individualDirectSupportBoRadio3"
                                                                        (change)="IDSWFormRadio3()">
                                                                </span>



                                                                <!-- </div>

                                                        </div> -->
                                                            </p>

                                                        </div>
                                                    </div>
                                                    <div class="row mt-2">
                                                        <div class="col">
                                                            <p>
                                                                Check if signing electronically:
                                                            </p>
                                                        </div>
                                                    </div>
                                                    <div class="row">
                                                        <div class="col d-inline-flex">
                                                            <input type="checkbox"
                                                                [(ngModel)]="individualDirectSupportBo.orgAffiliationInfoSignDeclaration">&nbsp;
                                                            <p>
                                                                I am signing this form electronically. My name
                                                                as typed in the signature field is my legally
                                                                binding signature. I
                                                                understand that my electronic signature has the
                                                                same legal effect and can be enforced in the
                                                                same way as a
                                                                handwritten signature. (Minnesota Statutes
                                                                325L.02(h), 325L.05 and 325L.08)
                                                            </p>

                                                        </div>

                                                    </div>
                                                    <div class="row">
                                                        <div class="col-lg-4">
                                                            <label>Organization name</label>
                                                            <input type="text" class="form-control"
                                                                [(ngModel)]="individualDirectSupportBo.organizationName"
                                                                [disabled]="emitemployeeBO.iscompleted">

                                                        </div>
                                                        <div class="col-lg-4">
                                                            <label>FACILITY NPI OR UMPI</label>
                                                            <input type="text" class="form-control" maxlength="10"
                                                                [(ngModel)]="individualDirectSupportBo.facilityNpi"
                                                                [disabled]="emitemployeeBO.iscompleted">

                                                        </div>
                                                        <div class="col-lg-4">
                                                            <label>STUDY ID</label>
                                                            <input type="text" class="form-control"
                                                                [(ngModel)]="individualDirectSupportBo.studyId"
                                                                [disabled]="emitemployeeBO.iscompleted">

                                                        </div>

                                                    </div>
                                                    <div class="row mb-2 mt-2">
                                                        <div class="col-lg-4">
                                                            <label>ORGANIZATION PERSONNEL COMPLETING FORM</label>
                                                            <input type="text" class="form-control"
                                                                [(ngModel)]="individualDirectSupportBo.orgPersonalCompletingForm"
                                                                [disabled]="emitemployeeBO.iscompleted">
                                                        </div>
                                                        <div class="col-lg-4">
                                                            <label>ORGANIZATION
                                                                PERSONNEL SIGNATURE</label>
                                                            <input type="text" class="form-control"
                                                                [(ngModel)]="individualDirectSupportBo.orgPersonalSign"
                                                                [disabled]="emitemployeeBO.iscompleted">
                                                        </div>
                                                        <div class="col-lg-4">
                                                            <label>ORGANIZATION FAX NUMBER</label>
                                                            <input type="text" class="form-control" maxlength="14"
                                                                [(ngModel)]="individualDirectSupportBo.orgPersonalFax"
                                                                (ngModelChange)="DemographicPhoneFormat()"
                                                                (keypress)="keyPress($event)"
                                                                [disabled]="emitemployeeBO.iscompleted">
                                                        </div>
                                                    </div>
                                                    <br>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-12  mb-3 mt-1 ">



                                        <div class="text-end">
                                            <button class="btn" [disabled]="emitemployeeBO?.iscompleted || isSaveorUpdateBoolean"
                                                *ngIf="global.OnboardingLoginType !='onboardLogin' && !emitemployeeBO.print"
                                                (click)="saveAgreement()">Save</button>
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>

            </div>

            <!-- MINNESOTA Indiviual Provider Agreement (MHCP) -->
            <div class="row mb-2 mt-2">
                <div class="col p-0">
                    <div class="card " style="height:auto;">
                        <div class="col mt-4 text-end">
                            <button class="btn btn-sm me-5" *ngIf="emitemployeeBO.print"
                                (click)="GetEmpOnboardDeatalis('IndividualProviderAgree')">Print</button>
                        </div>
                        <div class="card-body" style="padding:55px;">
                            <!-- <form [formGroup]="Document1"> -->
                            <div class="row mt-2 mb-2 col-4">
                                <img src="..\assets\img\Capture.JPG" class="img-fluid" alt="Responsive image">
                            </div>

                            <h5>MINNESOTA HEALTH CARE PROGRAMS (MHCP) </h5>
                            <h2 style="color: black;"><b>Individual Support Worker (CDCS, CSG, PCA, CFSS)
                                    Provider Agreement</b></h2>
                            <div class="row mt-3 ms-2">
                                <p>As a participating provider in Minnesota Health Care Programs (MHCP)
                                    administered by the Minnesota Department
                                    of Human Services (DHS), the provider agrees to:</p>
                            </div>
                            <div class="row ">
                                <div class="col p-0">
                                    <ol type="A" class="ms-5 p-0">
                                        <li>Submit documentation to your affiliated agency that fully discloses
                                            the extent of services provided to
                                            individuals under these programs. The documentation must be legible
                                            and meet the requirements of Minnesota
                                            Statutes, section 256B.0659, subdivision 12 for all individual
                                            support workers in Consumer Directed Community
                                            Supports (CDCS), Consumer Support Grant (CSG), Personal Care
                                            Assistance (PCA), and Community First Services
                                            and Supports (CFSS) .</li>
                                        <li>Furnish DHS, the secretary of the U.S. Department of Health and
                                            Human Services (DHHS), or the Minnesota
                                            Medicaid Fraud Control Unit with such information as it may request
                                            regarding payments claimed for services
                                            provided under these programs.</li>
                                        <li>Comply with all federal and state statutes and rules relating to the
                                            delivery of services to individuals and to the
                                            submission of claims for such services.</li>
                                        <li>Accept as payment in full, amounts paid in accordance with schedules
                                            established by DHS, except where
                                            payment by the member has been authorized by DHS.</li>
                                        <li>Make full disclosure of any conviction(s) of program crimes as
                                            required by the Code of Federal Regulations, title
                                            42, section 455.106.</li>
                                        <li>Comply with all federal statutes, implementing regulations and
                                            guidance prohibiting discrimination on the
                                            basis of race, color, national origin, sex, age, religion and
                                            disability in any program or activity receiving federal
                                            financial assistance from DHHS; and to comply with the Minnesota
                                            Human Rights Act.</li>
                                        <li>Provide services to members of the same scope and quality as would
                                            be provided to the general public, within
                                            MHCP guidelines.</li>
                                        <li>. Comply with the provisions of any fully executed agreement or
                                            addendum required by DHS, which is
                                            incorporated herein by reference.</li>
                                        <li>Comply with the advance directive requirements as required by the
                                            Code of Federal Regulations, title 42,
                                            sections 489.100 and 417.436.</li>
                                        <li>Properly handle and safeguard protected information collected,
                                            created, used, maintained, or disclosed on
                                            behalf of DHS. For purposes of this agreement, “protected
                                            information” means data subject to any of the
                                            following laws:</li>
                                        <ol type="1" class="ms-3 p-0">
                                            <li>The Minnesota Government Data Practices Act (MGDPA), Minnesota
                                                Statutes, chapter 13, section 13.46
                                                ("welfare data");</li>
                                            <li>The Minnesota Health Records Act, sections 144.291 and 144.298;
                                            </li>
                                            <li>The Health Insurance Portability and Accountability Act
                                                (“HIPAA”), including but not limited to the
                                                requirements of the Privacy Rule and the Security Regulations,
                                                the Code of Federal Regulations, title 45, parts
                                                160 and 164, subparts A and E.</li>
                                            <li>Federal law and regulations that govern the use and disclosure
                                                of substance abuse treatment records, the
                                                United States Code, title 42, section 290dd-2 and the Code of
                                                Federal Regulations, title 42, sections 2.1 to
                                                2.67; and Electronic initials accepted.</li>
                                            <div class="row">
                                                <div class="col-lg-8 ">
                                                </div>
                                                <div class="col-lg-4">
                                                    <label for="DIRECT SUPPORT WORKER INITIALS">
                                                        DIRECT SUPPORT WORKER INITIALS

                                                    </label>
                                                    <input type="text" class="form-control"
                                                        [(ngModel)]="individualSupportWorkerBo.directSupportWorkerInitial"
                                                        [disabled]="emitemployeeBO.iscompleted">
                                                </div>
                                            </div>
                                            <div class="row">
                                                <div class="col-lg-8">
                                                    <label for="NAME OF SUPPORT WORKER">
                                                        NAME OF SUPPORT WORKER

                                                    </label>
                                                    <input type="text" (change)="suptwrkName() " class="form-control"
                                                        [(ngModel)]="individualSupportWorkerBo.nameofSupportWorkerNamePrint"
                                                        [disabled]="emitemployeeBO.iscompleted">

                                                </div>
                                                <div class="col-lg-4">
                                                    <label for="UMPI">
                                                        UMPI

                                                    </label>
                                                    <input type="text" maxlength="10" class="form-control"
                                                        [(ngModel)]="individualSupportWorkerBo.umpi"
                                                        [disabled]="emitemployeeBO.iscompleted">
                                                </div>

                                            </div>


                                            <li>Any other applicable state and federal statutes, rules, and
                                                regulations affecting the collection, storage, use
                                                and dissemination of private or confidential information.</li>
                                        </ol>
                                        <li>
                                            Comply with the laws described in section J. This includes the
                                            provider:
                                        </li>

                                        <ol type="1" class="ms-4 p-0">
                                            <li>Not using or further disclosing protected information created,
                                                collected, received, stored, used, maintained or disseminated in
                                                the course or performance of this agreement other than as
                                                necessary to perform its obligations under this Provider
                                                Agreement, or as required by law, either during the period of
                                                this agreement or after. See, respectively, the Code of Federal
                                                Regulations, title 45, sections 164.502(b) and 164.514(d), and
                                                Minnesota Statutes, 13.05 subdivision 3.</li>
                                            <li>Using appropriate administrative, physical, and technical
                                                safeguards to prevent use or disclosure of the protected
                                                information other than as provided for by this agreement and to
                                                ensure the confidentiality, integrity, and availability of any
                                                electronic protected health information (PHI) that it creates,
                                                receives, maintains, or transmits on behalf of DHS. The provider
                                                will not transmit PHI over the Internet or any other unsecure or
                                                open communications channel unless such information is encrypted
                                                or otherwise safeguarded using procedures no less stringent than
                                                those described in the Code of Federal Regulations, title 45,
                                                section 164.312. If the provider stores or maintains PHI in
                                                encrypted form, the provider shall, at DHS’ request, promptly
                                                provide DHS with the key or keys to decrypt such information.
                                                The provider shall not forward previously encrypted data to any
                                                other party, unless otherwise required by this agreement.</li>
                                            <li>Mitigating, to the extent practicable, any harmful effects known
                                                to the provider of a use, disclosure, or breach of security with
                                                respect to protected information by the provider in violation of
                                                this agreement.</li>
                                        </ol>
                                        <li>
                                            Agree that this agreement may be immediately terminated at the
                                            discretion of DHS if it determines that the
                                            provider has violated a material term of the agreement, including
                                            but not limited to, non-compliance by the
                                            provider with the HIPAA Privacy Rule and Security Standards. If
                                            termination is not feasible, DHS shall report the
                                            breach to the Secretary of DHHS.
                                            Upon termination of this agreement, all of the protected information
                                            provided by DHS to the provider, or
                                            created or received by the provider on behalf of DHS, that the
                                            provider still maintains in any form, including
                                            information that is in the hands of subcontractors or agents of the
                                            provider, shall be destroyed or returned to
                                            DHS, and the provider shall retain no copies of such information. If
                                            it is infeasible to return or destroy the
                                            information, the provider shall provide DHS notification of the
                                            conditions that make return or destruction
                                            infeasible, and shall extend the protections of this agreement to
                                            such information and limit further use and
                                            disclosure of such information to those purposes that make return or
                                            destruction infeasible, for as long as the
                                            provider maintains the information.
                                        </li>
                                        <li>
                                            Agree that any ambiguity in this agreement shall be resolved to
                                            permit DHS to comply with HIPAA, MDGPA, and
                                            other applicable state and federal statutes, rules, and regulations
                                            affecting the collection, storage, use and
                                            dissemination of private or confidential information and other state
                                            and federal laws and regulations.
                                        </li>

                                    </ol>
                                    <div class="row ms-4">
                                        <p>Upon signature, this Provider Agreement supersedes and replaces all
                                            former Provider Agreements the provider has
                                            with DHS.</p>
                                    </div>
                                    <div class="row ms-4">
                                        <p>
                                            An individual applicant must personally sign the Provider Agreement.
                                            Sign and date this form, initial page 1, and
                                            return both page 1 and page 2 of this agreement.
                                        </p>
                                    </div>
                                    <div class="row ms-4">
                                        <p>
                                            Check if signing electronically:
                                        </p>
                                    </div>
                                    <div class="row ms-5">
                                        <p>
                                            <span> <input type="checkbox"
                                                    [(ngModel)]="individualSupportWorkerBo.signDeclaration"
                                                    [disabled]="emitemployeeBO.iscompleted"></span>
                                            <!--  -->
                                            I am signing this form electronically. My name as typed in the
                                            signature field is my legally binding signature. I
                                            understand that my electronic signature has the same legal effect
                                            and can be enforced in the same way as a
                                            handwritten signature. (Minnesota Statutes 325L.02(h), 325L.05 and
                                            325L.08)
                                        </p>
                                    </div>
                                    <div class="row">
                                        <div class="col-lg-8 ">
                                            <label>NAME OF SUPPORT WORKER (TYPE OR PRINT)</label>
                                            <input type="text" class="form-control"
                                                [(ngModel)]="individualSupportWorkerBo.nameofSupportWorkerNamePrint"
                                                [disabled]="emitemployeeBO.iscompleted">
                                        </div>
                                        <div class="col-lg-4">
                                            <label for="DIRECT SUPPORT WORKER INITIALS">
                                                TITLE
                                            </label>
                                            <input type="text" class="form-control"
                                                [(ngModel)]="individualSupportWorkerBo.title"
                                                [disabled]="emitemployeeBO.iscompleted">


                                        </div>
                                    </div>
                                    <div class="row mt-2 mb-3">
                                        <div class="col-lg-8">
                                            <button type="button" class="btn blue-btn" data-bs-toggle="modal"
                                                data-bs-target="#agepage_modal1"
                                                [disabled]="global.OnboardingLoginType != 'onboardLogin'">
                                                SIGNATURE OF SUPPORT WORKER
                                            </button>

                                        </div>
                                        <div class="col-lg-4">
                                            <div class="row">
                                                <div class="col-lg-2">
                                                    <label for="Date">Date</label>
                                                </div>
                                                <div class="col-lg-10" [formGroup]="dateForm">
                                                    <my-date-picker class="w-100" placeholder="mm/dd/yyyy"
                                                        [options]="myDatePickerOptions"
                                                        [selDate]="individualSupportWorkerBo.signDate"
                                                        (inputFieldChanged)="newdates($event,'inputchange','date35')"
                                                        (dateChanged)="newdates($event,'datechanged','date35')"
                                                        formControlName="signDate8"
                                                        [disabled]="emitemployeeBO.iscompleted">

                                                    </my-date-picker>
                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                    <div class="row mb-2 mt-2">
                                        <div class="col-lg-5">
                                            <input *ngIf="repsign!=''&& repsign!=null " type="image" src="{{repsign}}"
                                                class="form-control" style="width: 255px;height:120px;" width="48"
                                                height="48">

                                        </div>
                                    </div>
                                    <div class="row mt-2">
                                        <p>
                                            Keep a copy of the Provider Agreement for your files and upload the
                                            original form using the online <a
                                                href="https://mn.gov/dhs/partners-and-providers/policies-procedures/minnesota-health-care-programs/provider/mpse/"
                                                target="_blank">Minnesota
                                                Provider Screening and Enrollment (MPSE) portal</a> or fax to
                                            651-431-7465.
                                        </p>
                                    </div>
                                    <div class="row mb-2">
                                        <div class="col">
                                            <h2 style="text-align: center;"><b>Agreement Summary</b></h2>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-lg-6">
                                            <p>
                                                As an individual support worker, you are providing health care
                                                services to individuals. We require your enrollment in the
                                                Minnesota Health Care Programs (MHCP) and to be listed as the
                                                rendering provider on the claim so that you are represented as
                                                the person who provided the services. Knowing that a qualified
                                                individual provided the service ensures the safety of the people
                                                that the Minnesota Department of Human Services (DHS) serves. It
                                                also allows DHS to perform auditing and tracking of services
                                                which protects against double-billing and other types of fraud.
                                                Before enrollment is approved, MHCP must make certain that:
                                            </p>
                                            <ol type="1">
                                                <li>There is no legal or other reason why you shouldn’t provide
                                                    these services,</li>
                                                <li>You understand what is necessary to properly provide these
                                                    services, and</li>
                                                <li>You understand the need to protect the privacy of the people
                                                    you care for.</li>
                                            </ol>


                                            <p>
                                                To help ensure that each of these conditions is met, MHCP
                                                requires that you agree to the terms in the attached Provider
                                                Agreement. In general, this agreement requires that you:
                                            </p>

                                            <ol type="A">
                                                <li>Provide documents to your employer about the services you
                                                    provide.</li>
                                                <li>Provide documents to MHCP or other state and federal
                                                    agencies related to the services you provide, when
                                                    requested.</li>
                                                <li>Comply with federal and state laws about the services you
                                                    provide.</li>
                                                <li>Accept payment made to your employer as payment in full for
                                                    the services you provide. You cannot ask for nor accept
                                                    additional payment from the member.</li>
                                                <li>Disclose any criminal convictions you have related to
                                                    Medicare, Medicaid, or title XX services.</li>
                                                <li>Not discriminate against individuals because of their race,
                                                    color, national origin, sex, age, religion or disability
                                                    when you provide these services.</li>
                                                <li>Provide the same quality of service to persons receiving
                                                    public assistance as those who don’t receive such
                                                    assistance.</li>
                                            </ol>
                                        </div>
                                        <div class="col-lg-6">
                                            <ol type="A" start="8">
                                                <li>If you are enrolled to provide and bill for other services,
                                                    you must continue to follow the requirements of the
                                                    agreement you signed when you enrolled for those services.
                                                    The terms of that agreement are different than the terms in
                                                    the attached agreement.</li>
                                                <li>Comply with federal requirements about advance directives.
                                                    An advance directive is written instruction, such as a
                                                    living will, to give a patient control over medical
                                                    treatment decisions.</li>
                                                <li>Properly protect private information about the people to
                                                    whom you provide services, especially their health
                                                    information.</li>
                                                <li>Don’t disclose the private information of someone for whom
                                                    you provide services, unless it is needed for your work.
                                                    This includes not discussing someone’s private information
                                                    unless your job requires it. Also, ensure that the
                                                    information could not be accessed by someone who does not
                                                    have permission to see it. This includes not leaving
                                                    paperwork out where others can see it, and not sending
                                                    private information over the internet.</li>
                                                <li>Understand that this agreement may be canceled if you
                                                    violate its terms. If this agreement is canceled, you must
                                                    properly dispose of any private information you have about
                                                    the people you serve so that it is not discovered by someone
                                                    who does not have permission to see it.</li>
                                                <li>Understand that this agreement may be canceled if you
                                                    violate its terms. If this agreement is canceled, you must
                                                    properly dispose of any private information you have about
                                                    the people you serve so that it is not discovered by someone
                                                    who does not have permission to see it.</li>
                                            </ol>

                                            <p>
                                                This is a basic description of the terms of this agreement.
                                            </p>


                                            <p>
                                                By signing this agreement, you are agreeing to be legally bound
                                                by all of its terms. If you have questions about it, you should
                                                get answers to them before signing this agreement. If you need
                                                or want legal advice, you should contact your own attorney. For
                                                more information, call 651-431-2700.
                                            </p>



                                        </div>

                                    </div>
                                </div>
                            </div>


                            <div class="col-12  mb-3 mt-1 ">


                                <div class="text-end">
                                    <button class="btn" [disabled]="emitemployeeBO?.iscompleted || isSaveorUpdateBoolean"
                                        *ngIf="global.OnboardingLoginType !='onboardLogin' && !emitemployeeBO.print"
                                        (click)="saveAgreement()">Save</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>

            <!--Employment Eligibility Verification Department  -->
            <div class="row mb-2 mt-2">
                <div class="col p-0">
                    <div class="card" style="height:auto;">
                        <div class="card " style="height:auto;">
                            <div class="col mt-4 text-end">
                                <button class="btn btn-sm me-5" *ngIf="emitemployeeBO.print"
                                    (click)="GetEmpOnboardDeatalis('EmpEVerifyDepart')">Print</button>
                            </div>
                            <div class="row">
                                <div class="col-lg-12">
                                    <div class="card-body" style="padding: 45px;">
                                        <div class="row mb-2">
                                            <div class="col-lg-12">

                                                <div class="row text-center">
                                                    <div class="col d-inline-flex justify-content-center">
                                                        <img src="..\assets\i9_form_image.JPG"
                                                            class="img-fluid mt-lg-n4 mb-lg-3" alt="Responsive image">
                                                        <div style="text-align: center;">
                                                            <h4>
                                                                Employment Eligibility Verification Department
                                                            </h4>
                                                            <h4>
                                                                Department of Homeland Security
                                                            </h4>
                                                            <p>
                                                                U.S.Citizenship and Immigration
                                                            </p>
                                                        </div>


                                                    </div>

                                                </div>
                                                <div class="row">
                                                    <div class="col">
                                                        <h4 style="text-align: center;">
                                                            USCIS
                                                            Form I-9
                                                        </h4>
                                                    </div>
                                                </div>




                                            </div>
                                            <div class="row mb-2 mt-2 p-0">
                                                <div class="col p-0">
                                                    <div class="card">
                                                        <div class="card-body">
                                                            <div class="row">
                                                                <div class="col">
                                                                    <p>
                                                                        <b>
                                                                            ►START HERE: Read instructions carefully
                                                                            before completing this form. The
                                                                            instructions must be available, either in
                                                                            paper or electronically, during completion
                                                                            of this form. Employers are liable for
                                                                            errors in the completion of this form.
                                                                        </b>


                                                                    </p> <br>
                                                                    <p>
                                                                        <b>
                                                                            ANTI-DISCRIMINATION NOTICE:
                                                                        </b> It is illegal to discriminate against
                                                                        work-authorized individuals. Employers CANNOT
                                                                        specify which document(s) an employee may
                                                                        present to establish employment authorization
                                                                        and identity. The refusal to hire or continue to
                                                                        employ an individual because the documentation
                                                                        presented has a future expiration date may also
                                                                        constitute illegal discrimination.


                                                                    </p>

                                                                </div>

                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <div class="row mb-2 mt-2 col-12 p-0">
                                                <div class="col p-0">
                                                    <div class="card">
                                                        <div class="card-body">
                                                            <div class="row ">
                                                                <div class="col">
                                                                    <p><b>Section 1. Employee Information and
                                                                            Attestation (Employees must complete and
                                                                            sign
                                                                            Section 1 of Form I-9 no late(rthan the
                                                                            first
                                                                            day of
                                                                            employment, but not before accepting a job
                                                                            offer.)
                                                                        </b></p>


                                                                </div>

                                                            </div>
                                                            <div class="row mb-2">
                                                                <div class="col-lg-3">
                                                                    <label>Last Name (Family Name)</label>
                                                                    <input type="text" class="form-control"
                                                                        [(ngModel)]="employmentEligibilityBo.lastName"
                                                                        [disabled]="emitemployeeBO.iscompleted">

                                                                </div>
                                                                <div class="col-lg-3">
                                                                    <label>First Name (Given Name)</label>
                                                                    <input type="text" class="form-control"
                                                                        [(ngModel)]="employmentEligibilityBo.firstName"
                                                                        [disabled]="emitemployeeBO.iscompleted">

                                                                </div>
                                                                <div class="col-lg-3">
                                                                    <label>Middle Initial</label>
                                                                    <input type="text" class="form-control"
                                                                        [(ngModel)]="backgroundBo.middleName"
                                                                        [disabled]="emitemployeeBO.iscompleted">

                                                                </div>
                                                                <div class="col-lg-3">
                                                                    <label>Other Last Names Used (if any)</label>
                                                                    <input type="text" class="form-control"
                                                                        [(ngModel)]="backgroundBo.lastName"
                                                                        [disabled]="emitemployeeBO.iscompleted">

                                                                </div>


                                                            </div>
                                                            <div class="row mb-2">
                                                                <div class="col-lg-3">
                                                                    <label>Address(Street Number and Name)</label>
                                                                    <textarea class="form-control"
                                                                        [(ngModel)]="employmentEligibilityBo.address"
                                                                        [disabled]="emitemployeeBO.iscompleted"></textarea>

                                                                </div>
                                                                <div class="col-lg-3">
                                                                    <label>Apt. Number</label>
                                                                    <input type="text" class="form-control"
                                                                        [(ngModel)]="employmentEligibilityBo.apt"
                                                                        [disabled]="emitemployeeBO.iscompleted">

                                                                </div>
                                                                <div class="col-lg-3">
                                                                    <label>City or Town</label>
                                                                    <input type="text" class="form-control"
                                                                        [(ngModel)]="employmentEligibilityBo.city"
                                                                        [disabled]="emitemployeeBO.iscompleted">

                                                                </div>
                                                                <div class="col-lg-3">
                                                                    <label>State</label>
                                                                    <ng-select [items]="stateList" class="width25"
                                                                        [(ngModel)]="employmentEligibilityBo.state"
                                                                        [searchable]="true" [clearable]="true"
                                                                        bindLabel="name" bindValue="abbreviation"
                                                                        [disabled]="emitemployeeBO.iscompleted">
                                                                    </ng-select>

                                                                </div>


                                                            </div>
                                                            <div class="row mb-2">
                                                                <div class="col-lg-3">
                                                                    <label>ZipCode</label>
                                                                    <input (ngModelChange)="validZip() " type="text"
                                                                        [(ngModel)]="employmentEligibilityBo.employersZip"
                                                                        minlength="5" maxlength="11"
                                                                        class="form-control"
                                                                        [disabled]="emitemployeeBO.iscompleted">
                                                                    <span class="ssn1" *ngIf="zip3">{{ziperr}}</span>

                                                                    <!-- [(ngModel)]="employmentEligibilityBo.zip" -->
                                                                </div>
                                                                <div class="col-lg-3">
                                                                    <label>Date of Birth </label>
                                                                    <my-date-picker class="w-100"
                                                                        [options]="myDatePickerOptions"
                                                                        [disabled]="true"
                                                                        [selDate]="employmentEligibilityBo.dob"
                                                                        (inputFieldChanged)="newdates($event,'inputchange','date18')"
                                                                        (dateChanged)="newdates($event,'datechanged','date18')"
                                                                        placeholder="mm/dd/yyyy"
                                                                        [disabled]="emitemployeeBO.iscompleted">

                                                                    </my-date-picker>

                                                                </div>
                                                                <div class="col-lg-3">
                                                                    <label>U.S. Social Security Number</label>
                                                                    <input (ngModelChange)="checkssn() " type="password"
                                                                        [(ngModel)]="backgroundBo.ssn"
                                                                        class="form-control" minlength="7" maxlength="7"
                                                                        (keypress)="keyPress($event)" minlength="9"
                                                                        maxlength="9"
                                                                        [disabled]="emitemployeeBO.iscompleted">
                                                                    <span class="ssn1" *ngIf="ssn1">{{ssnerror}}</span>

                                                                </div>
                                                                <div class="col-lg-3">
                                                                    <label>
                                                                        Employee's E-mail Address
                                                                    </label>
                                                                    <input type="text" class="form-control"
                                                                        [(ngModel)]="employmentEligibilityBo.employees_Email"
                                                                        [disabled]="emitemployeeBO.iscompleted">

                                                                </div>
                                                                <div class="col-lg-3">
                                                                    <label>Employee's Telephone Number</label>
                                                                    <input type="text" class="form-control"
                                                                        minlength="10"
                                                                        [(ngModel)]="employmentEligibilityBo.employeesPhone"
                                                                        (ngModelChange)="DemographicPhoneFormat()"
                                                                        maxlength="14" (keypress)="keyPress($event)"
                                                                        [disabled]="emitemployeeBO.iscompleted">
                                                                </div>
                                                            </div>
                                                            <div class="row mt-2 mb-2">
                                                                <div class="col">
                                                                    <p>
                                                                        <b>
                                                                            I am aware that federal law provides for
                                                                            imprisonment and/or fines for false
                                                                            statements or use of false documents in
                                                                            connection with the completion of this form.
                                                                        </b>
                                                                    </p>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="row mb-2 mt-2 p-0">
                                                <div class="col p-0">
                                                    <div class="card">
                                                        <div class="card-body">
                                                            <div class="row">
                                                                <div class="col p-0">
                                                                    <p>
                                                                        <b>
                                                                            I attest, under penalty of perjury, that I
                                                                            am (check one of the following boxes):
                                                                        </b>
                                                                    </p>

                                                                </div>

                                                            </div>
                                                            <div class="row">
                                                                <div class="col">
                                                                    <p>
                                                                        <input type="radio" id="citizen1"
                                                                            name="stateofcitizenn" value="citizen"
                                                                            (change)="one_bool($event)"
                                                                            [(ngModel)]="employmentEligibilityBo.penaltyOfPerjury"
                                                                            [disabled]="emitemployeeBO.iscompleted">
                                                                        <!-- [(ngModel)]="employmentEligibilityBo.citizen_United_States" -->
                                                                        1. A
                                                                        citizen of
                                                                        the United States

                                                                    </p>
                                                                    <p>
                                                                        <!-- [(ngModel)]="employmentEligibilityBo.nonCitizen" -->
                                                                        <input type="radio" id="citizen2"
                                                                            name="stateofcitizenn" value="noncitizen"
                                                                            [(ngModel)]="employmentEligibilityBo.penaltyOfPerjury"
                                                                            [disabled]="emitemployeeBO.iscompleted">
                                                                        2. A
                                                                        noncitizen
                                                                        national of the United States (See instructions)

                                                                    </p>
                                                                    <p>
                                                                        <!-- [(ngModel)]="documentBO.employement_Eligibility_Verification.employeeInformation.lawful_resisdent" -->
                                                                        <!-- [(ngModel)]="employmentEligibilityBo.lawfulPermenantResident" -->
                                                                        <input type="radio" id="citizen3"
                                                                            name="stateofcitizenn"
                                                                            value="lawful_permanent"
                                                                            [(ngModel)]="employmentEligibilityBo.penaltyOfPerjury"
                                                                            [disabled]="emitemployeeBO.iscompleted">
                                                                        3. A
                                                                        lawful
                                                                        permanent resident (Alien Registration
                                                                        Number/USCIS Number): <input id="citizen3"
                                                                            [(ngModel)]="employmentEligibilityBo.alien_Registration_Number"
                                                                            type="text" min="0" class="form-control"
                                                                            (keypress)="keyPress($event)"
                                                                            style="width: 180px;display: inline-block;"
                                                                            [disabled]="emitemployeeBO.iscompleted">
                                                                    </p>
                                                                    <p>
                                                                        <!-- [(ngModel)]="employmentEligibilityBo.alienAuthWork" -->
                                                                        <input type="radio" id="citizen4"
                                                                            name="stateofcitizenn" value="alien"
                                                                            (change)="one_bool($event)"
                                                                            [(ngModel)]="employmentEligibilityBo.penaltyOfPerjury"
                                                                            [disabled]="emitemployeeBO.iscompleted">
                                                                        4. An alien authorized to work until (expiration
                                                                        date, if applicable, mm/dd/yyyy):
                                                                        <my-date-picker [options]="myDatePickerOptions"
                                                                            [selDate]="employmentEligibilityBo.alien_Registration_ExpiryDate"
                                                                            (inputFieldChanged)="newdates($event,'inputchange','date19')"
                                                                            (dateChanged)="newdates($event,'datechanged','date19')"
                                                                            style="width: 180px;display: inline-block;"
                                                                            placeholder="mm/dd/yyyy"
                                                                            [disabled]="emitemployeeBO.iscompleted">
                                                                        </my-date-picker>
                                                                    </p>

                                                                </div>

                                                            </div>
                                                            <div class="row">
                                                                <div class="col-lg-9">
                                                                    <p>
                                                                        Aliens authorized to work must provide only one
                                                                        of the following document numbers to complete
                                                                        Form I-9:
                                                                        An Alien Registration Number/USCIS Number OR
                                                                        Form I-94 Admission Number OR Foreign Passport
                                                                        Number.
                                                                    </p>


                                                                </div>


                                                            </div>
                                                            <div class="row mb-2 mt-2">
                                                                <div class="col-lg-9">
                                                                    <div class="row mb-2">
                                                                        <div class="col-lg-6">
                                                                            <label> 1. Alien Registration Number/USCIS
                                                                                Number:</label>
                                                                        </div>
                                                                        <div class="col-lg-6">
                                                                            <input type="text" class="form-control"
                                                                                [(ngModel)]="employmentEligibilityBo.alien_Registration_Number_Uscis_Number"
                                                                                [disabled]="emitemployeeBO.iscompleted">
                                                                        </div>
                                                                    </div>
                                                                    <div class="row mb-2">
                                                                        <div class="col" style="text-align: center;">
                                                                            <b> OR</b>
                                                                        </div>
                                                                    </div>
                                                                    <div class="row mb-2">
                                                                        <div class="col-lg-6">
                                                                            <label> 2. Form I-94 Admission
                                                                                Number:</label>
                                                                        </div>
                                                                        <div class="col-lg-6">
                                                                            <input type="text" class="form-control"
                                                                                [(ngModel)]="employmentEligibilityBo.form_I_94Admission_Number"
                                                                                [disabled]="emitemployeeBO.iscompleted">
                                                                        </div>
                                                                    </div>
                                                                    <div class="row mb-2">
                                                                        <div class="col" style="text-align: center;">
                                                                            <b> OR </b>
                                                                        </div>
                                                                    </div>
                                                                    <div class="row mb-2">
                                                                        <div class="col-lg-6">
                                                                            <label> 3. Foreign Passport Number:</label>
                                                                        </div>
                                                                        <div class="col-lg-6">
                                                                            <input type="text" class="form-control"
                                                                                [(ngModel)]="employmentEligibilityBo.foreign_Passport_Number"
                                                                                [disabled]="emitemployeeBO.iscompleted">
                                                                        </div>





                                                                    </div>
                                                                    <div class="row mb-2 mt-2">
                                                                        <div class="col-lg-6">
                                                                            <label> County of Issuance:</label>
                                                                        </div>
                                                                        <div class="col-lg-6">
                                                                            <input type="text" class="form-control"
                                                                                [(ngModel)]="employmentEligibilityBo.countryofIssuance"
                                                                                [disabled]="emitemployeeBO.iscompleted">
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div class="col-lg-3">
                                                                    <div class="card">
                                                                        <div class="card-body">
                                                                            QR CODE
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div class="row mb-2 mt-5">
                                                                <div class="col-lg-7">
                                                                    <div class="row mt-2">
                                                                        <div class="col-lg-7">
                                                                            <button class="btn blue-btn"
                                                                                data-bs-toggle="modal"
                                                                                data-bs-target="#signature_employee"
                                                                                [disabled]="global.OnboardingLoginType != 'onboardLogin'">Signature
                                                                                of Employee</button>
                                                                            <!-- signOfEmployee -->
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div class="col-lg-5">
                                                                    <div class="row">
                                                                        <div class="col-lg-4">
                                                                            <label> Today's Date:
                                                                            </label>
                                                                        </div>
                                                                        <div class="col-lg-8" [formGroup]="dateForm">
                                                                            <my-date-picker class="w-100"
                                                                                placeholder="mm/dd/yyyy"
                                                                                [options]="myDatePickerOptions"
                                                                                [selDate]="employmentEligibilityBo.todaysDate"
                                                                                (inputFieldChanged)="newdates($event,'inputchange','date20')"
                                                                                (dateChanged)="newdates($event,'datechanged','date20')"
                                                                                formControlName="signDate9">
                                                                            </my-date-picker>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div class="row mb-2 mt-2">
                                                                <div class="col">
                                                                    <input
                                                                        *ngIf="employeesign!=''&& employeesign!=null "
                                                                        type="image" src="{{employeesign}}"
                                                                        class="form-control"
                                                                        style="width: 255px;height:120px;" width="48"
                                                                        height="48">
                                                                </div>
                                                            </div>
                                                            <br>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="row mb-2 mt-2 col-12 p-0">
                                                <div class="col p-0">
                                                    <div class="card">
                                                        <div class="card-body">
                                                            <div class="row">
                                                                <div class="col">
                                                                    <p>
                                                                        <b>
                                                                            Preparer and/or Translator Certification
                                                                            (check one):
                                                                        </b>
                                                                    </p>
                                                                </div>
                                                            </div>
                                                            <div class="row ms-2">
                                                                <div class="col-lg-6">
                                                                    <p>
                                                                        <!--  -->
                                                                        <input type="radio" value="true"
                                                                            name="translatorr" id="one1"
                                                                            [(ngModel)]="employmentEligibilityBo.did_not_use_preparerortranslator">
                                                                        <!-- [(ngModel)]="documentBO.employement_Eligibility_Verification.empPreparerORTranslator.i_did_not_use" -->
                                                                        I did not use a preparer or translator.
                                                                    </p>
                                                                </div>
                                                                <div class="col-lg-6">
                                                                    <p>
                                                                        <!--  -->
                                                                        <input type="radio" id="one2" value="false"
                                                                            name="translatorr"
                                                                            [(ngModel)]="employmentEligibilityBo.did_not_use_preparerortranslator">

                                                                        A preparer(s) and/or translator(s) assisted the
                                                                        employee in completing Section 1.
                                                                    </p>
                                                                </div>
                                                            </div>
                                                            <div class="row">
                                                                <div class="col">
                                                                    <p>
                                                                        (Fields below must be completed and signed when
                                                                        preparers and/or translators assist an employee
                                                                        in completing Section 1.)
                                                                    </p>
                                                                </div>
                                                            </div>
                                                            <div class="row">
                                                                <div class="col">
                                                                    <p>
                                                                        <b>
                                                                            I attest, under penalty of perjury, that I
                                                                            have assisted in the completion of Section 1
                                                                            of this form and that to the best of my
                                                                            knowledge the information is true and
                                                                            correct.
                                                                        </b>
                                                                    </p>

                                                                </div>

                                                            </div>
                                                            <div class="row mb-2">
                                                                <div class="col-lg-7">
                                                                    <div class="row mt-2">
                                                                        <div class="col-lg-7">
                                                                            <button class="btn blue-btn"
                                                                                data-bs-toggle="modal"
                                                                                data-bs-target="#traslatorModal"
                                                                                [disabled]="global.OnboardingLoginType != 'onboardLogin'">Signature
                                                                                of Preparer or Translator</button>
                                                                            <!-- signOfPreparerorTraslator -->
                                                                        </div>


                                                                    </div>

                                                                </div>
                                                                <div class="col-lg-5">
                                                                    <div class="row">
                                                                        <div class="col-lg-4" [formGroup]="dateForm">
                                                                            <label> Today's Date:</label>
                                                                            <my-date-picker class="w-100"
                                                                                placeholder="mm/dd/yyyy"
                                                                                [options]="myDatePickerOptions"
                                                                                [selDate]="employmentEligibilityBo.signOfPreparerorTraslatorDate"
                                                                                (inputFieldChanged)="newdates($event,'inputchange','date21')"
                                                                                (dateChanged)="newdates($event,'datechanged','date21')"
                                                                                formControlName="signDate10"
                                                                                [disabled]="emitemployeeBO.iscompleted">

                                                                            </my-date-picker>
                                                                        </div>


                                                                    </div>
                                                                </div>


                                                            </div>
                                                            <div class="row mb-2 mt-2">
                                                                <div class="col">
                                                                    <input
                                                                        *ngIf="translatorsign!=''&& translatorsign!=null "
                                                                        type="image" src="{{translatorsign}}"
                                                                        class="form-control"
                                                                        style="width: 255px;height:120px;" width="48"
                                                                        height="48">

                                                                </div>

                                                            </div>
                                                            <div class="row mb-2 mt-2">
                                                                <div class="col-lg-6">
                                                                    <label>Last Name (Family Name)</label>
                                                                    <input type="text" class="form-control"
                                                                        [(ngModel)]="employmentEligibilityBo.preparerLastName"
                                                                        [disabled]="emitemployeeBO.iscompleted">

                                                                </div>
                                                                <div class="col-lg-6">
                                                                    <label>First Name (Given Name)</label>
                                                                    <input type="text" class="form-control"
                                                                        [(ngModel)]="employmentEligibilityBo.preparerFirstName"
                                                                        [disabled]="emitemployeeBO.iscompleted">

                                                                </div>

                                                            </div>
                                                            <div class="row mb-2 mt-2">
                                                                <div class="col-lg-5">
                                                                    <label>Address (Street Number and Name)</label>
                                                                    <textarea class="form-control"
                                                                        [(ngModel)]="employmentEligibilityBo.preparerAddress"
                                                                        [disabled]="emitemployeeBO.iscompleted"></textarea>

                                                                </div>
                                                                <div class="col-lg-4">
                                                                    <label>City or Town</label>
                                                                    <input type="text" class="form-control"
                                                                        [(ngModel)]="employmentEligibilityBo.preparerCity"
                                                                        [disabled]="emitemployeeBO.iscompleted">

                                                                </div>
                                                                <div class="col-lg-3">
                                                                    <label>State</label>
                                                                    <ng-select [items]="stateList" class="width25"
                                                                        [(ngModel)]="employmentEligibilityBo.preparerState"
                                                                        [searchable]="true" [clearable]="true"
                                                                        bindLabel="name" bindValue="abbreviation"
                                                                        [disabled]="emitemployeeBO.iscompleted">
                                                                    </ng-select>
                                                                </div>
                                                                <div class="col-lg-3">
                                                                    <label>Zip code</label>
                                                                    <input (ngModelChange)="validZip() " type="text"
                                                                        [(ngModel)]="employmentEligibilityBo.preparerZip"
                                                                        minlength="5" maxlength="11"
                                                                        (keypress)="keyPress($event)"
                                                                        class="form-control"
                                                                        [disabled]="emitemployeeBO.iscompleted">
                                                                    <span class="ssn1" *ngIf="zip4">{{ziperr}}</span>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="row mb-2 mt-2 p-0">
                                                <div class="col p-0">
                                                    <div class="card">
                                                        <div class="card-body">
                                                            <div class="row">
                                                                <div class="col">
                                                                    <p>
                                                                        <b>
                                                                            Section 2. Employer or Authorized
                                                                            Representative Review and Verification
                                                                        </b>
                                                                    </p>
                                                                </div>
                                                            </div>
                                                            <div class="row">
                                                                <div class="col">
                                                                    <p>
                                                                        (Employers or their authorized representative
                                                                        must complete and sign Section 2 within 3
                                                                        business days of the employee's first day of
                                                                        employment. You
                                                                        must physically examine one document from List A
                                                                        OR a combination of one document from List B and
                                                                        one document from List C as listed on the "Lists
                                                                        of Acceptable Documents.")
                                                                    </p>

                                                                </div>
                                                            </div>
                                                            <div class="row">
                                                                <div class="col">
                                                                    <h6>Employee Info from Section 1</h6>
                                                                </div>
                                                            </div>
                                                            <div class="row">
                                                                <div class="col-lg-3">
                                                                    <label>Last Name (Family Name) </label>
                                                                    <input type="text" class="form-control"
                                                                        [(ngModel)]="employmentEligibilityBo.employeeSection2LastName"
                                                                        [disabled]="emitemployeeBO.iscompleted">
                                                                </div>
                                                                <div class="col-lg-3">
                                                                    <label>First Name (Given Name) </label>
                                                                    <input type="text" class="form-control"
                                                                        [(ngModel)]="employmentEligibilityBo.employeeSection2FirstName"
                                                                        [disabled]="emitemployeeBO.iscompleted">

                                                                </div>
                                                                <div class="col-lg-3">
                                                                    <label>Middle Initial</label>
                                                                    <input type="text" class="form-control"
                                                                        [(ngModel)]="employmentEligibilityBo.employeeSection2MiddleName"
                                                                        [disabled]="emitemployeeBO.iscompleted">

                                                                </div>
                                                                <div class="col-lg-3">
                                                                    <label>Citizenship/Immigration Status</label>
                                                                    <input type="text" class="form-control"
                                                                        [(ngModel)]="employmentEligibilityBo.employeeSection2citizenship"
                                                                        [disabled]="emitemployeeBO.iscompleted">
                                                                    <!--  -->
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="row mb-2 mt-2 p-0">
                                                <div class="col p-0">
                                                    <div class="card">
                                                        <div class="card-body">
                                                            <div class="row">
                                                                <div class="col-lg-4">
                                                                    <b> <label>List A</label></b>
                                                                </div>
                                                                <div class="col-lg-8">
                                                                    <div class="row">
                                                                        <div class="col-lg-2">
                                                                            <b>
                                                                                <label>OR</label>
                                                                            </b>
                                                                        </div>
                                                                        <div class="col-lg-4">
                                                                            <b>
                                                                                <label>List B</label>
                                                                            </b>
                                                                        </div>
                                                                        <div class="col-lg-2">
                                                                            <b>
                                                                                <label>AND</label>
                                                                            </b>
                                                                        </div>
                                                                        <div class="col-lg-4">
                                                                            <b> <label>List C</label> </b>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div class="row">
                                                                <div class="col-lg-4">
                                                                    <label>Identity and Employment Authorization</label>
                                                                </div>
                                                                <div class="col-lg-4">
                                                                    <label>Identity</label>

                                                                </div>
                                                                <div class="col-lg-4">
                                                                    <label>Employment Authorization</label>
                                                                </div>
                                                            </div>
                                                            <div class="row">
                                                                <div class="col-lg-4">
                                                                    <label>Document Title</label>
                                                                    <input type="text" class="form-control"
                                                                        [(ngModel)]="employmentEligibilityBo.documentTitle"
                                                                        [disabled]="emitemployeeBO.iscompleted">

                                                                </div>
                                                                <div class="col-lg-8">
                                                                    <div class="row">
                                                                        <div class="col-lg-6">
                                                                            <label>Document Title</label>
                                                                            <input type="text" class="form-control"
                                                                                [(ngModel)]="employmentEligibilityBo.documentTitle1"
                                                                                [disabled]="emitemployeeBO.iscompleted">

                                                                        </div>
                                                                        <div class="col-lg-6">
                                                                            <label>Document Title</label>
                                                                            <input type="text" class="form-control"
                                                                                [(ngModel)]="employmentEligibilityBo.documentTitle2"
                                                                                [disabled]="emitemployeeBO.iscompleted">

                                                                        </div>

                                                                    </div>

                                                                </div>

                                                            </div>
                                                            <div class="row">
                                                                <div class="col-lg-4">
                                                                    <label>Issuing Authority</label>
                                                                    <input type="text" class="form-control"
                                                                        [(ngModel)]="employmentEligibilityBo.issuingAuthority"
                                                                        [disabled]="emitemployeeBO.iscompleted">

                                                                </div>
                                                                <div class="col-lg-8">
                                                                    <div class="row">
                                                                        <div class="col-lg-6">
                                                                            <label>Issuing Authority</label>
                                                                            <input type="text" class="form-control"
                                                                                [(ngModel)]="employmentEligibilityBo.issuingAuthority1"
                                                                                [disabled]="emitemployeeBO.iscompleted">

                                                                        </div>
                                                                        <div class="col-lg-6">
                                                                            <label>Issuing Authority</label>
                                                                            <input type="text" class="form-control"
                                                                                [(ngModel)]="employmentEligibilityBo.issuingAuthority2"
                                                                                [disabled]="emitemployeeBO.iscompleted">

                                                                        </div>

                                                                    </div>

                                                                </div>

                                                            </div>
                                                            <div class=" d-flex">
                                                                <div class="col-lg-4">
                                                                    <label>Document Number</label>
                                                                    <input type="text" min="0" class="form-control"
                                                                        [(ngModel)]="employmentEligibilityBo.documentNumber"
                                                                        [disabled]="emitemployeeBO.iscompleted">

                                                                </div>

                                                                <div class="col-lg-8">
                                                                    <div class="row">
                                                                        <div class="col-lg-6">
                                                                            <label>Document Number</label>
                                                                            <input type="text" min="0"
                                                                                class="form-control"
                                                                                [(ngModel)]="employmentEligibilityBo.documentNumber1"
                                                                                [disabled]="emitemployeeBO.iscompleted">

                                                                        </div>
                                                                        <div class="col-lg-6">
                                                                            <label>Document Number</label>
                                                                            <input type="text" min="0"
                                                                                class="form-control"
                                                                                [(ngModel)]="employmentEligibilityBo.documentNumber2"
                                                                                [disabled]="emitemployeeBO.iscompleted">

                                                                        </div>

                                                                    </div>

                                                                </div>

                                                            </div>
                                                            <div class="row">
                                                                <div class="col-lg-4 mb-2"
                                                                    style="border-bottom:1px solid #848484">
                                                                    <label>Expiration Date</label>
                                                                    <my-date-picker class="w-100"
                                                                        [selDate]="employmentEligibilityBo.expirationDate"
                                                                        (inputFieldChanged)="newdates($event,'inputchange','date22')"
                                                                        (dateChanged)="newdates($event,'datechanged','date22')"
                                                                        [options]="myDatePickerOptions"
                                                                        placeholder="mm/dd/yyyy"
                                                                        [disabled]="emitemployeeBO.iscompleted">
                                                                    </my-date-picker>

                                                                </div>
                                                                <div class="col-lg-8">
                                                                    <div class="row">
                                                                        <div class="col-lg-6">
                                                                            <label>Expiration Date</label>
                                                                            <my-date-picker class="w-100"
                                                                                [selDate]="employmentEligibilityBo.expirationDate1"
                                                                                (inputFieldChanged)="newdates($event,'inputchange','date23')"
                                                                                (dateChanged)="newdates($event,'datechanged','date23')"
                                                                                [options]="myDatePickerOptions"
                                                                                placeholder="mm/dd/yyyy"
                                                                                [disabled]="emitemployeeBO.iscompleted">
                                                                            </my-date-picker>

                                                                        </div>
                                                                        <div class="col-lg-6">
                                                                            <label>Expiration Date</label>
                                                                            <my-date-picker class="w-100"
                                                                                [selDate]="employmentEligibilityBo.expirationDate2"
                                                                                (inputFieldChanged)="newdates($event,'inputchange','date24')"
                                                                                (dateChanged)="newdates($event,'datechanged','date24')"
                                                                                [options]="myDatePickerOptions"
                                                                                placeholder="mm/dd/yyyy"
                                                                                [disabled]="emitemployeeBO.iscompleted">
                                                                            </my-date-picker>

                                                                        </div>

                                                                    </div>

                                                                </div>

                                                            </div>

                                                            <div class="row mb-2 mt-2">
                                                                <div class="col-lg-4">
                                                                    <div class="row">
                                                                        <div class="col-lg-12">
                                                                            <label>Document Title</label>
                                                                            <input type="text" class="form-control"
                                                                                [(ngModel)]="employmentEligibilityBo.documentTitle3"
                                                                                [disabled]="emitemployeeBO.iscompleted">

                                                                        </div>

                                                                    </div>
                                                                    <div class="row">
                                                                        <div class="col-lg-12">
                                                                            <label>Issuing Authority</label>
                                                                            <input type="text" class="form-control"
                                                                                [(ngModel)]="employmentEligibilityBo.issuingAuthority3"
                                                                                [disabled]="emitemployeeBO.iscompleted">

                                                                        </div>

                                                                    </div>
                                                                    <div class="row">
                                                                        <div class="col-lg-12">
                                                                            <label>Document Number</label>
                                                                            <input type="text" class="form-control"
                                                                                [(ngModel)]="employmentEligibilityBo.documentNumber3"
                                                                                [disabled]="emitemployeeBO.iscompleted">

                                                                        </div>

                                                                    </div>
                                                                    <div class="row">
                                                                        <div class="col-lg-12 mb-2"
                                                                            style="border-bottom:1px solid #848484">
                                                                            <label>Expiration Date</label>
                                                                            <my-date-picker class="w-100"
                                                                                [selDate]="employmentEligibilityBo.expirationDate3"
                                                                                (inputFieldChanged)="newdates($event,'inputchange','date25')"
                                                                                (dateChanged)="newdates($event,'datechanged','date25')"
                                                                                [options]="myDatePickerOptions"
                                                                                placeholder="mm/dd/yyyy"
                                                                                [disabled]="emitemployeeBO.iscompleted">
                                                                            </my-date-picker>

                                                                        </div>

                                                                    </div>
                                                                    <!-- <hr> -->
                                                                    <div class="row">
                                                                        <div class="col-lg-12">
                                                                            <label>Document Title</label>
                                                                            <input type="text" class="form-control"
                                                                                [(ngModel)]="employmentEligibilityBo.documentTitle4"
                                                                                [disabled]="emitemployeeBO.iscompleted">
                                                                        </div>
                                                                    </div>
                                                                    <div class="row">
                                                                        <div class="col-lg-12">
                                                                            <label>Issuing Authority</label>
                                                                            <input type="text" class="form-control"
                                                                                [(ngModel)]="employmentEligibilityBo.issuingAuthority4"
                                                                                [disabled]="emitemployeeBO.iscompleted">
                                                                        </div>
                                                                    </div>
                                                                    <div class="row">
                                                                        <div class="col-lg-12">
                                                                            <label>Document Number</label>
                                                                            <input type="text" class="form-control"
                                                                                [(ngModel)]="employmentEligibilityBo.documentNumber4"
                                                                                [disabled]="emitemployeeBO.iscompleted">
                                                                        </div>
                                                                    </div>
                                                                    <div class="row">
                                                                        <div class="col-lg-12">
                                                                            <label>Expiration Date</label>
                                                                            <my-date-picker class="w-100"
                                                                                [selDate]="employmentEligibilityBo.expirationDate4"
                                                                                (inputFieldChanged)="newdates($event,'inputchange','date26')"
                                                                                (dateChanged)="newdates($event,'datechanged','date26')"
                                                                                [options]="myDatePickerOptions"
                                                                                placeholder="mm/dd/yyyy"
                                                                                [disabled]="emitemployeeBO.iscompleted">
                                                                            </my-date-picker>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div class="col-lg-8">
                                                                    <div class="card">
                                                                        <div class="card-body">
                                                                            <table class="table">
                                                                                <tr>
                                                                                    <td rowspan="6">
                                                                                        <textarea rows="30" cols="25"
                                                                                            [(ngModel)]="employmentEligibilityBo.additionalInfo"
                                                                                            class="form-control"
                                                                                            placeholder="Additional Information"
                                                                                            [disabled]="emitemployeeBO.iscompleted"></textarea>

                                                                                    </td>
                                                                                    <td rowspan="6">
                                                                                        <div class="card">
                                                                                            <div class="card-body">
                                                                                                <p>QR CODE -sections 2 &
                                                                                                    3
                                                                                                    <br>
                                                                                                    Do not write in this
                                                                                                    space
                                                                                                </p>
                                                                                            </div>
                                                                                        </div>
                                                                                    </td>
                                                                                </tr>
                                                                            </table>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div class="row mb-2 mt-2">
                                                                <div class="col">
                                                                    <p>
                                                                        <b>
                                                                            Certification: I attest, under penalty of
                                                                            perjury, that (1) I have examined the
                                                                            document(s) presented by the above-named
                                                                            employee,
                                                                            (2) the above-listed document(s) appear to
                                                                            be genuine and to relate to the employee
                                                                            named, and (3) to the best of my knowledge
                                                                            the
                                                                            employee is authorized to work in the United
                                                                            States.
                                                                        </b>
                                                                    </p>

                                                                </div>

                                                            </div>
                                                            <div class="row mb-2 mt-2">
                                                                <div class="col-lg-5">
                                                                    <b><label>The employee's first day of employment
                                                                            (mm/dd/yyyy):</label></b>
                                                                </div>
                                                                <div class="col-lg-3">
                                                                    <my-date-picker class="w-100"
                                                                        [selDate]="employmentEligibilityBo.employeesFirstdayEmployment"
                                                                        (inputFieldChanged)="newdates($event,'inputchange','date27')"
                                                                        (dateChanged)="newdates($event,'datechanged','date27')"
                                                                        [options]="myDatePickerOptions"
                                                                        placeholder="mm/dd/yyyy"
                                                                        [disabled]="emitemployeeBO.iscompleted">
                                                                    </my-date-picker>
                                                                </div>
                                                                <div class="2">
                                                                    (See instructions for exemptions)
                                                                </div>
                                                            </div>
                                                            <div class="row mb-2 mt-5">
                                                                <div class="col-lg-7">
                                                                    <div class="row mt-2">
                                                                        <div class="col-lg-7">
                                                                            <button class="btn blue-btn"
                                                                                data-bs-toggle="modal"
                                                                                data-bs-target="#authorizedModal"
                                                                                [disabled]="global.OnboardingLoginType != 'onboardLogin'">Signature
                                                                                of Employer or Authorized
                                                                                Representative</button>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div class="col-lg-5">
                                                                    <div class="row">
                                                                        <div class="col-lg-4">
                                                                            <label> Today's Date:
                                                                            </label>
                                                                        </div>
                                                                        <div class="col-lg-8" [formGroup]="dateForm">
                                                                            <my-date-picker class="w-100"
                                                                                placeholder="mm/dd/yyyy"
                                                                                [options]="myDatePickerOptions"
                                                                                [selDate]="employmentEligibilityBo.employerSignDate1"
                                                                                (inputFieldChanged)="newdates($event,'inputchange','date28')"
                                                                                (dateChanged)="newdates($event,'datechanged','date28')"
                                                                                formControlName="signDate11"
                                                                                [disabled]="emitemployeeBO.iscompleted">
                                                                            </my-date-picker>

                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div class="row mb-2 mt-2">
                                                                <div class="col">
                                                                    <input
                                                                        *ngIf="authorizedsign!=''&& authorizedsign!=null "
                                                                        type="image" src="{{authorizedsign}}"
                                                                        class="form-control"
                                                                        style="width: 255px;height:120px;" width="48"
                                                                        height="48">

                                                                </div>
                                                            </div>
                                                            <div class="row mb-2 mt-2">
                                                                <div class="col-lg-3">
                                                                    <label>Title of Employer or Authorized
                                                                        Representative</label>
                                                                    <ng-select [items]="employerList" bindValue="id"
                                                                        bindLabel="lovName"
                                                                        [(ngModel)]="employmentEligibilityBo.employerTitle"
                                                                        [disabled]="emitemployeeBO.iscompleted">
                                                                    </ng-select>
                                                                </div>
                                                                <div class="col-lg-3">
                                                                    <label>Last Name of Employer or Authorized
                                                                        Representative</label>
                                                                    <input type="text" class="form-control"
                                                                        [(ngModel)]="employmentEligibilityBo.employerLastName"
                                                                        [disabled]="emitemployeeBO.iscompleted">
                                                                </div>
                                                                <div class="col-lg-3">
                                                                    <label>First Name of Employer or Authorized
                                                                        Representative</label>
                                                                    <input type="text" class="form-control"
                                                                        [(ngModel)]="employmentEligibilityBo.employerFirstName"
                                                                        [disabled]="emitemployeeBO.iscompleted">
                                                                    <!-- [(ngModel)]="employmentEligibilityBo.employerFirstName" disabled> -->

                                                                </div>
                                                                <div class="col-lg-3 mt-lg-4">
                                                                    <label>Employer's Business or Organization
                                                                        Name</label>
                                                                    <input type="text" class="form-control"
                                                                        [(ngModel)]="employmentEligibilityBo.employersOrgName"
                                                                        [disabled]="emitemployeeBO.iscompleted">
                                                                </div>
                                                            </div>
                                                            <div class="row mb-2 mt-2">
                                                                <div class="col-lg-4">
                                                                    <label>Employer's Business or Organization
                                                                        Address</label>
                                                                    <textarea class="form-control"
                                                                        [(ngModel)]="employmentEligibilityBo.employersAddress"
                                                                        [disabled]="emitemployeeBO.iscompleted"></textarea>
                                                                </div>
                                                                <div class="col-lg-3">
                                                                    <label>City or Town</label>
                                                                    <input type="text" class="form-control"
                                                                        [(ngModel)]="employmentEligibilityBo.employersCity"
                                                                        [disabled]="emitemployeeBO.iscompleted">
                                                                </div>
                                                                <div class="col-lg-3">
                                                                    <label>State</label>
                                                                    <ng-select [items]="stateList" class="width25"
                                                                        [(ngModel)]="employmentEligibilityBo.employersState"
                                                                        [searchable]="true" [clearable]="true"
                                                                        bindLabel="name" bindValue="abbreviation"
                                                                        [disabled]="emitemployeeBO.iscompleted">
                                                                    </ng-select>
                                                                </div>
                                                                <div class="col-lg-2">
                                                                    <label>Zip Code</label>
                                                                    <input (ngModelChange)="validZip() " type="text"
                                                                        [(ngModel)]="employmentEligibilityBo.employersZip"
                                                                        minlength="5" maxlength="11"
                                                                        (keypress)="keyPress($event)"
                                                                        class="form-control"
                                                                        [disabled]="emitemployeeBO.iscompleted">
                                                                    <span class="ssn1" *ngIf="zip5">{{ziperr}}</span>
                                                                </div>
                                                            </div>
                                                            <br>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="row mb-2 mt-2 p-0">
                                                <div class="col p-0">
                                                    <div class="card">
                                                        <div class="card-body">
                                                            <p> <b>Section 3. Reverification and Rehires</b> (To be
                                                                completed and signed by employer or authorized
                                                                representative.)</p>
                                                            <div class="row">
                                                                <div class="col-lg-8">
                                                                    <b>A.</b> <label>New Name (if applicable)</label>

                                                                </div>
                                                                <div class="col-lg-4">
                                                                    <b>B.</b> <label>Date of Rehire (if
                                                                        applicable)</label>
                                                                </div>
                                                            </div>

                                                            <div class="row">
                                                                <div class="col-lg-8">
                                                                    <div class="row">
                                                                        <div class="col-lg-4">
                                                                            <label>Last Name</label>
                                                                            <input type="text" class="form-control"
                                                                                [(ngModel)]="employmentEligibilityBo.reverificationLastName"
                                                                                [disabled]="emitemployeeBO.iscompleted">
                                                                        </div>
                                                                        <div class="col-lg-4">
                                                                            <label>First Name</label>
                                                                            <input type="text" class="form-control"
                                                                                [(ngModel)]="employmentEligibilityBo.reverificationFirstName"
                                                                                [disabled]="emitemployeeBO.iscompleted">
                                                                        </div>
                                                                        <div class="col-lg-4">
                                                                            <label>Middle Name</label>
                                                                            <input type="text" class="form-control"
                                                                                [(ngModel)]="employmentEligibilityBo.reverificationMiddleName"
                                                                                [disabled]="emitemployeeBO.iscompleted">
                                                                        </div>
                                                                    </div>
                                                                </div>

                                                                <div class="col-lg-4">
                                                                    <label>Date</label>
                                                                    <my-date-picker class="w-100"
                                                                        [options]="myDatePickerOptions"
                                                                        [selDate]="employmentEligibilityBo.reverificationDate"
                                                                        (inputFieldChanged)="newdates($event,'inputchange','date29')"
                                                                        (dateChanged)="newdates($event,'datechanged','date29')"
                                                                        placeholder="mm/dd/yyyy"
                                                                        [disabled]="emitemployeeBO.iscompleted">
                                                                    </my-date-picker>
                                                                </div>

                                                                <div class="row ms-1">
                                                                    <div class="col">
                                                                        <p><b>C.</b>If the employee's previous grant of
                                                                            employment authorization has expired,
                                                                            provide
                                                                            the information for the document or receipt
                                                                            that
                                                                            establishes
                                                                            continuing employment authorization in the
                                                                            space
                                                                            provided below.</p>
                                                                    </div>
                                                                </div>
                                                                <div class="row ms-1">
                                                                    <div class="col-lg-3">
                                                                        <label>Document Title</label>
                                                                        <input type="text" class="form-control"
                                                                            [disabled]="emitemployeeBO.iscompleted"
                                                                            [(ngModel)]="employmentEligibilityBo.employerDocumentTitle">

                                                                    </div>
                                                                    <div class="col-lg-4">
                                                                        <label>Document Number</label>
                                                                        <input type="text" class="form-control"
                                                                            [disabled]="emitemployeeBO.iscompleted"
                                                                            [(ngModel)]="employmentEligibilityBo.documentNum">

                                                                    </div>
                                                                    <div class="col-lg-5">
                                                                        <label>Expiration Date (if any)
                                                                            (mm/dd/yyyy)</label>

                                                                        <my-date-picker class="w-100"
                                                                            [selDate]="employmentEligibilityBo.documentExpiryDate"
                                                                            [options]="myDatePickerOptions"
                                                                            (inputFieldChanged)="newdates($event,'inputchange','date30')"
                                                                            (dateChanged)="newdates($event,'datechanged','date30')"
                                                                            placeholder="mm/dd/yyyy">
                                                                        </my-date-picker>
                                                                    </div>
                                                                </div>
                                                                <div class="row ms-1">
                                                                    <div class="col">
                                                                        <p><b>I attest, under penalty of perjury, that
                                                                                to
                                                                                the best of my knowledge, this employee
                                                                                is
                                                                                authorized to work in the United States,
                                                                                and
                                                                                if
                                                                                the employee presented document(s), the
                                                                                document(s) I have examined appear to be
                                                                                genuine and to relate to the
                                                                                individual.</b>
                                                                        </p>
                                                                    </div>
                                                                </div>
                                                                <div class="row col-12 mb-2 mt-5">
                                                                    <div class="col-lg-6">
                                                                        <div class="row mt-2">
                                                                            <div class="col-lg-12">
                                                                                <button class="btn blue-btn"
                                                                                    data-bs-toggle="modal"
                                                                                    data-bs-target="#authorizedRepModal"
                                                                                    [disabled]="global.OnboardingLoginType != 'onboardLogin'">Signature
                                                                                    of Employer or Authorized
                                                                                    Representative</button>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                    <div class="col-lg-5">
                                                                        <div class="row">
                                                                            <div class="col-lg-5 mt-1">
                                                                                <label> Today's Date:</label>
                                                                            </div>
                                                                            <div class="col-lg-7"
                                                                                [formGroup]="dateForm">
                                                                                <my-date-picker
                                                                                    [options]="myDatePickerOptions"
                                                                                    placeholder="mm/dd/yyyy"
                                                                                    formControlName="signDate12"
                                                                                    [selDate]="employmentEligibilityBo.employerSignDate3"
                                                                                    (inputFieldChanged)="newdates($event,'inputchange','date31')"
                                                                                    (dateChanged)="newdates($event,'datechanged','date31')">

                                                                                </my-date-picker>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div class="row col-12">
                                                                    <div class="col-lg-5 mb-2 mt-2">
                                                                        <div class="col">
                                                                            <img *ngIf="authorizedrepsign!=''&& authorizedrepsign!=null "
                                                                                src="{{authorizedrepsign}}"
                                                                                class="form-control"
                                                                                style="width: 255px;height:120px;"
                                                                                width="48" height="48">

                                                                        </div>

                                                                    </div>
                                                                    <div class="col-lg-5">
                                                                        <label>Name of Employer or Authorized
                                                                            Representative</label>
                                                                        <input type="text" class="form-control"
                                                                            [(ngModel)]="employmentEligibilityBo.nameofEmployer"
                                                                            [disabled]="emitemployeeBO.iscompleted">
                                                                        <!-- [(ngModel)]="employmentEligibilityBo.employerName" -->
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="row mb-2 mt-2">
                                                    <div class="col p-0">
                                                        <div class="card">
                                                            <div class="card-body">

                                                                <h4 style="text-align: center;">LISTS OF ACCEPTABLE
                                                                    DOCUMENTS
                                                                    All documents must be UNEXPIRED
                                                                </h4>
                                                                <p style="text-align: center;">Employees may present one
                                                                    selection from List A

                                                                    or a combination of one selection from List B and
                                                                    one
                                                                    selection from List C.</p>

                                                                <div class="row">
                                                                    <div class="col-lg-4">
                                                                        <p><b>LIST A
                                                                                Documents that Establish
                                                                                Both Identity and
                                                                                Employment Authorization OR</b></p>
                                                                    </div>
                                                                    <div class="col-lg-4">
                                                                        <p>
                                                                            <b>LIST B
                                                                                Documents that Establish
                                                                                Identity AND</b>
                                                                        </p>

                                                                    </div>
                                                                    <div class="col-lg-4">
                                                                        <p>
                                                                            <b>
                                                                                LIST C
                                                                                Documents that Establish
                                                                                Employment Authorization
                                                                            </b>
                                                                        </p>
                                                                    </div>


                                                                </div>
                                                                <div class="row">
                                                                    <div class="col-lg-4">
                                                                        <ol type="1" class="ms-2">
                                                                            <li>
                                                                                U.S. Passport or U.S. Passport Card
                                                                            </li>
                                                                            <li>
                                                                                Permanent Resident Card or Alien
                                                                                Registration Receipt Card (Form I-551)
                                                                            </li>
                                                                            <li>
                                                                                Foreign passport that contains a
                                                                                temporary I-551 stamp or temporary

                                                                                I-551 printed notation on a machine-
                                                                                readable immigrant visa
                                                                            </li>
                                                                            <li>
                                                                                Employment Authorization Document
                                                                                that contains a photograph (Form
                                                                                I-766)
                                                                            </li>
                                                                            <li>

                                                                                For a nonimmigrant alien authorized
                                                                                to work for a specific employer
                                                                                because of his or her status:
                                                                                <ol type="a" class="ms-4">
                                                                                    <li>Foreign passport; and</li>
                                                                                    <li>Form I-94 or Form I-94A that has
                                                                                        the following:</li>
                                                                                    <ol type="1" class="ms-2">
                                                                                        <li>The same name as the
                                                                                            passport;
                                                                                            and</li>
                                                                                        <li>
                                                                                            An endorsement of the
                                                                                            alien's
                                                                                            nonimmigrant status as long
                                                                                            as
                                                                                            that period of endorsement
                                                                                            has
                                                                                            not yet expired and the
                                                                                            proposed employment is not
                                                                                            in
                                                                                            conflict with any
                                                                                            restrictions
                                                                                            or
                                                                                            limitations identified on
                                                                                            the
                                                                                            form.
                                                                                        </li>

                                                                                    </ol>
                                                                                </ol>
                                                                            </li>
                                                                            <li>
                                                                                Passport from the Federated States
                                                                                of Micronesia (FSM) or the Republic
                                                                                of the Marshall Islands (RMI) with
                                                                                Form I-94 or Form I-94A indicating
                                                                                nonimmigrant admission under the
                                                                                Compact of Free Association Between
                                                                                the United States and the FSM or RMI
                                                                            </li>


                                                                        </ol>

                                                                    </div>
                                                                    <div class="col-lg-4">
                                                                        <ol type="1" class="ms-2">
                                                                            <li>
                                                                                Driver's license or ID card issued by a
                                                                                State or outlying possession of the
                                                                                United States provided it contains a
                                                                                photograph or information such as
                                                                                name, date of birth, gender, height, eye
                                                                                color, and address
                                                                            </li>
                                                                            <li>
                                                                                ID card issued by federal, state or
                                                                                local
                                                                                government agencies or entities,
                                                                                provided it contains a photograph or
                                                                                information such as name, date of birth,
                                                                                gender, height, eye color, and address
                                                                            </li>
                                                                            <li>
                                                                                School ID card with a photograph
                                                                            </li>
                                                                            <li>
                                                                                Voter's registration card
                                                                            </li>
                                                                            <li>
                                                                                U.S. Military card or draft record
                                                                            </li>
                                                                            <li>
                                                                                Military dependent's ID card
                                                                            </li>
                                                                            <li>
                                                                                U.S. Coast Guard Merchant Mariner
                                                                                Card
                                                                            </li>
                                                                            <li>
                                                                                Native American tribal document
                                                                            </li>
                                                                            <li>
                                                                                Driver's license issued by a Canadian
                                                                                government authority
                                                                            </li>
                                                                            <b>
                                                                                For persons under age 18 who are
                                                                                unable to present a document
                                                                                listed above:
                                                                            </b>
                                                                            <li>
                                                                                School record or report card
                                                                            </li>
                                                                            <li>
                                                                                Clinic, doctor, or hospital record
                                                                            </li>
                                                                            <li>
                                                                                Day-care or nursery school record
                                                                            </li>

                                                                        </ol>


                                                                    </div>
                                                                    <div class="col-lg-4">
                                                                        <ol type="1">
                                                                            <li>
                                                                                A Social Security Account Number
                                                                                card, unless the card includes one of
                                                                                the following restrictions:
                                                                            </li>
                                                                            <li>
                                                                                Certification of report of birth issued
                                                                                by the Department of State (Forms
                                                                                DS-1350, FS-545, FS-240)
                                                                            </li>
                                                                            <li>
                                                                                Original or certified copy of birth
                                                                                certificate issued by a State,
                                                                                county, municipal authority, or
                                                                                territory of the United States
                                                                                bearing an official seal
                                                                            </li>
                                                                            <li>
                                                                                Native American tribal document
                                                                            </li>
                                                                            <li>
                                                                                U.S. Citizen ID Card (Form I-197)
                                                                            </li>
                                                                            <li>
                                                                                Identification Card for Use of
                                                                                Resident Citizen in the United
                                                                                States (Form I-179)
                                                                            </li>
                                                                            <li>
                                                                                Employment authorization
                                                                                document issued by the
                                                                                Department of Homeland Security
                                                                            </li>

                                                                        </ol>

                                                                    </div>

                                                                </div>
                                                                <div class="row">
                                                                    <div class="col">
                                                                        <p style="text-align: center;">
                                                                            <b>
                                                                                Examples of many of these documents
                                                                                appear
                                                                                in the Handbook for Employers
                                                                                (M-274).<br>

                                                                                Refer to the instructions for more
                                                                                information about acceptable receipts.
                                                                            </b>
                                                                        </p>

                                                                    </div>

                                                                </div>




                                                            </div>

                                                        </div>

                                                    </div>

                                                </div>

                                            </div>
                                        </div>
                                        <div class="col-12  mb-3 mt-1 ">



                                            <div class="text-end">
                                                <button class="btn" [disabled]="emitemployeeBO?.iscompleted || isSaveorUpdateBoolean"
                                                    *ngIf="global.OnboardingLoginType !='onboardLogin' && !emitemployeeBO.print"
                                                    (click)="saveAgreement()">Save</button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!--Employee’s Withholding Certificate-->
            <div class="row mb-2 mt-2">
                <div class="col p-0">
                    <div class="card" style=" overflow-x:hidden;  height:auto;">
                        <div class="col mt-4 text-end">
                            <button class="btn btn-sm me-5" *ngIf="emitemployeeBO.print"
                                (click)="GetEmpOnboardDeatalis('EmpWithHoldCertify')">Print</button>
                        </div>

                        <div class="card-body" style="padding:85px;">
                            <!-- <form [formGroup]=""> -->
                            <div class="row mb-4">
                                <div class="col-lg-2">
                                    <h5>Form<h3><b>W-4</b></h3>
                                    </h5>
                                    <p>Department of the Treasury
                                        Internal Revenue Service </p>
                                </div>
                                <div class="col-lg-8">
                                    <div class="row">
                                        <div class="col-lg-12">
                                            <h4><b>Employee’s Withholding Certificate</b></h4>
                                            <p><b>(For use by employers, corporations, partnerships, trusts,
                                                    estates, churches,
                                                    government agencies, Indian tribal entities, certain
                                                    individuals, and others.)</b></p>
                                            <p>
                                                <b>
                                                    ▶ Complete Form W-4 so that your employer can withhold the
                                                    correct federal income tax from your pay
                                                </b>
                                            </p>
                                            <p><b>
                                                    ▶ Give Form W-4 to your employer
                                                </b></p>
                                            <p><b>
                                                    ▶ Your withholding is subject to review by the IRS.
                                                </b></p>

                                        </div>
                                    </div>

                                </div>
                                <div class="col-lg-2">
                                    <p>OMB No. 1545-0074</p>
                                    <h5><b>2024</b></h5>

                                </div>
                            </div>
                            <div class="row mb-2 mt-4">
                                <div class="col p-0">
                                    <div class="card ">
                                        <div class="card-header">
                                            <h5><b>Step 1:</b>&nbsp;<b>Enter Personal Information</b></h5>
                                        </div>
                                        <div class="card-body">
                                            <div class="row mt-3">
                                                <div class="col-lg-4">
                                                    <label>(a) First Name and initial</label>
                                                    <input type="text" class="form-control"
                                                        [(ngModel)]="employeesWithholdingBo.firstName"
                                                        [disabled]="emitemployeeBO.iscompleted">
                                                </div>
                                                <div class="col-lg-4">
                                                    <label>Last Name </label>
                                                    <input type="text" class="form-control"
                                                        [(ngModel)]="employeesWithholdingBo.lastName"
                                                        [disabled]="emitemployeeBO.iscompleted">
                                                </div>
                                                <div class="col-lg-4">
                                                    <label>(b) Social security number </label>
                                                    <input (ngModelChange)="checkssn() " type="password" minlength="9"
                                                        maxlength="9" (keypress)="keyPress($event)" class="form-control"
                                                        [(ngModel)]="backgroundBo.ssn"
                                                        [disabled]="emitemployeeBO.iscompleted">
                                                    <span class="ssn1" *ngIf="ssn2">{{ssnerror}}</span>
                                                </div>


                                            </div>
                                            <div class="row mt-2">
                                                <div class="col-lg-6">
                                                    <label>Address </label>
                                                    <textarea class="form-control"
                                                        [(ngModel)]="employeesWithholdingBo.address"
                                                        [disabled]="emitemployeeBO.iscompleted"></textarea>
                                                    <!--  -->

                                                    <label>City or town, state, and ZIP code</label>
                                                    <textarea class="form-control"
                                                        [(ngModel)]="employeesWithholdingBo.city"
                                                        [disabled]="emitemployeeBO.iscompleted"></textarea>
                                                    <!--  -->

                                                    <!-- <label>State</label>
                                                    <textarea  class="form-control"
                                                        [(ngModel)]="employeesWithholdingBo.state"  [disabled]="emitemployeeBO.iscompleted"></textarea> -->
                                                    <!--  nn-->
                                                    <!-- <label>ZipCode</label>
                                                    <textarea  class="form-control"
                                                        [(ngModel)]="employeesWithholdingBo.zip"  [disabled]="emitemployeeBO.iscompleted"></textarea> -->
                                                    <!--  -->

                                                </div>
                                                <div class="col-lg-2">

                                                </div>
                                                <div class="col-lg-3">
                                                    <p>▶ Does your name match the
                                                        name on your social security
                                                        card? If not, to ensure you get
                                                        credit for your earnings, contact
                                                        SSA at 800-772-1213 or go to
                                                        www.ssa.gov.</p>
                                                </div>
                                            </div>
                                            <div class="row mt-2">
                                                <div class="col-lg-1">
                                                    (c)
                                                </div>
                                                <div class="col-lg-1">
                                                    <!-- [(ngModel)]="employeesWithholdingBo.singleOrMarriedFillingSeparately" -->
                                                    <input type="radio" name="newstatus" value="singlee"
                                                        [(ngModel)]="employeesWithholdingBo.maritialStatus"
                                                        [disabled]="emitemployeeBO.iscompleted">
                                                </div>
                                                <div class="col-lg-5">
                                                    <label>Single or Married filing separately</label>
                                                </div>
                                            </div>
                                            <div class="row mt-2">
                                                <div class="col-lg-1">

                                                </div>
                                                <div class="col-lg-1">
                                                    <input type="radio" name="newstatus" value="marriedd"
                                                        [(ngModel)]="employeesWithholdingBo.maritialStatus"
                                                        [disabled]="emitemployeeBO.iscompleted">
                                                    <!-- [(ngModel)]="employeesWithholdingBo.marriedFillingjointlyOrQualifyingWidow" -->
                                                </div>
                                                <div class="col-lg-5">
                                                    <label>Married filing jointly or Qualifying
                                                        widow(er)</label>
                                                </div>
                                            </div>
                                            <div class="row mt-2">
                                                <div class="col-lg-1">

                                                </div>

                                                <div class="col-lg-1">
                                                    <!-- [(ngModel)]="employeesWithholdingBo.headofHousehold" -->
                                                    <input type="radio" name="newstatus" value="householdd"
                                                        [(ngModel)]="employeesWithholdingBo.maritialStatus"
                                                        (ngModelChange)="checkValue_single1($event) "
                                                        [disabled]="emitemployeeBO.iscompleted">
                                                </div>
                                                <div class="col-lg-5">
                                                    <label>Head of household (Check only if you’re unmarried and
                                                        pay more than half the costs of keeping up a home for
                                                        yourself and a qualifying individual.)</label>
                                                </div>
                                            </div>


                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="row mt-2 ms-2">
                                <p>Complete Steps 2–4 ONLY if they apply to you; otherwise, skip to Step 5. See
                                    page 2 for more information on each step, who can
                                    claim exemption from withholding, when to use the estimator at
                                    www.irs.gov/W4App, and privacy</p>
                            </div>
                            <div class="row mb-2 mt-4">
                                <div class="col p-0">
                                    <div class="card ">
                                        <div class="card-header">
                                            <h5><b>Step 2:</b>&nbsp;<b>Multiple Jobs
                                                    or Spouse
                                                    Works</b></h5>
                                        </div>
                                        <div class="card-body" style="padding:35px;">
                                            <div class="row mt-2">
                                                <p>Complete this step if you (1) hold more than one job at a
                                                    time, or (2) are married filing jointly and your spouse
                                                    also works. The correct amount of withholding depends on
                                                    income earned from all of these jobs.</p>
                                            </div>
                                            <div class="row mt-2">
                                                <p>Do only one of the following.</p>
                                                <ol type="a" style="margin-left: 30px;">
                                                    <li>Use the estimator at www.irs.gov/W4App for most
                                                        accurate withholding for this step (and Steps 3–4).If you or
                                                        spouse have self-employement income,use this option; or
                                                    </li>
                                                    <li> Use the Multiple Jobs Worksheet on page 3 and enter the result
                                                        in Step 4(c) below; or</li>
                                                    <li>If there are only two jobs total, you may check this box. Do the
                                                        same on Form W-4 for the other job. This
                                                        option is generally more accurate than (b) if pay at the lower
                                                        paying job is more than half of the pay at the
                                                        higher paying job. Otherwise, (b) is more accurate . . . . . . .
                                                        <input type="checkbox"
                                                            [(ngModel)]="employeesWithholdingBo.multipleJobsOrSpouseWorkSectionc" />

                                                    </li>
                                                </ol>
                                            </div>
                                            <!-- <div class="row mt-2">
                                                <p><b>TIP:</b> To be accurate, submit a 2022 Form W-4 for all
                                                    other jobs. If you (or your spouse) have self-employment
                                                    income, including as an independent contractor, use the
                                                    estimator.</p>

                                            </div> -->
                                            <div class="row mt-2">
                                                <p><b>Complete Steps 3–4(b) on Form W-4 for only ONE of these
                                                        jobs.</b> Leave those steps blank for the other jobs.
                                                    (Your withholding will
                                                    be most accurate if you complete Steps 3–4(b) on the Form
                                                    W-4 for the highest paying job.)</p>
                                            </div>

                                        </div>
                                    </div>
                                </div>

                            </div>
                            <div class="row mb-2 mt-4 mb-3">
                                <div class="col p-0">
                                    <div class="card ">
                                        <div class="card-header">
                                            <h5><b>Step3:</b>&nbsp;<b>Claim
                                                    Dependents </b></h5>
                                        </div>
                                        <div class="card-body" style="padding:35px;">
                                            <div class="row mt-2">
                                                <p>If your total income will be $200,000 or less ($400,000 or
                                                    less if married filing jointly):
                                                </p>
                                            </div>
                                            <div class="row mt-2">
                                                <p>Multiply the number of qualifying children under age 17 by
                                                    $2,000 ▶$ <input type="number" min="0" class="form-control"
                                                        [(ngModel)]="employeesWithholdingBo.qualifyingChildrenUnder_AgeSeventeen"
                                                        style="width: 180px;display: inline-block;"
                                                        [disabled]="emitemployeeBO.iscompleted"></p>
                                            </div>
                                            <div class="row mt-2">
                                                <p>Multiply the number of other dependents by $500 . . . .
                                                    ▶$ <input type="number" min="0" maxlength="14" class="form-control"
                                                        [(ngModel)]="employeesWithholdingBo.otherDependents"
                                                        style="width: 180px;display: inline-block;"
                                                        [disabled]="emitemployeeBO.iscompleted"></p>
                                            </div>

                                            <div class="row mt-2">
                                                <p>Add the amounts above for qualifying children and other dependents.
                                                    You may add to
                                                    this the amount of any other credits. Enter the total here . . .
                                                    . . . . . . 3&nbsp;&nbsp;$ <input type="number" min="0"
                                                        class="form-control" [(ngModel)]="employeesWithholdingBo.total"
                                                        style="width: 180px;display: inline-block;"
                                                        [disabled]="emitemployeeBO.iscompleted">
                                                </p>
                                            </div>

                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="row mb-2 mt-4 mb-3">
                                <div class="col p-0">
                                    <div class="card ">
                                        <div class="card-header">
                                            <h5><b>Step4:</b>&nbsp;(optional):
                                                Other
                                                Adjustments</h5>
                                        </div>
                                        <div class="card-body" style="padding:35px;">
                                            <div class="row mt-2">
                                                <ol type="a">
                                                    <li>
                                                        Other income (not from jobs). If you want tax withheld
                                                        for other income you
                                                        expect this year that won’t have withholding, enter the
                                                        amount of other income here.
                                                        This may include interest, dividends, and retirement
                                                        income . . . . . . . .4(a)&nbsp;&nbsp;$ <input type="number"
                                                            min="0" class="form-control"
                                                            [(ngModel)]="employeesWithholdingBo.otherIncome"
                                                            style="width: 180px;display: inline-block;"
                                                            [disabled]="emitemployeeBO.iscompleted">
                                                    </li>
                                                    <li>
                                                        Deductions. If you expect to claim deductions other than
                                                        the standard deduction and
                                                        want to reduce your withholding, use the Deductions
                                                        Worksheet on page 3 and enter
                                                        the result here . . . . . . . . . . . . . . . . . . . .
                                                        . . .4(b)&nbsp;&nbsp;$ <input type="number" min="0"
                                                            class="form-control"
                                                            [(ngModel)]="employeesWithholdingBo.deductions"
                                                            style="width: 180px;display: inline-block;"
                                                            [disabled]="emitemployeeBO.iscompleted">
                                                    </li>
                                                    <li>
                                                        Extra withholding. Enter any additional tax you want
                                                        withheld each pay period . .4(c)&nbsp;&nbsp;$ <input
                                                            type="number" min="0" class="form-control"
                                                            [(ngModel)]="employeesWithholdingBo.additionalTax"
                                                            style="width: 180px;display: inline-block;"
                                                            [disabled]="emitemployeeBO.iscompleted">
                                                    </li>
                                                </ol>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="row mb-2 mt-4 mb-3">
                                <div class="col p-0">
                                    <div class="card ">
                                        <div class="card-header">
                                            <h5><b>Step5:</b>&nbsp;Sign
                                                Here
                                            </h5>
                                        </div>
                                        <div class="card-body" style="padding:35px;">
                                            <div class="row mt-2">
                                                <p>Under penalties of perjury, I declare that this certificate,
                                                    to the best of my knowledge and belief, is true, correct,
                                                    and complete</p>

                                            </div>
                                            <div class="row mt-5 ms-2">
                                                <div class="col-6">
                                                    <button type="button" class="btn blue-btn" data-bs-toggle="modal"
                                                        data-bs-target="#nurse"
                                                        [disabled]="global.OnboardingLoginType != 'onboardLogin'">
                                                        Employee’s signature
                                                    </button>

                                                </div>

                                                <div class="col-lg-1">
                                                    <label for="cname">Date:</label>
                                                </div>
                                                <div class="col-lg-4" [formGroup]="dateForm">
                                                    <my-date-picker class="w-100" placeholder="mm/dd/yyyy"
                                                        [options]="myDatePickerOptions"
                                                        [selDate]="employeesWithholdingBo.signDate"
                                                        (inputFieldChanged)="newdates($event,'inputchange','date32')"
                                                        (dateChanged)="newdates($event,'datechanged','date32')"
                                                        formControlName="signDate13"
                                                        [disabled]="emitemployeeBO.iscompleted">
                                                    </my-date-picker>
                                                </div>

                                            </div>
                                            <div class="row">
                                                <p> (This form is not valid unless you sign it.)</p>
                                            </div>
                                            <div class="row mt-2 mb-2">

                                                <div class="col-lg-4">
                                                    <input *ngIf="Gurdsign!=''&& Gurdsign!=null " type="image"
                                                        src="{{Gurdsign}}" class="form-control"
                                                        style="width: 255px;height:120px;" alt="nurse" width="48"
                                                        height="48">
                                                </div>
                                            </div>


                                            <div class="row">
                                                <div class="col-lg-2">
                                                    Employers
                                                    Only

                                                </div>

                                                <div class="col-lg-3">
                                                    <label>Employer’s name and address</label>
                                                    <textarea type="text" class="form-control"
                                                        [(ngModel)]="employeesWithholdingBo.employeeName"
                                                        [disabled]="emitemployeeBO.iscompleted"></textarea>
                                                </div>
                                                <div class="col-lg-3">
                                                    <label>First date of
                                                        employment</label>
                                                    <my-date-picker class="w-100" [options]="myDatePickerOptions"
                                                        [selDate]="employeesWithholdingBo.firstDateOfEmployeement"
                                                        (inputFieldChanged)="newdates($event,'inputchange','date33')"
                                                        (dateChanged)="newdates($event,'datechanged','date33')"
                                                        placeholder="mm/dd/yyyy"
                                                        [disabled]="emitemployeeBO.iscompleted">
                                                    </my-date-picker>
                                                    <!--   <input        type="text" [(ngModel)]="EmployeeswithholdingcertificateBO.sign.firstDateOfEmployeement" class="form-control"> -->
                                                </div>
                                                <div class="col-lg-4">
                                                    <label>Employer identification
                                                        number (EIN)
                                                    </label>
                                                    <input type="text" class="form-control"
                                                        [disabled]="emitemployeeBO.iscompleted"
                                                        [(ngModel)]="employeesWithholdingBo.identificationNumber">
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <!-- <div class="row mt-4">
                                <div class="col-lg-6">
                                    <h4><b>General Instructions</b></h4>
                                    <p>Section references are to the Internal Revenue Code. </p>
                                    <h4><b>Future Developments</b></h4>
                                    <p>For the latest information about developments related to
                                        Form W-4, such as legislation enacted after it was published,
                                        go to www.irs.gov/FormW4.</p>
                                    <h4><b>Purpose of Form</b></h4>
                                    <p>Complete Form W-4 so that your employer can withhold the
                                        correct federal income tax from your pay. If too little is
                                        withheld, you will generally owe tax when you file your tax
                                        return and may owe a penalty. If too much is withheld, you
                                        will generally be due a refund. Complete a new Form W-4
                                        when Changes to your personal or financial situation would
                                        Change the entries on the form. For more information on
                                        withholding and when you must furnish a new Form W-4,
                                        see Pub. 505, Tax Withholding and Estimated Tax. </p>
                                    <p><b>Exemption from withholding.</b> You may claim exemption
                                        from withholding for 2022 if you meet both of the following
                                        conditions: you had no federal income tax liability in 2021
                                        and you expect to have no federal income tax liability in
                                        2022. You had no federal income tax liability in 2021 if (1)
                                        your total tax on line 24 on your 2021 Form 1040 or 1040-SR
                                        is zero (or less than the sum of lines 27a, 28, 29, and 30), or
                                        (2) you were not required to file a return because your
                                        income was below the filing threshold for your correct filing
                                        status. If you claim exemption, you will have no income tax
                                        withheld from your paycheck and may owe taxes and
                                        penalties when you file your 2022 tax return. To claim
                                        exemption from withholding, certify that you meet both of
                                        the conditions above by writing “Exempt” on Form W-4 in
                                        the space below Step 4(c). Then, complete Steps 1(a), 1(b),
                                        and 5. Do not complete any other steps. You will need to
                                        submit a new Form W-4 by February 15, 2023.</p>
                                    <p><b>Your privacy.</b> If you prefer to limit information provided in
                                        Steps 2 through 4, use the online estimator, which will also
                                        increase accuracy. </p>
                                    <p>As an alternative to the estimator: if you have concerns
                                        with Step 2(c), you may choose Step 2(b); if you have
                                        concerns with Step 4(a), you may enter an additional amount
                                        you want withheld per pay period in Step 4(c). If this is the
                                        only job in your household, you may instead check the box
                                        in Step 2(c), which will increase your withholding and
                                        significantly reduce your paycheck (often by thousands of
                                        dollars over the year).</p>
                                    <p><b>When to use the estimator.</b> Consider using the estimator at
                                        www.irs.gov/W4App if you:

                                    </p>
                                    <ul type="1" style="margin-left: 30px;">
                                        <li>Expect to work only part of the year;</li>
                                        <li>Have dividend or capital gain income, or are subject to
                                            additional taxes, such as Additional Medicare Tax;
                                        </li>
                                        <li>Have self-employment income (see below); or
                                        </li>
                                        <li>Prefer the most accurate withholding for multiple job
                                            situations</li>
                                    </ul>
                                    <p><b>Self-employment.</b> Generally, you will owe both income and
                                        self-employment taxes on any self-employment income you
                                        receive separate from the wages you receive as an
                                        employee. If you want to pay these taxes through
                                        withholding from your wages, use the estimator at
                                        www.irs.gov/W4App to figure the amount to have withheld.</p>
                                    <p>Nonresident alien. If you’re a nonresident alien, see Notice
                                        1392, Supplemental Form W-4 Instructions for Nonresident
                                        Aliens, before completing this form.</p>
                                    <p><b>Nonresident alien.</b> If you’re a nonresident alien, see Notice
                                        1392, Supplemental Form W-4 Instructions for Nonresident
                                        Aliens, before completing this form</p>
                                </div>
                                <div class="col-lg-6">
                                    <h4><b>Specific Instructions</b></h4>
                                    <p><b>Step 1(c).</b> Check your anticipated filing status. This will
                                        determine the standard deduction and tax rates used to
                                        compute your withholding</p>
                                    <p><b>Step 2.</b> Use this step if you (1) have more than one job at the
                                        same time, or (2) are married filing jointly and you and your
                                        spouse both work.</p>
                                    <p>Option (a) most accurately calculates the additional tax
                                        you need to have withheld, while option (b) does so with a
                                        little less accuracy. </p>
                                    <p>If you (and your spouse) have a total of only two jobs, you
                                        may instead check the box in option (c). The box must also
                                        be checked on the Form W-4 for the other job. If the box is
                                        checked, the standard deduction and tax brackets will be
                                        cut in half for each job to calculate withholding. This option
                                        is roughly accurate for jobs with similar pay; otherwise, more
                                        tax than necessary may be withheld, and this extra amount
                                        will be larger the greater the difference in pay is between the
                                        two jobs</p>
                                    <p>
                                        Multiple jobs. Complete Steps 3 through 4(b) on only
                                        one Form W-4. Withholding will be most accurate if
                                        you do this on the Form W-4 for the highest paying job</p>
                                    <p><b>step3</b> This step provides instructions for determining the
                                        amount of the child tax credit and the credit for other
                                        dependents that you may be able to claim when you file your
                                        tax return. To qualify for the child tax credit, the child must
                                        be under age 17 as of December 31, must be your
                                        dependent who generally lives with you for more than half
                                        the year, and must have the required social security number.
                                        You may be able to claim a credit for other dependents for
                                        whom a child tax credit can’t be claimed, such as an older
                                        child or a qualifying relative. For additional eligibility
                                        requirements for these credits, see Pub. 501, Dependents,
                                        Standard Deduction, and Filing Information. You can also
                                        include other tax credits for which you are eligible in this
                                        step, such as the foreign tax credit and the education tax
                                        credits. To do so, add an estimate of the amount for the year
                                        to your credits for dependents and enter the total amount in
                                        Step 3. Including these credits will increase your paycheck
                                        and reduce the amount of any refund you may receive when
                                        you file your tax return</p>
                                    <h4><b>Step 4 (optional).</b></h4>
                                    <p><b>Step 4(a).</b> Enter in this step the total of your other
                                        estimated income for the year, if any. You shouldn’t include
                                        income from any jobs or self-employment. If you complete
                                        Step 4(a), you likely won’t have to make estimated tax
                                        payments for that income. If you prefer to pay estimated tax
                                        rather than having tax on other income withheld from your
                                        paycheck, see Form 1040-ES, Estimated Tax for Individuals.
                                    </p>


                                    <p><b>Step 4(b).</b> Enter in this step the amount from the
                                        Deductions Worksheet, line 5, if you expect to claim
                                        deductions other than the basic standard deduction on your
                                        2022 tax return and want to reduce your withholding to
                                        account for these deductions. This includes both itemized
                                        deductions and other deductions such as for student loan
                                        interest and IRAs</p>


                                    <p><b>Step 4(c).</b> Enter in this step any additional tax you want
                                        withheld from your pay each pay period, including any
                                        amounts from the Multiple Jobs Worksheet, line 4. Entering
                                        an amount here will reduce your paycheck and will either
                                        increase your refund or reduce any amount of tax that you
                                        owe.</p>
                                </div>
                            </div>
                            <div class="row mb-2 mt-4 mb-3">
                                <div class="col">
                                    <div class="card ">
                                        <div class="card-header">
                                            <h5><b>Step 2(b)</b>&nbsp;—Multiple Jobs Worksheet (Keep for your
                                                records.)</h5>
                                        </div>
                                        <div class="card-body" style="padding:35px;">
                                            <div class="row mt-2">
                                                <p>If you choose the option in Step 2(b) on Form W-4, complete
                                                    this worksheet (which calculates the total extra tax for all
                                                    jobs) on only ONE
                                                    Form W-4. Withholding will be most accurate if you complete
                                                    the worksheet and enter the result on the Form W-4 for the
                                                    highest paying job.</p>
                                            </div>
                                            <div class="row mt-2">
                                                <p>Note: If more than one job has annual wages of more than
                                                    $120,000 or there are more than three jobs, see Pub. 505 for
                                                    additional
                                                    tables; or, you can use the online withholding estimator at
                                                    www.irs.gov/W4App.</p>
                                            </div>
                                            <div class="row mt-2">
                                                <ol style="margin-left: 10px;" type="1">
                                                    <li>Two jobs. If you have two jobs or you’re married filing
                                                        jointly and you and your spouse each have one
                                                        job, find the amount from the appropriate table on page
                                                        4. Using the “Higher Paying Job” row and the
                                                        “Lower Paying Job” column, find the value at the
                                                        intersection of the two household salaries and enter
                                                        that value on line 1. Then, skip to line 3 . . . . . . .
                                                        . . . . . . . . . . . . . .&nbsp;&nbsp;1
                                                        &nbsp;&nbsp;$ <input type="text" class="form-control"
                                                            [(ngModel)]="employeesWithholdingBo.multiJobsWorksheetFirstJobField"
                                                            style="width: 180px;display: inline-block;" [disabled]="emitemployeeBO.iscompleted">
                                                    </li>



                                                    <li>Three jobs. If you and/or your spouse have three jobs at
                                                        the same time, complete lines 2a, 2b, and
                                                        2c below. Otherwise, skip to line 3.</li>
                                                    <ol style="margin-left: 30px;" type="a">
                                                        <li>Find the amount from the appropriate table on page 4
                                                            using the annual wages from the highest
                                                            paying job in the “Higher Paying Job” row and the
                                                            annual wages for your next highest paying job
                                                            in the “Lower Paying Job” column. Find the value at
                                                            the intersection of the two household salaries
                                                            and enter that value on line 2a . . . . . . . . . .
                                                            . . . . . . . . . . . . .&nbsp;&nbsp;2a
                                                            &nbsp;&nbsp;$ <input type="text" class="form-control"  [disabled]="emitemployeeBO.iscompleted"
                                                                [(ngModel)]="employeesWithholdingBo.multiJobsWorksheetSecondjobField_a"
                                                                style="width: 180px;display: inline-block;">
                                                        </li>
                                                        <li>Add the annual wages of the two highest paying jobs
                                                            from line 2a together and use the total as the
                                                            wages in the “Higher Paying Job” row and use the
                                                            annual wages for your third job in the “Lower
                                                            Paying Job” column to find the amount from the
                                                            appropriate table on page 4 and enter this amount
                                                            on line 2b . . . . . . . . . . . . . . . . . . . . .
                                                            . . . . . . . &nbsp;&nbsp;2b &nbsp;&nbsp;$ <input
                                                                type="text" class="form-control"  [disabled]="emitemployeeBO.iscompleted"
                                                                [(ngModel)]="employeesWithholdingBo.multiJobsWorksheetSecondjobField_b"
                                                                style="width: 180px;display: inline-block;">
                                                        </li>

                                                        <li>Add the amounts from lines 2a and 2b and enter the
                                                            result on line 2c . . . . . . . . . .&nbsp;&nbsp;2c
                                                            &nbsp;&nbsp;$ <input type="text" class="form-control"  [disabled]="emitemployeeBO.iscompleted"
                                                                [(ngModel)]="employeesWithholdingBo.multiJobsWorksheetSecondjobField_c"
                                                                style="width: 180px;display: inline-block;">
                                                        </li>

                                                    </ol>


                                                    <li> Enter the number of pay periods per year for the
                                                        highest paying job. For example, if that job pays
                                                        weekly, enter 52; if it pays every other week, enter 26;
                                                        if it pays monthly, enter 12, etc. . . . .
                                                        .&nbsp;&nbsp;3 &nbsp;&nbsp;$ <input type="text"
                                                            class="form-control"  [disabled]="emitemployeeBO.iscompleted"
                                                            [(ngModel)]="employeesWithholdingBo.multiJobsWorksheetThirdHobField"
                                                            style="width: 180px;display: inline-block;">
                                                    </li>



                                                    <li>Divide the annual amount on line 1 or line 2c by the
                                                        number of pay periods on line 3. Enter this
                                                        amount here and in Step 4(c) of Form W-4 for the highest
                                                        paying job (along with any other additional
                                                        amount you want withheld) . . . . . . . . . . . . . . .
                                                        . . . . . . . . . . &nbsp;&nbsp;4 &nbsp;&nbsp;$ <input
                                                            type="text" class="form-control"  [disabled]="emitemployeeBO.iscompleted"
                                                            [(ngModel)]="employeesWithholdingBo.multiJobsWorksheetTourthJobField"
                                                            style="width: 180px;display: inline-block;">
                                                    </li>
                                                </ol>


                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="row mb-2 mt-4 mb-3">
                                <div class="col">
                                    <div class="card ">
                                        <div class="card-header">
                                            <h5><b>Step 4(b)</b>&nbsp;—Deductions Worksheet (Keep for your
                                                records.)</h5>
                                        </div>
                                        <div class="card-body" style="padding:35px;">


                                            <div class="row mt-2">

                                                <ol type="1" style="margin-left:30px">
                                                    <li>Enter an estimate of your 2022 itemized deductions (from
                                                        Schedule A (Form 1040)). Such deductions
                                                        may include qualifying home mortgage interest,
                                                        charitable contributions, state and local taxes (up to
                                                        $10,000), and medical expenses in excess of 7.5% of your
                                                        income. . . . . . . . . &nbsp;&nbsp;1
                                                        &nbsp;&nbsp;$ <input type="number" min="0" class="form-control"
                                                            [(ngModel)]="employeesWithholdingBo.deductionfirstamout"
                                                            style="width: 180px;display: inline-block;"
                                                            [disabled]="emitemployeeBO.iscompleted"
                                                            >
                                                    </li>
                                                    <li>Enter: <ul style="margin-left:30px">
                                                            <li>$25,900 if you’re married filing jointly or
                                                                qualifying widow(er)</li>
                                                            <li>$19,400 if you’re head of household</li>
                                                            <li>$12,950 if you’re single or married filing
                                                                separately. . . . . . . .
                                                                &nbsp;&nbsp;2&nbsp;&nbsp;$ <input type="number" min="0"
                                                                    class="form-control"
                                                                    [(ngModel)]="employeesWithholdingBo.deductionSecondamount"
                                                                    style="width: 180px;display: inline-block;"
                                                                    [disabled]="emitemployeeBO.iscompleted"
                                                                    >
                                                            </li>
                                                        </ul>
                                                    </li>
                                                    <li>If line 1 is greater than line 2, subtract line 2 from
                                                        line 1 and enter the result here. If line 2 is greater
                                                        than line 1, enter “-0-” . . . . . . . &nbsp;&nbsp;3
                                                        &nbsp;&nbsp;$ <input type="number" min="0" class="form-control"
                                                            [(ngModel)]="employeesWithholdingBo.deductionThirdamount"
                                                            style="width: 180px;display: inline-block;"
                                                            [disabled]="emitemployeeBO.iscompleted"
                                                            >
                                                    </li>
                                                    <li>Enter an estimate of your student loan interest,
                                                        deductible IRA contributions, and certain other
                                                        adjustments (from Part II of Schedule 1 (Form 1040)).
                                                        See Pub. 505 for more information . . . .&nbsp;&nbsp;4
                                                        &nbsp;&nbsp;$ <input type="number" min="0" class="form-control"
                                                            [(ngModel)]="employeesWithholdingBo.deductionFourthamount"
                                                            style="width: 180px;display: inline-block;"
                                                            [disabled]="emitemployeeBO.iscompleted"
                                                            >
                                                    </li>
                                                    <li>Add
                                                        lines 3 and 4. Enter the result here and in Step 4(b) of
                                                        Form W-4 . . . . . . . . . &nbsp;&nbsp;5
                                                        &nbsp;&nbsp;$ <input type="number" min="0" class="form-control"
                                                            [(ngModel)]="employeesWithholdingBo.deductionFifthamount"
                                                            style="width: 180px;display: inline-block;"
                                                            [disabled]="emitemployeeBO.iscompleted"
                                                            >
                                                    </li>

                                                </ol>
                                            </div>

                                        </div>
                                    </div>
                                </div>
                            </div>


                            <div class="row mt-3">
                                <div class="col-lg-6">
                                    <b>Privacy Act and Paperwork Reduction Act Notice</b>. We ask for the
                                    information
                                    on this form to carry out the Internal Revenue laws of the United States.
                                    Internal
                                    Revenue Code sections 3402(f)(2) and 6109 and their regulations require you
                                    to
                                    provide this information; your employer uses it to determine your federal
                                    income
                                    tax withholding. Failure to provide a properly completed form will result in
                                    your
                                    being treated as a single person with no other entries on the form;
                                    providing
                                    fraudulent information may subject you to penalties. Routine uses of this
                                    information include giving it to the Department of Justice for civil and
                                    criminal
                                    litigation; to cities, states, the District of Columbia, and U.S.
                                    commonwealths and
                                    possessions for use in administering their tax laws; and to the Department
                                    of
                                    Health and Human Services for use in the National Directory of New Hires. We
                                    may also disclose this information to other countries under a tax treaty, to
                                    federal
                                    and state agencies to enforce federal nontax criminal laws, or to federal
                                    law
                                    enforcement and intelligence agencies to combat terrorism
                                </div>
                                <div class="col-lg-6">
                                    You are not required to provide the information requested on a form that is
                                    subject to the Paperwork Reduction Act unless the form displays a valid OMB
                                    control number. Books or records relating to a form or its instructions must
                                    be
                                    retained as long as their contents may become material in the administration
                                    of
                                    any Internal Revenue law. Generally, tax returns and return information are
                                    confidential, as required by Code section 6103.
                                    The average time and expenses required to complete and file this form will
                                    vary
                                    depending on individual circumstances. For estimated averages, see the
                                    instructions for your income tax return.
                                    If you have suggestions for making this form simpler, we would be happy to
                                    hear
                                    from you. See the instructions for your income tax return.

                                </div>
                            </div>

                            <div class="row mt-4 mb-2">
                                <img src="..\assets\img\married.JPG" class="img-fluid" alt="Responsive image">
                            </div>

                            <div class="row mt-2 mb-2">
                                <img src="..\assets\img\log.JPG" class="img-fluid" alt="Responsive image">
                            </div> -->



                            <!-- </form> -->
                            <!-- documentBO.employees_withholding_certificate.sign.date -->

                            <div class="col-12  mb-3 mt-1 ">


                                <div class="text-end">
                                    <button class="btn" [disabled]="emitemployeeBO?.iscompleted || isSaveorUpdateBoolean"
                                        *ngIf="global.OnboardingLoginType !='onboardLogin' && !emitemployeeBO.print"
                                        (click)="saveAgreement()">Save</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!--W-4MN MINNESOTA WithHolding Allowness -->
            <div class="row mb-2 mt-2">
                <div class="col p-0">
                    <div class="card" style=" overflow-x:hidden;  height:auto;">
                        <div class="card" style=" overflow-x:hidden;  height:auto;">
                            <div class="col mt-4 text-end">
                                <button class="btn btn-sm me-5" *ngIf="emitemployeeBO.print"
                                    (click)="GetEmpOnboardDeatalis('MinnsottaWithHold')">Print</button>
                            </div>

                            <div class="card-body" style="padding:85px;">
                                <!-- <form [formGroup]=""> -->
                                <div class="row mt-4 mb-2">
                                    <img src="../../../../assets/img/mahi.jpg" class="img-fluid" alt="Responsive image">
                                </div>

                                <div class="row mt-2">
                                    <p><b>Complete Form W-4MN so your employer can withhold the correct Minnesota income
                                            tax from your pay. Consider completing a new Form W-4MN each
                                            year and when your personal or financial situation changes. If no Form W-4MN
                                            is in effect, the number of withholding allowances claimed will be zero.</b>
                                    </p>
                                </div>

                                <div class="row mb-2 mt-4">
                                    <div class="col p-0">
                                        <div class="card ">
                                            <div class="card-header">
                                                <h5><b>Step 1:</b>&nbsp;<b>Enter Personal Information</b></h5>
                                            </div>
                                            <div class="card-body">
                                                <div class="row mt-3">
                                                    <div class="col-lg-4">
                                                        <label>(a) First name and initial
                                                        </label>
                                                        <input type="text" class="form-control"
                                                            [(ngModel)]="w4MinnesotaWithholdingBo.firstName"
                                                            [disabled]="emitemployeeBO.iscompleted">
                                                    </div>
                                                    <div class="col-lg-4">
                                                        <label>Last Name </label>
                                                        <input type="text" class="form-control"
                                                            [(ngModel)]="w4MinnesotaWithholdingBo.lastName"
                                                            [disabled]="emitemployeeBO.iscompleted">
                                                    </div>
                                                    <div class="col-lg-4">
                                                        <label>(b) Social security number </label>
                                                        <input (ngModelChange)="checkssn() " type="password"
                                                            minlength="9" maxlength="9" (keypress)="keyPress($event)"
                                                            class="form-control" [(ngModel)]="backgroundBo.ssn"
                                                            [disabled]="emitemployeeBO.iscompleted">
                                                        <span class="ssn1" *ngIf="ssn3">{{ssnerror}}</span>
                                                    </div>

                                                </div>
                                                <div class="row mt-2">
                                                    <div class="col-lg-6">
                                                        <label>Permanent Address </label>
                                                        <textarea class="form-control"
                                                            [(ngModel)]="w4MinnesotaWithholdingBo.address"
                                                            [disabled]="emitemployeeBO.iscompleted"></textarea>
                                                        <!--  -->
                                                        <div class="row">
                                                            <div class="col-lg-4">
                                                                <label>City</label>
                                                                <input type="text" class="form-control"
                                                                    [(ngModel)]="w4MinnesotaWithholdingBo.city"
                                                                    [disabled]="emitemployeeBO.iscompleted">
                                                                <!--  -->
                                                            </div>
                                                            <div class="col-lg-4">
                                                                <label>State</label>
                                                                <ng-select [items]="stateList" class="width25"
                                                                    [searchable]="true" [clearable]="true"
                                                                    bindLabel="name" bindValue="abbreviation"
                                                                    [(ngModel)]="w4MinnesotaWithholdingBo.state"
                                                                    [disabled]="emitemployeeBO.iscompleted">
                                                                    <!--  -->
                                                                </ng-select>
                                                            </div>
                                                            <div class="col-lg-4">
                                                                <label>Zip code</label>
                                                                <input (ngModelChange)="validZip() " type="text"
                                                                    class="form-control" minlength="5" maxlength="11"
                                                                    (keypress)="keyPress($event)"
                                                                    [(ngModel)]="w4MinnesotaWithholdingBo.zip"
                                                                    [disabled]="emitemployeeBO.iscompleted">
                                                                <span class="ssn1" *ngIf="zip6">{{ziperr}}</span>
                                                                <!--  -->

                                                            </div>
                                                        </div>


                                                    </div>

                                                    <div class="col-lg-6">
                                                        <div class="row mt-2">

                                                            <div class="col-lg-1">
                                                                <input type="radio" id="m1" name="fruit1" value="single"
                                                                    [disabled]="emitemployeeBO.iscompleted"
                                                                    [(ngModel)]="w4MinnesotaWithholdingBo.maritalStatus"
                                                                    checked>
                                                            </div>
                                                            <div class="col-lg-10">
                                                                <label>Single; Married, but legally separated; or
                                                                    Spouse is a nonresident alien</label>
                                                            </div>
                                                        </div>
                                                        <!-- <div class="row mt-2">

                                                            <div class="col-lg-1">
                                                                <input type="radio" name="fruit1"
                                                                    value="nonresident_alien" id="m2"
                                                                    [(ngModel)]="w4MinnesotaWithholdingBo.maritalStatus"
                                                                    [disabled]="emitemployeeBO.iscompleted"
                                                                    >
                                                            </div>
                                                            <div class="col-lg-10">
                                                                <label>Spouse is a nonresident alien</label>
                                                            </div>
                                                        </div> -->
                                                        <div class="row mt-2">

                                                            <div class="col-lg-1">
                                                                <input type="radio" id="m3" name="fruit1"
                                                                    value="married"
                                                                    [(ngModel)]="w4MinnesotaWithholdingBo.maritalStatus">
                                                            </div>
                                                            <div class="col-lg-10">
                                                                <label>Married</label>
                                                            </div>
                                                        </div>
                                                        <div class="row mt-2">

                                                            <div class="col-lg-1">
                                                                <input type="radio" id="m4" name="fruit1"
                                                                    value="married_singlerate"
                                                                    [(ngModel)]="w4MinnesotaWithholdingBo.maritalStatus">
                                                            </div>
                                                            <div class="col-lg-10">
                                                                <label>Married, but withhold at higher Single
                                                                    rate</label>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>



                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="row mt-2 ms-4">
                                    <p><b>Complete Section 1 OR Section 2, then sign the bottom and give the
                                            completed form to your employer</b></p>
                                </div>



                                <div class="row mb-2 mt-4 mb-3">
                                    <div class="col">
                                        <div class="card ">
                                            <div class="card-header">
                                                <div class="d-flex ms-lg-1">
                                                    <input type="radio" (change)="sectionDetermine($event)" id="sec1"
                                                        name="sectionn" value="false"
                                                        [(ngModel)]="w4MinnesotaWithholdingBo.determine_minnesota_allowances">
                                                    <!-- [(ngModel)]="documentBO.w_4MN_minnesotta_withholding_allowance.determiningMinnesotaAllowances.exemption_minnesota_withholding" -->
                                                    <h5 class="ms-1 pt-2"><b> Section 1 -</b>&nbsp;Determining Minnesota
                                                        Allowances</h5>
                                                </div>
                                            </div>
                                            <div class="card-body" style="padding:35px;">


                                                <div class="row mt-2" [formGroup]="Section1Form">
                                                    <ol style="margin-left: 10px;" type="A">
                                                        <li> Enter “1” if no one else can claim you as a dependent
                                                            ...................................&nbsp;&nbsp;A
                                                            &nbsp;&nbsp; <input type="text" class="form-control"
                                                                style="width: 180px;display: inline-block;"
                                                                formControlName="input1"
                                                                [(ngModel)]="w4MinnesotaWithholdingBo.ifNoOneClaimyouasdependent"
                                                                [disabled]="emitemployeeBO.iscompleted">
                                                        </li>



                                                        <li> Enter “1” if any of the following apply:
                                                            .................................................&nbsp;&nbsp;B
                                                            &nbsp;&nbsp; <input type="text" class="form-control"
                                                                formControlName="input2"
                                                                style="width: 180px;display: inline-block;"
                                                                [(ngModel)]="w4MinnesotaWithholdingBo.ifanyofFollowingApply"
                                                                [disabled]="emitemployeeBO.iscompleted">
                                                        </li>
                                                        <ul style="margin-left: 30px;">
                                                            <li>You are single and have only one job</li>
                                                            <li>You are married, have only one job, and your spouse
                                                                does not work</li>

                                                            <li>Your wages from a second job or your spouse’s wages
                                                                are $1500 or less</li>
                                                        </ul>


                                                        <li>Enter “1” if you are married. Or choose to enter “0” if
                                                            you are married and have either a working
                                                            spouse or more than one job. (Entering “0” may help you
                                                            avoid having too little tax withheld.) . .&nbsp;&nbsp;C
                                                            &nbsp;&nbsp; <input type="text" class="form-control"
                                                                formControlName="input3"
                                                                style="width: 180px;display: inline-block;"
                                                                [(ngModel)]="w4MinnesotaWithholdingBo.haveeitherworkingSpouseormorethanOneJob"
                                                                [disabled]="emitemployeeBO.iscompleted">
                                                        </li>
                                                        <li> Enter the number of dependents (other than your spouse
                                                            or yourself)
                                                            you will claim on your tax return.
                                                            ...................................................&nbsp;&nbsp;D
                                                            &nbsp;&nbsp; <input type="text" class="form-control"
                                                                formControlName="input4"
                                                                [disabled]="emitemployeeBO.iscompleted"
                                                                style="width: 180px;display: inline-block;"
                                                                [(ngModel)]="w4MinnesotaWithholdingBo.numberofdependents">
                                                        </li>
                                                        <li>Enter “1” if you will use the filing status Head of
                                                            Household (see instructions).
                                                            ................&nbsp;&nbsp;E&nbsp;&nbsp; <input type="text"
                                                                class="form-control" formControlName="input5"
                                                                style="width: 180px;display: inline-block;"
                                                                [disabled]="emitemployeeBO.iscompleted"
                                                                [(ngModel)]="w4MinnesotaWithholdingBo.filingstatusHeadofHousehold">
                                                        </li>

                                                        <li>Add steps A through E. If you plan to itemize deductions
                                                            on your 2022 Minnesota income tax
                                                            return, you may also complete the Itemized Deductions
                                                            and Additional Income Worksheet.
                                                            ..&nbsp;&nbsp;F&nbsp;&nbsp; <input type="text"
                                                                class="form-control" formControlName="input6"
                                                                style="width: 180px;display: inline-block;"
                                                                [disabled]="emitemployeeBO.iscompleted"
                                                                [(ngModel)]="w4MinnesotaWithholdingBo.deductionsandAdditionalIncomeWorksheet">
                                                        </li>

                                                    </ol>
                                                    <ol style="margin-left: 10px;" type="1">
                                                        <li>Minnesota Allowances. Enter Step F from Section 1 above
                                                            or Step 10 of the Itemized Deductions Worksheet
                                                            ...........&nbsp;&nbsp;1 &nbsp;&nbsp;$ <input type="text"
                                                                class="form-control" formControlName="input7"
                                                                style="width: 180px;display: inline-block;"
                                                                [(ngModel)]="w4MinnesotaWithholdingBo.minnesotaAllwances">
                                                        </li>
                                                        <li>Additional Minnesota withholding you want deducted for
                                                            each pay period (see instructions)
                                                            .........................&nbsp;&nbsp;2
                                                            &nbsp;&nbsp;$ <input type="text" class="form-control"
                                                                formControlName="input8"
                                                                [disabled]="emitemployeeBO.iscompleted"
                                                                style="width: 180px;display: inline-block;"
                                                                [(ngModel)]="w4MinnesotaWithholdingBo.additionalMinnesotawithholding">
                                                        </li>
                                                    </ol>



                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>


                                <!-- this. = val.target.checked -->
                                <!-- this.documentBO.w_4MN_minnesotta_withholding_allowance.determiningMinnesotaAllowances.determine_minnesota_allowances = false -->

                                <div class="row mb-2 mt-4 mb-3">
                                    <div class="col">
                                        <div class="card ">
                                            <div class="card-header">
                                                <div class="d-flex ms-lg-1">
                                                    <input type="radio" (change)="sectionDetermine($event)" id="sec2"
                                                        name="sectionn" value="true"
                                                        [disabled]="emitemployeeBO.iscompleted"
                                                        [(ngModel)]="w4MinnesotaWithholdingBo.determine_minnesota_allowances">
                                                    <!-- section($event); 
                                   [(ngModel)]="documentBO.w_4MN_minnesotta_withholding_allowance.determiningMinnesotaAllowances.determine_minnesota_allowances"
    -->
                                                    <h5 class="ms-1 pt-2"><b>Section 2</b>&nbsp;— Exemption From
                                                        Minnesota
                                                        Withholding</h5>
                                                </div>
                                            </div>
                                            <div class="card-body" style="padding:35px;">
                                                <div>
                                                    <div class="row mt-2 ms-2">
                                                        <p>Complete Section 2 if you claim to be exempt from Minnesota
                                                            income tax withholding (see Section 2 instructions for
                                                            qualifications). If applicable,
                                                            check one box below to indicate why you believe you are
                                                            exempt</p>
                                                    </div>
                                                    <div class="d-flex ms-2" [formGroup]="Section2Form">
                                                        <input type="radio" name="radiosection23" value="A"
                                                            [(ngModel)]="w4MinnesotaWithholdingBo.exemption_minnesota_withholdingsec2"
                                                            (change)="option_section2($event)"
                                                            [ngModelOptions]="{standalone: true}"
                                                            [disabled]="emitemployeeBO.iscompleted">

                                                        &nbsp;&nbsp;<p>A&nbsp;&nbsp; I meet the
                                                            requirements and claim exempt from both federal and
                                                            Minnesota income tax withholding</p>
                                                    </div>
                                                    <div class="d-flex ms-2" [formGroup]="Section2Form">
                                                        <input type="radio" name="radiosection23" value="B"
                                                            [(ngModel)]="w4MinnesotaWithholdingBo.exemption_minnesota_withholdingsec2"
                                                            (change)="option_section2($event)"
                                                            [ngModelOptions]="{standalone: true}"
                                                            [disabled]="emitemployeeBO.iscompleted">&nbsp;&nbsp;<p>
                                                            B&nbsp;&nbsp;Even though I
                                                            did not claim exempt from federal withholding, I claim
                                                            exempt from Minnesota withholding, because:</p>
                                                    </div>
                                                    <ul style="margin-left:50px;" class="mt-3">
                                                        <li>I had no Minnesota income tax liability last year</li>
                                                        <li>I received a refund of all Minnesota income tax withheld
                                                        </li>
                                                        <li>I expect to have no Minnesota income tax liability this year
                                                        </li>


                                                    </ul>
                                                    <div class="d-flex ms-2" [formGroup]="Section2Form">
                                                        <input type="radio" name="radiosection23" value="C"
                                                            [(ngModel)]="w4MinnesotaWithholdingBo.exemption_minnesota_withholdingsec2"
                                                            (change)="option_section2($event)"
                                                            [disabled]="emitemployeeBO.iscompleted"
                                                            [ngModelOptions]="{standalone: true}">&nbsp;&nbsp; <p>
                                                            C&nbsp;&nbsp;All of these
                                                            apply:</p>
                                                    </div>
                                                    <ul style="margin-left:50px mt-3" [formGroup]="Section2Form">
                                                        <li>My spouse is a military service member assigned to a
                                                            military location in Minnesota</li>
                                                        <li>My domicile (legal residence) is in another state</li>
                                                        <li>I am in Minnesota solely to be with my spouse. My state of
                                                            domicile is&nbsp;&nbsp; <input type="text"
                                                                class="form-control"
                                                                style="width: 180px;display: inline-block;"
                                                                formControlName="input1"
                                                                [disabled]="emitemployeeBO.iscompleted"
                                                                [(ngModel)]="w4MinnesotaWithholdingBo.state_domicile">
                                                        </li>
                                                    </ul>
                                                    <div class="d-flex ms-2" [formGroup]="Section2Form">
                                                        <input type="radio" name="radiosection23" value="D"
                                                            [(ngModel)]="w4MinnesotaWithholdingBo.exemption_minnesota_withholdingsec2"
                                                            (change)="option_section2($event)"
                                                            [ngModelOptions]="{standalone: true}"
                                                            [disabled]="emitemployeeBO.iscompleted">&nbsp;&nbsp;<P>
                                                            D&nbsp;&nbsp;I am an
                                                            American Indian that resides and works on a reservation for
                                                            which i am enrolled(see instructions).
                                                        </P>
                                                    </div>
                                                    <div class="row ms-4 mt-3" [formGroup]="Section2Form">
                                                        <p> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Enter the reservation
                                                            name&nbsp;&nbsp; <input type="text" class="form-control"
                                                                style="width: 180px;display: inline-block;"
                                                                formControlName="input2"
                                                                [disabled]="emitemployeeBO.iscompleted"
                                                                [(ngModel)]="w4MinnesotaWithholdingBo.reservation_name">
                                                        </p>
                                                    </div>
                                                    <div class="row ms-4" [formGroup]="Section2Form">
                                                        <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Enter your Certificate of
                                                            Degree of Indian Blood (CDIB)/Enrollment
                                                            number&nbsp;&nbsp; <input type="text" class="form-control"
                                                                style="width: 180px;display: inline-block;"
                                                                formControlName="input3"
                                                                [disabled]="emitemployeeBO.iscompleted"
                                                                [(ngModel)]="w4MinnesotaWithholdingBo.enroll_no">
                                                        </p>

                                                    </div>

                                                    <div class="row">

                                                        <div class="col-12">
                                                            <p> <input type="radio" name="radiosection23" value="E"
                                                                    (change)="option_section2($event)"
                                                                    [disabled]="emitemployeeBO.iscompleted"
                                                                    [(ngModel)]="w4MinnesotaWithholdingBo.exemption_minnesota_withholdingsec2"
                                                                    [ngModelOptions]="{standalone: true}">&nbsp;&nbsp;E&nbsp;&nbsp;I
                                                                am a
                                                                member of the Minnesota National Guard or an active duty
                                                                U.S. military member and claim exempt from Minnesota
                                                                withholding
                                                                on my military pay</p>
                                                        </div>

                                                    </div>

                                                    <div class="row">
                                                        <div class="col-12">
                                                            <p> <input type="radio" name="radiosection23" value="F"
                                                                    (change)="option_section2($event)"
                                                                    [disabled]="emitemployeeBO.iscompleted"
                                                                    [(ngModel)]="w4MinnesotaWithholdingBo.exemption_minnesota_withholdingsec2"
                                                                    [ngModelOptions]="{standalone: true}">
                                                                &nbsp;&nbsp;F&nbsp;&nbsp;I
                                                                receive a military pension or other military retirement
                                                                pay as calculated under U.S. Code, title 10, sections
                                                                1401 through 1414, 1447
                                                                through 1455, and 12733, and I claim exempt from
                                                                Minnesota withholding on this retirement pay</p>

                                                        </div>

                                                    </div>



                                                    <div class="row mt-2">
                                                        <p>I certify that all information provided in Section 1 OR
                                                            Section 2 is correct. I understand there is a $500 penalty
                                                            for filing a false Form W-4MN</p>
                                                    </div>

                                                    <div class="row mt-5 ms-2">
                                                        <div class="col-lg-4">
                                                            <button type="button" class="btn blue-btn"
                                                                [disabled]="global.OnboardingLoginType != 'onboardLogin'"
                                                                data-bs-toggle="modal" data-bs-target="#nur">
                                                                Employee’s Signature
                                                            </button>

                                                        </div>
                                                        <div class="col-lg-1">
                                                            <label for="cname">Date:</label>
                                                        </div>
                                                        <div class="col-lg-2">
                                                            <my-date-picker class="w-100"
                                                                [selDate]="w4MinnesotaWithholdingBo.date"
                                                                (inputFieldChanged)="newdates($event,'inputchange','date34')"
                                                                (dateChanged)="newdates($event,'datechanged','date34')"
                                                                [options]="myDatePickerOptions" placeholder="mm/dd/yyyy"
                                                                [disabled]="emitemployeeBO.iscompleted">
                                                            </my-date-picker>
                                                        </div>
                                                        <div class="col-lg-3 text-center">
                                                            <label>Daytime Phone Number</label>
                                                        </div>
                                                        <div class="col-lg-2">
                                                            <input type="text" class="form-control"
                                                                [(ngModel)]="w4MinnesotaWithholdingBo.phoneNumber"
                                                                (ngModelChange)="DemographicPhoneFormat()"
                                                                (keypress)="keyPress($event)" maxlength="14"
                                                                minlength="14" [disabled]="emitemployeeBO.iscompleted">
                                                        </div>


                                                    </div>

                                                    <div class="row mt-2 mb-2">

                                                        <div class="col-lg-4">
                                                            <input *ngIf="clientsign1!=''&& clientsign1!=null "
                                                                type="image" src="{{clientsign1}}" class="form-control"
                                                                style="width: 255px;height:120px;" alt="nurse"
                                                                width="48" height="48">
                                                        </div>
                                                    </div>


                                                    <div class="row mt-2">
                                                        <p>Employees: Give the completed form to your employer. </p>
                                                    </div>
                                                    <div class="row mt-2">
                                                        <h5><b>Employers</b></h5>
                                                    </div>
                                                    <div class="row mt-2">
                                                        See the employer instructions to determine if you must send a
                                                        copy of this form to the Minnesota Department of Revenue. If
                                                        required, enter your
                                                        information below and mail this form to the address in the
                                                        instructions. (Incomplete forms are considered invalid.) We may
                                                        assess a $50 penalty for
                                                        each required Form W-4MN not filed with us. Keep a copy for your
                                                        records
                                                    </div>

                                                    <div class="row mt-2 mb-3">
                                                        <div class="col">
                                                            <div class="card ">
                                                                <div class="card-body" style="padding:25px;">
                                                                    <div class="row">
                                                                        <div class="col-lg-12">
                                                                            <div class="row mt-2">
                                                                                <div class="col-4">
                                                                                    <label>Name of Employer </label>
                                                                                    <input type="text"
                                                                                        class="form-control"
                                                                                        [(ngModel)]="relationshipBo.employeeName"
                                                                                        [disabled]="emitemployeeBO.iscompleted">
                                                                                </div>
                                                                                <div class="col-4">
                                                                                    <label>Minnesota Tax ID
                                                                                        Number</label>

                                                                                    <input type="text"
                                                                                        class="form-control"
                                                                                        [(ngModel)]="w4MinnesotaWithholdingBo.taxIdNumber"
                                                                                        [disabled]="emitemployeeBO.iscompleted"
                                                                                        [ngModelOptions]="{standalone: true}">

                                                                                </div>
                                                                                <div class="col-4">
                                                                                    <label>Federal Employer ID Number
                                                                                        (FEIN)</label>

                                                                                    <input type="text"
                                                                                        class="form-control"
                                                                                        [disabled]="emitemployeeBO.iscompleted"
                                                                                        [(ngModel)]="w4MinnesotaWithholdingBo.federal_Id_number"
                                                                                        [ngModelOptions]="{standalone: true}" />

                                                                                </div>
                                                                            </div>

                                                                            <div class="row mt-2">
                                                                                <div class="col-5">
                                                                                    <label>Address</label>

                                                                                    <textarea class="form-control"
                                                                                        [(ngModel)]="backgroundBo.address"
                                                                                        [disabled]="emitemployeeBO.iscompleted"></textarea>


                                                                                </div>
                                                                                <div class="col-3">
                                                                                    <label>City
                                                                                    </label>
                                                                                    <input type="text"
                                                                                        [(ngModel)]="backgroundBo.city"
                                                                                        class="form-control"
                                                                                        [disabled]="emitemployeeBO.iscompleted">
                                                                                </div>
                                                                                <div class="col-2">
                                                                                    <label>State</label>

                                                                                    <ng-select [items]="stateList"
                                                                                        [(ngModel)]="backgroundBo.state1"
                                                                                        [searchable]="true"
                                                                                        [clearable]="true"
                                                                                        bindLabel="name"
                                                                                        bindValue="abbreviation"
                                                                                        [disabled]="emitemployeeBO.iscompleted">
                                                                                    </ng-select>
                                                                                </div>
                                                                                <div class="col-2">
                                                                                    <label>Zip Code</label>
                                                                                    <input (ngModelChange)="validZip() "
                                                                                        type="text" minlength="5"
                                                                                        maxlength="11"
                                                                                        (keypress)="keyPress($event)"
                                                                                        class="form-control"
                                                                                        [(ngModel)]="backgroundBo.zip"
                                                                                        [disabled]="emitemployeeBO.iscompleted">
                                                                                    <span class="ssn1"
                                                                                        *ngIf="zip7">{{ziperr}}</span>


                                                                                </div>

                                                                            </div>

                                                                        </div>

                                                                    </div>


                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>

                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>







                                <!-- </form> -->
                                <!-- documentBO.w_4MN_minnesotta_withholding_allowance.determiningMinnesotaAllowances.date -->

                                <div class="col-12  mb-3 mt-1 ">
                                    <div class="text-end">
                                        <button class="btn" [disabled]="emitemployeeBO?.iscompleted || isSaveorUpdateBoolean"
                                            *ngIf="global.OnboardingLoginType !='onboardLogin' && !emitemployeeBO.print"
                                            (click)="saveAgreement()">Save</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!--W-4MN Instruction for Employeers-->
            <!-- <div class="row mb-2 mt-2">
                <div class="col p-0">
                    <div class="card " style=" overflow-x:hidden;
                               
                                height:auto;">
                        <div class="col mt-4 text-end">
                            <button class="btn btn-sm me-5" *ngIf="emitemployeeBO.print"
                                (click)="GetEmpOnboardDeatalis('EmpW4Pension')">Print</button>
                        </div>
                        <div class="card-body" style="padding:65px;">
                          
                            <div class="row mt-2 mb-2">
                                <img src="..\assets\img\revenue.JPG" class="img-fluid" alt="Responsive image">
                            </div>

                            <div class="row mt-4">
                                <p>Complete this form for your employer to calculate the amount of Minnesota
                                    income tax to be withheld from your pay.</p>
                            </div>
                            <div class="row mt-2">
                                <h5><b>When should I complete Form W-4MN?</b></h5>
                            </div>
                            <ul style="margin-left:30px;">
                                <li>You begin employment</li>
                                <li>You Change your filing status</li>
                                <li>You reasonably expect to Change your filing status in the next calendar year
                                </li>
                                <li>Your personal or financial situation Changes</li>
                                <li>You claim exempt from Minnesota withholding (see Section 2 instructions for
                                    qualifications)</li>
                                <li> You receive distributions from an annuity or pension</li>
                            </ul>
                            <div class="row mt-2">
                                <p>If you have not had sufficient Minnesota income tax withheld from your wages,
                                    we may assess penalty and interest when you file your state
                                    income tax return</p>
                            </div>
                            <div c lass="row mt-2">
                                <p><b>Note:</b> Your employer may be required to submit a copy of your Form
                                    W-4MN to the Minnesota Department of Revenue. You may be subject to a
                                    $500 penalty if you provide a false Form W-4MN.</p>
                            </div>
                            <div class="row mt-2">
                                <p><b>You must enter your Social Security Number for this Form W-4MN to be
                                        valid. </b></p>
                            </div>
                            <div class="row mt-2">
                                <h5><b>What if I have completed federal Form W-4?</b></h5>
                            </div>
                            <div class="row mt-2">
                                <p>If you completed a 2022 Form W-4, you must complete Form W-4MN to determine
                                    your Minnesota withholding allowances.</p>
                            </div>
                            <div class="row mt-2">
                                <p>If you claim exempt from Minnesota withholding, complete only Section 2 of
                                    Form W-4MN and sign and date the form to validate it. If you
                                    complete Section 2, you must complete a new Form W-4MN by February 15 in
                                    each following year in which you claim an exemption from
                                    Minnesota withholding.</p>
                            </div>
                            <div class="row mt-2">
                                <p>You cannot claim exempt from withholding if all of these apply:</p>
                            </div>
                            <ul style="margin-left: 30px;">
                                <li>
                                    Another person can claim you as a dependent on their federal tax return
                                </li>
                                <li>
                                    Your annual income exceeds $1,100
                                </li>
                                <li>
                                    Your annual income includes more than $350 of unearned income
                                </li>
                            </ul>
                            <div class="row mt-2">
                                <h5><b>What if I am a nonresident alien for U.S. income taxes?</b></h5>
                            </div>
                            <div class="row mt-2">
                                <p>If you are a nonresident alien, you are not allowed to claim exempt from
                                    withholding. You will check the single box for marital status
                                    regardless of your actual marital status and may enter one personal
                                    allowance on Step A. Enter zero on steps B, C, and E.
                                    If you are resident of Canada, Mexico, South Korea, or India, and are
                                    allowed to claim dependents, you may enter the number of dependents on
                                    Step D.</p>
                            </div>
                            <div class="row mt-2">
                                <h5><b>What if I am a nonresident alien for U.S. income taxes?</b></h5>
                            </div>
                            <div class="row mt-2">
                                <p>If you are a nonresident alien, you are not allowed to claim exempt from
                                    withholding. You will check the single box for marital status
                                    regardless of your actual marital status and may enter one personal
                                    allowance on Step A. Enter zero on steps B, C, and E</p>
                            </div>
                            <div class="row mt-2">
                                <p>If you are resident of Canada, Mexico, South Korea, or India, and are allowed
                                    to claim dependents, you may enter the number of dependents on
                                    Step D.</p>
                            </div>
                            <div class="row mt-2">
                                <h4><b>Section 1 — Minnesota Allowances Worksheet</b></h4>
                            </div>
                            <div class="row mt-2">
                                <p>Complete Section 1 to find your allowances for Minnesota withholding tax. For
                                    regular wages, withholding must be based on allowances you
                                    claimed and may not be a flat amount or percentage of wages.</p>
                            </div>
                            <div class="row mt-2">
                                <p>If you expect to owe more income tax for the year than will be withheld, you
                                    can claim fewer allowances or request additional Minnesota
                                    withholding from your wages. Enter the amount of additional Minnesota income
                                    tax you want withheld on line 2 of Section 1.</p>
                            </div>
                            <div class="row mt-2">
                                <h4><b>Nonwage Income</b></h4>
                            </div>
                            <div class="row mt-2">
                                <p>Consider making estimated payments if you have a large amount of “nonwage
                                    income.” Nonwage income (other than tax-exempt income)
                                    includes interest, dividends, net rental income, unemployment compensation,
                                    gambling winnings, prizes and awards, hobby income, capital
                                    gains, royalties, and partnership income. </p>
                            </div>
                            <div class="row mt-2">
                                <h5><b>Two Earners or Multiple Jobs</b></h5>
                            </div>
                            <div class="row mt-2">
                                <p>If your spouse works or you have more than one job, figure the total number
                                    of allowances you are entitled to claim on all jobs using
                                    worksheets from only one Form W-4MN. Usually, your withholding will be more
                                    accurate when all allowances are claimed on the Form
                                    W-4MN for the highest paying job and zero allowances are claimed on the
                                    others.</p>
                            </div>
                            <div class="row mt-2">
                                <h5><b>Head of Household Filing Status</b></h5>
                            </div>
                            <div class="row mt-2">
                                <p>You may claim Head of Household as your filing status if you are unmarried
                                    and pay more than 50% of the costs of keeping up a home for
                                    yourself, your dependents, and other qualifying individuals. Enter “1” on
                                    Step E if you may claim Head of Household as your filing status on
                                    your tax return. </p>
                            </div>
                            <div class="row mt-2">
                                <h5><b>What if I itemize deductions on my Minnesota return or have other nonwage
                                        income?</b></h5>
                            </div>



                            <div class="row mt-2">
                                <p>
                                    Use the Itemized Deductions and Additional Income Worksheet to find your
                                    Minnesota withholding allowances. Complete Section 1 on page 1,
                                    then follow the steps in the worksheet on the next page to find additional
                                    allowances
                                </p>
                            </div>
                            <div class="row mt-2 mb-3">
                                <div class="col">
                                    <div class="card ">
                                        <div class="card-body" style="padding:25px;">
                                            <div class="row">
                                                <div class="col-lg-12">
                                                    <p>1&nbsp;&nbsp;Enter an estimate of your 2022 Minnesota
                                                        itemized deductions. For 2022, you may have to reduce
                                                        your itemized deductions </p>
                                                    <p>if your income is over $206,050 ($103,025 for Married
                                                        Filing Separately). . . . . . . . <input type="number" min="0"  [disabled]="emitemployeeBO.iscompleted"
                                                            class="form-control" [ngModelOptions]="{standalone: true}"
                                                            [(ngModel)]="w4MNInstructionsBo.estimate_Minnesota_ItemizedDeductions"
                                                            style="display: inline-block;width: 200px;">&nbsp;
                                                    </p>
                                                    <p>2&nbsp;&nbsp;Enter one of the following based on your
                                                        filing status:. . . . . . . <input type="number" min="0"  [disabled]="emitemployeeBO.iscompleted"
                                                            class="form-control" [ngModelOptions]="{standalone: true}"
                                                            [(ngModel)]="w4MNInstructionsBo.enterBasedOnFillingStatus"
                                                            style="display: inline-block;width: 200px;">&nbsp;
                                                    </p>

                                                    <ul style="margin-left:30px">
                                                        <li>$25,800 if Married Filing Jointly</li>
                                                        <li>$19,400 if Head of Household</li>
                                                        <li> $12,900 if Single or Married Filing Separately</li>
                                                    </ul>
                                                    <p>3&nbsp;&nbsp;Subtract step 2 from step 1. If zero or
                                                        less, enter 0 . . . . . . . . <input type="number" min="0"
                                                            class="form-control" [ngModelOptions]="{standalone: true}"
                                                            [(ngModel)]="w4MNInstructionsBo.subtractStep2FromStep1"
                                                            style="display: inline-block;width: 200px;" [disabled]="emitemployeeBO.iscompleted">&nbsp;
                                                    </p>
                                                    <p>4&nbsp;&nbsp;Enter an estimate of your 2022 additional
                                                        standard deduction (from page 11 of the Form M1
                                                        instructions). . . . . <input type="number" min="0"
                                                            class="form-control"
                                                            [(ngModel)]="w4MNInstructionsBo.estimate_AdditionalStandardDeductions"
                                                            style="display: inline-block;width: 200px;" [disabled]="emitemployeeBO.iscompleted">&nbsp;
                                                    </p>
                                                    <p>5&nbsp;&nbsp;Add steps 3 and 4 . . . . . <input type="number"
                                                            min="0" class="form-control"
                                                            [ngModelOptions]="{standalone: true}"
                                                            [(ngModel)]="w4MNInstructionsBo.addStep3AndStep4"
                                                            style="display: inline-block;width: 200px;" [disabled]="emitemployeeBO.iscompleted">&nbsp;
                                                    </p>
                                                    <p>6&nbsp;&nbsp;Enter an estimate of your 2022 taxable
                                                        nonwage income . . . . . . . <input type="number" min="0"  [disabled]="emitemployeeBO.iscompleted"
                                                            class="form-control" [ngModelOptions]="{standalone: true}"
                                                            [(ngModel)]="w4MNInstructionsBo.estimateTaxableNonwageIncome"
                                                            style="display: inline-block;width: 200px;">&nbsp;
                                                    </p>
                                                    <p>7&nbsp;&nbsp;Subtract step 6 from step 5. If zero, enter
                                                        0. If less than zero, enter the amount in parentheses. .
                                                        . . . . . . <input type="number" min="0" class="form-control"
                                                            [ngModelOptions]="{standalone: true}"
                                                            [(ngModel)]="w4MNInstructionsBo.subtractStep6FromStep5"  [disabled]="emitemployeeBO.iscompleted"
                                                            style="display: inline-block;width: 200px;">&nbsp;
                                                    </p>
                                                    <p>8&nbsp;&nbsp;Divide the amount on step 7 by $4,450. If a
                                                        negative amount, enter in parentheses. Do not include
                                                        fractions . . . . . . <input type="number" min="0"  [disabled]="emitemployeeBO.iscompleted"
                                                            class="form-control" str
                                                            [(ngModel)]="w4MNInstructionsBo.divideAmountOnStep7bySomeAmt"
                                                            [ngModelOptions]="{standalone: true}"
                                                            style="display: inline-block;width: 200px;">&nbsp;
                                                    </p>
                                                    <p>9&nbsp;&nbsp;Enter the number on step F of Section 1 on
                                                        page 1 . . . . . . . . <input type="number" min="0"
                                                            class="form-control"
                                                            [(ngModel)]="w4MNInstructionsBo.numberStepF" [disabled]="emitemployeeBO.iscompleted"
                                                            [ngModelOptions]="{standalone: true}"
                                                            style="display: inline-block;width: 200px;">&nbsp;
                                                    </p>
                                                    <p>10&nbsp;&nbsp;Add step 8 and 9 and enter the total here.
                                                        If zero or less, enter 0. Enter this amount on line 1 of
                                                        page 1. . . . . . <input type="number" min="0"
                                                            class="form-control"  [disabled]="emitemployeeBO.iscompleted"
                                                            [(ngModel)]="w4MNInstructionsBo.addStep8andStep9"
                                                            [ngModelOptions]="{standalone: true}"
                                                            style="display: inline-block;width: 200px;">&nbsp;
                                                    </p>
                                                </div>

                                            </div>


                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="row mt-2">
                                <h5><b>Section 2 — Minnesota Exemption</b></h5>
                            </div>
                            <div class="row mt-2">
                                <p>Your employer will not withhold Minnesota taxes from your pay if you are
                                    exempt from Minnesota withholding. You cannot claim exempt
                                    from withholding if all of these apply:</p>
                            </div>
                            <ul style="margin-left:30px">
                                <li>Another person can claim you as a dependent on their federal tax return</li>
                                <li>Your annual income exceeds $1,100</li>
                                <li>Your annual income includes more than $350 of unearned income</li>
                            </ul>
                            <div class="row mt-2">
                                <h5><b>Box A</b></h5>
                            </div>
                            <div class="row mt-2">
                                <p>
                                    Check box A of Section 2 to claim exempt if all of these apply:
                                </p>
                            </div>
                            <ul style="margin-left:30px">
                                <li>You meet the requirements to be exempt from federal withholding</li>
                                <li>You had no Minnesota income tax liability in the prior year and received a
                                    full refund of Minnesota tax withheld</li>
                                <li>You expect to have no Minnesota income tax liability for the current year
                                </li>
                            </ul>
                            <div class="row mt-2">
                                <h5><b>Box B</b></h5>
                            </div>
                            <div class="row mt-2">
                                <p>Check box B of Section 2 if you are not claiming exempt from federal
                                    withholding, but meet the second and third requirements for box A.</p>
                            </div>
                            <div class="row mt-2">
                                <h5><b>Box C</b></h5>
                            </div>
                            <div class="row mt-2">
                                <p>
                                    Check box C in Section 2 to claim exempt if all of these apply
                                </p>
                            </div>
                            <ul style="margin-left:30px">
                                <li>
                                    You are the spouse of a military member assigned to duty in Minnesota
                                </li>
                                <li>
                                    You and your spouse are domiciled in another state
                                </li>
                                <li>
                                    You are in Minnesota solely to be with your active duty military spouse
                                    member
                                </li>
                            </ul>
                            <div class="row mt-2">
                                <h5><b>Boxes D-G</b></h5>
                            </div>
                            <div class="row mt-2">
                                <p>If you receive income from the following sources, it is exempt from Minnesota
                                    withholding. Your employer will not withhold Minnesota tax
                                    from that income when you check the appropriate box in Section 2</p>
                            </div>
                            <ul style="margin-left:30px">
                                <li>
                                    <b>Box D:</b> You receive wages as a member of an American Indian tribe
                                    living and working on the reservation of which you are an enrolled
                                    member. Enter the name of your reservation and your Certificate of Degree of
                                    Indian or Alaskan Blood (CDIB) number
                                </li>
                                <li>
                                    <b> Box E:</b> You receive wages for Minnesota National Guard (MNG) pay or
                                    for active duty U.S. military pay. MNG and active duty U.S.
                                    military members can claim exempt from Minnesota withholding on these wages,
                                    even if they are taxable federally. For more information,
                                    see Income Tax Fact Sheet 5, Military Personnel
                                </li>
                                <li>
                                    <b>Box F:</b>You receive a military pension or other military retirement pay
                                    calculated under U.S. Code title 10, sections 1401 through 1414, 1447
                                    through 1455, and 12733. You may claim exempt from Minnesota withholding on
                                    this income even if it is taxable federally
                                </li>
                            </ul>
                            <div class="row mt-2">
                                <p><b>Note:</b> You may not want to claim exempt if you (or your spouse if
                                    filing a joint return) expect to have other forms of income subject to
                                    Minnesota tax and you want to avoid owing tax at the end of the year.
                                    If you complete Section 2, you must complete a new Form W-4MN by February 15
                                    in each following year</p>
                            </div>
                            <div class="row mt-2">
                                <p>If you complete Section 2, you must complete a new Form W-4MN by February 15
                                    in each following year.</p>
                            </div>
                            <div class="row mt-2">
                                <h5><b>Nonresident Alien</b></h5>
                            </div>
                            <div class="row mt-2">
                                <p>If you are a nonresident alien for federal tax purposes, do not complete
                                    Section 2. </p>
                            </div>
                            <div class="row mt-2">
                                <h5>Line 2 — Additional Minnesota Withholding</h5>
                            </div>
                            <div class="row mt-2">
                                <p>If you would like an additional amount of tax to be deducted per payment
                                    period, enter the amount on line 2. Do not enter a percentage of the
                                    payment you want to be deducted</p>
                            </div>
                            <div class="row mt-2">
                                <h5><b>Use of Information</b></h5>
                            </div>
                            <div class="row mt-2">
                                <p>All information on Form W-4MN is private by state law. It cannot be given to
                                    others without your consent, except to the Internal Revenue Service,
                                    to other states that guarantee the same privacy, or by court order. Your
                                    name, address, and Social Security Number are required for identification.
                                    Information about your allowances is required to determine your correct tax.
                                    We ask for your phone number so we can call if we have a question.</p>
                            </div>
                            <div class="row mt-2">
                                <h5><b>Questions?</b></h5>
                            </div>
                            <ul style="margin-left:30px">
                                <li>
                                    Website: www.revenue.state.mn.us
                                </li>
                                <li>
                                    Email: withholding.tax@state.mn.us
                                </li>
                                <li>
                                    Phone: 651-282-9999 or 1-800-657-3594 (toll-free)
                                </li>
                            </ul>
                           
                            <div class="row mb-2 mt-2">
                                <div class="col p-0">
                                    <div class="card " style=" overflow-x:hidden; height:auto;">
                                        <div class="card-body" style="padding:65px;">
                                           
                                            <div class="row mt-2">
                                                <h3><b>Form W-4MN Employer Instructions</b></h3>
                                            </div>
                                            <div class="row mt-2">
                                                <h5><b>Form W-4MN Requirement</b></h5>
                                            </div>
                                            <div class="row mt-2">
                                                <p>Federal Form W-4 will not determine withholding allowances used to
                                                    determine
                                                    the amount of Minnesota withholding. Employees completing a
                                                    2022 Form W-4 will need to complete 2022 Form W-4MN to determine the
                                                    appropriate amount of Minnesota withholding</p>
                                            </div>
                                            <div class="row mt-2">
                                                <h5><b>Lock-In Letters</b></h5>
                                            </div>
                                            <div class="row mt-2">
                                                <p>Internal Revenue Service (IRS) Letter 2800C tells you when the IRS
                                                    believes
                                                    your employee may have filed an incorrect federal Form W-4. If
                                                    you receive this letter, you must provide the Minnesota Department
                                                    of
                                                    Revenue with a copy of the employee’s Form W-4MN. We will verify
                                                    the number of allowances that the employee may claim for Minnesota
                                                    purposes.
                                                    Continue using the Form W-4MN you were using at the time
                                                    you received Letter 2800C from the IRS, until we notify you to
                                                    Change the
                                                    amount of allowances on the employee’s Form W-4MN. If the
                                                    employee has not completed a Form W-4MN, have them complete the form
                                                    and use
                                                    the allowances calculated on that form until notified by the
                                                    department</p>
                                            </div>
                                            <div class="row mt-2">
                                                <p><b>Use the amount on line 1 of page 1 for calculating the withholding
                                                        tax for
                                                        your employees.</b></p>
                                            </div>
                                            <div class="row mt-2">
                                                <h5><b>When does an employee complete Form W-4MN?</b></h5>
                                            </div>
                                            <div class="row mt-2">
                                                <p>Employees complete Form W-4MN when they begin employment or when
                                                    their
                                                    personal or financial situation Changes</p>
                                            </div>
                                            <div class="row mt-2">
                                                <h5><b>How should I determine Minnesota withholding for an employee that
                                                        does
                                                        not complete Form W-4MN?</b></h5>
                                            </div>
                                            <div class="row mt-2">
                                                <p>If an employee does not complete Form W-4MN and they have a federal
                                                    Form W-4
                                                    (from 2019 or prior years) on file, use the allowances on
                                                    their federal Form W-4. Otherwise, withhold Minnesota tax as if the
                                                    employee
                                                    is single with zero withholding allowances.</p>
                                            </div>
                                            <div class="row mt-2">
                                                <h5><b>What if my employee claims to be exempt from Minnesota
                                                        withholding?</b>
                                                </h5>
                                            </div>
                                            <div class="row mt-2">
                                                <p>If your employee claims exempt from Minnesota withholding, they must
                                                    complete
                                                    Section 2 of Form W-4MN. They must provide you with a
                                                    new Form W-4MN by February 15 of each year. If you are paying an
                                                    employee
                                                    for wages that are exempt from withholding, such as Medicaid
                                                    Waiver Payments or wages to H-2A visa workers, do not send us Form
                                                    W-4MN</p>
                                            </div>
                                            <div class="row mt-2">
                                                <h5><b>When do I need to submit copies of a Form W-4MN to the
                                                        department?</b>
                                                </h5>
                                            </div>
                                            <div class="row mt-2">
                                                <p>
                                                    When do I need to submit copies of a Form W-4MN to the department?
                                                </p>
                                            </div>
                                            <ul style="margin-left: 30px;">
                                                <li>The employee claims more than 10 Minnesota withholding allowances
                                                </li>
                                                <li>The employee checked box A or B under Section 2, and you reasonably
                                                    expect
                                                    the employee’s wages to exceed $200 per week</li>
                                                <li>You believe the employee is not entitled to the number of allowances
                                                    claimed
                                                </li>
                                            </ul>
                                            <div class="row mt-2">
                                                <p>You do not need to submit Form W-4MN to us if the employee is asking
                                                    to have
                                                    additional Minnesota withholding deducted from their pay.
                                                    We may assess a $50 penalty for each Form W-4MN you do not file with
                                                    us when
                                                    required.</p>








                                            </div>
                                            <div class="row">
                                                <p>Mail Forms W-4MN to:</p>
                                            </div>
                                            <div class="row">
                                                <p>Minnesota Department of Revenue </p>
                                            </div>
                                            <div class="row">
                                                <p>600 N. Robert St</p>
                                            </div>
                                            <div class="row">
                                                <p>St. Paul, MN 55146-6501</p>
                                            </div>
                                            <div class="row mt-2">
                                                <h5><b>What if my employee is a resident of a state that has a
                                                        reciprocity
                                                        agreement with Minnesota?</b></h5>
                                            </div>
                                            <div class="row mt-2">
                                                <p>If your employee is a resident of North Dakota or Michigan and they
                                                    do not
                                                    want you to withhold Minnesota tax from their wages, they must
                                                    complete Form MWR, Reciprocity Exemption/Affidavit of Residency.
                                                    They must
                                                    complete a Form MWR by February 28 of each year, or within
                                                    30 days after they begin working or Change their permanent
                                                    residence. See
                                                    Withholding Fact Sheet 20, Reciprocity - Employee Withholding, for
                                                    more information. </p>
                                            </div>
                                            <div class="row mt-2">
                                                <h5><b>What is an invalid Form W-4MN?</b></h5>
                                            </div>
                                            <div class="row mt-2">
                                                <p>A Form W-4MN is considered invalid if any of these apply:</p>
                                            </div>
                                            <ul style="margin-left: 30px;">
                                                <li>There is any unauthorized Change or addition to the form, including
                                                    any
                                                    Change to the language certifying the form is correct
                                                </li>
                                                <li>
                                                    The employee indicates in any way the form is false by the date they
                                                    provide
                                                    you with the form
                                                </li>
                                                <li>The form is incomplete or lacks the necessary signatures</li>
                                                <li>Both Section 1 and Section 2 were completed</li>
                                                <li>The employer information is incomplete</li>
                                            </ul>
                                            <div class="row mt-2">
                                                <h5><b>What if I receive an invalid form?</b></h5>
                                            </div>
                                            <div class="row mt-2">
                                                <p>Do not use the invalid form to calculate Minnesota income tax
                                                    withholding.
                                                    Have the employee complete and submit a new Form W-4MN.
                                                    If the employee does not give you a valid form, and you have an
                                                    earlier Form
                                                    W-4MN from them, use the earlier form to calculate their
                                                    withholding</p>
                                                <p>If a valid Form W-4MN is not completed by the employee, withhold
                                                    taxes as if
                                                    the employee is single and claiming zero withholding
                                                    allowances</p>
                                            </div>
                                            <div class="row mt-2">
                                                <h5><b>What if my employee is a nonresident alien of the United
                                                        States?</b></h5>
                                            </div>
                                            <div class="row mt-2">
                                                <p>If the wages to this employee are subject to income tax withholding,
                                                    you will
                                                    use Table 1 and the procedure under<b>Withholding Adjustment
                                                        for Nonresident Alien Employees</b> in IRS Publication 15-T to
                                                    determine
                                                    the correct Minnesota withholding tax. Do not use this procedure
                                                    for nonresident alien students from India and business apprentices
                                                    from
                                                    India. See IRS Notice 1392 for special instructions and withholding
                                                    exceptions</p>
                                            </div>
                                         



                                        </div>
                                    </div>
                                </div>
                            </div>

                    
                            <div class="col-12  mb-3 mt-1 ">

                                <div class=" text-end">
                                    <button class="btn text-end"
                                        *ngIf="global.OnboardingLoginType !='onboardLogin' && !emitemployeeBO.print"
                                        (click)="saveAgreement()">Save</button>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div> -->

        </div>
    </div>
</div>



<span id="NurseSign" data-bs-toggle="modal" data-bs-target="#nursesign"></span>
<div class="modal fade" id="nursesign" data-bs-backdrop="false">
    <div class="modal-dialog modal-md" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title font-header">Rep Sign</h5>
                <button type="button" class="btn-close" (click)="closeNurseSignModal()">&times;</button>
            </div>
            <div class="modal-body">

                <div class="row">
                    <div class="col-lg-12">

                        <signature-pad #EnrollPad [options]="signaturePadOptions" (onEndEvent)="drawsign()">
                        </signature-pad>

                    </div>

                </div>

            </div>
            <div class="modal-footer">
                <button type="button" class="btn blue-btn btn-sm" (click)="ClearEmployeeSignature2()">Clear</button>
                <button type="button" class="btn blue-btn btn-sm" (click)="closeNurseSignModal()">Close</button>
            </div>
        </div>
    </div>
</div>

<div class="modal fade" id="nursesign" data-bs-backdrop="false">
    <div class="modal-dialog modal-md" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title font-header">Rep Sign</h5>
                <button type="button" class="btn-close" data-bs-dismiss="modal">&times;</button>
            </div>
            <div class="modal-body">

                <div class="row">
                    <div class="col-lg-12">

                        <signature-pad #EnrollPad [options]="signaturePadOptions" (onEndEvent)="drawsign()">
                        </signature-pad>

                    </div>

                </div>

            </div>
            <div class="modal-footer">
                <button type="button" class="btn blue-btn btn-sm" (click)="ClearEmployeeSignature2()">Clear</button>
                <button type="button" class="btn blue-btn btn-sm" data-bs-dismiss="modal">Close</button>
            </div>
        </div>
    </div>
</div>
<div class="modal fade" id="emp_signature" data-bs-backdrop="false">
    <div class="modal-dialog modal-md" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title font-header"> Sign</h5>
                <button type="button" class="btn-close" data-bs-dismiss="modal">&times;</button>
            </div>
            <div class="modal-body">

                <div class="row">
                    <div class="col-lg-12">

                        <signature-pad #EnrollPad_EMP [options]="signaturePadOptions"
                            (onEndEvent)="drawsign_employer()">
                        </signature-pad>

                    </div>

                </div>

            </div>
            <div class="modal-footer">
                <button type="button" class="btn blue-btn btn-sm" (click)="ClearEmployee_sign1()">Clear</button>
                <button type="button" class="btn blue-btn btn-sm" data-bs-dismiss="modal">Close</button>
            </div>
        </div>
    </div>
</div>

<div class="modal fade" id="emp_signature2" data-bs-backdrop="false">
    <div class="modal-dialog modal-md" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title font-header"> Sign</h5>
                <button type="button" class="btn-close" data-bs-dismiss="modal">&times;</button>
            </div>
            <div class="modal-body">

                <div class="row">
                    <div class="col-lg-12">

                        <signature-pad #EnrollPad_2 [options]="signaturePadOptions"
                            (onEndEvent)="drawsign_employer_2()">
                        </signature-pad>

                    </div>

                </div>

            </div>
            <div class="modal-footer">
                <button type="button" class="btn blue-btn btn-sm" (click)="clearemployyesing3()">Clear</button>
                <button type="button" class="btn blue-btn btn-sm" data-bs-dismiss="modal">Close</button>
            </div>
        </div>
    </div>
</div>

<!-- <div class="modal fade" id="RZ"  data-bs-backdrop="false">
    <div class="modal-dialog modal-md" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title font-header"> Sign</h5>
                <button type="button" class="btn-close"  data-bs-dismiss="modal">&times;</button>
            </div>
            <div class="modal-body">

                <div class="row">
                    <div class="col-lg-12">

                        <signature-pad #EnrollPad_2 [options]="signaturePadOptions"
                            (onEndEvent)="drawsign_employer_2()">
                        </signature-pad>

                    </div>

                </div>

            </div>
            <div class="modal-footer">
                <button type="button" class="btn blue-btn btn-sm" (click)="ClearEmployee_sign3()">Clear</button>
                <button type="button" class="btn blue-btn btn-sm"  data-bs-dismiss="modal">Close</button>
            </div>
        </div>
    </div>
</div> -->
<div class="modal fade" id="app_signature" data-bs-backdrop="false">
    <div class="modal-dialog modal-md" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title font-header"> Sign</h5>
                <button type="button" class="btn-close" data-bs-dismiss="modal">&times;</button>
            </div>
            <div class="modal-body">

                <div class="row">
                    <div class="col-lg-12">

                        <signature-pad #EnrollPad_APP [options]="signaturePadOptions"
                            (onEndEvent)="drawsign_applicant()">
                        </signature-pad>

                    </div>

                </div>

            </div>
            <div class="modal-footer">
                <button type="button" class="btn blue-btn btn-sm" (click)="ClearApplicant_sign()">Clear</button>
                <button type="button" class="btn blue-btn btn-sm" data-bs-dismiss="modal">Close</button>
            </div>
        </div>
    </div>
</div>

<span id="i9FormModal" data-bs-toggle="modal" data-bs-target="#signature_employee"></span>
<div class="modal" tabindex="-1" role="dialog" id="signature_employee" data-bs-backdrop="false">
    <div class="modal-dialog" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title">Signature employee</h5>
                <button type="button" class="btn-close" (click)="closeSignarueModal()" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body">
                <div class="row mt-2 ms-2">
                    <div class="col-lg-12">
                        <signature-pad #EmployeeSignaturePad [options]="signaturePadOptions"
                            (onEndEvent)="drawCompeteemployeesign()"></signature-pad>


                    </div>


                </div>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn blue-btn" (click)="ClearEmployee_sign()">Clear</button>
                <button type="button" class="btn blue-btn" (click)="closeSignarueModal()">Close</button>
            </div>
        </div>
    </div>
</div>
<span id="BackModal1" data-bs-toggle="modal" data-bs-target="#background_modal1"></span>
<div class="modal" tabindex="-1" role="dialog" id="background_modal1" data-bs-backdrop="false">
    <div class="modal-dialog" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title">Signature employee</h5>
                <button type="button" class="btn-close" (click)="closeBackModal1()" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body">
                <div class="row mt-2 ms-2">
                    <div class="col-lg-12">
                        <signature-pad #EnrollmentsignaturePad [options]="signaturePadOptions"
                            (onEndEvent)="drawCompleteEmployeesign()"></signature-pad>


                    </div>


                </div>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn blue-btn" (click)="ClearEmployeeSignature()">Clear</button>
                <button type="button" class="btn blue-btn" (click)="closeBackModal1()">Close</button>
            </div>
        </div>
    </div>
</div>


<span id="BackModal2" data-bs-toggle="modal" data-bs-target="#background_modal2"></span>

<div class="modal" tabindex="-1" role="dialog" id="background_modal2" data-bs-backdrop="false">
    <div class="modal-dialog" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title">Legal Guardian Signature (If employee is under the age of 18):</h5>
                <button type="button" class="btn-close" (click)="closeBackModal2()" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body">
                <div class="row mt-2 ms-2">
                    <div class="col-lg-12">
                        <signature-pad #GurdiansignaturePad [options]="signaturePadOptions"
                            (onEndEvent)="drawCompleteGurdiansign()"></signature-pad>


                    </div>


                </div>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn blue-btn" (click)="ClearGurdianSignature()">Clear</button>
                <button type="button" class="btn blue-btn" (click)="closeBackModal2()">Close</button>
            </div>
        </div>
    </div>
</div>
<span id="BackModal3" data-bs-toggle="modal" data-bs-target="#background_modal3"></span>

<div class="modal" tabindex="-1" role="dialog" id="background_modal3" data-bs-backdrop="false">
    <div class="modal-dialog" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title">Legal Guardian Signature (If employee is under the age of 18):</h5>
                <button type="button" class="btn-close" (click)="closeBackModal3()" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body">
                <div class="row mt-2 ms-2">
                    <div class="col-lg-12">
                        <signature-pad #GurdianPad [options]="signaturePadOptions" (onEndEvent)="drawGurdiansign()">
                        </signature-pad>


                    </div>


                </div>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn blue-btn" (click)="ClearGurdianSignature1()">Clear</button>
                <button type="button" class="btn blue-btn" (click)="closeBackModal3()">Close</button>
            </div>
        </div>
    </div>
</div>
<span id="DHS_4469AModal1" data-bs-toggle="modal" data-bs-target="#DHS_4469A_modal1"></span>

<div class="modal" tabindex="-1" role="dialog" id="DHS_4469A_modal1" data-bs-backdrop="false">
    <div class="modal-dialog" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title">ORGANIZATION PERSONNEL SIGNATURE:</h5>
                <button type="button" class="btn-close" (click)="closeDHS_4469AModal1()" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body">
                <div class="row mt-2 ms-2">
                    <div class="col-lg-12">
                        <signature-pad #SupportworkerPad [options]="signaturePadOptions"
                            (onEndEvent)="drawCompetesupportsign()"></signature-pad>


                    </div>


                </div>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn blue-btn" (click)="clearsupportsign()">Clear</button>
                <button type="button" class="btn blue-btn" (click)="closeDHS_4469AModal1()">Close</button>
            </div>
        </div>
    </div>
</div>
<span id="DHS_4469AModal2" data-bs-toggle="modal" data-bs-target="#DHS_4469A_modal2"></span>

<div class="modal" tabindex="-1" role="dialog" id="DHS_4469A_modal2" data-bs-backdrop="false">
    <div class="modal-dialog" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title">Applicant Signature:</h5>
                <button type="button" class="btn-close" (click)="closeDHS_4469AModal2()" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body">
                <div class="row mt-2 ms-2">
                    <div class="col-lg-12">
                        <signature-pad #SignatureIndividualPad [options]="signaturePadOptions"
                            (onEndEvent)="drawCompeteindividualsign()"></signature-pad>


                    </div>


                </div>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn blue-btn" (click)="clearindividualsign()">Clear</button>
                <button type="button" class="btn blue-btn" (click)="closeDHS_4469AModal2()">Close</button>
            </div>
        </div>
    </div>
</div>
<span id="Employee_GenModal1" data-bs-toggle="modal" data-bs-target="#Employee_Gen_modal1"></span>

<div class="modal" tabindex="-1" role="dialog" id="Employee_Gen_modal1" data-bs-backdrop="false">
    <div class="modal-dialog" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title">Employee/Applicant Signature</h5>
                <button type="button" class="btn-close" (click)="closeEmployeeGenModal1()" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body">
                <div class="row mt-2 ms-2">
                    <div class="col-lg-12">
                        <signature-pad #ApplicantsignaturePad [options]="signaturePadOptions"
                            (onEndEvent)="drawCompleteapplicantsign()"></signature-pad>


                    </div>


                </div>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn blue-btn" (click)="clearApplicantsign()">Clear</button>
                <button type="button" class="btn blue-btn" (click)="closeEmployeeGenModal1()">Close</button>
            </div>
        </div>
    </div>
</div>
<span id="Employee_GenModal2" data-bs-toggle="modal" data-bs-target="#Employee_Gen_modal2"></span>

<div class="modal" tabindex="-1" role="dialog" id="Employee_Gen_modal2" data-bs-backdrop="false">
    <div class="modal-dialog" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title">Signature of parent/Legal Guardian</h5>
                <button type="button" class="btn-close" (click)="closeEmployeeGenModal2()" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body">
                <div class="row mt-2 ms-2">
                    <div class="col-lg-12">
                        <signature-pad #LegalsignaturePad [options]="signaturePadOptions"
                            (onEndEvent)="drawCompletelegalsign()"></signature-pad>


                    </div>


                </div>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn blue-btn" (click)="clearLegalsign()">Clear</button>
                <button type="button" class="btn blue-btn" (click)="closeEmployeeGenModal2()">Close</button>
            </div>
        </div>
    </div>
</div>
<span id="FEA_EmpModal1" data-bs-toggle="modal" data-bs-target="#FEA_Emp_modal1"></span>

<div class="modal" tabindex="-1" role="dialog" id="FEA_Emp_modal1" data-bs-backdrop="false">
    <div class="modal-dialog" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title">Employee Signature</h5>
                <button type="button" class="btn-close" (click)="closeFEAModal1()" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body">
                <div class="row mt-2 ms-2">
                    <div class="col-lg-12">
                        <signature-pad #Pad [options]="signaturePadOptions" (onEndEvent)="sign1()"></signature-pad>


                    </div>


                </div>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn blue-btn" (click)="ClearEmployeeSignature3()">Clear</button>
                <button type="button" class="btn blue-btn" (click)="closeFEAModal1()">Close</button>
            </div>
        </div>
    </div>
</div>


<span id="ageModal1" data-bs-toggle="modal" data-bs-target="#agepage_modal1"></span>

<div class="modal" tabindex="-1" role="dialog" id="agepage_modal1" data-bs-backdrop="false">
    <div class="modal-dialog" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title">SIGNATURE OF SUPPORT WORKER</h5>
                <button type="button" class="btn-close" (click)="closeageModal1()" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body">
                <div class="row mt-2 ms-2">
                    <div class="col-lg-12">
                        <signature-pad #ageRepSignaturePad [options]="signaturePadOptions"
                            (onEndEvent)="drawCompeteRepsign()"></signature-pad>


                    </div>


                </div>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn blue-btn" (click)="clearRepsign()">Clear</button>
                <button type="button" class="btn blue-btn" (click)="closeageModal1()">Close</button>
            </div>
        </div>
    </div>
</div>
<span id="WageModal1" data-bs-toggle="modal" data-bs-target="#wagepage_modal1"></span>

<div class="modal" tabindex="-1" role="dialog" id="wagepage_modal1" data-bs-backdrop="false">
    <div class="modal-dialog" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title">Participant/Rep Signature</h5>
                <button type="button" class="btn-close" (click)="closeWageModal1()" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body">
                <div class="row mt-2 ms-2">
                    <div class="col-lg-12">
                        <signature-pad #WageRepSignaturePad [options]="signaturePadOptions"
                            (onEndEvent)="drawCompeteRepemployeesign()"></signature-pad>


                    </div>


                </div>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn blue-btn" (click)="clearRepemployeesign()">Clear</button>
                <button type="button" class="btn blue-btn" (click)="closeWageModal1()">Close</button>
            </div>
        </div>
    </div>
</div>
<span id="TranslatorModal" data-bs-toggle="modal" data-bs-target="#traslatorModal"></span>

<div class="modal" tabindex="-1" role="dialog" id="traslatorModal" data-bs-backdrop="false">
    <div class="modal-dialog" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title">Signature of Preparer or Translator</h5>
                <button type="button" class="btn-close" (click)="closeTranslatorModal()" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body">
                <div class="row mt-2 ms-2">
                    <div class="col-lg-12">
                        <signature-pad #TranslatorSignaturePad [options]="signaturePadOptions"
                            (onEndEvent)="drawCompetetranslatorsign()"></signature-pad>


                    </div>


                </div>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn blue-btn" (click)="cleartranslatorsign()">Clear</button>
                <button type="button" class="btn blue-btn" (click)="closeTranslatorModal()">Close</button>
            </div>
        </div>
    </div>
</div>
<span id="AuthorizedModal" data-bs-toggle="modal" data-bs-target="#authorizedModal"></span>

<div class="modal" tabindex="-1" role="dialog" id="authorizedModal" data-bs-backdrop="false">
    <div class="modal-dialog" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title">Signature of Employer or Authorized Representative</h5>
                <button type="button" class="btn-close" (click)="closeAuthorizedModal()" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body">
                <div class="row mt-2 ms-2">
                    <div class="col-lg-12">
                        <signature-pad #AuthorizedSignaturePad [options]="signaturePadOptions"
                            (onEndEvent)="drawCompeteauthorizedsign()"></signature-pad>


                    </div>


                </div>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn blue-btn" (click)="clearauthorizedsign()">Clear</button>
                <button type="button" class="btn blue-btn" (click)="closeAuthorizedModal()">Close</button>
            </div>
        </div>
    </div>
</div>
<span id="AuthorizedRepModal" data-bs-toggle="modal" data-bs-target="#authorizedRepModal"></span>

<div class="modal" tabindex="-1" role="dialog" id="authorizedRepModal" data-bs-backdrop="false">
    <div class="modal-dialog" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title">Signature of Employer or Authorized Representative</h5>
                <button type="button" class="btn-close" (click)="closeAuthorizedRepModal()" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body">
                <div class="row mt-2 ms-2">
                    <div class="col-lg-12">
                        <signature-pad #AuthorizedRepSignaturePad [options]="signaturePadOptions"
                            (onEndEvent)="drawCompeteauthorizedRepsign()"></signature-pad>


                    </div>


                </div>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn blue-btn" (click)="clearauthorizedRepsign()">Clear</button>
                <button type="button" class="btn blue-btn" (click)="closeAuthorizedRepModal()">Close</button>
            </div>
        </div>
    </div>
</div>


<span id="NurseSignModal" data-bs-toggle="modal" data-bs-target="#nursesignmodal"></span>
<div class="modal fade" id="nursesignmodal" data-bs-backdrop="false">
    <div class="modal-dialog modal-md" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title font-header">Employee Sign</h5>
                <button type="button" class="btn-close" (click)="closeNurseModal()">&times;</button>
            </div>
            <div class="modal-body">

                <signature-pad #EmpSignPad [options]="signaturePadOptions" (onEndEvent)="drawCompleteEmpsign()">
                </signature-pad>

                <div class="row">
                    <div class="col-lg-12">



                    </div>

                </div>

            </div>
            <div class="modal-footer">
                <button type="button" class="btn blue-btn btn-sm" (click)="ClearEmployeeSignature1()">Clear</button>
                <button type="button" class="btn blue-btn btn-sm" id="closedeletemodal"
                    (click)="closeNurseModal()">Close</button>
            </div>
        </div>
    </div>
</div>
<div class="modal fade" id="nursesign" data-bs-backdrop="false">
    <div class="modal-dialog modal-md" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title font-header">Rep Sign</h5>
                <button type="button" class="btn-close" data-bs-dismiss="modal">&times;</button>
            </div>
            <div class="modal-body">

                <div class="row">
                    <div class="col-lg-12">

                        <signature-pad #EnrollPad [options]="signaturePadOptions" (onEndEvent)="drawsign()">
                        </signature-pad>

                    </div>

                </div>

            </div>
            <div class="modal-footer">
                <button type="button" class="btn blue-btn btn-sm" (click)="ClearEmployeeSignature2()">Clear</button>
                <button type="button" class="btn blue-btn btn-sm" id="closedeletemodal"
                    data-bs-dismiss="modal">Close</button>
            </div>
        </div>
    </div>
</div>
<div class="modal fade" id="nurse" data-bs-backdrop="false">
    <div class="modal-dialog modal-md" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title font-header"> Sign</h5>
                <button type="button" class="btn-close" data-bs-dismiss="modal">&times;</button>
            </div>
            <div class="modal-body">

                <div class="row">
                    <div class="col-lg-12">

                        <signature-pad #rollPad [options]="signaturePadOptions" (onEndEvent)="draw()"></signature-pad>

                    </div>

                </div>

            </div>
            <div class="modal-footer">
                <button type="button" class="btn blue-btn btn-sm" (click)="ClearEmployeeSignature4()">Clear</button>
                <button type="button" class="btn blue-btn btn-sm" id="closedeletemodal"
                    data-bs-dismiss="modal">Close</button>
            </div>
        </div>
    </div>
</div>
<div class="modal fade" id="epe" data-bs-backdrop="false">
    <div class="modal-dialog modal-md" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title font-header"> Sign</h5>
                <button type="button" class="btn-close" data-bs-dismiss="modal">&times;</button>
            </div>
            <div class="modal-body">

                <div class="row">
                    <div class="col-lg-12">

                        <signature-pad #rollPad3 [options]="signaturePadOptions" (onEndEvent)="draw3()"></signature-pad>

                    </div>

                </div>

            </div>
            <div class="modal-footer">
                <button type="button" class="btn blue-btn btn-sm" (click)="ClearEmployeeSignature9()">Clear</button>
                <button type="button" class="btn blue-btn btn-sm" id="closedeletemodal"
                    data-bs-dismiss="modal">Close</button>
            </div>
        </div>
    </div>
</div>
<div class="modal fade" id="epr" data-bs-backdrop="false">
    <div class="modal-dialog modal-md" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title font-header"> Sign</h5>
                <button type="button" class="btn-close" data-bs-dismiss="modal">&times;</button>
            </div>
            <div class="modal-body">

                <div class="row">
                    <div class="col-lg-12">

                        <signature-pad #rollPad4 [options]="signaturePadOptions" (onEndEvent)="draw4()"></signature-pad>

                    </div>

                </div>

            </div>
            <div class="modal-footer">
                <button type="button" class="btn blue-btn btn-sm" (click)="ClearEmployeeSignature0()">Clear</button>
                <button type="button" class="btn blue-btn btn-sm" id="closedeletemodal"
                    data-bs-dismiss="modal">Close</button>
            </div>
        </div>
    </div>
</div>
<div class="modal fade" id="applicant" data-bs-backdrop="false">
    <div class="modal-dialog modal-md" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title font-header"> Sign</h5>
                <button type="button" class="btn-close" data-bs-dismiss="modal">&times;</button>
            </div>
            <div class="modal-body">

                <div class="row">
                    <div class="col-lg-12">

                        <signature-pad #appsignpad [options]="signaturePadOptions" (onEndEvent)="appsign()">
                        </signature-pad>

                    </div>

                </div>

            </div>
            <div class="modal-footer">
                <button type="button" class="btn blue-btn btn-sm" (click)="Clearapp()">Clear</button>
                <button type="button" class="btn blue-btn btn-sm" id="closedeletemodal"
                    data-bs-dismiss="modal">Close</button>
            </div>
        </div>
    </div>
</div>

<div class="modal fade" id="parentsign" data-bs-backdrop="false">
    <div class="modal-dialog modal-md" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title font-header"> Sign</h5>
                <button type="button" class="btn-close" data-bs-dismiss="modal">&times;</button>
            </div>
            <div class="modal-body">

                <div class="row">
                    <div class="col-lg-12">

                        <signature-pad #parentsignpad [options]="signaturePadOptions" (onEndEvent)="parentsign()">
                        </signature-pad>

                    </div>

                </div>

            </div>
            <div class="modal-footer">
                <button type="button" class="btn blue-btn btn-sm" (click)="Clearparent2()">Clear</button>
                <button type="button" class="btn blue-btn btn-sm" id="closedeletemodal"
                    data-bs-dismiss="modal">Close</button>
            </div>
        </div>
    </div>
</div>

<div class="modal fade" id="authsign" data-bs-backdrop="false">
    <div class="modal-dialog modal-md" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title font-header"> Sign</h5>
                <button type="button" class="btn-close" data-bs-dismiss="modal">&times;</button>
            </div>
            <div class="modal-body">

                <div class="row">
                    <div class="col-lg-12">

                        <signature-pad #authsignpad [options]="signaturePadOptions" (onEndEvent)="parentsign1()">
                        </signature-pad>

                    </div>

                </div>

            </div>
            <div class="modal-footer">
                <button type="button" class="btn blue-btn btn-sm" (click)="Clearparent()">Clear</button>
                <button type="button" class="btn blue-btn btn-sm" id="closedeletemodal"
                    data-bs-dismiss="modal">Close</button>
            </div>
        </div>
    </div>
</div>



<div class="modal fade" id="nur" data-bs-backdrop="false">
    <div class="modal-dialog modal-md" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title font-header"> Sign</h5>
                <button type="button" class="btn-close" data-bs-dismiss="modal">&times;</button>
            </div>
            <div class="modal-body">

                <div class="row">
                    <div class="col-lg-12">

                        <signature-pad #EnPad [options]="signaturePadOptions" (onEndEvent)="create()"></signature-pad>

                    </div>

                </div>

            </div>
            <div class="modal-footer">
                <button type="button" class="btn blue-btn btn-sm" (click)="ClearEmployeeSignature5()">Clear</button>
                <button type="button" class="btn blue-btn btn-sm" id="closedeletemodal"
                    data-bs-dismiss="modal">Close</button>
            </div>
        </div>
    </div>
</div>
<div class="modal fade" id="deposit" data-bs-backdrop="false">
    <div class="modal-dialog modal-md" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title font-header"> Sign</h5>
                <button type="button" class="btn-close" data-bs-dismiss="modal">&times;</button>
            </div>
            <div class="modal-body">

                <div class="row">
                    <div class="col-lg-12">

                        <signature-pad #depositPad [options]="signaturePadOptions" (onEndEvent)="create2()">
                        </signature-pad>

                    </div>

                </div>

            </div>
            <div class="modal-footer">
                <button type="button" class="btn blue-btn btn-sm" (click)="ClearEmployeeSignature6()">Clear</button>
                <button type="button" class="btn blue-btn btn-sm" id="closedeletemodal"
                    data-bs-dismiss="modal">Close</button>
            </div>
        </div>
    </div>
</div>


<span id="sendToEmployermodal" data-bs-toggle="modal" data-bs-target="#sendToEmployer"></span>
<div class="modal fade" id="sendToEmployer" data-bs-backdrop="false">
    <div class="modal-dialog modal-md">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title font-header" id="exampleModalLabel">
                    <span>Mail Notes</span>
                </h5>
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true"></span>
                </button>
            </div>
            <div class="modal-body">
                <p>Notes</p>
                <label class="mx-auto" style="font-size: 12px; color: red;"><i
                        class="fa fa-info-circle fa-lg"></i>&nbsp;
                    This will be attached above in this mail</label>
                <textarea class="form-control" [(ngModel)]="sendtoemployer.agencyNote"> </textarea>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn  btn-sm" (click)="SentToEmployer()">Submit</button>
                <button type="button" class="btn  btn-sm" data-bs-dismiss="modal">Cancel</button>
            </div>
        </div>
    </div>
</div>


<span id="sendToEmployeModal" data-bs-toggle="modal" data-bs-target="#sendToEmployee"></span>
<div class="modal fade" id="sendToEmployee" data-bs-backdrop="false">
    <div class="modal-dialog modal-md">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title font-header" id="exampleModalLabel">
                    <span>Mail Notes</span>
                </h5>
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true"></span>
                </button>
            </div>
            <div class="modal-body">
                <p>Notes</p>
                <label class="mx-auto" style="font-size: 12px; color: red;"><i
                        class="fa fa-info-circle fa-lg"></i>&nbsp;
                    This will be attached above in this mail</label>
                <textarea class="form-control" [(ngModel)]="sendtoemployee.agencyNote"> </textarea>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn  btn-sm" (click)="SentToEmployee()">Submit</button>
                <button type="button" class="btn  btn-sm" data-bs-dismiss="modal">Cancel</button>
            </div>
        </div>
    </div>
</div>



<div style="position: absolute; left: -1156px; top: 500px;">
    <kendo-pdf-export #pdfOnboardinglistEmp paperSize="A3">
        <div style="width:1080px;padding-left: 15px;">
            <div class="mx-2">
                <div class="row mb-2" *ngIf="EMPAppCover">
                    <div class="col p-0">
                        <div class="card ">

                            <div class="card-body" style="padding:65px;">
                                <!-- <form [formGroup]=""> -->
                                <div class="row mt-2 mb-2 justify-content-center">
                                    <h3 class="text-center"><b>Employee Application Cover</b></h3>
                                </div>
                                <div class="d-flex mt-3">
                                    <p class="ms-4 mt-1">Thank you for completing </p>
                                    <input id="scrollArea" [(ngModel)]="employeeApplicationBo.employeeName"
                                        class="form-control mx-1" style="width:30rem;" type="text" disabled>
                                    <p class="mt-lg-1"> Employee Application.</p>

                                </div>
                                <ul style="margin-left:30px">
                                    <div class="row mt-4">
                                        <li>You are the applicant or employee in the following forms.</li>
                                    </div>
                                    <div class="row mt-4">
                                        <li>Please include a copy of your photo ID.</li>
                                    </div>
                                    <div class="row mt-4">
                                        <li>The Department of Human Services (DHS) does not accept an electronic
                                            signature on
                                            their Individual Support Worker Application. DHS accepts a copy of the
                                            completed form.
                                            DHS refers to the applicant or employee as the Individual Direct Support
                                            Worker</li>
                                    </div>
                                    <div class="row mt-4">
                                        <li>You cannot be scheduled until you have cleared a background study which
                                            includes
                                            fingerprinting.{{global.agencyName}} pays for the cost of the study and
                                            fingerprinting can only be
                                            completed at an approved location. We notify your employer of your start
                                            date. We
                                            cannot pay hours before you are cleared to work by DHS.</li>
                                    </div>
                                    <div class="row mt-4">
                                        <li>Your employer will provide your pay rate and signs your Pay Notice.</li>
                                    </div>
                                    <div class="row mt-4">
                                        <li>Your employer will verify your ID’s for the Employment Eligibility
                                            Verification (I-9) and
                                            sign under the Employer section of that form.</li>
                                    </div>
                                    <div class="row mt-4">
                                        <li>{{global.agencyName}} is your employer’s Fiscal/ Employer Agent (F/ EA).
                                        </li>

                                    </div>

                                </ul>


                                <!-- </form> -->

                            </div>


                        </div>
                    </div>
                </div>
                <!--dis  -->
                <span [ngClass]="{'page-break-before': BackAuth,'page-break-before-single':singlePrint}"></span>
                <div class="row " *ngIf="BackAuth">
                    <div class="col p-0">
                        <div class="card" style="height:auto;">
                            <div class="card-body" style="padding:35px;">
                                <div class="row mt-2 mb-2 justify-content-center">
                                    <h3 class="ms-lg-1 text-center"><b>Background Study Authorization</b></h3>
                                </div>
                                <div class="col p-0">
                                    <h6 class=""><b>Participant/Employer</b></h6>
                                </div>
                                <div class="row mt-2">
                                    <div class="col-lg-3">
                                        <input type="text" class="form-control" disabled
                                            [(ngModel)]="backgroundBo.participantName">
                                    </div>
                                </div>
                                <div class="row  mb-3">
                                    <div class="col">
                                        <div class="card ">
                                            <div class="card-body" style="padding:25px;">
                                                <div class="row">
                                                    <div class="col-lg-12">
                                                        <div class="row">
                                                            <h6 class="ms-lg-1"><b>Applicant Information</b></h6>
                                                        </div>
                                                        <div class="row">
                                                            <div class="col-lg-3 col-md-6 col-sm-6">
                                                                <label class="label">
                                                                    First Name

                                                                </label>
                                                                <input type="text" class="form-control"
                                                                    [(ngModel)]="backgroundBo.firstName" disabled>
                                                            </div>
                                                            <div class="col-lg-3 col-md-6 col-sm-6">
                                                                <label class="label">Middle Name</label>
                                                                <input type="text" class="form-control"
                                                                    [(ngModel)]="backgroundBo.middleName" disabled>
                                                            </div>
                                                            <div class="col-lg-3 col-md-6 col-sm-6">
                                                                <label class="label">Last Name </label>
                                                                <input type="text" class="form-control"
                                                                    [(ngModel)]="backgroundBo.lastName" disabled>
                                                            </div>
                                                            <div class="col-lg-3 col-md-6 col-sm-6">
                                                                <label class="label">Gender </label>

                                                                <ng-select [(ngModel)]="backgroundBo.genderName"
                                                                    disabled>

                                                                </ng-select>
                                                            </div>
                                                            <div class="col-lg-3 col-md-6 col-sm-6">
                                                                <label class="label">
                                                                    Date of Birth </label>

                                                                <input type="text" class="form-control"
                                                                    [(ngModel)]="backgroundBo.dob">
                                                            </div>
                                                            <div class="col-lg-3 col-md-6 col-sm-6">
                                                                <label class="label">SSN
                                                                </label>
                                                                <input type="text" [(ngModel)]="backgroundBo.ssn"
                                                                    class="form-control" disabled>

                                                            </div>

                                                            <div class="col-lg-3 col-md-6 col-sm-6">
                                                                <label class="label">Phone Number</label>
                                                                <input class=" form-control" type="text"
                                                                    [(ngModel)]="backgroundBo.phone" disabled>
                                                            </div>
                                                            <div class="col-lg-3 col-md-6 col-sm-6">
                                                                <label class="label">Email
                                                                </label>
                                                                <input type="text" class="form-control"
                                                                    [(ngModel)]="backgroundBo.email" disabled>
                                                            </div>
                                                        </div>
                                                        <div class="row">
                                                            <div class="col-lg-3 col-md-6 col-sm-6">
                                                                <label class="label">Driver License</label>
                                                                <input class=" form-control" type="text" disabled
                                                                    [(ngModel)]="backgroundBo.driver_LicenseNo">
                                                            </div>

                                                            <div class="col-lg-3 col-md-6 col-sm-6">
                                                                <label class="label">State</label>
                                                                <ng-select class="width25"
                                                                    [(ngModel)]="backgroundBo.state" disabled>
                                                                </ng-select>
                                                            </div>

                                                            <div class="col-lg-3  col-md-6 col-sm-6">
                                                                <label class="label">
                                                                    Place of Birth</label>
                                                                <input class=" form-control" type="text" disabled
                                                                    [(ngModel)]="backgroundBo.placeofBirth">
                                                            </div>
                                                        </div>

                                                        <div class="row mt-2">
                                                            <label class="label ms-lg-3"><b>Address</b> </label>
                                                        </div>
                                                        <div class="row">
                                                            <div class="col-lg-3 col-md-6 col-sm-6">
                                                                <label class="label">street</label>
                                                                <input type="text" class="form-control"
                                                                    [(ngModel)]="backgroundBo.address" disabled>
                                                            </div>
                                                            <div class="col-lg-3 col-md-6 col-sm-6">
                                                                <label class="label">City</label>
                                                                <input type="text" class="form-control"
                                                                    [(ngModel)]="backgroundBo.city" disabled>
                                                            </div>
                                                            <div class="col-lg-3 col-md-6 col-sm-6">
                                                                <label class="label">State</label>
                                                                <ng-select [items]="stateList" class="width25"
                                                                    [(ngModel)]="backgroundBo.state1" disabled>
                                                                </ng-select>
                                                            </div>
                                                            <div class="col-lg-3 col-md-6 col-sm-6">
                                                                <label class="label">ZipCode</label>
                                                                <input class="form-control"
                                                                    [(ngModel)]="backgroundBo.zip" disabled />

                                                            </div>
                                                        </div>
                                                        <div class="row">
                                                            <div class="col-lg-3 col-md-6 col-sm-6">
                                                                <label class="label">County</label>
                                                                <input type="text" class="form-control"
                                                                    [(ngModel)]="backgroundBo.county" disabled>
                                                            </div>
                                                        </div>
                                                        <div class="row mt-2">
                                                            <label class="label ml-lg-4 mt-lg-1"><b>Previous Names Used
                                                                </b></label>
                                                        </div>
                                                        <div class="d-flex">
                                                            <div class="col-lg-4">
                                                                <input type="text"
                                                                    [(ngModel)]="backgroundBo.previousNamesUsed1"
                                                                    class="form-control">
                                                            </div>
                                                            <div class="col-lg-2"></div>
                                                            <div class="col-lg-4 d-flex">
                                                                <label class=" col-lg-4 label mt-1">Date</label>

                                                                <input type="text" class="form-control"
                                                                    [(ngModel)]="backgroundBo.previousNamesUsedDate1">
                                                            </div>
                                                        </div>
                                                        <div class="d-flex mt-1">
                                                            <div class="col-lg-4">
                                                                <input type="text" class="form-control"
                                                                    [(ngModel)]="backgroundBo.previousNamesUsed2">
                                                            </div>
                                                            <div class=" col-lg-2">
                                                            </div>
                                                            <div class="col-lg-4 d-flex">
                                                                <label class=" col-lg-4 label mt-1">Date</label>

                                                                <input type="text" class="form-control"
                                                                    [(ngModel)]="backgroundBo.previousNamesUsedDate2">
                                                            </div>
                                                        </div>
                                                        <div class="row mt-2">
                                                            <label class="label ml-lg-4"><b>Previous Addresses Used
                                                                    (within
                                                                    the last 5 years)</b></label>
                                                        </div>
                                                        <div class="d-flex">
                                                            <div class="col-lg-4">
                                                                <textarea
                                                                    [(ngModel)]="backgroundBo.previous_Addresses_Used1"
                                                                    class="form-control"></textarea>
                                                            </div>
                                                            <div class="col-lg-2"></div>
                                                            <div class="col-lg-4 d-flex">
                                                                <label class="label col-lg-4 mt-1">Date</label>

                                                                <input type="text" class="form-control"
                                                                    [(ngModel)]="backgroundBo.previous_Addresses_UsedDate1">
                                                            </div>
                                                        </div>
                                                        <div class="d-flex mt-2">
                                                            <div class="col-lg-4">
                                                                <textarea
                                                                    [(ngModel)]="backgroundBo.previous_Addresses_Used2"
                                                                    class="form-control"></textarea>
                                                            </div>
                                                            <div class="col-lg-2"></div>
                                                            <div class="col-lg-4 d-flex">
                                                                <label class="label col-lg-4 mt-1">Date</label>

                                                                <input type="text" class="form-control"
                                                                    [(ngModel)]="backgroundBo.previous_Addresses_UsedDate2">
                                                            </div>
                                                        </div>
                                                        <div class="d-flex mt-2">
                                                            <div class="col-lg-4">
                                                                <textarea
                                                                    [(ngModel)]="backgroundBo.previous_Addresses_Used3"
                                                                    class="form-control"></textarea>
                                                            </div>
                                                            <div class="col-lg-2"></div>
                                                            <div class="col-lg-4 d-flex">
                                                                <label class="label col-lg-4 mt-1">Date</label>

                                                                <input type="text" class="form-control"
                                                                    [(ngModel)]="backgroundBo.previous_Addresses_UsedDate3">
                                                            </div>
                                                        </div>
                                                        <div class="row mt-4 ms-2">
                                                            <p>By signing this authorization, I give
                                                                {{global.agencyName}}
                                                                permission to submit a background study request
                                                                to DHS as part of my application as a direct support
                                                                worker on a self-direction program. I verify
                                                                that the information provided is accurate and
                                                                complete. The following checks will be run: </p>
                                                        </div>
                                                        <ul style="margin-left: 30px;">
                                                            <li>MN DHS NetStudy 2.0 Background Study</li>
                                                            <li>Office of Inspector General Exclusions Database</li>
                                                        </ul>

                                                        <div class="row mt-2 mb-2">
                                                            <div class="col-8">
                                                                <img src="{{appsign1}}" class="form-control"
                                                                    style="width: 255px;height:120px;" alt="nurse"
                                                                    width="48" height="48">
                                                            </div>
                                                            <div class="col-4">
                                                                <label>Date:</label>
                                                                <input type="text" class="form-control"
                                                                    [(ngModel)]="backgroundBo.applicantSignatureDate">
                                                            </div>
                                                        </div>
                                                        <div class="row mt-4 ms-2">
                                                            *If Applicant is under 18, the parent/guardian must sign
                                                            as well
                                                        </div>

                                                        <div class="row mt-2 mb-2">

                                                            <div class="col-8">
                                                                <img src="{{sign4}}" class="form-control"
                                                                    style="width: 255px;height:120px;" alt="nurse"
                                                                    width="48" height="48">
                                                            </div>
                                                            <div class="col-4">
                                                                <label for="cname">Date:</label>
                                                                <input type="text" class="form-control"
                                                                    [(ngModel)]="backgroundBo.parentSignatureDate">
                                                            </div>

                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>


                            </div>

                        </div>
                    </div>

                </div>

                <!--dis Pay Notice -->
                <span [ngClass]="{'page-break-before': PayNotice,'page-break-before-single':singlePrint}"></span>
                <div class="row mb-2 mt-2" *ngIf="PayNotice">
                    <div class="col p-0">
                        <div class="card" style="                                  
                                        height:auto;">

                            <div class="card-body" style="padding:65px;">

                                <div class="row mt-2 mb-3 mb-2 justify-content-center">
                                    <h3 class="text-center"><b>Pay Notice</b></h3>
                                </div>
                                <div class="row mt-2">
                                    <div class="col-lg-2">
                                        <label>
                                            Employee Name
                                        </label>
                                    </div>
                                    <div class="col-lg-4">
                                        <input type="text" class="form-control" [(ngModel)]="payNoticeBo.employeeName"
                                            disabled>
                                    </div>
                                    <div class="col-lg-2">
                                        <label>Employer Name
                                        </label>
                                    </div>
                                    <div class="col-lg-4">
                                        <input type="text" class="form-control" [(ngModel)]="payNoticeBo.employerName"
                                            disabled>
                                    </div>
                                </div>

                                <div class="mt-3">
                                    <table class="table-bordered col w-100">
                                        <tr style="height:30px;">
                                            <th>S.No</th>
                                            <th>Start Date</th>
                                            <th>End Date</th>
                                            <th>Service</th>
                                            <th>Pay Rate</th>
                                        </tr>
                                        <tr style="height:25px;" *ngFor="let val of payratelist;let i = index">
                                            <td>{{i+1}}</td>
                                            <td>{{val.startDate |date:'MM/dd/yyyy'}}</td>
                                            <td>{{val.endDate | date:'MM/dd/yyyy'}}</td>
                                            <td>{{val.serviceName}}</td>
                                            <td>{{val.rate}}</td>
                                        </tr>
                                    </table>
                                </div>

                                <div class="row mt-2">
                                    <p><b>Employee is non exempt (entitled to overtime, minimum wage, other
                                            protections under Minn.
                                            Stat. 177).</b></p>
                                </div>
                                <div class="row mt-2">
                                    <p> Overtime is paid at 1.5 times the regular rate for hours worked over 40 per
                                        workweek</p>
                                </div>
                                <div class="row mt-2">
                                    <p>The Collective Bargaining Agreement (SEIU/DHS) sets minimum wage, rules for
                                        Paid Time Off
                                        (PTO) accrual and designates Holiday pay:</p>
                                </div>
                                <ul style="margin-left: 30px;">
                                    <li>1 hour of PTO is earned for every 30 hours worked and accrued per pay period
                                        unless
                                        PTO is declined.</li>
                                    <li>Hours worked on the following Holidays are paid at 1.5 times the regular pay
                                        rate: New
                                        Year’s Day, Dr. Martin Luther King Jr. Day, Memorial Day, Labor Day, and
                                        Thanksgiving</li>
                                    <li>Employees choose 2 Floating Holidays per year. Hours worked on these days
                                        are paid at
                                        1.5 times the regular rate</li>
                                </ul>
                                <div class="row mt-2">
                                    <p>Sick and safe leave may apply for employees in Duluth, Minneapolis and St
                                        Paul. City Sick and
                                        Safe Time (SST) rules are available in the Employee Handbook.</p>
                                </div>
                                <div class="row mt-2">
                                    <p>
                                        Pay is issued every other Friday for a 14-day pay period, if time is
                                        submitted according to {{global.agencyName}}’s payroll calendar.
                                    </p>
                                </div>
                                <div class="row mt-2">
                                    <p>Deductions that may be made from employee’s pay include:</p>
                                </div>
                                <ul style="margin-left:30px;">
                                    <li>FICA (Social Security/Medicare)</li>
                                    <li>Federal/State Income Withholding Taxes
                                    </li>
                                    <li> Garnishments/Wage Attachments/Union Deductions (if applicable, as required
                                        by law)
                                    </li>
                                </ul>
                                <div class="row mt-4">
                                    <div class="col-lg-7">
                                        <div class="row">
                                            <div class="col-lg-7">
                                                <img src="{{Gurdsign3}}" class="form-control"
                                                    style="width: 255px;height:120px;" alt="nurse" width="48"
                                                    height="48">
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-lg-4">
                                        <div class="row">
                                            <div class="col-lg-3">
                                                <label for="cname">Date </label>
                                            </div>
                                            <div class="col-lg-7">
                                                <input type="text" class="form-control"
                                                    [(ngModel)]="payNoticeBo.employeeSignDate">
                                            </div>

                                        </div>
                                    </div>

                                </div>
                                <div class="row mt-4">
                                    <div class="col-lg-7">
                                        <div class="row">
                                            <div class="col-lg-7">
                                                <img src="{{employeesign2}}" class="form-control"
                                                    style="width: 255px;height:120px;" alt="nurse" width="48"
                                                    height="48">
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-lg-4">
                                        <div class="row">
                                            <div class="col-lg-3">
                                                <label for="cname">Date </label>
                                            </div>
                                            <div class="col-lg-7">
                                                <input type="text" class="form-control"
                                                    [(ngModel)]="payNoticeBo.employerSignDate">
                                            </div>

                                        </div>
                                    </div>

                                </div>





                            </div>

                        </div>
                    </div>

                </div>

                <!-- dis Relationship Disclosure-->
                <span
                    [ngClass]="{'page-break-before': RelationDisclosure,'page-break-before-single':singlePrint}"></span>
                <div class="row  mt-2" *ngIf="RelationDisclosure">
                    <div class="col p-0">
                        <div class="card" style="height:auto;">

                            <div class="card-body" style="padding:50px;">
                                <!-- <form [formGroup]=""> -->
                                <div class="row mt-2 mb-2 justify-content-center">
                                    <h3 class="text-center"><b>Relationship Disclosure</b></h3>
                                </div>
                                <div class="row mt-2">
                                    <div class="col-lg-2">
                                        <label>
                                            Applicant Name
                                        </label>
                                    </div>
                                    <div class="col-lg-4">
                                        <input type="text" class="form-control"
                                            [(ngModel)]="relationshipBo.employeeName">
                                    </div>
                                    <div class="col-lg-2">
                                        <label>Applicant DOB

                                        </label>
                                    </div>
                                    <div class="col-lg-4">

                                        <input type="text" class="form-control" [(ngModel)]="relationshipBo.dob">
                                    </div>
                                </div>
                                <div class="row mt-2">
                                    <div class="col-lg-3">
                                        <label>Employer (EIN Holder) Name
                                        </label>
                                    </div>
                                    <div class="col-lg-3">
                                        <input type="text" class="form-control"
                                            [(ngModel)]="relationshipBo.employerName" disabled>
                                    </div>
                                </div>
                                <div class="row mt-2">
                                    Employees providing household services may be exempt from paying certain federal
                                    and state
                                    taxes. If the employee qualifies, the exemptions must be applied.
                                </div>
                                <div class="row mt-2">
                                    <p><b>Please check relationship to Employer (FEIN Holder): </b></p>
                                </div>
                                <div class="d-flex col-5 my-3">
                                    <label class="me-4 fs-5"><b>Relationship</b></label>
                                    <input class="form-control ps-3
                                   " type="text" [(ngModel)]="reationshipname" disabled>

                                </div>
                                <div class="row mt-2">
                                    <table class="table-bordered table-responsive">
                                        <tr class="tr">
                                            <th class="th" style="width:5%">S.no</th>
                                            <th class="th" style="width:15%">TAX</th>
                                            <th class="th" style="width:20%">Taxable</th>

                                        </tr>
                                        <tr class="tr" *ngFor="let tax of relationShipTaxName;let i=index">

                                            <td class="td">{{i+1}}</td>
                                            <td class="td">{{tax.taxName}}</td>
                                            <td class="td">{{tax.taxable}}</td>

                                        </tr>



                                    </table>
                                </div>
                                <div class="row mt-2">
                                    <p>*According to IRS definition, parent is typically defined here as biological
                                        or adoptive. A stepparent is not necessarily considered
                                        a parent for the purposes of exemptions listed. The FMS Coordinator will
                                        verify exemption with additional questions as needed.</p>
                                </div>
                                <div class="row mt-2">
                                    <p>** Minors include siblings and must be students. Federal and state labor
                                        restrictions are in place for hours a minor can work and
                                        job duties they can perform. <a
                                            href="https://www.dli.mn.gov/sites/default/files/pdf/child_labor.pdf"
                                            target="_blank">https://www.dli.mn.gov/sites/default/files/pdf/child_labor.pdf</a>
                                    </p>
                                </div>
                                <div class="row mt-2">
                                    <p>***General employees have no relationship to the employer or have a
                                        relationship that is not listed: child 21+, grandparents,
                                        sibling 18+, cousins, aunts, uncles, etc are general employees.</p>
                                </div>
                                <div class="row mt-2">
                                    <p><b>Workers' Compensation (WC) is required for employees except spouse,
                                            parent, or child of the
                                            employer</b>. Coverage is billed to the participant employer’s budget.
                                    </p>
                                </div>
                                <div class="row mt-1">
                                    <div class="col-lg-1">
                                        <input type="radio" id="spouse1" name="spouses" [(ngModel)]="spouse"
                                            value="true">
                                    </div>
                                    <!--  
                                [(ngModel)]="documentBO.relationship_Disclosure.want_worker"-->
                                    <div class="col-lg-10">
                                        I am a spouse, parent, or child of the employer and want Workers’
                                        Compensation coverage
                                    </div>
                                </div>
                                <div class="row ">
                                    <div class="col-lg-1">
                                        <input type="radio" id="spouse2" name="spouses" [(ngModel)]="spouse"
                                            value="false">
                                        <!-- [(ngModel)]="documentBO.relationship_Disclosure.decline_worker" -->
                                    </div>
                                    <div class="col-lg-10">
                                        I am a spouse, parent, or child of the employer and decline Workers'
                                        Compensation coverage.
                                    </div>
                                </div>

                                <div class="row mt-2 mb-2">
                                    <div class="col-lg-7">
                                        <img src="{{clientsign0}}" class="form-control"
                                            style="width: 255px;height:120px;" alt="nurse" width="48" height="48">
                                    </div>
                                    <div class="col-lg-4">
                                        <label>Date:</label>
                                        <input type="text" class="form-control"
                                            [(ngModel)]="relationshipBo.applicantSignDate">
                                    </div>
                                </div>

                                <div class="row mt-2 mb-2">

                                    <div class="col-lg-7">
                                        <img src="{{employeesign3}}" class="form-control"
                                            style="width: 255px;height:120px;" alt="nurse" width="48" height="48">
                                    </div>
                                    <div class="col-lg-4">
                                        <label>Date:</label>
                                        <input type="text" class="form-control"
                                            [(ngModel)]="relationshipBo.employersSignDate">
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>

                </div>

                <!-- dis  Employee Agreement and Direct Deposit-->
                <span [ngClass]="{'page-break-before': DirectDeposit,'page-break-before-single':singlePrint}"></span>
                <div class="row mb-2 mt-2" *ngIf="DirectDeposit">
                    <div class="col p-0">
                        <div class="card" style="height:auto;">

                            <div class="card-body" style="padding:65px;">

                                <div class="row mt-2 mb-2 mb-2 justify-content-center">
                                    <h3 class="text-center"><b>Employee Agreement and Direct Deposit</b></h3>
                                </div>

                                <div class="row mt-4">
                                    <p>I acknowledge that I have reviewed the Employee Handbook, including Mandated
                                        Reporting,
                                        Fraud, Roles and Responsibilities and HIPAA Data Privacy.</p>
                                </div>
                                <div class="row mt-2">
                                    <p>I understand I am an employee of the participant employer. My employer is
                                        responsible for
                                        hiring, training, establishing job duties, scheduling, supervising, and
                                        evaluating my
                                        performance. The participant employer sets my pay rate within program
                                        guidelines. If I am
                                        scheduled to work by my employer beyond budgeted funds, {{global.agencyName}}
                                        FMS
                                        will
                                        not pay. I
                                        understand that submitting time I did not work is fraud.</p>
                                </div>
                                <div class="row mt-2">
                                    {{global.agencyName}} FMS acts as the Fiscal/Employer Agent (F/EA) and is
                                    responsible
                                    for
                                    payroll, filing
                                    taxes, and W-2s. {{global.agencyName}} FMS uses CYMA for payroll processing. Pay
                                    statements
                                    and PTO
                                    accrual are available through CYMA.
                                </div>
                                <div class="row mt-2">
                                    I authorize {{global.agencyName}} FMS to initiate automatic deposits to my account
                                    and
                                    initiate debit
                                    entries to my account for the purpose of correcting an erroneous amount
                                    previously
                                    deposited in my account. If the designated account is closed or has an
                                    insufficient balance for
                                    withdrawal, I authorize {{global.agencyName}} FMS to withhold from payment owed to
                                    me by
                                    {{global.agencyName}} FMS
                                    until the erroneous amount is repaid.

                                </div>
                                <div class="row mt-1">
                                    <p><b>Please include a voided check or bank letter for direct deposit</b></p>
                                </div>
                                <div class="row mt-1">
                                    <div class="col-lg-3">
                                        <label>Routing #</label>
                                    </div>
                                    <div class="col-lg-3">
                                        <input type="text" class="form-control"
                                            [(ngModel)]="employeeAgreementBo.routing" disabled>
                                    </div>
                                </div>
                                <div class="row mt-2">
                                    <div class="col-lg-3">
                                        <label>Account #456</label>
                                    </div>
                                    <div class="col-lg-3">
                                        <input type="text" class="form-control"
                                            [(ngModel)]="employeeAgreementBo.account" disabled>
                                    </div>
                                </div>
                                <div class="row mt-2">
                                    <div class="col-lg-1">
                                        <input type="radio" id="checking" name="savecheck" value="check"
                                            [(ngModel)]="employeeAgreementBo.checkingOrSaving">
                                        <!-- [(ngModel)]="documentBO.employees_Aggrement_Dir_DepositBO.checking_bool"> -->
                                    </div>
                                    <div class="col-lg-6">
                                        <label>Checking</label>
                                    </div>
                                </div>
                                <div class="row mt-2">
                                    <div class="col-lg-1">
                                        <input type="radio" id="saving" name="savecheck" value="save"
                                            [(ngModel)]="employeeAgreementBo.checkingOrSaving">
                                        <!-- [(ngModel)]="documentBO.employees_Aggrement_Dir_DepositBO.savings_bool"> -->
                                    </div>
                                    <div class="col-lg-6">
                                        <label> Savings</label>
                                    </div>
                                </div>
                                <div class="row mt-2">
                                    {{global.agencyName}} FMS is not responsible for charges I incur from my financial
                                    institution for writing
                                    checks against my account before funds have been credited to my account.
                                </div>
                                <div class="row mt-2">
                                    By signing this agreement, I verify that information I have provided is
                                    accurate. {{global.agencyName}} uses
                                    information on the Relationship Disclosure to set up the correct taxes for me
                                    and if I have
                                    submitted inaccurate information, I am liable for taxes owed.
                                </div>

                                <div class="row mt-2">
                                    <div class="col-lg-2">
                                        <label>Applicant Name </label>
                                    </div>
                                    <div class="col-lg-3">
                                        <input type="text" class="form-control"
                                            [(ngModel)]="relationshipBo.employeeName" disabled>
                                    </div>
                                </div>
                                <div class="row mb-2">

                                    <div class="col-lg-7">
                                        <img src="{{clientsign2}}" class="form-control"
                                            style="width: 255px;height:120px;" alt="nurse" width="48" height="48">
                                    </div>

                                </div>

                            </div>

                        </div>
                    </div>

                </div>

                <!--  Individual Direct Support Worker Enrollment Application-->
                <span [ngClass]="{'page-break-before': IndividualDSWEA,'page-break-before-single':singlePrint}"></span>
                <div class="row mb-2 mt-2" *ngIf="IndividualDSWEA">
                    <div class="col p-0">
                        <div class="card" style="height:auto;page-break-inside: avoid;">

                            <div class="row">
                                <div class="col-lg-12">
                                    <div class="card-body">
                                        <!-- <form [formGroup]="dh1form"> -->
                                        <div class="row mb-2">
                                            <div class="col-lg-12">
                                                <img src="..\assets\img\DHS_4469A.JPG" class="img-fluid"
                                                    alt="Responsive image">
                                                <h3 class="mb-0" style="text-align: center;">
                                                    <b>
                                                        Individual Direct Support Worker Enrollment Application
                                                        (Consumer Directed Community Supports [CDCS] and Consumer
                                                        Support Grant [CSG])
                                                    </b>
                                                </h3>
                                                <p class="mb-2 mt-2">
                                                    Complete all fields to enroll an individual direct support
                                                    worker (DSW). Complete this form, print and then submit to
                                                    Minnesota Health Care Programs (MHCP). An incomplete form will
                                                    delay processing of this application. Check one of the
                                                    following:
                                                </p>
                                            </div>
                                        </div>
                                        <div class=" ms-2">
                                            <div class="col-lg-5 d-flex">
                                                <!-- [value]="val.Key" -->
                                                <input type="radio" id="new_hire" name="hire"
                                                    [(ngModel)]="individualDirectSupportBo.newHireOrReHire"
                                                    value="newhire">
                                                <!-- [(ngModel)]="documentBO.individual_direct_support_worker_entrollment.newHire" -->
                                                <label class="ms-2 mt-lg-2">Newhire (requires new background study for
                                                    CDCS
                                                    only)</label>

                                            </div>

                                        </div>

                                        <div class="row">
                                            <div class="col-lg-5 ms-2">
                                                <input type="radio" id="rehire" name="hire"
                                                    [(ngModel)]="individualDirectSupportBo.newHireOrReHire"
                                                    value="rehire">&nbsp;
                                                <!-- [(ngModel)]="documentBO.individual_direct_support_worker_entrollment.reHire" -->
                                                <label class="ms-1">Rehire (requires new background study for CDCS
                                                    only)</label>

                                            </div>
                                            <div class="col-lg-3">
                                                <label>PREVIOUS EMPLOYMENT END DATE:</label>

                                            </div>
                                            <div class="col-lg-3">

                                                <input type="text" class="form-control"
                                                    [(ngModel)]="individualDirectSupportBo.previousEmployementEndDate">

                                            </div>

                                        </div>

                                        <div class="row">
                                            <div class="col">
                                                <div class="card">
                                                    <div class="card-body" style="padding-right:25px;">
                                                        <b>
                                                            <h4>Individual DSW Information</h4>
                                                        </b>
                                                        <div class="row mb-2 mt-2">
                                                            <div class="col-lg-4">
                                                                <label>PROVIDER TYPE</label>
                                                                <input type="text" class="form-control" disabled
                                                                    [(ngModel)]="individualDirectSupportBo.providerType">


                                                            </div>
                                                            <div class="col-lg-3">
                                                                <label>SOCIAL SECURITY NUMBER
                                                                </label>
                                                                <input type="text"
                                                                    [(ngModel)]="individualDirectSupportBo.ssn"
                                                                    class="form-control" disabled>

                                                            </div>
                                                            <div class="col-lg-5">
                                                                <label>NPI OR UMPI (IF REQUESTING
                                                                    REINSTATEMENT)
                                                                </label>
                                                                <input maxlength="10" type="text" class="form-control"
                                                                    [(ngModel)]="individualDirectSupportBo.npiOrUmpi"
                                                                    disabled>

                                                            </div>



                                                        </div>
                                                        <div class="row mb-2 mt-2">
                                                            <div class="col-lg-4">
                                                                <label>LEGAL NAME (FIRST)

                                                                </label>
                                                                <input type="text" class="form-control"
                                                                    [(ngModel)]="individualDirectSupportBo.firstName"
                                                                    disabled>

                                                            </div>
                                                            <div class="col-lg-4">
                                                                <label>FULL MIDDLE NAME</label>
                                                                <input type="text" class="form-control"
                                                                    [(ngModel)]="individualDirectSupportBo.middleName"
                                                                    disabled>

                                                            </div>
                                                            <div class="col-lg-4">
                                                                <label>LAST NAME</label>

                                                                <input type="text" class="form-control"
                                                                    [(ngModel)]="individualDirectSupportBo.lastName"
                                                                    disabled>

                                                            </div>

                                                        </div>
                                                        <div class="row mb-2 mt-2">
                                                            <div class="col-lg-4">
                                                                <label>Date of Birth </label>

                                                                <input type="text" class="form-control"
                                                                    [(ngModel)]="individualDirectSupportBo.dob">


                                                            </div>
                                                            <div class="col-lg-4">
                                                                <label>Phone Number</label>
                                                                <input type="text" minlength="14" maxlength="14"
                                                                    class="form-control"
                                                                    [(ngModel)]="individualDirectSupportBo.phone"
                                                                    disabled>

                                                            </div>

                                                        </div>
                                                        <div class="row mb-2 mt-2">
                                                            <div class="col-8">
                                                                If individual has been working in a different
                                                                support position or was enrolled for MCO claims
                                                                only, has the
                                                                individual been continuously employed by your
                                                                agency?



                                                            </div>
                                                            <div class="col-2">
                                                                &nbsp; <span>Yes</span>
                                                                <input type="radio" value="true" name="yes_1"
                                                                    [(ngModel)]="individualDirectSupportBoRadio1">
                                                                &nbsp; &nbsp; No

                                                                <input type="radio" value="false" name="yes_1"
                                                                    [(ngModel)]="individualDirectSupportBoRadio1">
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <!-- </div> -->
                                        <div class="row mb-2 mt-2">
                                            <div class="col">
                                                <div class="card">
                                                    <div class="card-body">
                                                        <h4><b>Individual DSW Background Study Information</b></h4>
                                                        <div class="row mb-2 mt-2">
                                                            <div class="col-lg-7">
                                                                <label>PROGRAM TYPE</label>
                                                                <input type="text" class="form-control"
                                                                    placeholder="CDCS(C4)you must submit and have the individual pass a backgrounf check"
                                                                    [(ngModel)]="individualDirectSupportBo.programType">

                                                            </div>

                                                        </div>
                                                        <!-- <div class="row mt-2 mb-2">
                                                            <div class="col">
                                                                <table class="table table table-bordered">
                                                                    <thead>
                                                                        <tr>
                                                                            <th>BGS number
                                                                                (required only for CDCS)</th>
                                                                            <th>
                                                                                Application number
                                                                            </th>
                                                                            <th>Facility ID </th>
                                                                        </tr>
                                                                    </thead>
                                                                    <tbody>
                                                                        <tr
                                                                            *ngFor="let table of DSwstudyBolist; let i=index">
                                                                            <td>
                                                                                <input type="text"
                                                                                    
                                                                                    class="form-control" [(ngModel)]="table.bsgNumber">
                                                                                   <input type="text" value="hi" class="form-control">
                                                                            
                                                                                
                                                                            </td>
                                                                            <td>
                                                                                <input type="number"
                                                                                    [(ngModel)]="table.applicationNumber                                                                                    "
                                                                                    class="form-control">
                                                                              
                                                                            </td>
                                                                            <td>
                                                                                <input (
                                                                                    [(ngModel)]="table.facilityId"
                                                                                    class="form-control">
                                                                            </td>
                                                                        
                                                                        </tr>
                                                                    </tbody>
                                                                </table>
                                                                <table style="width:100%">
                                                                    <tr>
                                                                        <th>BGS number
                                                                            (required only for CDCS)</th>
                                                                        <th>
                                                                            Application number
                                                                        </th>
                                                                        <th>Facility ID </th>
                                                                    </tr>
                                                                <div class="card">
                                                                    <div class="card-body">
                                                                        <tr
                                                                        *ngFor="let table of DSwstudyBolist; let i=index">
                                                                        <td>
                                                                            <input type="text"
                                                                                
                                                                                class="form-control" [(ngModel)]="table.bsgNumber">
                                                                               <input type="text" value="hi" class="form-control">
                                                                        
                                                                            
                                                                        </td>
                                                                        <td>
                                                                            <input type="number"
                                                                                [(ngModel)]="table.applicationNumber                                                                                    "
                                                                                class="form-control">
                                                                          
                                                                        </td>
                                                                        <td>
                                                                            <input (
                                                                                [(ngModel)]="table.facilityId"
                                                                                class="form-control">
                                                                        </td>
                                                                    
                                                                    </tr>
                                                                    </div>
                                                                </div>
                            
                                                                  </table>
                                                            </div>

                                                        </div> -->
                                                        <div class="row mt-2" style="height:auto;">
                                                            <div class="col">
                                                                <table class="table-bordered table-responsive">
                                                                    <tr class="tr">
                                                                        <th class="th" style="width:25%">BGS number
                                                                            (required only for CDCS)</th>
                                                                        <th class="th" style="width:25%"> Application
                                                                            number</th>
                                                                        <th class="th" style="width:25%">Facility ID
                                                                        </th>

                                                                    </tr>
                                                                    <tr class="tr"
                                                                        *ngFor="let tab of DSwstudyBolist; let i=index">

                                                                        <td class="td">{{tab.bsgNumber}}</td>
                                                                        <td class="td">{{tab.applicationNumber}}</td>
                                                                        <td class="td">{{tab.facilityId}}</td>

                                                                    </tr>



                                                                </table>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="row mb-2 mt-2">
                                            <div class="col">
                                                <div class="card">
                                                    <div class="card-body">
                                                        <h4><b>Individual DSW Address</b></h4>
                                                        <div class="row mb-2 mt-2">
                                                            <div class="col-lg-7">
                                                                <label>STREET ADDRESS</label>
                                                                <textarea class="form-control"
                                                                    placeholder="Residential address only - Do not enter PO Box"
                                                                    [(ngModel)]="individualDirectSupportBo.street"
                                                                    disabled></textarea>
                                                            </div>
                                                        </div>
                                                        <div class="row mb-2 mt-2">
                                                            <div class="col-lg-3">
                                                                <label>city</label>
                                                                <input type="text" class="form-control"
                                                                    [(ngModel)]="individualDirectSupportBo.city"
                                                                    disabled>
                                                            </div>
                                                            <div class="col-lg-3">
                                                                <label>State</label>
                                                                <ng-select class="width25"
                                                                    [(ngModel)]="individualDirectSupportBo.state"
                                                                    disabled>
                                                                </ng-select>
                                                            </div>
                                                            <div class="col-lg-3">
                                                                <label>Zip Code</label>
                                                                <input type="text" class="form-control"
                                                                    [(ngModel)]="individualDirectSupportBo.zip"
                                                                    disabled>

                                                            </div>
                                                            <div class="col-lg-3">
                                                                <label>COUNTY OF RESIDENCE</label>
                                                                <input type="text" class="form-control"
                                                                    [(ngModel)]="individualDirectSupportBo.county"
                                                                    disabled>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="row mb-2 mt-2">
                                            <div class="col">
                                                <div class="card">
                                                    <div class="card-body">
                                                        <h4><b>Individual DSW Training Information</b></h4>
                                                        <div class="row mb-2 mt-2">
                                                            <div class="col d-flex">
                                                                Did this worker take Qualified Enhanced Rate
                                                                training? (an optional training)


                                                                &nbsp;&nbsp;Yes &nbsp;
                                                                <input type="radio" class="me-1" name="rd" value="true"
                                                                    [(ngModel)]="individualDirectSupportBoRadio2">
                                                                <!-- [(ngModel)]="documentBO.individual_direct_support_worker_entrollment.check_if_Qualified_Enhanced_Rate_Training"
                                                                        [(ngModel)]="documentBO.individual_direct_support_worker_entrollment.check_if_Qualified_Enhanced_Rate_Training" -->
                                                                &nbsp;&nbsp;No &nbsp;
                                                                <input type="radio" name="rd" value="false"
                                                                    [(ngModel)]="individualDirectSupportBoRadio2">
                                                            </div>
                                                        </div>
                                                        <div class="row">
                                                            <div class="col-lg-6">
                                                                <label>OPTIONAL TRAINING COMPLETION DATE</label>

                                                                <input type="text" class="form-control"
                                                                    [(ngModel)]="individualDirectSupportBo.optionalTrainingCompletionDate">
                                                            </div>
                                                            <div class="col-lg-6">
                                                                <label>OPTIONAL TRAINING EXPIRATION DATE (if
                                                                    applicable)</label>

                                                                <input type="text" class="form-control"
                                                                    [(ngModel)]="individualDirectSupportBo.optionalTrainingExpirationDate">
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="row mb-2 mt-2">
                                            <div class="col">
                                                <div class="card">
                                                    <div class="card-body">
                                                        <h4><b>Individual DSW Provider Statement</b></h4>
                                                        <div class="row">
                                                            <div class="col">
                                                                <p>
                                                                    I have reviewed and certify the information
                                                                    provided on this form is true and correct to the
                                                                    best of my knowledge.
                                                                    I will notify MHCP Provider Eligibility and
                                                                    Compliance of any additions or ngModelChanges to
                                                                    the information.
                                                                    By signing this form, I acknowledge I have read
                                                                    and understand the Data
                                                                    Privacy
                                                                    Notice (DHS-6287) (PDF) I also
                                                                    authorize MHCP to use the information you
                                                                    collect about me according to the Privacy
                                                                    Notice.
                                                                    Check if signing electronically:
                                                                </p>
                                                                <p>Check if signing electronically:</p>
                                                                <p> <input type="checkbox"
                                                                        [(ngModel)]="individualDirectSupportBo.signelectronically">I
                                                                    am signing this form electronically. My name as
                                                                    typed in the signature field is my legally
                                                                    binding signature. I
                                                                    understand that my electronic signature has the
                                                                    same legal effect and can be enforced in the
                                                                    same way as a
                                                                    handwritten signature. (Minnesota Statutes
                                                                    325L.02(h), 325L.05 and 325L.08)</p>
                                                            </div>
                                                        </div>
                                                        <div class="row">
                                                            <div class="col-lg-7">
                                                                <label>NAME OF INDIVIDUAL SUPPORT WORKER (PRINT OR
                                                                    TYPE) </label>
                                                                <input type="text" class="form-control"
                                                                    [(ngModel)]="individualSupportWorkerBo.agencyName">
                                                            </div>
                                                        </div>
                                                        <div class="row mt-2 mb-2">

                                                            <div class="col-lg-5">
                                                                <img src="{{individualsign}}" class="form-control"
                                                                    style="width: 255px;height:120px;" width="48"
                                                                    height="48">
                                                            </div>
                                                            <div class="col-4">
                                                                <label> DATE SIGNED:</label>
                                                                <input type="text" class="form-control"
                                                                    [(ngModel)]="individualDirectSupportBo.signDate">
                                                            </div>
                                                        </div>
                                                        <br>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="row mb-2 mt-2">
                                            <div class="col">
                                                <div class="card">
                                                    <div class="card-body">
                                                        <h4>Organization Affiliation Information</h4>
                                                        <div class="row">
                                                            <div class="col-10">
                                                                <p>
                                                                    You may affiliate or enroll the individual DSW
                                                                    named on this form with another Fiscal Support
                                                                    Entity (FSE) or
                                                                    Financial Management Services (FMS) agency or
                                                                    location you directly own without completing
                                                                    another application
                                                                    and agreement. Do you want to affiliate this
                                                                    individual DSW with any other agency or location
                                                                    you own?



                                                                    <!-- </div>
    
                                                            </div> -->
                                                                </p>
                                                            </div>
                                                            <div class="col-2">
                                                                <label>Yes</label>



                                                                <input type="radio" class="me-1" id="radio1"
                                                                    value="true" name="yes_3"
                                                                    [(ngModel)]="individualDirectSupportBoRadio3">
                                                                <label>No</label>
                                                                <input type="radio" value="false" id="radio2"
                                                                    name="yes_3"
                                                                    [(ngModel)]="individualDirectSupportBoRadio3">
                                                            </div>

                                                        </div>
                                                        <div class="row mt-2">
                                                            <div class="col">
                                                                <p>
                                                                    Check if signing electronically:
                                                                </p>
                                                            </div>
                                                        </div>
                                                        <div class="row">
                                                            <div class="col ">
                                                                <input type="checkbox"
                                                                    [(ngModel)]="individualDirectSupportBo.orgAffiliationInfoSignDeclaration">&nbsp;
                                                                <p>
                                                                    I am signing this form electronically. My name
                                                                    as typed in the signature field is my legally
                                                                    binding signature. I
                                                                    understand that my electronic signature has the
                                                                    same legal effect and can be enforced in the
                                                                    same way as a
                                                                    handwritten signature. (Minnesota Statutes
                                                                    325L.02(h), 325L.05 and 325L.08)
                                                                </p>

                                                            </div>

                                                        </div>
                                                        <div class="row">
                                                            <div class="col-lg-4">
                                                                <label>Organization name</label>
                                                                <input type="text" class="form-control"
                                                                    [(ngModel)]="individualDirectSupportBo.organizationName">

                                                            </div>
                                                            <div class="col-lg-4">
                                                                <label>FACILITY NPI OR UMPI</label>
                                                                <input type="text" class="form-control" maxlength="10"
                                                                    [(ngModel)]="individualDirectSupportBo.facilityNpi">

                                                            </div>
                                                            <div class="col-lg-4">
                                                                <label>STUDY ID</label>
                                                                <input type="text" class="form-control"
                                                                    [(ngModel)]="individualDirectSupportBo.studyId">

                                                            </div>

                                                        </div>
                                                        <div class="row mb-2 mt-2">
                                                            <div class="col-lg-4">
                                                                <label>ORGANIZATION PERSONNEL COMPLETING FORM</label>
                                                                <input type="text" class="form-control"
                                                                    [(ngModel)]="individualDirectSupportBo.orgPersonalCompletingForm">
                                                            </div>
                                                            <div class="col-lg-4">
                                                                <label>ORGANIZATION
                                                                    PERSONNEL SIGNATURE</label>
                                                                <input type="text" class="form-control"
                                                                    [(ngModel)]="individualDirectSupportBo.orgPersonalSign">
                                                            </div>
                                                            <div class="col-lg-4">
                                                                <label>ORGANIZATION FAX NUMBER</label>
                                                                <input type="text" class="form-control" maxlength="14"
                                                                    [(ngModel)]="individualDirectSupportBo.orgPersonalFax">
                                                            </div>
                                                        </div>
                                                        <br>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-12  mb-3 mt-1 ">



                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>

                </div>

                <!-- MINNESOTA HEALTH CARE PROGRAMS (MHCP) -->
                <span
                    [ngClass]="{'page-break-before': IndividualProviderAgree,'page-break-before-single':singlePrint}"></span>
                <div class="row mb-2 mt-2" *ngIf="IndividualProviderAgree">
                    <div class="col p-0">
                        <div class="card" style="height:auto;page-break-inside: avoid;">


                            <div class="card-body" style="padding:55px;">
                                <!-- <form [formGroup]="Document1"> -->
                                <div class="row mt-2 mb-2 col-4">
                                    <img src="..\assets\img\Capture.JPG" class="img-fluid" alt="Responsive image">
                                </div>

                                <h5>MINNESOTA HEALTH CARE PROGRAMS (MHCP) </h5>
                                <h2 style="color: black;"><b>Individual Support Worker (CDCS, CSG, PCA, CFSS)
                                        Provider Agreement</b></h2>
                                <div class="row mt-3 ms-2">
                                    <p>As a participating provider in Minnesota Health Care Programs (MHCP)
                                        administered by the Minnesota Department
                                        of Human Services (DHS), the provider agrees to:</p>
                                </div>
                                <div class="row ">
                                    <div class="col p-0">
                                        <ol type="A" class="ms-5 p-0">
                                            <li>Submit documentation to your affiliated agency that fully discloses
                                                the extent of services provided to
                                                individuals under these programs. The documentation must be legible
                                                and meet the requirements of Minnesota
                                                Statutes, section 256B.0659, subdivision 12 for all individual
                                                support workers in Consumer Directed Community
                                                Supports (CDCS), Consumer Support Grant (CSG), Personal Care
                                                Assistance (PCA), and Community First Services
                                                and Supports (CFSS) .</li>
                                            <li>Furnish DHS, the secretary of the U.S. Department of Health and
                                                Human Services (DHHS), or the Minnesota
                                                Medicaid Fraud Control Unit with such information as it may request
                                                regarding payments claimed for services
                                                provided under these programs.</li>
                                            <li>Comply with all federal and state statutes and rules relating to the
                                                delivery of services to individuals and to the
                                                submission of claims for such services.</li>
                                            <li>Accept as payment in full, amounts paid in accordance with schedules
                                                established by DHS, except where
                                                payment by the member has been authorized by DHS.</li>
                                            <li>Make full disclosure of any conviction(s) of program crimes as
                                                required by the Code of Federal Regulations, title
                                                42, section 455.106.</li>
                                            <li>Comply with all federal statutes, implementing regulations and
                                                guidance prohibiting discrimination on the
                                                basis of race, color, national origin, sex, age, religion and
                                                disability in any program or activity receiving federal
                                                financial assistance from DHHS; and to comply with the Minnesota
                                                Human Rights Act.</li>
                                            <li>Provide services to members of the same scope and quality as would
                                                be provided to the general public, within
                                                MHCP guidelines.</li>
                                            <li>. Comply with the provisions of any fully executed agreement or
                                                addendum required by DHS, which is
                                                incorporated herein by reference.</li>
                                            <li>Comply with the advance directive requirements as required by the
                                                Code of Federal Regulations, title 42,
                                                sections 489.100 and 417.436.</li>
                                            <li>Properly handle and safeguard protected information collected,
                                                created, used, maintained, or disclosed on
                                                behalf of DHS. For purposes of this agreement, “protected
                                                information” means data subject to any of the
                                                following laws:</li>
                                            <ol type="1" class="ms-3 ">
                                                <li>The Minnesota Government Data Practices Act (MGDPA), Minnesota
                                                    Statutes, chapter 13, section 13.46
                                                    ("welfare data");</li>
                                                <li>The Minnesota Health Records Act, sections 144.291 and 144.298;
                                                </li>
                                                <li>The Health Insurance Portability and Accountability Act
                                                    (“HIPAA”), including but not limited to the
                                                    requirements of the Privacy Rule and the Security Regulations,
                                                    the Code of Federal Regulations, title 45, parts
                                                    160 and 164, subparts A and E.</li>
                                                <li>Federal law and regulations that govern the use and disclosure
                                                    of substance abuse treatment records, the
                                                    United States Code, title 42, section 290dd-2 and the Code of
                                                    Federal Regulations, title 42, sections 2.1 to
                                                    2.67; and Electronic initials accepted.</li>
                                                <div class="row ">
                                                    <div class="col-lg-6">
                                                        <label for="NAME OF SUPPORT WORKER">
                                                            NAME OF SUPPORT WORKER

                                                        </label>
                                                        <input type="text" class="form-control"
                                                            [(ngModel)]="individualSupportWorkerBo.nameofSupportWorkerName"
                                                            disabled>
                                                    </div>
                                                    <div class="col-lg-6">
                                                        <label for="DIRECT SUPPORT WORKER INITIALS">
                                                            DIRECT SUPPORT WORKER INITIALS

                                                        </label>
                                                        <input type="text" class="form-control"
                                                            [(ngModel)]="individualSupportWorkerBo.directSupportWorkerInitial">
                                                    </div>
                                                </div>
                                                <div class="row">

                                                    <div class="col-lg-8">
                                                        <label for="UMPI">
                                                            UMPI

                                                        </label>
                                                        <input type="text" class="form-control"
                                                            [(ngModel)]="individualSupportWorkerBo.umpi" disabled>
                                                    </div>

                                                </div>


                                                <li>Any other applicable state and federal statutes, rules, and
                                                    regulations affecting the collection, storage, use
                                                    and dissemination of private or confidential information.</li>
                                            </ol>
                                            <li>
                                                Comply with the laws described in section J. This includes the
                                                provider:
                                            </li>

                                            <ol type="1" class="ms-4 p-0">
                                                <li>Not using or further disclosing protected information created,
                                                    collected, received, stored, used, maintained or disseminated in
                                                    the course or performance of this agreement other than as
                                                    necessary to perform its obligations under this Provider
                                                    Agreement, or as required by law, either during the period of
                                                    this agreement or after. See, respectively, the Code of Federal
                                                    Regulations, title 45, sections 164.502(b) and 164.514(d), and
                                                    Minnesota Statutes, 13.05 subdivision 3.</li>
                                                <li>Using appropriate administrative, physical, and technical
                                                    safeguards to prevent use or disclosure of the protected
                                                    information other than as provided for by this agreement and to
                                                    ensure the confidentiality, integrity, and availability of any
                                                    electronic protected health information (PHI) that it creates,
                                                    receives, maintains, or transmits on behalf of DHS. The provider
                                                    will not transmit PHI over the Internet or any other unsecure or
                                                    open communications channel unless such information is encrypted
                                                    or otherwise safeguarded using procedures no less stringent than
                                                    those described in the Code of Federal Regulations, title 45,
                                                    section 164.312. If the provider stores or maintains PHI in
                                                    encrypted form, the provider shall, at DHS’ request, promptly
                                                    provide DHS with the key or keys to decrypt such information.
                                                    The provider shall not forward previously encrypted data to any
                                                    other party, unless otherwise required by this agreement.</li>
                                                <li>Mitigating, to the extent practicable, any harmful effects known
                                                    to the provider of a use, disclosure, or breach of security with
                                                    respect to protected information by the provider in violation of
                                                    this agreement.</li>
                                            </ol>
                                            <li>
                                                Agree that this agreement may be immediately terminated at the
                                                discretion of DHS if it determines that the
                                                provider has violated a material term of the agreement, including
                                                but not limited to, non-compliance by the
                                                provider with the HIPAA Privacy Rule and Security Standards. If
                                                termination is not feasible, DHS shall report the
                                                breach to the Secretary of DHHS.
                                                Upon termination of this agreement, all of the protected information
                                                provided by DHS to the provider, or
                                                created or received by the provider on behalf of DHS, that the
                                                provider still maintains in any form, including
                                                information that is in the hands of subcontractors or agents of the
                                                provider, shall be destroyed or returned to
                                                DHS, and the provider shall retain no copies of such information. If
                                                it is infeasible to return or destroy the
                                                information, the provider shall provide DHS notification of the
                                                conditions that make return or destruction
                                                infeasible, and shall extend the protections of this agreement to
                                                such information and limit further use and
                                                disclosure of such information to those purposes that make return or
                                                destruction infeasible, for as long as the
                                                provider maintains the information.
                                            </li>
                                            <li>
                                                Agree that any ambiguity in this agreement shall be resolved to
                                                permit DHS to comply with HIPAA, MDGPA, and
                                                other applicable state and federal statutes, rules, and regulations
                                                affecting the collection, storage, use and
                                                dissemination of private or confidential information and other state
                                                and federal laws and regulations.
                                            </li>

                                        </ol>
                                        <div class="row ms-4">
                                            <p>Upon signature, this Provider Agreement supersedes and replaces all
                                                former Provider Agreements the provider has
                                                with DHS.</p>
                                        </div>
                                        <div class="row ms-4">
                                            <p>
                                                An individual applicant must personally sign the Provider Agreement.
                                                Sign and date this form, initial page 1, and
                                                return both page 1 and page 2 of this agreement.
                                            </p>
                                        </div>
                                        <div class="row ms-4">
                                            <p>
                                                Check if signing electronically:
                                            </p>
                                        </div>
                                        <div class="row ms-5">
                                            <p>
                                                <span> <input type="checkbox"
                                                        [(ngModel)]="individualSupportWorkerBo.signDeclaration"></span>
                                                <!--  -->
                                                I am signing this form electronically. My name as typed in the
                                                signature field is my legally binding signature. I
                                                understand that my electronic signature has the same legal effect
                                                and can be enforced in the same way as a
                                                handwritten signature. (Minnesota Statutes 325L.02(h), 325L.05 and
                                                325L.08)
                                            </p>
                                        </div>
                                        <div class="row">
                                            <div class="col-lg-8 ">
                                                <label>NAME OF SUPPORT WORKER (TYPE OR PRINT)</label>
                                                <input type="text" class="form-control"
                                                    [(ngModel)]="individualSupportWorkerBo.nameofSupportWorkerNamePrint"
                                                    disabled>
                                            </div>
                                            <div class="col-lg-4">
                                                <label for="DIRECT SUPPORT WORKER INITIALS">
                                                    TITLE
                                                </label>
                                                <input type="text" class="form-control"
                                                    [(ngModel)]="individualSupportWorkerBo.title">


                                            </div>
                                        </div>

                                        <div class="row mb-2 mt-2">
                                            <div class="col-lg-5">
                                                <img src="{{repsign}}" class="form-control"
                                                    style="width: 255px;height:120px;" width="48" height="48">

                                            </div>
                                            <div class="col-4">
                                                <label>Date:</label>
                                            </div>
                                        </div>
                                        <div class="row mt-2">
                                            <p>
                                                Keep a copy of the Provider Agreement for your files and upload the
                                                <!-- original form using the online <a
                                                    href="https://mn.gov/dhs/partners-and-providers/policies-procedures/minnesota-health-care-programs/provider/mpse/"
                                                    target="_blank">Minnesota -->
                                                Provider Screening and Enrollment (MPSE) portal or fax to
                                                651-431-7465.
                                            </p>
                                        </div>
                                        <div class="row mb-2">
                                            <div class="col">
                                                <h2 style="text-align: center;"><b>Agreement Summary</b></h2>
                                            </div>
                                        </div>
                                        <div class="row ">
                                            <div class="col">
                                                <p>
                                                    As an individual support worker, you are providing health care
                                                    services to individuals. We require your enrollment in the
                                                    Minnesota Health Care Programs (MHCP) and to be listed as the
                                                    rendering provider on the claim so that you are represented as
                                                    the person who provided the services. Knowing that a qualified
                                                    individual provided the service ensures the safety of the people
                                                    that the Minnesota Department of Human Services (DHS) serves. It
                                                    also allows DHS to perform auditing and tracking of services
                                                    which protects against double-billing and other types of fraud.
                                                    Before enrollment is approved, MHCP must make certain that:
                                                </p>
                                                <ol type="1">
                                                    <li>There is no legal or other reason why you shouldn’t provide
                                                        these services,</li>
                                                    <li>You understand what is necessary to properly provide these
                                                        services, and</li>
                                                    <li>You understand the need to protect the privacy of the people
                                                        you care for.</li>
                                                </ol>


                                                <p>
                                                    To help ensure that each of these conditions is met, MHCP
                                                    requires that you agree to the terms in the attached Provider
                                                    Agreement. In general, this agreement requires that you:
                                                </p>

                                                <ol type="A">
                                                    <li>Provide documents to your employer about the services you
                                                        provide.</li>
                                                    <li>Provide documents to MHCP or other state and federal
                                                        agencies related to the services you provide, when
                                                        requested.</li>
                                                    <li>Comply with federal and state laws about the services you
                                                        provide.</li>
                                                    <li>Accept payment made to your employer as payment in full for
                                                        the services you provide. You cannot ask for nor accept
                                                        additional payment from the member.</li>
                                                    <li>Disclose any criminal convictions you have related to
                                                        Medicare, Medicaid, or title XX services.</li>
                                                    <li>Not discriminate against individuals because of their race,
                                                        color, national origin, sex, age, religion or disability
                                                        when you provide these services.</li>
                                                    <li>Provide the same quality of service to persons receiving
                                                        public assistance as those who don’t receive such
                                                        assistance.</li>
                                                </ol>
                                            </div>
                                            <div class="col">
                                                <ol type="A" start="8">
                                                    <li>If you are enrolled to provide and bill for other services,
                                                        you must continue to follow the requirements of the
                                                        agreement you signed when you enrolled for those services.
                                                        The terms of that agreement are different than the terms in
                                                        the attached agreement.</li>
                                                    <li>Comply with federal requirements about advance directives.
                                                        An advance directive is written instruction, such as a
                                                        living will, to give a patient control over medical
                                                        treatment decisions.</li>
                                                    <li>Properly protect private information about the people to
                                                        whom you provide services, especially their health
                                                        information.</li>
                                                    <li>Don’t disclose the private information of someone for whom
                                                        you provide services, unless it is needed for your work.
                                                        This includes not discussing someone’s private information
                                                        unless your job requires it. Also, ensure that the
                                                        information could not be accessed by someone who does not
                                                        have permission to see it. This includes not leaving
                                                        paperwork out where others can see it, and not sending
                                                        private information over the internet.</li>
                                                    <li>Understand that this agreement may be canceled if you
                                                        violate its terms. If this agreement is canceled, you must
                                                        properly dispose of any private information you have about
                                                        the people you serve so that it is not discovered by someone
                                                        who does not have permission to see it.</li>
                                                    <li>Understand that this agreement may be canceled if you
                                                        violate its terms. If this agreement is canceled, you must
                                                        properly dispose of any private information you have about
                                                        the people you serve so that it is not discovered by someone
                                                        who does not have permission to see it.</li>
                                                </ol>

                                                <p>
                                                    This is a basic description of the terms of this agreement.
                                                </p>


                                                <p>
                                                    By signing this agreement, you are agreeing to be legally bound
                                                    by all of its terms. If you have questions about it, you should
                                                    get answers to them before signing this agreement. If you need
                                                    or want legal advice, you should contact your own attorney. For
                                                    more information, call 651-431-2700.
                                                </p>



                                            </div>

                                        </div>
                                    </div>
                                </div>


                                <div class="col-12  mb-3 mt-1 ">



                                </div>
                            </div>
                        </div>
                    </div>

                </div>

                <!--Employment Eligibility Verification Department  -->
                <span [ngClass]="{'page-break-before': EmpEVerifyDepart,'page-break-before-single':singlePrint}"></span>
                <div class="row mb-2 mt-2" *ngIf="EmpEVerifyDepart">
                    <div class="col p-0">
                        <div class="card" style="height:auto;page-break-inside: avoid;">
                            <div class="row">
                                <div class="col-lg-12">

                                    <div class="card-body" style="padding: 45px;">
                                        <div class="row mb-2">
                                            <div class="col-lg-12">

                                                <div class="row text-center">
                                                    <div class="col d-inline-flex justify-content-center">
                                                        <img src="..\assets\i9_form_image.JPG"
                                                            class="img-fluid mt-lg-n4 mb-lg-3" alt="Responsive image">
                                                        <div style="text-align: center;">
                                                            <h4>
                                                                Employment Eligibility Verification Department
                                                            </h4>
                                                            <h4>
                                                                Department of Homeland Security
                                                            </h4>
                                                            <p>
                                                                U.S.Citizenship and Immigration
                                                            </p>
                                                        </div>


                                                    </div>

                                                </div>
                                                <div class="row">
                                                    <div class="col">
                                                        <h4 style="text-align: center;">
                                                            USCIS
                                                            Form I-9
                                                        </h4>
                                                    </div>
                                                </div>




                                            </div>
                                            <div class="row mb-2 mt-2 p-0">
                                                <div class="col p-0">
                                                    <div class="card">
                                                        <div class="card-body">
                                                            <div class="row">
                                                                <div class="col">
                                                                    <p>
                                                                        <b>
                                                                            ►START HERE: Read instructions carefully
                                                                            before completing this form. The
                                                                            instructions must be available, either in
                                                                            paper or electronically, during completion
                                                                            of this form. Employers are liable for
                                                                            errors in the completion of this form.
                                                                        </b>


                                                                    </p> <br>
                                                                    <p>
                                                                        <b>
                                                                            ANTI-DISCRIMINATION NOTICE:
                                                                        </b> It is illegal to discriminate against
                                                                        work-authorized individuals. Employers CANNOT
                                                                        specify which document(s) an employee may
                                                                        present to establish employment authorization
                                                                        and identity. The refusal to hire or continue to
                                                                        employ an individual because the documentation
                                                                        presented has a future expiration date may also
                                                                        constitute illegal discrimination.


                                                                    </p>

                                                                </div>

                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <div class="row mb-2 mt-2 col-12 p-0">
                                                <div class="col p-0">
                                                    <div class="card">
                                                        <div class="card-body">
                                                            <div class="row ">
                                                                <div class="col">
                                                                    <p><b>Section 1. Employee Information and
                                                                            Attestation (Employees must complete and
                                                                            sign
                                                                            Section 1 of Form I-9 no late(rthan the
                                                                            first
                                                                            day of
                                                                            employment, but not before accepting a job
                                                                            offer.)
                                                                        </b></p>


                                                                </div>

                                                            </div>
                                                            <div class="row mb-2">
                                                                <div class="col-lg-3">
                                                                    <label>Last Name (Family Name)</label>
                                                                    <input type="text" class="form-control"
                                                                        [(ngModel)]="employmentEligibilityBo.lastName"
                                                                        disabled>

                                                                </div>
                                                                <div class="col-lg-3">
                                                                    <label>First Name (Given Name)</label>
                                                                    <input type="text" class="form-control"
                                                                        [(ngModel)]="employmentEligibilityBo.firstName"
                                                                        disabled>

                                                                </div>
                                                                <div class="col-lg-3">
                                                                    <label>Middle Initial</label>
                                                                    <input type="text" class="form-control"
                                                                        [(ngModel)]="employmentEligibilityBo.middleName"
                                                                        disabled>

                                                                </div>
                                                                <div class="col-lg-3">
                                                                    <label>Other Last Names Used (if any)</label>
                                                                    <input type="text" class="form-control"
                                                                        [(ngModel)]="employmentEligibilityBo.otherLastNameUsed"
                                                                        disabled>

                                                                </div>


                                                            </div>
                                                            <div class="row mb-2">
                                                                <div class="col-lg-3">
                                                                    <label>Address(Street Number and Name)</label>
                                                                    <textarea class="form-control"
                                                                        [(ngModel)]="employmentEligibilityBo.address"
                                                                        disabled></textarea>

                                                                </div>
                                                                <div class="col-lg-3">
                                                                    <label>Apt. Number</label>
                                                                    <input type="text" class="form-control"
                                                                        [(ngModel)]="employmentEligibilityBo.apt"
                                                                        disabled>

                                                                </div>
                                                                <div class="col-lg-3">
                                                                    <label>City or Town</label>
                                                                    <input type="text" class="form-control"
                                                                        [(ngModel)]="employmentEligibilityBo.city"
                                                                        disabled>

                                                                </div>
                                                                <div class="col-lg-3">
                                                                    <label>State</label>
                                                                    <ng-select [items]="stateList" class="width25"
                                                                        [(ngModel)]="employmentEligibilityBo.state"
                                                                        disabled>
                                                                    </ng-select>

                                                                </div>


                                                            </div>
                                                            <div class="row mb-2">
                                                                <div class="col-lg-3">
                                                                    <label>ZipCode</label>
                                                                    <input type="text"
                                                                        [(ngModel)]="employmentEligibilityBo.employersZip"
                                                                        minlength="5" maxlength="11"
                                                                        class="form-control" disabled>


                                                                    <!-- [(ngModel)]="employmentEligibilityBo.zip" -->
                                                                </div>
                                                                <div class="col-lg-3">
                                                                    <label>Date of Birth </label>

                                                                    <input type="text" class="form-control"
                                                                        [(ngModel)]="employmentEligibilityBo.dob">

                                                                </div>
                                                                <div class="col-lg-3">
                                                                    <label>U.S. Social Security Number</label>
                                                                    <input type="text"
                                                                        [(ngModel)]="employmentEligibilityBo.us_Ssn"
                                                                        class="form-control">


                                                                </div>
                                                                <div class="col-lg-3">
                                                                    <label>
                                                                        Employee's E-mail Address
                                                                    </label>
                                                                    <input type="text" class="form-control"
                                                                        [(ngModel)]="employmentEligibilityBo.employees_Email"
                                                                        disabled>

                                                                </div>
                                                                <div class="col-lg-3">
                                                                    <label>Employee's Telephone Number</label>
                                                                    <input type="text" class="form-control"
                                                                        [(ngModel)]="employmentEligibilityBo.employeesPhone">
                                                                </div>
                                                            </div>
                                                            <div class="row mt-2 mb-2">
                                                                <div class="col">
                                                                    <p>
                                                                        <b>
                                                                            I am aware that federal law provides for
                                                                            imprisonment and/or fines for false
                                                                            statements or use of false documents in
                                                                            connection with the completion of this form.
                                                                        </b>
                                                                    </p>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="row mb-2 mt-2 p-0">
                                                <div class="col p-0">
                                                    <div class="card">
                                                        <div class="card-body">
                                                            <div class="row">
                                                                <div class="col p-0">
                                                                    <p>
                                                                        <b>
                                                                            I attest, under penalty of perjury, that I
                                                                            am (check one of the following boxes):
                                                                        </b>
                                                                    </p>

                                                                </div>

                                                            </div>
                                                            <div class="row">
                                                                <div class="col">
                                                                    <p>
                                                                        <input type="radio" id="citizen1"
                                                                            name="stateofcitizen" value="citizen"
                                                                            (change)="one_bool($event)"
                                                                            [(ngModel)]="employmentEligibilityBo.penaltyOfPerjury">
                                                                        <!-- [(ngModel)]="employmentEligibilityBo.citizen_United_States" -->
                                                                        1. A
                                                                        citizen of
                                                                        the United States

                                                                    </p>
                                                                    <p>
                                                                        <!-- [(ngModel)]="employmentEligibilityBo.nonCitizen" -->
                                                                        <input type="radio" id="citizen2"
                                                                            name="stateofcitizen" value="noncitizen"
                                                                            [(ngModel)]="employmentEligibilityBo.penaltyOfPerjury">
                                                                        2. A
                                                                        noncitizen
                                                                        national of the United States (See instructions)

                                                                    </p>
                                                                    <p>

                                                                        <input type="radio" id="citizen3"
                                                                            name="stateofcitizen"
                                                                            value="lawful_permanent"
                                                                            [(ngModel)]="employmentEligibilityBo.penaltyOfPerjury">
                                                                        3. A
                                                                        lawful
                                                                        permanent resident (Alien Registration
                                                                        Number/USCIS Number): <input id="citizen3"
                                                                            [(ngModel)]="employmentEligibilityBo.alien_Registration_Number"
                                                                            type="text" min="0" class="form-control"
                                                                            style="width: 180px;display: inline-block;">
                                                                    </p>
                                                                    <p>
                                                                        <!-- [(ngModel)]="employmentEligibilityBo.alienAuthWork" -->
                                                                        <input type="radio" id="citizen4"
                                                                            name="stateofcitizen" value="alien"
                                                                            [(ngModel)]="employmentEligibilityBo.penaltyOfPerjury">
                                                                        4. An alien authorized to work until (expiration
                                                                        date, if applicable, mm/dd/yyyy):

                                                                        <input type="text" class="form-control"
                                                                            [(ngModel)]="employmentEligibilityBo.alien_Registration_ExpiryDate">
                                                                    </p>

                                                                </div>

                                                            </div>
                                                            <div class="row">
                                                                <div class="col-lg-9">
                                                                    <p>
                                                                        Aliens authorized to work must provide only one
                                                                        of the following document numbers to complete
                                                                        Form I-9:
                                                                        An Alien Registration Number/USCIS Number OR
                                                                        Form I-94 Admission Number OR Foreign Passport
                                                                        Number.
                                                                    </p>


                                                                </div>


                                                            </div>
                                                            <div class="row mb-2 mt-2">
                                                                <div class="col-lg-9">
                                                                    <div class="row mb-2">
                                                                        <div class="col-lg-6">
                                                                            <label> 1. Alien Registration Number/USCIS
                                                                                Number:</label>
                                                                        </div>
                                                                        <div class="col-lg-6">
                                                                            <input type="text" class="form-control"
                                                                                [(ngModel)]="employmentEligibilityBo.alien_Registration_Number_Uscis_Number">
                                                                        </div>
                                                                    </div>
                                                                    <div class="row mb-2">
                                                                        <div class="col" style="text-align: center;">
                                                                            <b> OR</b>
                                                                        </div>
                                                                    </div>
                                                                    <div class="row mb-2">
                                                                        <div class="col-lg-6">
                                                                            <label> 2. Form I-94 Admission
                                                                                Number:</label>
                                                                        </div>
                                                                        <div class="col-lg-6">
                                                                            <input type="text" class="form-control"
                                                                                [(ngModel)]="employmentEligibilityBo.form_I_94Admission_Number">
                                                                        </div>
                                                                    </div>
                                                                    <div class="row mb-2">
                                                                        <div class="col" style="text-align: center;">
                                                                            <b> OR </b>
                                                                        </div>
                                                                    </div>
                                                                    <div class="row mb-2">
                                                                        <div class="col-lg-6">
                                                                            <label> 3. Foreign Passport Number:</label>
                                                                        </div>
                                                                        <div class="col-lg-6">
                                                                            <input type="text" class="form-control"
                                                                                [(ngModel)]="employmentEligibilityBo.foreign_Passport_Number">
                                                                        </div>





                                                                    </div>
                                                                    <div class="row mb-2 mt-2">
                                                                        <div class="col-lg-6">
                                                                            <label> County of Issuance:</label>
                                                                        </div>
                                                                        <div class="col-lg-6">
                                                                            <input type="text" class="form-control"
                                                                                [(ngModel)]="employmentEligibilityBo.countryofIssuance">
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div class="col-lg-3">
                                                                    <div class="card">
                                                                        <div class="card-body">
                                                                            QR CODE
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>

                                                            <div class="row mb-2 mt-2">
                                                                <div class="col-6">
                                                                    <img src="{{employeesign}}" class="form-control"
                                                                        style="width: 255px;height:120px;" width="48"
                                                                        height="48">
                                                                </div>
                                                                <div class="col-4">
                                                                    <label>Today's Date:</label>
                                                                    <input type="text" class="form-control"
                                                                        [(ngModel)]="employmentEligibilityBo.todaysDate">
                                                                </div>
                                                            </div>
                                                            <br>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="row mb-2 mt-2 col-12 p-0">
                                                <div class="col p-0">
                                                    <div class="card">
                                                        <div class="card-body">
                                                            <div class="row">
                                                                <div class="col">
                                                                    <p>
                                                                        <b>
                                                                            Preparer and/or Translator Certification
                                                                            (check one):
                                                                        </b>
                                                                    </p>
                                                                </div>
                                                            </div>
                                                            <div class="row ms-2">
                                                                <div class="col-lg-6">
                                                                    <p>
                                                                        <!--  -->
                                                                        <input type="radio" value="true"
                                                                            name="translator" id="one1"
                                                                            [(ngModel)]="employmentEligibilityBo.did_not_use_preparerortranslator">
                                                                        <!-- [(ngModel)]="documentBO.employement_Eligibility_Verification.empPreparerORTranslator.i_did_not_use" -->
                                                                        I did not use a preparer or translator.
                                                                    </p>
                                                                </div>
                                                                <div class="col-lg-6">
                                                                    <p>
                                                                        <!--  -->
                                                                        <input type="radio" id="one2" value="false"
                                                                            name="translator"
                                                                            [(ngModel)]="employmentEligibilityBo.did_not_use_preparerortranslator">

                                                                        A preparer(s) and/or translator(s) assisted the
                                                                        employee in completing Section 1.
                                                                    </p>
                                                                </div>
                                                            </div>
                                                            <div class="row">
                                                                <div class="col">
                                                                    <p>
                                                                        (Fields below must be completed and signed when
                                                                        preparers and/or translators assist an employee
                                                                        in completing Section 1.)
                                                                    </p>
                                                                </div>
                                                            </div>
                                                            <div class="row">
                                                                <div class="col">
                                                                    <p>
                                                                        <b>
                                                                            I attest, under penalty of perjury, that I
                                                                            have assisted in the completion of Section 1
                                                                            of this form and that to the best of my
                                                                            knowledge the information is true and
                                                                            correct.
                                                                        </b>
                                                                    </p>

                                                                </div>

                                                            </div>

                                                            <div class="row mb-2 mt-2">
                                                                <div class="col-7">
                                                                    <img src="{{translatorsign}}" class="form-control"
                                                                        style="width: 255px;height:120px;" width="48"
                                                                        height="48">

                                                                </div>
                                                                <div class="col-4">
                                                                    <label>Today's Date:</label>
                                                                    <input type="text" class="form-control"
                                                                        [(ngModel)]="employmentEligibilityBo.signOfPreparerorTraslatorDate">
                                                                </div>

                                                            </div>
                                                            <div class="row mb-2 mt-2">
                                                                <div class="col-lg-6">
                                                                    <label>Last Name (Family Name)</label>
                                                                    <input type="text" class="form-control"
                                                                        [(ngModel)]="employmentEligibilityBo.preparerLastName">

                                                                </div>
                                                                <div class="col-lg-6">
                                                                    <label>First Name (Given Name)</label>
                                                                    <input type="text" class="form-control"
                                                                        [(ngModel)]="employmentEligibilityBo.preparerFirstName">

                                                                </div>

                                                            </div>
                                                            <div class="row mb-2 mt-2">
                                                                <div class="col-lg-5">
                                                                    <label>Address (Street Number and Name)</label>
                                                                    <textarea class="form-control"
                                                                        [(ngModel)]="employmentEligibilityBo.preparerAddress"></textarea>

                                                                </div>
                                                                <div class="col-lg-4">
                                                                    <label>City or Town</label>
                                                                    <input type="text" class="form-control"
                                                                        [(ngModel)]="employmentEligibilityBo.preparerCity">

                                                                </div>
                                                                <div class="col-lg-3">
                                                                    <label>State</label>
                                                                    <ng-select [items]="stateList" class="width25"
                                                                        [(ngModel)]="employmentEligibilityBo.preparerState">
                                                                    </ng-select>
                                                                </div>
                                                                <div class="col-lg-3">
                                                                    <label>Zip code</label>
                                                                    <input type="text" class="form-control" [(ngModel)]="employmentEligibilityBo.preparerZip
                                                                    ">

                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="row mb-2 mt-2 p-0">
                                                <div class="col p-0">
                                                    <div class="card">
                                                        <div class="card-body">
                                                            <div class="row">
                                                                <div class="col">
                                                                    <p>
                                                                        <b>
                                                                            Section 2. Employer or Authorized
                                                                            Representative Review and Verification
                                                                        </b>
                                                                    </p>
                                                                </div>
                                                            </div>
                                                            <div class="row">
                                                                <div class="col">
                                                                    <p>
                                                                        (Employers or their authorized representative
                                                                        must complete and sign Section 2 within 3
                                                                        business days of the employee's first day of
                                                                        employment. You
                                                                        must physically examine one document from List A
                                                                        OR a combination of one document from List B and
                                                                        one document from List C as listed on the "Lists
                                                                        of Acceptable Documents.")
                                                                    </p>

                                                                </div>
                                                            </div>
                                                            <div class="row">
                                                                <div class="col">
                                                                    <h6>Employee Info from Section 1</h6>
                                                                </div>
                                                            </div>
                                                            <div class="row">
                                                                <div class="col-lg-3">
                                                                    <label>Last Name (Family Name) </label>
                                                                    <input type="text" class="form-control"
                                                                        [(ngModel)]="employmentEligibilityBo.employeeSection2LastName">
                                                                </div>
                                                                <div class="col-lg-3">
                                                                    <label>First Name (Given Name) </label>
                                                                    <input type="text" class="form-control"
                                                                        [(ngModel)]="employmentEligibilityBo.employeeSection2FirstName">

                                                                </div>
                                                                <div class="col-lg-3">
                                                                    <label>Middle Initial</label>
                                                                    <input type="text" class="form-control"
                                                                        [(ngModel)]="employmentEligibilityBo.employeeSection2MiddleName">

                                                                </div>
                                                                <div class="col-lg-3">
                                                                    <label>Citizenship/Immigration Status</label>
                                                                    <input type="text" class="form-control"
                                                                        [(ngModel)]="employmentEligibilityBo.employeeSection2citizenship">
                                                                    <!--  -->
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="row mb-2 mt-2 p-0">
                                                <div class="col p-0">
                                                    <div class="card">
                                                        <div class="card-body">
                                                            <div class="row">
                                                                <div class="col-lg-4">
                                                                    <b> <label>List A</label></b>
                                                                </div>
                                                                <div class="col-lg-8">
                                                                    <div class="row">
                                                                        <div class="col-lg-2">
                                                                            <b>
                                                                                <label>OR</label>
                                                                            </b>
                                                                        </div>
                                                                        <div class="col-lg-4">
                                                                            <b>
                                                                                <label>List B</label>
                                                                            </b>
                                                                        </div>
                                                                        <div class="col-lg-2">
                                                                            <b>
                                                                                <label>AND</label>
                                                                            </b>
                                                                        </div>
                                                                        <div class="col-lg-4">
                                                                            <b> <label>List C</label> </b>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div class="row">
                                                                <div class="col-lg-4">
                                                                    <label>Identity and Employment Authorization</label>
                                                                </div>
                                                                <div class="col-lg-4">
                                                                    <label>Identity</label>

                                                                </div>
                                                                <div class="col-lg-4">
                                                                    <label>Employment Authorization</label>
                                                                </div>
                                                            </div>
                                                            <div class="row">
                                                                <div class="col-lg-4">
                                                                    <label>Document Title</label>
                                                                    <input type="text" class="form-control"
                                                                        [(ngModel)]="employmentEligibilityBo.documentTitle">

                                                                </div>
                                                                <div class="col-lg-8">
                                                                    <div class="row">
                                                                        <div class="col-lg-6">
                                                                            <label>Document Title</label>
                                                                            <input type="text" class="form-control"
                                                                                [(ngModel)]="employmentEligibilityBo.documentTitle1">

                                                                        </div>
                                                                        <div class="col-lg-6">
                                                                            <label>Document Title</label>
                                                                            <input type="text" class="form-control"
                                                                                [(ngModel)]="employmentEligibilityBo.documentTitle2">

                                                                        </div>

                                                                    </div>

                                                                </div>

                                                            </div>
                                                            <div class="row">
                                                                <div class="col-lg-4">
                                                                    <label>Issuing Authority</label>
                                                                    <input type="text" class="form-control"
                                                                        [(ngModel)]="employmentEligibilityBo.issuingAuthority">

                                                                </div>
                                                                <div class="col-lg-8">
                                                                    <div class="row">
                                                                        <div class="col-lg-6">
                                                                            <label>Issuing Authority</label>
                                                                            <input type="text" class="form-control"
                                                                                [(ngModel)]="employmentEligibilityBo.issuingAuthority1">

                                                                        </div>
                                                                        <div class="col-lg-6">
                                                                            <label>Issuing Authority</label>
                                                                            <input type="text" class="form-control"
                                                                                [(ngModel)]="employmentEligibilityBo.issuingAuthority2">

                                                                        </div>

                                                                    </div>

                                                                </div>

                                                            </div>
                                                            <div class=" d-flex">
                                                                <div class="col-lg-4">
                                                                    <label>Document Number</label>
                                                                    <input type="text" min="0" class="form-control"
                                                                        [(ngModel)]="employmentEligibilityBo.documentNumber">

                                                                </div>

                                                                <div class="col-lg-8">
                                                                    <div class="row">
                                                                        <div class="col-lg-6">
                                                                            <label>Document Number</label>
                                                                            <input type="text" min="0"
                                                                                class="form-control"
                                                                                [(ngModel)]="employmentEligibilityBo.documentNumber1">

                                                                        </div>
                                                                        <div class="col-lg-6">
                                                                            <label>Document Number</label>
                                                                            <input type="text" min="0"
                                                                                class="form-control"
                                                                                [(ngModel)]="employmentEligibilityBo.documentNumber2">

                                                                        </div>

                                                                    </div>

                                                                </div>

                                                            </div>
                                                            <div class="row">
                                                                <div class="col-lg-4 mb-2"
                                                                    style="border-bottom:1px solid #848484">
                                                                    <label>Expiration Date</label>

                                                                    <input type="text" class="form-control"
                                                                        [(ngModel)]="employmentEligibilityBo.expirationDate">

                                                                </div>
                                                                <div class="col-lg-8">
                                                                    <div class="row">
                                                                        <div class="col-lg-6">
                                                                            <label>Expiration Date</label>

                                                                            <input type="text" class="form-control"
                                                                                [(ngModel)]="employmentEligibilityBo.expirationDate1">

                                                                        </div>
                                                                        <div class="col-lg-6">
                                                                            <label>Expiration Date</label>

                                                                            <input type="text" class="form-control"
                                                                                [(ngModel)]="employmentEligibilityBo.expirationDate2">
                                                                        </div>

                                                                    </div>

                                                                </div>

                                                            </div>

                                                            <div class="row mb-2 mt-2">
                                                                <div class="col-lg-4">
                                                                    <div class="row">
                                                                        <div class="col-lg-12">
                                                                            <label>Document Title</label>
                                                                            <input type="text" class="form-control"
                                                                                [(ngModel)]="employmentEligibilityBo.documentTitle3">

                                                                        </div>

                                                                    </div>
                                                                    <div class="row">
                                                                        <div class="col-lg-12">
                                                                            <label>Issuing Authority</label>
                                                                            <input type="text" class="form-control"
                                                                                [(ngModel)]="employmentEligibilityBo.issuingAuthority3">

                                                                        </div>

                                                                    </div>
                                                                    <div class="row">
                                                                        <div class="col-lg-12">
                                                                            <label>Document Number</label>
                                                                            <input type="text" class="form-control"
                                                                                [(ngModel)]="employmentEligibilityBo.documentNumber3">

                                                                        </div>

                                                                    </div>
                                                                    <div class="row">
                                                                        <div class="col-lg-12 mb-2"
                                                                            style="border-bottom:1px solid #848484">
                                                                            <label>Expiration Date</label>

                                                                            <input type="text" class="form-control"
                                                                                [(ngModel)]="employmentEligibilityBo.expirationDate3">

                                                                        </div>

                                                                    </div>
                                                                    <!-- <hr> -->
                                                                    <div class="row">
                                                                        <div class="col-lg-12">
                                                                            <label>Document Title</label>
                                                                            <input type="text" class="form-control"
                                                                                [(ngModel)]="employmentEligibilityBo.documentTitle4">
                                                                        </div>
                                                                    </div>
                                                                    <div class="row">
                                                                        <div class="col-lg-12">
                                                                            <label>Issuing Authority</label>
                                                                            <input type="text" class="form-control"
                                                                                [(ngModel)]="employmentEligibilityBo.issuingAuthority4">
                                                                        </div>
                                                                    </div>
                                                                    <div class="row">
                                                                        <div class="col-lg-12">
                                                                            <label>Document Number</label>
                                                                            <input type="text" class="form-control"
                                                                                [(ngModel)]="employmentEligibilityBo.documentNumber4">
                                                                        </div>
                                                                    </div>
                                                                    <div class="row">
                                                                        <div class="col-lg-12">
                                                                            <label>Expiration Date</label>

                                                                            <input type="text" class="form-control"
                                                                                [(ngModel)]="employmentEligibilityBo.expirationDate4">
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div class="col-lg-8">
                                                                    <div class="card">
                                                                        <div class="card-body">
                                                                            <table class="table">
                                                                                <tr>
                                                                                    <td rowspan="6">
                                                                                        <textarea rows="30" cols="25"
                                                                                            [(ngModel)]="employmentEligibilityBo.additionalInfo"
                                                                                            class="form-control"
                                                                                            placeholder="Additional Information"></textarea>

                                                                                    </td>
                                                                                    <td rowspan="6">
                                                                                        <div class="card">
                                                                                            <div class="card-body">
                                                                                                <p>QR CODE -sections 2 &
                                                                                                    3
                                                                                                    <br>
                                                                                                    Do not write in this
                                                                                                    space
                                                                                                </p>
                                                                                            </div>
                                                                                        </div>
                                                                                    </td>
                                                                                </tr>
                                                                            </table>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div class="row mb-2 mt-2">
                                                                <div class="col">
                                                                    <p>
                                                                        <b>
                                                                            Certification: I attest, under penalty of
                                                                            perjury, that (1) I have examined the
                                                                            document(s) presented by the above-named
                                                                            employee,
                                                                            (2) the above-listed document(s) appear to
                                                                            be genuine and to relate to the employee
                                                                            named, and (3) to the best of my knowledge
                                                                            the
                                                                            employee is authorized to work in the United
                                                                            States.
                                                                        </b>
                                                                    </p>

                                                                </div>

                                                            </div>
                                                            <div class="row mb-2 mt-2">
                                                                <div class="col-lg-7">
                                                                    <b><label>The employee's first day of employment
                                                                            (mm/dd/yyyy):</label></b>
                                                                </div>
                                                                <div class="col-lg-3">
                                                                    <input type="text" class="form-control"
                                                                        [(ngModel)]="employmentEligibilityBo.employeesFirstdayEmployment">
                                                                </div>
                                                                <div class="2">
                                                                    (See instructions for exemptions)
                                                                </div>
                                                            </div>

                                                            <div class="row mb-2 mt-2">
                                                                <div class="col">
                                                                    <img src="{{authorizedsign}}" class="form-control"
                                                                        style="width: 255px;height:120px;" width="48"
                                                                        height="48">

                                                                </div>
                                                                <div class="col-4">
                                                                    <label> Today's Date:
                                                                    </label>
                                                                    <input type="text" class="form-control"
                                                                        [(ngModel)]="employmentEligibilityBo.employerSignDate1">
                                                                </div>
                                                            </div>
                                                            <div class="row mb-2 mt-2">
                                                                <div class="col-lg-3">
                                                                    <label>Title of Employer or Authorized
                                                                        Representative</label>
                                                                    <ng-select [items]="employerList" bindValue="id"
                                                                        bindLabel="lovName"
                                                                        [(ngModel)]="employmentEligibilityBo.employerTitle">
                                                                    </ng-select>
                                                                </div>
                                                                <div class="col-lg-3">
                                                                    <label>Last Name of Employer or Authorized
                                                                        Representative</label>
                                                                    <input type="text" class="form-control"
                                                                        [(ngModel)]="employmentEligibilityBo.employerLastName"
                                                                        disabled>
                                                                </div>
                                                                <div class="col-lg-3">
                                                                    <label>First Name of Employer or Authorized
                                                                        Representative</label>
                                                                    <input type="text" class="form-control"
                                                                        [(ngModel)]="employmentEligibilityBo.employerFirstName">
                                                                    <!-- [(ngModel)]="employmentEligibilityBo.employerFirstName" disabled> -->

                                                                </div>
                                                                <div class="col-lg-3 mt-lg-4">
                                                                    <label>Employer's Business or Organization
                                                                        Name</label>
                                                                    <input type="text" class="form-control"
                                                                        [(ngModel)]="employmentEligibilityBo.employersOrgName">
                                                                </div>
                                                            </div>
                                                            <div class="row mb-2 mt-2">
                                                                <div class="col-lg-4">
                                                                    <label>Employer's Business or Organization
                                                                        Address</label>
                                                                    <textarea class="form-control"
                                                                        [(ngModel)]="employmentEligibilityBo.employersAddress"
                                                                        disabled></textarea>
                                                                </div>
                                                                <div class="col-lg-3">
                                                                    <label>City or Town</label>
                                                                    <input type="text" class="form-control"
                                                                        [(ngModel)]="employmentEligibilityBo.employersCity"
                                                                        disabled>
                                                                </div>
                                                                <div class="col-lg-3">
                                                                    <label>State</label>
                                                                    <ng-select [items]="stateList" class="width25"
                                                                        [(ngModel)]="employmentEligibilityBo.employersState"
                                                                        disabled>
                                                                    </ng-select>
                                                                </div>
                                                                <div class="col-lg-2">
                                                                    <label>Zip Code</label>
                                                                    <input type="text"
                                                                        [(ngModel)]="employmentEligibilityBo.employersZip"
                                                                        class="form-control" disabled>

                                                                </div>
                                                            </div>
                                                            <br>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="row mb-2 mt-2 p-0">
                                                <div class="col p-0">
                                                    <div class="card">
                                                        <div class="card-body">
                                                            <p> <b>Section 3. Reverification and Rehires</b> (To be
                                                                completed and signed by employer or authorized
                                                                representative.)</p>
                                                            <div class="row">
                                                                <div class="col-lg-8">
                                                                    <b>A.</b> <label>New Name (if applicable)</label>

                                                                </div>
                                                                <div class="col-lg-4">
                                                                    <b>B.</b> <label>Date of Rehire (if
                                                                        applicable)</label>
                                                                </div>
                                                            </div>

                                                            <div class="row">
                                                                <div class="col-lg-8">
                                                                    <div class="row">
                                                                        <div class="col-lg-4">
                                                                            <label>Last Name</label>
                                                                            <input type="text" class="form-control"
                                                                                [(ngModel)]="employmentEligibilityBo.reverificationLastName"
                                                                                disabled>
                                                                        </div>
                                                                        <div class="col-lg-4">
                                                                            <label>First Name</label>
                                                                            <input type="text" class="form-control"
                                                                                [(ngModel)]="employmentEligibilityBo.reverificationFirstName"
                                                                                disabled>
                                                                        </div>
                                                                        <div class="col-lg-4">
                                                                            <label>Middle Name</label>
                                                                            <input type="text" class="form-control"
                                                                                [(ngModel)]="employmentEligibilityBo.reverificationMiddleName"
                                                                                disabled>
                                                                        </div>
                                                                    </div>
                                                                </div>

                                                                <div class="col-lg-4">
                                                                    <label>Date</label>

                                                                    <input type="text" class="form-control"
                                                                        [(ngModel)]="employmentEligibilityBo.reverificationDate">
                                                                </div>

                                                                <div class="row ms-1">
                                                                    <div class="col">
                                                                        <p><b>C.</b>If the employee's previous grant of
                                                                            employment authorization has expired,
                                                                            provide
                                                                            the information for the document or receipt
                                                                            that
                                                                            establishes
                                                                            continuing employment authorization in the
                                                                            space
                                                                            provided below.</p>
                                                                    </div>
                                                                </div>
                                                                <div class="row ms-1">
                                                                    <div class="col-lg-3">
                                                                        <label>Document Title</label>
                                                                        <input type="text" class="form-control"
                                                                            [(ngModel)]="employmentEligibilityBo.employerDocumentTitle">

                                                                    </div>
                                                                    <div class="col-lg-4">
                                                                        <label>Document Number</label>
                                                                        <input type="text" class="form-control"
                                                                            [(ngModel)]="employmentEligibilityBo.documentNum">

                                                                    </div>
                                                                    <div class="col-lg-5">
                                                                        <label>Expiration Date (if any)
                                                                            (mm/dd/yyyy)</label>


                                                                        <input type="text" class="form-control"
                                                                            [(ngModel)]="employmentEligibilityBo.documentExpiryDate">
                                                                    </div>
                                                                </div>
                                                                <div class="row ms-1">
                                                                    <div class="col">
                                                                        <p><b>I attest, under penalty of perjury, that
                                                                                to
                                                                                the best of my knowledge, this employee
                                                                                is
                                                                                authorized to work in the United States,
                                                                                and
                                                                                if
                                                                                the employee presented document(s), the
                                                                                document(s) I have examined appear to be
                                                                                genuine and to relate to the
                                                                                individual.</b>
                                                                        </p>
                                                                    </div>
                                                                </div>

                                                                <div class="row col-12">
                                                                    <div class="col-lg-5 mb-2 mt-2">
                                                                        <div class="col">
                                                                            <img src="{{authorizedrepsign}}"
                                                                                class="form-control"
                                                                                style="width: 255px;height:120px;"
                                                                                width="48" height="48">

                                                                        </div>


                                                                    </div>
                                                                    <div class="col-lg-7">
                                                                        <label>Name of Employer or Authorized
                                                                            Representative</label>
                                                                        <input type="text" class="form-control"
                                                                            [(ngModel)]="employmentEligibilityBo.nameofEmployer">
                                                                        <!-- [(ngModel)]="employmentEligibilityBo.nameofEmployer" -->
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="row  mt-4">
                                                    <div class="col p-0">
                                                        <div class="card">
                                                            <div class="card-body">

                                                                <h4 style="text-align: center;">LISTS OF ACCEPTABLE
                                                                    DOCUMENTS
                                                                    All documents must be UNEXPIRED
                                                                </h4>
                                                                <p style="text-align: center;">Employees may present one
                                                                    selection from List A

                                                                    or a combination of one selection from List B and
                                                                    one
                                                                    selection from List C.</p>

                                                                <div class="row">
                                                                    <div class="col-lg-4">
                                                                        <p><b>LIST A
                                                                                Documents that Establish
                                                                                Both Identity and
                                                                                Employment Authorization OR</b></p>
                                                                    </div>
                                                                    <div class="col-lg-4">
                                                                        <p>
                                                                            <b>LIST B
                                                                                Documents that Establish
                                                                                Identity AND</b>
                                                                        </p>

                                                                    </div>
                                                                    <div class="col-lg-4">
                                                                        <p>
                                                                            <b>
                                                                                LIST C
                                                                                Documents that Establish
                                                                                Employment Authorization
                                                                            </b>
                                                                        </p>
                                                                    </div>


                                                                </div>
                                                                <div class="row">
                                                                    <div class="col-lg-4">
                                                                        <ol type="1" class="ms-2">
                                                                            <li>
                                                                                U.S. Passport or U.S. Passport Card
                                                                            </li>
                                                                            <li>
                                                                                Permanent Resident Card or Alien
                                                                                Registration Receipt Card (Form I-551)
                                                                            </li>
                                                                            <li>
                                                                                Foreign passport that contains a
                                                                                temporary I-551 stamp or temporary

                                                                                I-551 printed notation on a machine-
                                                                                readable immigrant visa
                                                                            </li>
                                                                            <li>
                                                                                Employment Authorization Document
                                                                                that contains a photograph (Form
                                                                                I-766)
                                                                            </li>
                                                                            <li>

                                                                                For a nonimmigrant alien authorized
                                                                                to work for a specific employer
                                                                                because of his or her status:
                                                                                <ol type="a" class="ms-4">
                                                                                    <li>Foreign passport; and</li>
                                                                                    <li>Form I-94 or Form I-94A that has
                                                                                        the following:</li>
                                                                                    <ol type="1" class="ms-2">
                                                                                        <li>The same name as the
                                                                                            passport;
                                                                                            and</li>
                                                                                        <li>
                                                                                            An endorsement of the
                                                                                            alien's
                                                                                            nonimmigrant status as long
                                                                                            as
                                                                                            that period of endorsement
                                                                                            has
                                                                                            not yet expired and the
                                                                                            proposed employment is not
                                                                                            in
                                                                                            conflict with any
                                                                                            restrictions
                                                                                            or
                                                                                            limitations identified on
                                                                                            the
                                                                                            form.
                                                                                        </li>

                                                                                    </ol>
                                                                                </ol>
                                                                            </li>
                                                                            <li>
                                                                                Passport from the Federated States
                                                                                of Micronesia (FSM) or the Republic
                                                                                of the Marshall Islands (RMI) with
                                                                                Form I-94 or Form I-94A indicating
                                                                                nonimmigrant admission under the
                                                                                Compact of Free Association Between
                                                                                the United States and the FSM or RMI
                                                                            </li>


                                                                        </ol>

                                                                    </div>
                                                                    <div class="col-lg-4">
                                                                        <ol type="1" class="ms-2">
                                                                            <li>
                                                                                Driver's license or ID card issued by a
                                                                                State or outlying possession of the
                                                                                United States provided it contains a
                                                                                photograph or information such as
                                                                                name, date of birth, gender, height, eye
                                                                                color, and address
                                                                            </li>
                                                                            <li>
                                                                                ID card issued by federal, state or
                                                                                local
                                                                                government agencies or entities,
                                                                                provided it contains a photograph or
                                                                                information such as name, date of birth,
                                                                                gender, height, eye color, and address
                                                                            </li>
                                                                            <li>
                                                                                School ID card with a photograph
                                                                            </li>
                                                                            <li>
                                                                                Voter's registration card
                                                                            </li>
                                                                            <li>
                                                                                U.S. Military card or draft record
                                                                            </li>
                                                                            <li>
                                                                                Military dependent's ID card
                                                                            </li>
                                                                            <li>
                                                                                U.S. Coast Guard Merchant Mariner
                                                                                Card
                                                                            </li>
                                                                            <li>
                                                                                Native American tribal document
                                                                            </li>
                                                                            <li>
                                                                                Driver's license issued by a Canadian
                                                                                government authority
                                                                            </li>
                                                                            <b>
                                                                                For persons under age 18 who are
                                                                                unable to present a document
                                                                                listed above:
                                                                            </b>
                                                                            <li>
                                                                                School record or report card
                                                                            </li>
                                                                            <li>
                                                                                Clinic, doctor, or hospital record
                                                                            </li>
                                                                            <li>
                                                                                Day-care or nursery school record
                                                                            </li>

                                                                        </ol>


                                                                    </div>
                                                                    <div class="col-lg-4">
                                                                        <ol type="1">
                                                                            <li>
                                                                                A Social Security Account Number
                                                                                card, unless the card includes one of
                                                                                the following restrictions:
                                                                            </li>
                                                                            <li>
                                                                                Certification of report of birth issued
                                                                                by the Department of State (Forms
                                                                                DS-1350, FS-545, FS-240)
                                                                            </li>
                                                                            <li>
                                                                                Original or certified copy of birth
                                                                                certificate issued by a State,
                                                                                county, municipal authority, or
                                                                                territory of the United States
                                                                                bearing an official seal
                                                                            </li>
                                                                            <li>
                                                                                Native American tribal document
                                                                            </li>
                                                                            <li>
                                                                                U.S. Citizen ID Card (Form I-197)
                                                                            </li>
                                                                            <li>
                                                                                Identification Card for Use of
                                                                                Resident Citizen in the United
                                                                                States (Form I-179)
                                                                            </li>
                                                                            <li>
                                                                                Employment authorization
                                                                                document issued by the
                                                                                Department of Homeland Security
                                                                            </li>

                                                                        </ol>

                                                                    </div>

                                                                </div>
                                                                <div class="row">
                                                                    <div class="col">
                                                                        <p style="text-align: center;">
                                                                            <b>
                                                                                Examples of many of these documents
                                                                                appear
                                                                                in the Handbook for Employers
                                                                                (M-274).<br>

                                                                                Refer to the instructions for more
                                                                                information about acceptable receipts.
                                                                            </b>
                                                                        </p>

                                                                    </div>

                                                                </div>




                                                            </div>

                                                        </div>

                                                    </div>

                                                </div>

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <!--Employee’s Withholding Certificate-->
                <span
                    [ngClass]="{'page-break-before': EmpWithHoldCertify,'page-break-before-single':singlePrint}"></span>
                <div class="row mb-2 mt-2" *ngIf="EmpWithHoldCertify">
                    <div class="col p-0">
                        <div class="card" style="height:auto;page-break-inside: avoid;">
                            <div class="card-header">
                                <div class="row">
                                    <div class="col-lg-12">

                                    </div>
                                </div>
                            </div>
                            <div class="card-body" style="padding:85px;">
                                <!-- <form [formGroup]=""> -->
                                <div class="row mb-4">
                                    <div class="col-lg-2">
                                        <h5>Form<h3><b>W-4</b></h3>
                                        </h5>
                                        <p>Department of the Treasury
                                            Internal Revenue Service </p>
                                    </div>
                                    <div class="col-lg-8">
                                        <div class="row">
                                            <div class="col-lg-12">
                                                <h4><b>Employee’s Withholding Certificate</b></h4>
                                                <p><b>(For use by employers, corporations, partnerships, trusts,
                                                        estates, churches,
                                                        government agencies, Indian tribal entities, certain
                                                        individuals, and others.)</b></p>
                                                <p>
                                                    <b>
                                                        ▶ Complete Form W-4 so that your employer can withhold the
                                                        correct federal income tax from your pay
                                                    </b>
                                                </p>
                                                <p><b>
                                                        ▶ Give Form W-4 to your employer
                                                    </b></p>
                                                <p><b>
                                                        ▶ Your withholding is subject to review by the IRS.
                                                    </b></p>

                                            </div>
                                        </div>

                                    </div>
                                    <div class="col-lg-2">
                                        <p>OMB No. 1545-0074</p>
                                        <h5><b>2024</b></h5>

                                    </div>
                                </div>
                                <div class="row mb-2 mt-4">
                                    <div class="col p-0">
                                        <div class="card ">
                                            <div class="card-header">
                                                <h5><b>Step 1:</b>&nbsp;<b>Enter Personal Information</b></h5>
                                            </div>
                                            <div class="card-body">
                                                <div class="row mt-3">
                                                    <div class="col-lg-4">
                                                        <label>(a) First name and middle initial </label>
                                                        <input type="text" class="form-control"
                                                            [(ngModel)]="employeesWithholdingBo.firstName" disabled>
                                                    </div>
                                                    <div class="col-lg-4">
                                                        <label>Last Name </label>
                                                        <input type="text" class="form-control"
                                                            [(ngModel)]="employeesWithholdingBo.lastName" disabled>
                                                    </div>
                                                    <div class="col-lg-4">
                                                        <label>(b) Social security number </label>
                                                        <input type="text" class="form-control"
                                                            [(ngModel)]="employeesWithholdingBo.social_Security_Number"
                                                            disabled>

                                                    </div>


                                                </div>
                                                <div class="row mt-2">
                                                    <div class="col-lg-6">
                                                        <label>Address </label>
                                                        <textarea class="form-control"
                                                            [(ngModel)]="employeesWithholdingBo.address"></textarea>
                                                        <!--  -->

                                                        <label>City</label>
                                                        <textarea disabled class="form-control"
                                                            [(ngModel)]="employeesWithholdingBo.city"></textarea>
                                                        <!--  -->

                                                        <label>State</label>
                                                        <textarea disabled class="form-control"
                                                            [(ngModel)]="employeesWithholdingBo.state"></textarea>
                                                        <!--  nn-->
                                                        <label>ZipCode</label>
                                                        <textarea disabled class="form-control"
                                                            [(ngModel)]="employeesWithholdingBo.zip"></textarea>
                                                        <!--  -->

                                                    </div>
                                                    <div class="col-lg-2">

                                                    </div>
                                                    <div class="col-lg-3">
                                                        <p>▶ Does your name match the
                                                            name on your social security
                                                            card? If not, to ensure you get
                                                            credit for your earnings, contact
                                                            SSA at 800-772-1213 or go to
                                                            www.ssa.gov.</p>
                                                    </div>
                                                </div>
                                                <div class="row mt-2">
                                                    <div class="col-lg-1">
                                                        (c)
                                                    </div>
                                                    <div class="col-lg-1">
                                                        <!-- [(ngModel)]="employeesWithholdingBo.singleOrMarriedFillingSeparately" -->
                                                        <input type="radio" name="statusss" value="singlee"
                                                            [(ngModel)]="employeesWithholdingBo.maritialStatus">
                                                    </div>
                                                    <div class="col-lg-5">
                                                        <label>Single or Married filing separately</label>
                                                    </div>
                                                </div>
                                                <div class="row mt-2">
                                                    <div class="col-lg-1">

                                                    </div>
                                                    <div class="col-lg-1">
                                                        <input type="radio" name="statusss" value="marriedd"
                                                            [(ngModel)]="employeesWithholdingBo.maritialStatus">
                                                        <!-- [(ngModel)]="employeesWithholdingBo.marriedFillingjointlyOrQualifyingWidow" -->
                                                    </div>
                                                    <div class="col-lg-5">
                                                        <label>Married filing jointly or Qualifying
                                                            widow(er)</label>
                                                    </div>
                                                </div>
                                                <div class="row mt-2">
                                                    <div class="col-lg-1">

                                                    </div>

                                                    <div class="col-lg-1">
                                                        <!-- [(ngModel)]="employeesWithholdingBo.headofHousehold" -->
                                                        <input type="radio" name="statusss" value="householdd"
                                                            [(ngModel)]="employeesWithholdingBo.maritialStatus">
                                                    </div>
                                                    <div class="col-lg-5">
                                                        <label>Head of household (Check only if you’re unmarried and
                                                            pay more than half the costs of keeping up a home for
                                                            yourself and a qualifying individual.)</label>
                                                    </div>
                                                </div>


                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="row mt-1 ms-2">
                                    <p>Complete Steps 2–4 ONLY if they apply to you; otherwise, skip to Step 5. See
                                        page 2 for more information on each step, who can
                                        claim exemption from withholding, when to use the estimator at
                                        www.irs.gov/W4App, and privacy</p>
                                </div>
                                <div class="row mb-2 mt-4">
                                    <div class="col p-0">
                                        <div class="card ">
                                            <div class="card-header">
                                                <h5><b>Step 2:</b>&nbsp;<b>Multiple Jobs
                                                        or Spouse
                                                        Works</b></h5>
                                            </div>
                                            <div class="card-body" style="padding:35px;">
                                                <div class="row mt-2">
                                                    <p>Complete this step if you (1) hold more than one job at a
                                                        time, or (2) are married filing jointly and your spouse
                                                        also works. The correct amount of withholding depends on
                                                        income earned from all of these jobs.</p>
                                                </div>
                                                <div class="row mt-2">
                                                    <p>Do only one of the following.</p>
                                                    <ol type="a" style="margin-left: 30px;">
                                                        <li> Use the estimator at www.irs.gov/W4App for most
                                                            accurate withholding for this step (and Steps 3–4).If you or
                                                            spouse have self-employement income,use this option; or
                                                        </li>
                                                        <li>Use the Multiple Jobs Worksheet on page 3 and enter the
                                                            result in Step 4(c) below; or</li>
                                                        <li>If there are only two jobs total, you may check this box. Do
                                                            the same on Form W-4 for the other job. This
                                                            option is generally more accurate than (b) if pay at the
                                                            lower paying job is more than half of the pay at the
                                                            higher paying job. Otherwise, (b) is more accurate . . . . .
                                                            . ....
                                                            <input type="checkbox"
                                                                [(ngModel)]="employeesWithholdingBo.multipleJobsOrSpouseWorkSectionc" />

                                                        </li>
                                                    </ol>
                                                </div>
                                                <!-- <div class="row mt-2">
                                                    <p><b>TIP:</b> To be accurate, submit a 2022 Form W-4 for all
                                                        other jobs. If you (or your spouse) have self-employment
                                                        income, including as an independent contractor, use the
                                                        estimator.</p>

                                                </div> -->
                                                <div class="row mt-2">
                                                    <p><b>Complete Steps 3–4(b) on Form W-4 for only ONE of these
                                                            jobs.</b> Leave those steps blank for the other jobs.
                                                        (Your withholding will
                                                        be most accurate if you complete Steps 3–4(b) on the Form
                                                        W-4 for the highest paying job.)</p>
                                                </div>

                                            </div>
                                        </div>
                                    </div>

                                </div>
                                <div class="row mb-2 mt-4 mb-3">
                                    <div class="col p-0">
                                        <div class="card ">
                                            <div class="card-header">
                                                <h5><b>Step3:</b>&nbsp;<b>Claim
                                                        Dependents </b></h5>
                                            </div>
                                            <div class="card-body" style="padding:35px;">
                                                <div class="row mt-2">
                                                    <p>If your total income will be $200,000 or less ($400,000 or
                                                        less if married filing jointly):
                                                    </p>
                                                </div>
                                                <div class="row mt-2">
                                                    <p>Multiply the number of qualifying children under age 17 by
                                                        $2,000 ▶$ <input type="number" min="0" class="form-control"
                                                            [(ngModel)]="employeesWithholdingBo.qualifyingChildrenUnder_AgeSeventeen"
                                                            style="width: 180px;display: inline-block;"></p>
                                                </div>
                                                <div class="row mt-2">
                                                    <p>Multiply the number of other dependents by $500 . . . .
                                                        ▶$ <input type="number" min="0" maxlength="14"
                                                            class="form-control"
                                                            [(ngModel)]="employeesWithholdingBo.otherDependents"
                                                            style="width: 180px;display: inline-block;"></p>
                                                </div>

                                                <div class="row mt-2">
                                                    <p>Add the amounts above for qualifying children and other
                                                        dependents. You may add to
                                                        this the amount of any other credits. Enter the total here . . .
                                                        . . . . . . .&nbsp;&nbsp;$ <input type="number" min="0"
                                                            class="form-control"
                                                            [(ngModel)]="employeesWithholdingBo.total"
                                                            style="width: 180px;display: inline-block;">
                                                    </p>
                                                </div>

                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="row mb-2 mt-4 mb-3">
                                    <div class="col p-0">
                                        <div class="card ">
                                            <div class="card-header">
                                                <h5><b>Step4:</b>&nbsp;(optional):
                                                    Other
                                                    Adjustments</h5>
                                            </div>
                                            <div class="card-body" style="padding:35px;">
                                                <div class="row mt-2">
                                                    <ol type="a">
                                                        <li>
                                                            Other income (not from jobs). If you want tax withheld
                                                            for other income you
                                                            expect this year that won’t have withholding, enter the
                                                            amount of other income here.
                                                            This may include interest, dividends, and retirement
                                                            income . . . . . . . .4(a)&nbsp;&nbsp;$ <input type="number"
                                                                min="0" class="form-control"
                                                                [(ngModel)]="employeesWithholdingBo.otherIncome"
                                                                style="width: 180px;display: inline-block;">
                                                        </li>
                                                        <li>
                                                            Deductions. If you expect to claim deductions other than
                                                            the standard deduction and
                                                            want to reduce your withholding, use the Deductions
                                                            Worksheet on page 3 and enter
                                                            the result here . . . . . . . . . . . . . . . . . . . .
                                                            . . .4(b)&nbsp;&nbsp;$ <input type="number" min="0"
                                                                class="form-control"
                                                                [(ngModel)]="employeesWithholdingBo.deductions"
                                                                style="width: 180px;display: inline-block;">
                                                        </li>
                                                        <li>
                                                            Extra withholding. Enter any additional tax you want
                                                            withheld each pay period . .4(c)&nbsp;&nbsp;$ <input
                                                                type="number" min="0" class="form-control"
                                                                [(ngModel)]="employeesWithholdingBo.additionalTax"
                                                                style="width: 180px;display: inline-block;">
                                                        </li>
                                                    </ol>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="row mb-2 mt-4 mb-3">
                                    <div class="col p-0">
                                        <div class="card ">
                                            <div class="card-header">
                                                <h5><b>Step5:</b>&nbsp;Sign
                                                    Here
                                                </h5>
                                            </div>
                                            <div class="card-body" style="padding:35px;">
                                                <div class="row mt-2">
                                                    <p>Under penalties of perjury, I declare that this certificate,
                                                        to the best of my knowledge and belief, is true, correct,
                                                        and complete</p>

                                                </div>
                                                <div class="row mt-3">
                                                    <div class="col-12">
                                                        <div class="row">
                                                            <div class="col">

                                                                <img src="{{Gurdsign}}" class="form-control"
                                                                    style="width: 245px;height:120px;" alt="nurse"
                                                                    width="48" height="48">

                                                            </div>
                                                            <div class="col">


                                                                <label>Date:</label>


                                                                <input type="text" class="form-control"
                                                                    [(ngModel)]="employeesWithholdingBo.signDate">

                                                            </div>
                                                        </div>
                                                    </div>





                                                </div>
                                                <div class="row">
                                                    <p> (This form is not valid unless you sign it.)</p>
                                                </div>



                                                <div class="row">
                                                    <div class="col-lg-2">
                                                        Employers
                                                        Only

                                                    </div>

                                                    <div class="col-lg-3">
                                                        <label>Employer’s name and address</label>
                                                        <textarea type="text" class="form-control"
                                                            [(ngModel)]="employeesWithholdingBo.employeeName"></textarea>
                                                    </div>
                                                    <div class="col-lg-3">
                                                        <label>First date of
                                                            employment</label>

                                                        <input type="text" class="form-control"
                                                            [(ngModel)]="employeesWithholdingBo.firstDateOfEmployeement">
                                                        <!--   <input        type="text" [(ngModel)]="EmployeeswithholdingcertificateBO.sign.firstDateOfEmployeement" class="form-control"> -->
                                                    </div>
                                                    <div class="col-lg-4">
                                                        <label>Employer identification
                                                            number (EIN)
                                                        </label>
                                                        <input type="text" class="form-control"
                                                            [(ngModel)]="employeesWithholdingBo.identificationNumber">
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>


                                <div class="row mt-4">
                                    <div class="col-12">
                                        <h4><b>General Instructions</b></h4>
                                        <p>Section references are to the Internal Revenue Code. </p>
                                        <h4><b>Future Developments</b></h4>
                                        <p>For the latest information about developments related to
                                            Form W-4, such as legislation enacted after it was published,
                                            go to www.irs.gov/FormW4.</p>
                                        <h4><b>Purpose of Form</b></h4>
                                        <p>Complete Form W-4 so that your employer can withhold the
                                            correct federal income tax from your pay. If too little is
                                            withheld, you will generally owe tax when you file your tax
                                            return and may owe a penalty. If too much is withheld, you
                                            will generally be due a refund. Complete a new Form W-4
                                            when Changes to your personal or financial situation would
                                            Change the entries on the form. For more information on
                                            withholding and when you must furnish a new Form W-4,
                                            see Pub. 505, Tax Withholding and Estimated Tax. </p>
                                        <p><b>Exemption from withholding.</b> You may claim exemption
                                            from withholding for 2022 if you meet both of the following
                                            conditions: you had no federal income tax liability in 2021
                                            and you expect to have no federal income tax liability in
                                            2022. You had no federal income tax liability in 2021 if (1)
                                            your total tax on line 24 on your 2021 Form 1040 or 1040-SR
                                            is zero (or less than the sum of lines 27a, 28, 29, and 30), or
                                            (2) you were not required to file a return because your
                                            income was below the filing threshold for your correct filing
                                            status. If you claim exemption, you will have no income tax
                                            withheld from your paycheck and may owe taxes and
                                            penalties when you file your 2022 tax return. To claim
                                            exemption from withholding, certify that you meet both of
                                            the conditions above by writing “Exempt” on Form W-4 in
                                            the space below Step 4(c). Then, complete Steps 1(a), 1(b),
                                            and 5. Do not complete any other steps. You will need to
                                            submit a new Form W-4 by February 15, 2023.</p>
                                        <p><b>Your privacy.</b> If you prefer to limit information provided in
                                            Steps 2 through 4, use the online estimator, which will also
                                            increase accuracy. </p>
                                        <p>As an alternative to the estimator: if you have concerns
                                            with Step 2(c), you may choose Step 2(b); if you have
                                            concerns with Step 4(a), you may enter an additional amount
                                            you want withheld per pay period in Step 4(c). If this is the
                                            only job in your household, you may instead check the box
                                            in Step 2(c), which will increase your withholding and
                                            significantly reduce your paycheck (often by thousands of
                                            dollars over the year).</p>
                                        <p><b>When to use the estimator.</b> Consider using the estimator at
                                            www.irs.gov/W4App if you:

                                        </p>
                                        <ul type="1" style="margin-left: 30px;">
                                            <li>Expect to work only part of the year;</li>
                                            <li>Have dividend or capital gain income, or are subject to
                                                additional taxes, such as Additional Medicare Tax;
                                            </li>
                                            <li>Have self-employment income (see below); or
                                            </li>
                                            <li>Prefer the most accurate withholding for multiple job
                                                situations</li>
                                        </ul>
                                        <p><b>Self-employment.</b> Generally, you will owe both income and
                                            self-employment taxes on any self-employment income you
                                            receive separate from the wages you receive as an
                                            employee. If you want to pay these taxes through
                                            withholding from your wages, use the estimator at
                                            www.irs.gov/W4App to figure the amount to have withheld.</p>
                                        <p>Nonresident alien. If you’re a nonresident alien, see Notice
                                            1392, Supplemental Form W-4 Instructions for Nonresident
                                            Aliens, before completing this form.</p>
                                        <p><b>Nonresident alien.</b> If you’re a nonresident alien, see Notice
                                            1392, Supplemental Form W-4 Instructions for Nonresident
                                            Aliens, before completing this form</p>
                                    </div>
                                    <div class="col-12">
                                        <h4><b>Specific Instructions</b></h4>
                                        <p><b>Step 1(c).</b> Check your anticipated filing status. This will
                                            determine the standard deduction and tax rates used to
                                            compute your withholding</p>
                                        <p><b>Step 2.</b> Use this step if you (1) have more than one job at the
                                            same time, or (2) are married filing jointly and you and your
                                            spouse both work.</p>
                                        <p>Option (a) most accurately calculates the additional tax
                                            you need to have withheld, while option (b) does so with a
                                            little less accuracy. </p>
                                        <p>If you (and your spouse) have a total of only two jobs, you
                                            may instead check the box in option (c). The box must also
                                            be checked on the Form W-4 for the other job. If the box is
                                            checked, the standard deduction and tax brackets will be
                                            cut in half for each job to calculate withholding. This option
                                            is roughly accurate for jobs with similar pay; otherwise, more
                                            tax than necessary may be withheld, and this extra amount
                                            will be larger the greater the difference in pay is between the
                                            two jobs</p>
                                        <p>
                                            Multiple jobs. Complete Steps 3 through 4(b) on only
                                            one Form W-4. Withholding will be most accurate if
                                            you do this on the Form W-4 for the highest paying job</p>
                                        <p><b>step3</b> This step provides instructions for determining the
                                            amount of the child tax credit and the credit for other
                                            dependents that you may be able to claim when you file your
                                            tax return. To qualify for the child tax credit, the child must
                                            be under age 17 as of December 31, must be your
                                            dependent who generally lives with you for more than half
                                            the year, and must have the required social security number.
                                            You may be able to claim a credit for other dependents for
                                            whom a child tax credit can’t be claimed, such as an older
                                            child or a qualifying relative. For additional eligibility
                                            requirements for these credits, see Pub. 501, Dependents,
                                            Standard Deduction, and Filing Information. You can also
                                            include other tax credits for which you are eligible in this
                                            step, such as the foreign tax credit and the education tax
                                            credits. To do so, add an estimate of the amount for the year
                                            to your credits for dependents and enter the total amount in
                                            Step 3. Including these credits will increase your paycheck
                                            and reduce the amount of any refund you may receive when
                                            you file your tax return</p>
                                        <h4><b>Step 4 (optional).</b></h4>
                                        <p><b>Step 4(a).</b> Enter in this step the total of your other
                                            estimated income for the year, if any. You shouldn’t include
                                            income from any jobs or self-employment. If you complete
                                            Step 4(a), you likely won’t have to make estimated tax
                                            payments for that income. If you prefer to pay estimated tax
                                            rather than having tax on other income withheld from your
                                            paycheck, see Form 1040-ES, Estimated Tax for Individuals.
                                        </p>


                                        <p><b>Step 4(b).</b> Enter in this step the amount from the
                                            Deductions Worksheet, line 5, if you expect to claim
                                            deductions other than the basic standard deduction on your
                                            2022 tax return and want to reduce your withholding to
                                            account for these deductions. This includes both itemized
                                            deductions and other deductions such as for student loan
                                            interest and IRAs</p>


                                        <p><b>Step 4(c).</b> Enter in this step any additional tax you want
                                            withheld from your pay each pay period, including any
                                            amounts from the Multiple Jobs Worksheet, line 4. Entering
                                            an amount here will reduce your paycheck and will either
                                            increase your refund or reduce any amount of tax that you
                                            owe.</p>
                                    </div>
                                </div>
                                <div class="row mb-2 mt-4 mb-3">
                                    <div class="col">
                                        <div class="card ">
                                            <div class="card-header">
                                                <h5><b>Step 2(b)</b>&nbsp;—Multiple Jobs Worksheet (Keep for your
                                                    records.)</h5>
                                            </div>
                                            <div class="card-body" style="padding:35px;">
                                                <div class="row mt-2">
                                                    <p>If you choose the option in Step 2(b) on Form W-4, complete
                                                        this worksheet (which calculates the total extra tax for all
                                                        jobs) on only ONE
                                                        Form W-4. Withholding will be most accurate if you complete
                                                        the worksheet and enter the result on the Form W-4 for the
                                                        highest paying job.</p>
                                                </div>
                                                <div class="row mt-2">
                                                    <p>Note: If more than one job has annual wages of more than
                                                        $120,000 or there are more than three jobs, see Pub. 505 for
                                                        additional
                                                        tables; or, you can use the online withholding estimator at
                                                        www.irs.gov/W4App.</p>
                                                </div>
                                                <div class="row mt-2">
                                                    <ol style="margin-left: 10px;" type="1">
                                                        <li>Two jobs. If you have two jobs or you’re married filing
                                                            jointly and you and your spouse each have one
                                                            job, find the amount from the appropriate table on page
                                                            4. Using the “Higher Paying Job” row and the
                                                            “Lower Paying Job” column, find the value at the
                                                            intersection of the two household salaries and enter
                                                            that value on line 1. Then, skip to line 3 . . . . . . .
                                                            . . . . . . . . . . . . . .&nbsp;&nbsp;1
                                                            &nbsp;&nbsp;$ <input type="text" class="form-control"
                                                                [(ngModel)]="employeesWithholdingBo.multiJobsWorksheetFirstJobField"
                                                                style="width: 180px;display: inline-block;">
                                                        </li>



                                                        <li>Three jobs. If you and/or your spouse have three jobs at
                                                            the same time, complete lines 2a, 2b, and
                                                            2c below. Otherwise, skip to line 3.</li>
                                                        <ol style="margin-left: 30px;" type="a">
                                                            <li>Find the amount from the appropriate table on page 4
                                                                using the annual wages from the highest
                                                                paying job in the “Higher Paying Job” row and the
                                                                annual wages for your next highest paying job
                                                                in the “Lower Paying Job” column. Find the value at
                                                                the intersection of the two household salaries
                                                                and enter that value on line 2a . . . . . . . . . .
                                                                . . . . . . . . . . . . .&nbsp;&nbsp;2a
                                                                &nbsp;&nbsp;$ <input type="text" class="form-control"
                                                                    [(ngModel)]="employeesWithholdingBo.multiJobsWorksheetSecondjobField_a"
                                                                    style="width: 180px;display: inline-block;">
                                                            </li>
                                                            <li>Add the annual wages of the two highest paying jobs
                                                                from line 2a together and use the total as the
                                                                wages in the “Higher Paying Job” row and use the
                                                                annual wages for your third job in the “Lower
                                                                Paying Job” column to find the amount from the
                                                                appropriate table on page 4 and enter this amount
                                                                on line 2b . . . . . . . . . . . . . . . . . . . . .
                                                                . . . . . . . &nbsp;&nbsp;2b &nbsp;&nbsp;$ <input
                                                                    type="text" class="form-control"
                                                                    [(ngModel)]="employeesWithholdingBo.multiJobsWorksheetSecondjobField_b"
                                                                    style="width: 180px;display: inline-block;">
                                                            </li>

                                                            <li>Add the amounts from lines 2a and 2b and enter the
                                                                result on line 2c . . . . . . . . . .&nbsp;&nbsp;2c
                                                                &nbsp;&nbsp;$ <input type="text" class="form-control"
                                                                    [(ngModel)]="employeesWithholdingBo.multiJobsWorksheetSecondjobField_c"
                                                                    style="width: 180px;display: inline-block;">
                                                            </li>

                                                        </ol>


                                                        <li> Enter the number of pay periods per year for the
                                                            highest paying job. For example, if that job pays
                                                            weekly, enter 52; if it pays every other week, enter 26;
                                                            if it pays monthly, enter 12, etc. . . . .
                                                            .&nbsp;&nbsp;3 &nbsp;&nbsp;$ <input type="text"
                                                                class="form-control"
                                                                [(ngModel)]="employeesWithholdingBo.multiJobsWorksheetThirdHobField"
                                                                style="width: 180px;display: inline-block;">
                                                        </li>



                                                        <li>Divide the annual amount on line 1 or line 2c by the
                                                            number of pay periods on line 3. Enter this
                                                            amount here and in Step 4(c) of Form W-4 for the highest
                                                            paying job (along with any other additional
                                                            amount you want withheld) . . . . . . . . . . . . . . .
                                                            . . . . . . . . . . &nbsp;&nbsp;4 &nbsp;&nbsp;$ <input
                                                                type="text" class="form-control"
                                                                [(ngModel)]="employeesWithholdingBo.multiJobsWorksheetTourthJobField"
                                                                style="width: 180px;display: inline-block;">
                                                        </li>
                                                    </ol>


                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="row mb-2 mt-4 mb-3">
                                    <div class="col">
                                        <div class="card ">
                                            <div class="card-header">
                                                <h5><b>Step 4(b)</b>&nbsp;—Deductions Worksheet (Keep for your
                                                    records.)</h5>
                                            </div>
                                            <div class="card-body" style="padding:35px;">


                                                <div class="row mt-2">

                                                    <ol type="1" style="margin-left:30px">
                                                        <li>Enter an estimate of your 2022 itemized deductions (from
                                                            Schedule A (Form 1040)). Such deductions
                                                            may include qualifying home mortgage interest,
                                                            charitable contributions, state and local taxes (up to
                                                            $10,000), and medical expenses in excess of 7.5% of your
                                                            income. . . . . . . . . &nbsp;&nbsp;1
                                                            &nbsp;&nbsp;$ <input type="number" min="0"
                                                                class="form-control"
                                                                [(ngModel)]="employeesWithholdingBo.deductionfirstamout"
                                                                style="width: 180px;display: inline-block;">
                                                        </li>
                                                        <li>Enter: <ul style="margin-left:30px">
                                                                <li>$25,900 if you’re married filing jointly or
                                                                    qualifying widow(er)</li>
                                                                <li>$19,400 if you’re head of household</li>
                                                                <li>$12,950 if you’re single or married filing
                                                                    separately. . . . . . . .
                                                                    &nbsp;&nbsp;2&nbsp;&nbsp;$ <input type="number"
                                                                        min="0" class="form-control"
                                                                        [(ngModel)]="employeesWithholdingBo.deductionSecondamount"
                                                                        style="width: 180px;display: inline-block;">
                                                                </li>
                                                            </ul>
                                                        </li>
                                                        <li>If line 1 is greater than line 2, subtract line 2 from
                                                            line 1 and enter the result here. If line 2 is greater
                                                            than line 1, enter “-0-” . . . . . . . &nbsp;&nbsp;3
                                                            &nbsp;&nbsp;$ <input type="number" min="0"
                                                                class="form-control"
                                                                [(ngModel)]="employeesWithholdingBo.deductionThirdamount"
                                                                style="width: 180px;display: inline-block;">
                                                        </li>
                                                        <li>Enter an estimate of your student loan interest,
                                                            deductible IRA contributions, and certain other
                                                            adjustments (from Part II of Schedule 1 (Form 1040)).
                                                            See Pub. 505 for more information . . . .&nbsp;&nbsp;4
                                                            &nbsp;&nbsp;$ <input type="number" min="0"
                                                                class="form-control"
                                                                [(ngModel)]="employeesWithholdingBo.deductionFourthamount"
                                                                style="width: 180px;display: inline-block;">
                                                        </li>
                                                        <li>Add
                                                            lines 3 and 4. Enter the result here and in Step 4(b) of
                                                            Form W-4 . . . . . . . . . &nbsp;&nbsp;5
                                                            &nbsp;&nbsp;$ <input type="number" min="0"
                                                                class="form-control"
                                                                [(ngModel)]="employeesWithholdingBo.deductionFifthamount"
                                                                style="width: 180px;display: inline-block;">
                                                        </li>

                                                    </ol>
                                                </div>

                                            </div>
                                        </div>
                                    </div>
                                </div>


                                <div class="row mt-1">
                                    <div class="col-lg-6">
                                        <b>Privacy Act and Paperwork Reduction Act Notice</b>. We ask for the
                                        information
                                        on this form to carry out the Internal Revenue laws of the United States.
                                        Internal
                                        Revenue Code sections 3402(f)(2) and 6109 and their regulations require you
                                        to
                                        provide this information; your employer uses it to determine your federal
                                        income
                                        tax withholding. Failure to provide a properly completed form will result in
                                        your
                                        being treated as a single person with no other entries on the form;
                                        providing
                                        fraudulent information may subject you to penalties. Routine uses of this
                                        information include giving it to the Department of Justice for civil and
                                        criminal
                                        litigation; to cities, states, the District of Columbia, and U.S.
                                        commonwealths and
                                        possessions for use in administering their tax laws; and to the Department
                                        of
                                        Health and Human Services for use in the National Directory of New Hires. We
                                        may also disclose this information to other countries under a tax treaty, to
                                        federal
                                        and state agencies to enforce federal nontax criminal laws, or to federal
                                        law
                                        enforcement and intelligence agencies to combat terrorism
                                    </div>
                                    <div class="col-lg-6">
                                        You are not required to provide the information requested on a form that is
                                        subject to the Paperwork Reduction Act unless the form displays a valid OMB
                                        control number. Books or records relating to a form or its instructions must
                                        be
                                        retained as long as their contents may become material in the administration
                                        of
                                        any Internal Revenue law. Generally, tax returns and return information are
                                        confidential, as required by Code section 6103.
                                        The average time and expenses required to complete and file this form will
                                        vary
                                        depending on individual circumstances. For estimated averages, see the
                                        instructions for your income tax return.
                                        If you have suggestions for making this form simpler, we would be happy to
                                        hear
                                        from you. See the instructions for your income tax return.

                                    </div>
                                </div>

                                <div class="row mt-4 mb-2">
                                    <img src="..\assets\img\married.JPG" class="img-fluid" alt="Responsive image">
                                </div>

                                <div class="row mt-2 mb-2">
                                    <img src="..\assets\img\log.JPG" class="img-fluid" alt="Responsive image">
                                </div>


                            </div>
                        </div>
                    </div>
                </div>
                <!--Employee’s MinnsottaWithHold-->
                <span
                    [ngClass]="{'page-break-before': MinnsottaWithHold,'page-break-before-single':singlePrint}"></span>
                <div class="row mt-2 mb-4" *ngIf="MinnsottaWithHold">
                    <div class="col p-0">
                        <div class="card ">
                            <div class="card-body" style="padding:85px;page-break-inside: avoid;">
                                <div class="row mt-4 mb-2">
                                    <img src="../../../../assets/img/mahi.jpg" class="img-fluid" alt="Responsive image">
                                </div>

                                <div class="row mt-2">
                                    <p><b>Complete Form W-4MN so your employer can withhold the correct Minnesota income
                                            tax from your pay. Consider completing a new Form W-4MN each
                                            year and when your personal or financial situation changes. If no Form W-4MN
                                            is in effect, the number of withholding allowances claimed will be zero.</b>
                                    </p>
                                </div>

                                <div class="row mb-2 mt-4">
                                    <div class="col p-0">
                                        <div class="card ">
                                            <div class="card-header">
                                                <h5><b>Step 1:</b>&nbsp;<b>Enter Personal Information</b></h5>
                                            </div>
                                            <div class="card-body">
                                                <div class="row mt-3">
                                                    <div class="col-lg-4">
                                                        <label>(a) First name and initial
                                                        </label>
                                                        <input type="text" class="form-control"
                                                            [(ngModel)]="w4MinnesotaWithholdingBo.firstName" disabled>
                                                    </div>
                                                    <div class="col-lg-4">
                                                        <label>Last Name </label>
                                                        <input type="text" class="form-control"
                                                            [(ngModel)]="w4MinnesotaWithholdingBo.lastName" disabled>
                                                    </div>
                                                    <div class="col-lg-4">
                                                        <label>(b) Social security number </label>
                                                        <input type="text" class="form-control"
                                                            [(ngModel)]="w4MinnesotaWithholdingBo.socialSecurityNumber"
                                                            disabled>

                                                    </div>

                                                </div>
                                                <div class="row mt-2">
                                                    <div class="col-lg-6">
                                                        <label>Permanent Address </label>
                                                        <textarea class="form-control"
                                                            [(ngModel)]="w4MinnesotaWithholdingBo.personalAddress"
                                                            disabled></textarea>
                                                        <!--  -->
                                                        <div class="row">
                                                            <div class="col-lg-4">
                                                                <label>City</label>
                                                                <input type="text" class="form-control"
                                                                    [(ngModel)]="w4MinnesotaWithholdingBo.personalCity"
                                                                    disabled>
                                                                <!--  -->
                                                            </div>
                                                            <div class="col-lg-4">
                                                                <label>State</label>
                                                                <ng-select [items]="stateList" class="width25"
                                                                    [(ngModel)]="w4MinnesotaWithholdingBo.personalState"
                                                                    disabled>
                                                                    <!--  -->
                                                                </ng-select>
                                                            </div>
                                                            <div class="col-lg-4">
                                                                <label>Zip code</label>
                                                                <input type="text" class="form-control"
                                                                    [(ngModel)]="w4MinnesotaWithholdingBo.personalZip"
                                                                    disabled>

                                                                <!--  -->

                                                            </div>
                                                        </div>


                                                    </div>

                                                    <div class="col-lg-6">
                                                        <div class="row mt-2">

                                                            <div class="col-lg-1">
                                                                <input type="radio" id="m1" name="mstatus"
                                                                    value="single"
                                                                    [(ngModel)]="w4MinnesotaWithholdingBo.maritalStatus">
                                                            </div>
                                                            <div class="col-lg-10">
                                                                <label>Single; Married, but legally separated; or
                                                                    Spouse is a nonresident alien</label>
                                                            </div>
                                                        </div>
                                                        <!-- <div class="row mt-2">

                                                            <div class="col-lg-1">
                                                                <input type="radio" name="mstatus"
                                                                    value="nonresident_alien" id="m2"
                                                                    [(ngModel)]="w4MinnesotaWithholdingBo.maritalStatus">
                                                            </div>
                                                            <div class="col-lg-10">
                                                                <label>Spouse is a nonresident alien</label>
                                                            </div>
                                                        </div> -->
                                                        <div class="row mt-2">

                                                            <div class="col-lg-1">
                                                                <input type="radio" id="m3" name="mstatus"
                                                                    value="married"
                                                                    [(ngModel)]="w4MinnesotaWithholdingBo.maritalStatus">
                                                            </div>
                                                            <div class="col-lg-10">
                                                                <label>Married</label>
                                                            </div>
                                                        </div>
                                                        <div class="row mt-2">

                                                            <div class="col-lg-1">
                                                                <input type="radio" id="m4" name="mstatus"
                                                                    value="married_singlerate"
                                                                    [(ngModel)]="w4MinnesotaWithholdingBo.maritalStatus">
                                                            </div>
                                                            <div class="col-lg-10">
                                                                <label>Married, but withhold at higher Single
                                                                    rate</label>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>



                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="row mt-2 ms-4">
                                    <p><b>Complete Section 1 OR Section 2, then sign the bottom and give the
                                            completed form to your employer</b></p>
                                </div>



                                <div class="row mb-2 mt-4 mb-3">
                                    <div class="col">
                                        <div class="card ">
                                            <div class="card-header">
                                                <div class="d-flex ms-lg-1">
                                                    <input type="radio" id="sec1" name="section" value="false"
                                                        [(ngModel)]="w4MinnesotaWithholdingBo.determine_minnesota_allowances">
                                                    <!-- [(ngModel)]="documentBO.w_4MN_minnesotta_withholding_allowance.determiningMinnesotaAllowances.exemption_minnesota_withholding" -->
                                                    <h5 class="ms-1 pt-2"><b> Section 1 -</b>&nbsp;Determining Minnesota
                                                        Allowances</h5>
                                                </div>
                                            </div>
                                            <div class="card-body" style="padding:35px;">


                                                <div class="row mt-2">
                                                    <ol style="margin-left: 10px;" type="A">
                                                        <li> Enter “1” if no one else can claim you as a dependent
                                                            ...................................&nbsp;&nbsp;A
                                                            &nbsp;&nbsp; <input type="text" class="form-control"
                                                                style="width: 180px;display: inline-block;"
                                                                [(ngModel)]="w4MinnesotaWithholdingBo.ifNoOneClaimyouasdependent">
                                                        </li>



                                                        <li> Enter “1” if any of the following apply:
                                                            .................................................&nbsp;&nbsp;B
                                                            &nbsp;&nbsp; <input type="text" class="form-control"
                                                                style="width: 180px;display: inline-block;"
                                                                [(ngModel)]="w4MinnesotaWithholdingBo.ifanyofFollowingApply">
                                                        </li>
                                                        <ul style="margin-left: 30px;">
                                                            <li>You are single and have only one job</li>
                                                            <li>You are married, have only one job, and your spouse
                                                                does not work</li>

                                                            <li>Your wages from a second job or your spouse’s wages
                                                                are $1500 or less</li>
                                                        </ul>


                                                        <li>Enter “1” if you are married. Or choose to enter “0” if
                                                            you are married and have either a working
                                                            spouse or more than one job. (Entering “0” may help you
                                                            avoid having too little tax withheld.) . .&nbsp;&nbsp;C
                                                            &nbsp;&nbsp; <input type="text" class="form-control"
                                                                style="width: 180px;display: inline-block;"
                                                                [(ngModel)]="w4MinnesotaWithholdingBo.haveeitherworkingSpouseormorethanOneJob">
                                                        </li>
                                                        <li> Enter the number of dependents (other than your spouse
                                                            or yourself)
                                                            you will claim on your tax return.
                                                            ...................................................&nbsp;&nbsp;D
                                                            &nbsp;&nbsp; <input type="text" class="form-control"
                                                                style="width: 180px;display: inline-block;"
                                                                [(ngModel)]="w4MinnesotaWithholdingBo.numberofdependents">
                                                        </li>
                                                        <li>Enter “1” if you will use the filing status Head of
                                                            Household (see instructions).
                                                            ................&nbsp;&nbsp;E&nbsp;&nbsp; <input type="text"
                                                                class="form-control"
                                                                style="width: 180px;display: inline-block;"
                                                                [(ngModel)]="w4MinnesotaWithholdingBo.filingstatusHeadofHousehold">
                                                        </li>

                                                        <li>Add steps A through E. If you plan to itemize deductions
                                                            on your 2022 Minnesota income tax
                                                            return, you may also complete the Itemized Deductions
                                                            and Additional Income Worksheet.
                                                            ..&nbsp;&nbsp;F&nbsp;&nbsp; <input type="text"
                                                                class="form-control"
                                                                style="width: 180px;display: inline-block;"
                                                                [(ngModel)]="w4MinnesotaWithholdingBo.deductionsandAdditionalIncomeWorksheet">
                                                        </li>

                                                    </ol>
                                                    <ol style="margin-left: 10px;" type="1">
                                                        <li>Minnesota Allowances. Enter Step F from Section 1 above
                                                            or Step 10 of the Itemized Deductions Worksheet
                                                            ...........&nbsp;&nbsp;1 &nbsp;&nbsp;$ <input type="text"
                                                                class="form-control"
                                                                style="width: 180px;display: inline-block;"
                                                                [(ngModel)]="w4MinnesotaWithholdingBo.minnesotaAllwances">
                                                        </li>
                                                        <li>Additional Minnesota withholding you want deducted for
                                                            each pay period (see instructions)
                                                            .........................&nbsp;&nbsp;2
                                                            &nbsp;&nbsp;$ <input type="text" class="form-control"
                                                                style="width: 180px;display: inline-block;"
                                                                [(ngModel)]="w4MinnesotaWithholdingBo.additionalMinnesotawithholding">
                                                        </li>
                                                    </ol>



                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>


                                <!-- this. = val.target.checked -->
                                <!-- this.documentBO.w_4MN_minnesotta_withholding_allowance.determiningMinnesotaAllowances.determine_minnesota_allowances = false -->

                                <div class="row mb-2 mt-4 mb-3">
                                    <div class="col">
                                        <div class="card ">
                                            <div class="card-header">
                                                <div class="d-flex ms-lg-1">
                                                    <input type="radio" (change)="sectionDetermine($event)" id="sec2"
                                                        name="section" value="true"
                                                        [(ngModel)]="w4MinnesotaWithholdingBo.determine_minnesota_allowances">
                                                    <!-- section($event); 
                                       [(ngModel)]="documentBO.w_4MN_minnesotta_withholding_allowance.determiningMinnesotaAllowances.determine_minnesota_allowances"
        -->
                                                    <h5 class="ms-1 pt-2"><b>Section 2</b>&nbsp;— Exemption From
                                                        Minnesota
                                                        Withholding</h5>
                                                </div>
                                            </div>
                                            <div class="card-body" style="padding:35px;">
                                                <div>
                                                    <div class="row mt-2 ms-2">
                                                        <p>Complete Section 2 if you claim to be exempt from Minnesota
                                                            income tax withholding (see Section 2 instructions for
                                                            qualifications). If applicable,
                                                            check one box below to indicate why you believe you are
                                                            exempt</p>
                                                    </div>
                                                    <div class="d-flex ms-2">
                                                        <input type="radio" value="A" name="radiosection26"
                                                            [(ngModel)]="w4MinnesotaWithholdingBo.exemption_minnesota_withholdingsec2">&nbsp;&nbsp;
                                                        <p>A&nbsp;&nbsp; I meet the
                                                            requirements and claim exempt from both federal and
                                                            Minnesota income tax withholding</p>
                                                    </div>
                                                    <div class="d-flex ms-2">
                                                        <input type="radio" name="radiosection26" value="B"
                                                            [(ngModel)]="w4MinnesotaWithholdingBo.exemption_minnesota_withholdingsec2">&nbsp;&nbsp;
                                                        <p>B&nbsp;&nbsp;Even though I
                                                            did not claim exempt from federal withholding, I claim
                                                            exempt from Minnesota withholding, because:</p>
                                                    </div>
                                                    <ul style="margin-left:50px;" class="mt-3">
                                                        <li>I had no Minnesota income tax liability last year</li>
                                                        <li>I received a refund of all Minnesota income tax withheld
                                                        </li>
                                                        <li>I expect to have no Minnesota income tax liability this year
                                                        </li>


                                                    </ul>
                                                    <div class="d-flex ms-2">
                                                        <input type="radio"
                                                            [(ngModel)]="w4MinnesotaWithholdingBo.exemption_minnesota_withholdingsec2"
                                                            name="radiosection26" id="c" value="C">&nbsp;&nbsp; <p>
                                                            C&nbsp;&nbsp;All of these
                                                            apply:</p>
                                                    </div>
                                                    <ul style="margin-left:50px mt-3">
                                                        <li>My spouse is a military service member assigned to a
                                                            military location in Minnesota</li>
                                                        <li>My domicile (legal residence) is in another state</li>
                                                        <li>I am in Minnesota solely to be with my spouse. My state of
                                                            domicile is&nbsp;&nbsp; <input type=" text"
                                                                class="form-control"
                                                                style="width: 180px;display: inline-block;"
                                                                [(ngModel)]="w4MinnesotaWithholdingBo.state_domicile">
                                                        </li>
                                                    </ul>
                                                    <div class="d-flex ms-2">
                                                        <input type="radio"
                                                            [(ngModel)]="w4MinnesotaWithholdingBo.exemption_minnesota_withholdingsec2"
                                                            (change)="abc()" id="d" name="radiosection26"
                                                            value="D">&nbsp;&nbsp;<P>D&nbsp;&nbsp;I am an
                                                            American Indian that resides and works on a reservation for
                                                            which i am enrolled(see instructions).
                                                        </P>
                                                    </div>
                                                    <div class="row ms-4 mt-3">
                                                        <p> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Enter the reservation
                                                            name&nbsp;&nbsp; <input type="text" class="form-control"
                                                                style="width: 180px;display: inline-block;"
                                                                [(ngModel)]="w4MinnesotaWithholdingBo.reservation_name">
                                                        </p>
                                                    </div>
                                                    <div class="row ms-4">
                                                        <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Enter your Certificate of
                                                            Degree of Indian Blood (CDIB)/Enrollment
                                                            number&nbsp;&nbsp; <input type="text" class="form-control"
                                                                style="width: 180px;display: inline-block;"
                                                                [(ngModel)]="w4MinnesotaWithholdingBo.enroll_no">
                                                        </p>

                                                    </div>

                                                    <div class="row">

                                                        <div class="col-12">
                                                            <p> <input name="radiosection26" type="radio"
                                                                    [(ngModel)]="w4MinnesotaWithholdingBo.exemption_minnesota_withholdingsec2"
                                                                    value="E">&nbsp;&nbsp;E&nbsp;&nbsp;I am a
                                                                member of the Minnesota National Guard or an active duty
                                                                U.S. military member and claim exempt from Minnesota
                                                                withholding
                                                                on my military pay</p>
                                                        </div>

                                                    </div>

                                                    <div class="row">
                                                        <div class="col-12">
                                                            <p> <input value="F" name="radiosection26" type="radio"
                                                                    [(ngModel)]="w4MinnesotaWithholdingBo.exemption_minnesota_withholdingsec2">
                                                                &nbsp;&nbsp;F&nbsp;&nbsp;I
                                                                receive a military pension or other military retirement
                                                                pay as calculated under U.S. Code, title 10, sections
                                                                1401 through 1414, 1447
                                                                through 1455, and 12733, and I claim exempt from
                                                                Minnesota withholding on this retirement pay</p>

                                                        </div>

                                                    </div>



                                                    <div class="row mt-2">
                                                        <p>I certify that all information provided in Section 1 OR
                                                            Section 2 is correct. I understand there is a $500 penalty
                                                            for filing a false Form W-4MN</p>
                                                    </div>

                                                    <div class="row mt-5 ms-2">


                                                        <div class="col-lg-3 text-center">
                                                            <label>Daytime Phone Number</label>
                                                        </div>
                                                        <div class="col-lg-2">
                                                            <input type="text" class="form-control"
                                                                [(ngModel)]="w4MinnesotaWithholdingBo.phoneNumber"
                                                                (ngModelChange)="DemographicPhoneFormat()"
                                                                (keypress)="keyPress($event)" maxlength="14"
                                                                minlength="14">
                                                        </div>


                                                    </div>

                                                    <div class="row mt-2 mb-2">

                                                        <div class="col-lg-4">
                                                            <img src="{{clientsign1}}" class="form-control"
                                                                style="width: 255px;height:120px;" alt="nurse"
                                                                width="48" height="48">
                                                        </div>

                                                    </div>


                                                    <div class="row mt-2">
                                                        <p>Employees: Give the completed form to your employer. </p>
                                                    </div>
                                                    <div class="row mt-2">
                                                        <h5><b>Employers</b></h5>
                                                    </div>
                                                    <div class="row mt-2">
                                                        See the employer instructions to determine if you must send a
                                                        copy of this form to the Minnesota Department of Revenue. If
                                                        required, enter your
                                                        information below and mail this form to the address in the
                                                        instructions. (Incomplete forms are considered invalid.) We may
                                                        assess a $50 penalty for
                                                        each required Form W-4MN not filed with us. Keep a copy for your
                                                        records
                                                    </div>

                                                    <div class="row mt-2 mb-3">
                                                        <div class="col">
                                                            <div class="card ">
                                                                <div class="card-body" style="padding:25px;">
                                                                    <div class="row">
                                                                        <div class="col-lg-12">
                                                                            <div class="row mt-2">
                                                                                <div class="col-4">
                                                                                    <label>Name of Appointee </label>
                                                                                    <input type="text"
                                                                                        class="form-control"
                                                                                        [(ngModel)]="relationshipBo.employeeName"
                                                                                        disabled>
                                                                                </div>
                                                                                <div class="col-4">
                                                                                    <label>Minnesota Tax ID
                                                                                        Number</label>

                                                                                    <input type="text"
                                                                                        class="form-control"
                                                                                        [(ngModel)]="w4MinnesotaWithholdingBo.taxIdNumber">

                                                                                </div>
                                                                                <div class="col-4">
                                                                                    <label>Federal Employer ID Number
                                                                                        (FEIN)</label>

                                                                                    <input type="text"
                                                                                        class="form-control"
                                                                                        [(ngModel)]="w4MinnesotaWithholdingBo.federal_Id_number" />

                                                                                </div>
                                                                            </div>

                                                                            <div class="row mt-2">
                                                                                <div class="col-5">
                                                                                    <label>Address</label>

                                                                                    <textarea class="form-control"
                                                                                        disabled></textarea>


                                                                                </div>
                                                                                <div class="col-3">
                                                                                    <label>City
                                                                                    </label>
                                                                                    <input type="text"
                                                                                        class="form-control" disabled>
                                                                                </div>
                                                                                <div class="col-2">
                                                                                    <label>State</label>

                                                                                    <ng-select [items]="stateList"
                                                                                        [searchable]="true"
                                                                                        [clearable]="true"
                                                                                        bindLabel="name"
                                                                                        bindValue="abbreviation">
                                                                                    </ng-select>
                                                                                </div>
                                                                                <div class="col-2">
                                                                                    <label>Zip Code</label>
                                                                                    <input type="text"
                                                                                        class="form-control" disabled>



                                                                                </div>

                                                                            </div>

                                                                        </div>

                                                                    </div>


                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>

                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <span [ngClass]="{'page-break-before': EmpW4Pension,'page-break-before-single':singlePrint}"></span>
                <div *ngIf="EmpW4Pension">
                    <!-- <div class="row mb-2 mt-2">
                        <div class="col p-0">
                            <div class="card-body" style="padding:55px;page-break-inside: avoid;">
                               
                                <div class="row mt-2 mb-2">
                                    <img src="..\assets\img\revenue.JPG" class="img-fluid" alt="Responsive image">
                                </div>

                                <div class="row mt-4">
                                    <p>Complete this form for your employer to calculate the amount of Minnesota
                                        income tax to be withheld from your pay.</p>
                                </div>
                                <div class="row mt-2">
                                    <h5><b>When should I complete Form W-4MN?</b></h5>
                                </div>
                                <ul style="margin-left:30px;">
                                    <li>You begin employment</li>
                                    <li>You Change your filing status</li>
                                    <li>You reasonably expect to Change your filing status in the next calendar year
                                    </li>
                                    <li>Your personal or financial situation Changes</li>
                                    <li>You claim exempt from Minnesota withholding (see Section 2 instructions for
                                        qualifications)</li>
                                    <li> You receive distributions from an annuity or pension</li>
                                </ul>
                                <div class="row mt-2">
                                    <p>If you have not had sufficient Minnesota income tax withheld from your wages,
                                        we may assess penalty and interest when you file your state
                                        income tax return</p>
                                </div>
                                <div c lass="row mt-2">
                                    <p><b>Note:</b> Your employer may be required to submit a copy of your Form
                                        W-4MN to the Minnesota Department of Revenue. You may be subject to a
                                        $500 penalty if you provide a false Form W-4MN.</p>
                                </div>
                                <div class="row mt-2">
                                    <p><b>You must enter your Social Security Number for this Form W-4MN to be
                                            valid. </b></p>
                                </div>
                                <div class="row mt-2">
                                    <h5><b>What if I have completed federal Form W-4?</b></h5>
                                </div>
                                <div class="row mt-2">
                                    <p>If you completed a 2022 Form W-4, you must complete Form W-4MN to determine
                                        your Minnesota withholding allowances.</p>
                                </div>
                                <div class="row mt-2">
                                    <p>If you claim exempt from Minnesota withholding, complete only Section 2 of
                                        Form W-4MN and sign and date the form to validate it. If you
                                        complete Section 2, you must complete a new Form W-4MN by February 15 in
                                        each following year in which you claim an exemption from
                                        Minnesota withholding.</p>
                                </div>
                                <div class="row mt-2">
                                    <p>You cannot claim exempt from withholding if all of these apply:</p>
                                </div>
                                <ul style="margin-left: 30px;">
                                    <li>
                                        Another person can claim you as a dependent on their federal tax return
                                    </li>
                                    <li>
                                        Your annual income exceeds $1,100
                                    </li>
                                    <li>
                                        Your annual income includes more than $350 of unearned income
                                    </li>
                                </ul>
                                <div class="row mt-2">
                                    <h5><b>What if I am a nonresident alien for U.S. income taxes?</b></h5>
                                </div>
                                <div class="row mt-2">
                                    <p>If you are a nonresident alien, you are not allowed to claim exempt from
                                        withholding. You will check the single box for marital status
                                        regardless of your actual marital status and may enter one personal
                                        allowance on Step A. Enter zero on steps B, C, and E.
                                        If you are resident of Canada, Mexico, South Korea, or India, and are
                                        allowed to claim dependents, you may enter the number of dependents on
                                        Step D.</p>
                                </div>
                                <div class="row mt-2">
                                    <h5><b>What if I am a nonresident alien for U.S. income taxes?</b></h5>
                                </div>
                                <div class="row mt-2">
                                    <p>If you are a nonresident alien, you are not allowed to claim exempt from
                                        withholding. You will check the single box for marital status
                                        regardless of your actual marital status and may enter one personal
                                        allowance on Step A. Enter zero on steps B, C, and E</p>
                                </div>
                                <div class="row mt-2">
                                    <p>If you are resident of Canada, Mexico, South Korea, or India, and are allowed
                                        to claim dependents, you may enter the number of dependents on
                                        Step D.</p>
                                </div>
                                <div class="row mt-2">
                                    <h4><b>Section 1 — Minnesota Allowances Worksheet</b></h4>
                                </div>
                                <div class="row mt-2">
                                    <p>Complete Section 1 to find your allowances for Minnesota withholding tax. For
                                        regular wages, withholding must be based on allowances you
                                        claimed and may not be a flat amount or percentage of wages.</p>
                                </div>
                                <div class="row mt-2">
                                    <p>If you expect to owe more income tax for the year than will be withheld, you
                                        can claim fewer allowances or request additional Minnesota
                                        withholding from your wages. Enter the amount of additional Minnesota income
                                        tax you want withheld on line 2 of Section 1.</p>
                                </div>
                                <div class="row mt-2">
                                    <h4><b>Nonwage Income</b></h4>
                                </div>
                                <div class="row mt-2">
                                    <p>Consider making estimated payments if you have a large amount of “nonwage
                                        income.” Nonwage income (other than tax-exempt income)
                                        includes interest, dividends, net rental income, unemployment compensation,
                                        gambling winnings, prizes and awards, hobby income, capital
                                        gains, royalties, and partnership income. </p>
                                </div>
                                <div class="row mt-2">
                                    <h5><b>Two Earners or Multiple Jobs</b></h5>
                                </div>
                                <div class="row mt-2">
                                    <p>If your spouse works or you have more than one job, figure the total number
                                        of allowances you are entitled to claim on all jobs using
                                        worksheets from only one Form W-4MN. Usually, your withholding will be more
                                        accurate when all allowances are claimed on the Form
                                        W-4MN for the highest paying job and zero allowances are claimed on the
                                        others.</p>
                                </div>
                                <div class="row mt-2">
                                    <h5><b>Head of Household Filing Status</b></h5>
                                </div>
                                <div class="row mt-2">
                                    <p>You may claim Head of Household as your filing status if you are unmarried
                                        and pay more than 50% of the costs of keeping up a home for
                                        yourself, your dependents, and other qualifying individuals. Enter “1” on
                                        Step E if you may claim Head of Household as your filing status on
                                        your tax return. </p>
                                </div>
                                <div class="row mt-2">
                                    <h5><b>What if I itemize deductions on my Minnesota return or have other nonwage
                                            income?</b></h5>
                                </div>



                                <div class="row mt-2">
                                    <p>
                                        Use the Itemized Deductions and Additional Income Worksheet to find your
                                        Minnesota withholding allowances. Complete Section 1 on page 1,
                                        then follow the steps in the worksheet on the next page to find additional
                                        allowances
                                    </p>
                                </div>
                                <div class="row mt-2 p-0 mb-3">
                                    <div class="col p-0">
                                        <div class="card">
                                            <div class="row">
                                                <div class="col">
                                                    <p>1&nbsp;&nbsp;Enter an estimate of your 2022 Minnesota
                                                        itemized deductions. For 2022, you may have to reduce
                                                        your itemized deductions </p>
                                                    <p>if your income is over $206,050 ($103,025 for Married
                                                        Filing Separately). . . . . . . . <input type="number" min="0"
                                                            class="form-control"
                                                            [(ngModel)]="w4MNInstructionsBo.estimate_Minnesota_ItemizedDeductions"
                                                            style="display: inline-block;width: 150px;">&nbsp;
                                                    </p>
                                                    <p>2&nbsp;&nbsp;Enter one of the following based on your
                                                        filing status:. . . . . . . <input type="number" min="0"
                                                            class="form-control"
                                                            [(ngModel)]="w4MNInstructionsBo.enterBasedOnFillingStatus"
                                                            style="display: inline-block;width: 150px;">&nbsp;
                                                    </p>

                                                    <ul style="margin-left:30px">
                                                        <li>$25,800 if Married Filing Jointly</li>
                                                        <li>$19,400 if Head of Household</li>
                                                        <li> $12,900 if Single or Married Filing Separately</li>
                                                    </ul>
                                                    <p>3&nbsp;&nbsp;Subtract step 2 from step 1. If zero or
                                                        less, enter 0 . . . . . . . . <input type="number" min="0"
                                                            class="form-control"
                                                            [(ngModel)]="w4MNInstructionsBo.subtractStep2FromStep1"
                                                            style="display: inline-block;width: 150px;">&nbsp;
                                                    </p>
                                                    <p>4&nbsp;&nbsp;Enter an estimate of your 2022 additional
                                                        standard deduction (from page 11 of the Form M1
                                                        instructions). . . . . <input type="number" min="0"
                                                            class="form-control"
                                                            [(ngModel)]="w4MNInstructionsBo.estimate_AdditionalStandardDeductions"
                                                            style="display: inline-block;width: 150px;">&nbsp;
                                                    </p>
                                                    <p>5&nbsp;&nbsp;Add steps 3 and 4 . . . . . <input type="number"
                                                            min="0" class="form-control"
                                                            [(ngModel)]="w4MNInstructionsBo.addStep3AndStep4"
                                                            style="display: inline-block;width: 150px;">&nbsp;
                                                    </p>
                                                    <p>6&nbsp;&nbsp;Enter an estimate of your 2022 taxable
                                                        nonwage income . . . . . . . <input type="number" min="0"
                                                            class="form-control"
                                                            [(ngModel)]="w4MNInstructionsBo.estimateTaxableNonwageIncome"
                                                            style="display: inline-block;width: 150px;">&nbsp;
                                                    </p>
                                                    <p>7&nbsp;&nbsp;Subtract step 6 from step 5. If zero, enter
                                                        0. If less than zero, enter the amount in parentheses. .
                                                        . . . . . . <input type="number" min="0" class="form-control"
                                                            [(ngModel)]="w4MNInstructionsBo.subtractStep6FromStep5"
                                                            style="display: inline-block;width: 150px;">&nbsp;
                                                    </p>
                                                    <p>8&nbsp;&nbsp;Divide the amount on step 7 by $4,450. If a
                                                        negative amount, enter in parentheses. Do not include
                                                        fractions . . . . . . <input type="number" min="0"
                                                            class="form-control" str
                                                            [(ngModel)]="w4MNInstructionsBo.divideAmountOnStep7bySomeAmt"
                                                            style="display: inline-block;width: 150px;">&nbsp;
                                                    </p>
                                                    <p>9&nbsp;&nbsp;Enter the number on step F of Section 1 on
                                                        page 1 . . . . . . . . <input type="number" min="0"
                                                            class="form-control"
                                                            [(ngModel)]="w4MNInstructionsBo.numberStepF"
                                                            style="display: inline-block;width: 150px;">&nbsp;
                                                    </p>
                                                    <p>10&nbsp;&nbsp;Add step 8 and 9 and enter the total here.
                                                        If zero or less, enter 0. Enter this amount on line 1 of
                                                        page 1. . . . . . <input type="number" min="0"
                                                            class="form-control"
                                                            [(ngModel)]="w4MNInstructionsBo.addStep8andStep9"
                                                            style="display: inline-block;width: 150px;">&nbsp;
                                                    </p>
                                                </div>

                                            </div>


                                        </div>

                                    </div>
                                </div>

                                <div class="row mt-2">
                                    <h5><b>Section 2 — Minnesota Exemption</b></h5>
                                </div>
                                <div class="row mt-2">
                                    <p>Your employer will not withhold Minnesota taxes from your pay if you are
                                        exempt from Minnesota withholding. You cannot claim exempt
                                        from withholding if all of these apply:</p>
                                </div>
                                <ul style="margin-left:30px">
                                    <li>Another person can claim you as a dependent on their federal tax return</li>
                                    <li>Your annual income exceeds $1,100</li>
                                    <li>Your annual income includes more than $350 of unearned income</li>
                                </ul>
                                <div class="row mt-2">
                                    <h5><b>Box A</b></h5>
                                </div>
                                <div class="row mt-2">
                                    <p>
                                        Check box A of Section 2 to claim exempt if all of these apply:
                                    </p>
                                </div>
                                <ul style="margin-left:30px">
                                    <li>You meet the requirements to be exempt from federal withholding</li>
                                    <li>You had no Minnesota income tax liability in the prior year and received a
                                        full refund of Minnesota tax withheld</li>
                                    <li>You expect to have no Minnesota income tax liability for the current year
                                    </li>
                                </ul>
                                <div class="row mt-2">
                                    <h5><b>Box B</b></h5>
                                </div>
                                <div class="row mt-2">
                                    <p>Check box B of Section 2 if you are not claiming exempt from federal
                                        withholding, but meet the second and third requirements for box A.</p>
                                </div>
                                <div class="row mt-2">
                                    <h5><b>Box C</b></h5>
                                </div>
                                <div class="row mt-2">
                                    <p>
                                        Check box C in Section 2 to claim exempt if all of these apply
                                    </p>
                                </div>
                                <ul style="margin-left:30px">
                                    <li>
                                        You are the spouse of a military member assigned to duty in Minnesota
                                    </li>
                                    <li>
                                        You and your spouse are domiciled in another state
                                    </li>
                                    <li>
                                        You are in Minnesota solely to be with your active duty military spouse
                                        member
                                    </li>
                                </ul>
                                <div class="row mt-2">
                                    <h5><b>Boxes D-G</b></h5>
                                </div>
                                <div class="row mt-2">
                                    <p>If you receive income from the following sources, it is exempt from Minnesota
                                        withholding. Your employer will not withhold Minnesota tax
                                        from that income when you check the appropriate box in Section 2</p>
                                </div>
                                <ul style="margin-left:30px">
                                    <li>
                                        <b>Box D:</b> You receive wages as a member of an American Indian tribe
                                        living and working on the reservation of which you are an enrolled
                                        member. Enter the name of your reservation and your Certificate of Degree of
                                        Indian or Alaskan Blood (CDIB) number
                                    </li>
                                    <li>
                                        <b> Box E:</b> You receive wages for Minnesota National Guard (MNG) pay or
                                        for active duty U.S. military pay. MNG and active duty U.S.
                                        military members can claim exempt from Minnesota withholding on these wages,
                                        even if they are taxable federally. For more information,
                                        see Income Tax Fact Sheet 5, Military Personnel
                                    </li>
                                    <li>
                                        <b>Box F:</b>You receive a military pension or other military retirement pay
                                        calculated under U.S. Code title 10, sections 1401 through 1414, 1447
                                        through 1455, and 12733. You may claim exempt from Minnesota withholding on
                                        this income even if it is taxable federally
                                    </li>
                                </ul>
                                <div class="row mt-2">
                                    <p><b>Note:</b> You may not want to claim exempt if you (or your spouse if
                                        filing a joint return) expect to have other forms of income subject to
                                        Minnesota tax and you want to avoid owing tax at the end of the year.
                                        If you complete Section 2, you must complete a new Form W-4MN by February 15
                                        in each following year</p>
                                </div>
                                <div class="row mt-2">
                                    <p>If you complete Section 2, you must complete a new Form W-4MN by February 15
                                        in each following year.</p>
                                </div>
                                <div class="row mt-2">
                                    <h5><b>Nonresident Alien</b></h5>
                                </div>
                                <div class="row mt-2">
                                    <p>If you are a nonresident alien for federal tax purposes, do not complete
                                        Section 2. </p>
                                </div>
                                <div class="row mt-2">
                                    <h5>Line 2 — Additional Minnesota Withholding</h5>
                                </div>
                                <div class="row mt-2">
                                    <p>If you would like an additional amount of tax to be deducted per payment
                                        period, enter the amount on line 2. Do not enter a percentage of the
                                        payment you want to be deducted</p>
                                </div>
                                <div class="row mt-2">
                                    <h5><b>Use of Information</b></h5>
                                </div>
                                <div class="row mt-2">
                                    <p>All information on Form W-4MN is private by state law. It cannot be given to
                                        others without your consent, except to the Internal Revenue Service,
                                        to other states that guarantee the same privacy, or by court order. Your
                                        name, address, and Social Security Number are required for identification.
                                        Information about your allowances is required to determine your correct tax.
                                        We ask for your phone number so we can call if we have a question.</p>
                                </div>
                                <div class="row mt-2">
                                    <h5><b>Questions?</b></h5>
                                </div>
                                <ul style="margin-left:30px">
                                    <li>
                                        Website: www.revenue.state.mn.us
                                    </li>
                                    <li>
                                        Email: withholding.tax@state.mn.us
                                    </li>
                                    <li>
                                        Phone: 651-282-9999 or 1-800-657-3594 (toll-free)
                                    </li>
                                </ul>



                            </div>
                        </div>
                    </div> -->

                    <div class="row mb-2 mt-2">
                        <div class="col p-0">
                            <div class="card " style="height:auto;">
                                <div class="card-body" style="padding:55px;">

                                    <div class="row mt-2">
                                        <h3><b>Form W-4MN Employer Instructions</b></h3>
                                    </div>
                                    <div class="row mt-2">
                                        <h5><b>Form W-4MN Requirement</b></h5>
                                    </div>
                                    <div class="row mt-2">
                                        <p>Federal Form W-4 will not determine withholding allowances used to determine
                                            the amount of Minnesota withholding. Employees completing a
                                            2022 Form W-4 will need to complete 2022 Form W-4MN to determine the
                                            appropriate amount of Minnesota withholding</p>
                                    </div>
                                    <div class="row mt-2">
                                        <h5><b>Lock-In Letters</b></h5>
                                    </div>
                                    <div class="row mt-2">
                                        <p>Internal Revenue Service (IRS) Letter 2800C tells you when the IRS believes
                                            your employee may have filed an incorrect federal Form W-4. If
                                            you receive this letter, you must provide the Minnesota Department of
                                            Revenue with a copy of the employee’s Form W-4MN. We will verify
                                            the number of allowances that the employee may claim for Minnesota purposes.
                                            Continue using the Form W-4MN you were using at the time
                                            you received Letter 2800C from the IRS, until we notify you to Change the
                                            amount of allowances on the employee’s Form W-4MN. If the
                                            employee has not completed a Form W-4MN, have them complete the form and use
                                            the allowances calculated on that form until notified by the
                                            department</p>
                                    </div>
                                    <div class="row mt-2">
                                        <p><b>Use the amount on line 1 of page 1 for calculating the withholding tax for
                                                your employees.</b></p>
                                    </div>
                                    <div class="row mt-2">
                                        <h5><b>When does an employee complete Form W-4MN?</b></h5>
                                    </div>
                                    <div class="row mt-2">
                                        <p>Employees complete Form W-4MN when they begin employment or when their
                                            personal or financial situation Changes</p>
                                    </div>
                                    <div class="row mt-2">
                                        <h5><b>How should I determine Minnesota withholding for an employee that does
                                                not complete Form W-4MN?</b></h5>
                                    </div>
                                    <div class="row mt-2">
                                        <p>If an employee does not complete Form W-4MN and they have a federal Form W-4
                                            (from 2019 or prior years) on file, use the allowances on
                                            their federal Form W-4. Otherwise, withhold Minnesota tax as if the employee
                                            is single with zero withholding allowances.</p>
                                    </div>
                                    <div class="row mt-2">
                                        <h5><b>What if my employee claims to be exempt from Minnesota withholding?</b>
                                        </h5>
                                    </div>
                                    <div class="row mt-2">
                                        <p>If your employee claims exempt from Minnesota withholding, they must complete
                                            Section 2 of Form W-4MN. They must provide you with a
                                            new Form W-4MN by February 15 of each year. If you are paying an employee
                                            for wages that are exempt from withholding, such as Medicaid
                                            Waiver Payments or wages to H-2A visa workers, do not send us Form W-4MN</p>
                                    </div>
                                    <div class="row mt-2">
                                        <h5><b>When do I need to submit copies of a Form W-4MN to the department?</b>
                                        </h5>
                                    </div>
                                    <div class="row mt-2">
                                        <p>
                                            When do I need to submit copies of a Form W-4MN to the department?
                                        </p>
                                    </div>
                                    <ul style="margin-left: 30px;">
                                        <li>The employee claims more than 10 Minnesota withholding allowances</li>
                                        <li>The employee checked box A or B under Section 2, and you reasonably expect
                                            the employee’s wages to exceed $200 per week</li>
                                        <li>You believe the employee is not entitled to the number of allowances claimed
                                        </li>
                                    </ul>
                                    <div class="row mt-2">
                                        <p>You do not need to submit Form W-4MN to us if the employee is asking to have
                                            additional Minnesota withholding deducted from their pay.
                                            We may assess a $50 penalty for each Form W-4MN you do not file with us when
                                            required.</p>








                                    </div>
                                    <div class="row">
                                        <p>Mail Forms W-4MN to:</p>
                                    </div>
                                    <div class="row">
                                        <p>Minnesota Department of Revenue </p>
                                    </div>
                                    <div class="row">
                                        <p>600 N. Robert St</p>
                                    </div>
                                    <div class="row">
                                        <p>St. Paul, MN 55146-6501</p>
                                    </div>
                                    <div class="row mt-2">
                                        <h5><b>What if my employee is a resident of a state that has a reciprocity
                                                agreement with Minnesota?</b></h5>
                                    </div>
                                    <div class="row mt-2">
                                        <p>If your employee is a resident of North Dakota or Michigan and they do not
                                            want you to withhold Minnesota tax from their wages, they must
                                            complete Form MWR, Reciprocity Exemption/Affidavit of Residency. They must
                                            complete a Form MWR by February 28 of each year, or within
                                            30 days after they begin working or Change their permanent residence. See
                                            Withholding Fact Sheet 20, Reciprocity - Employee Withholding, for
                                            more information. </p>
                                    </div>
                                    <div class="row mt-2">
                                        <h5><b>What is an invalid Form W-4MN?</b></h5>
                                    </div>
                                    <div class="row mt-2">
                                        <p>A Form W-4MN is considered invalid if any of these apply:</p>
                                    </div>
                                    <ul style="margin-left: 30px;">
                                        <li>There is any unauthorized Change or addition to the form, including any
                                            Change to the language certifying the form is correct
                                        </li>
                                        <li>
                                            The employee indicates in any way the form is false by the date they provide
                                            you with the form
                                        </li>
                                        <li>The form is incomplete or lacks the necessary signatures</li>
                                        <li>Both Section 1 and Section 2 were completed</li>
                                        <li>The employer information is incomplete</li>
                                    </ul>
                                    <div class="row mt-2">
                                        <h5><b>What if I receive an invalid form?</b></h5>
                                    </div>
                                    <div class="row mt-2">
                                        <p>Do not use the invalid form to calculate Minnesota income tax withholding.
                                            Have the employee complete and submit a new Form W-4MN.
                                            If the employee does not give you a valid form, and you have an earlier Form
                                            W-4MN from them, use the earlier form to calculate their
                                            withholding</p>
                                        <p>If a valid Form W-4MN is not completed by the employee, withhold taxes as if
                                            the employee is single and claiming zero withholding
                                            allowances</p>
                                    </div>
                                    <div class="row mt-2">
                                        <h5><b>What if my employee is a nonresident alien of the United States?</b></h5>
                                    </div>
                                    <div class="row mt-2">
                                        <p>If the wages to this employee are subject to income tax withholding, you will
                                            use Table 1 and the procedure underWithholding Adjustment
                                            for Nonresident Alien Employees in IRS Publication 15-T to determine
                                            the correct Minnesota withholding tax. Do not use this procedure
                                            for nonresident alien students from India and business apprentices from
                                            India. See IRS Notice 1392 for special instructions and withholding
                                            exceptions</p>
                                    </div>




                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </kendo-pdf-export>
</div>




<span id="openShowPass" data-bs-target="#showaccountnumberbankrouting" data-bs-toggle="modal"></span>
<div class="modal hide modalbackgrod" id="showaccountnumberbankrouting" tabindex="-1" role="dialog"
    aria-labelledby="exampleModalLabel" aria-hidden="true" data-bs-backdrop="false">
    <div class="modal-dialog" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title font-header" id="exampleModalLabel">
                    Show {{filedname}}
                </h5>
                <button type="button" class="btn-close" (click)=closeeyeicon() data-bs-dismiss="modal">
                </button>
            </div>

            <div class="modal-body">
                <form [formGroup]="showPassAccountRouting">
                    <div class="row mb-2">
                        <div class="col-lg-3">
                            <label style="font-weight: 600; margin-top: 6px">Password<sup
                                    style="color: red; font-size: 1.35em; top: 0em">&nbsp;*</sup></label>
                        </div>
                        <div class="col-lg-5">
                            <input type="password" class="form-control" formControlName="Password"
                                [(ngModel)]="admin_Password" (keyup)="passvalid($event)" />
                            <div *ngIf="
          showPassAccountRouting.controls['Password'].invalid &&
          (showPassAccountRouting.controls['Password'].dirty ||
            showPassAccountRouting.controls['Password'].touched)
        " class="alert alert-danger" style="height: 30px; margin-top: 10px">
                                <div *ngIf="showPassAccountRouting.controls['Password'].errors.required">
                                    Password is required.
                                </div>
                            </div>
                            <!-- <div *ngIf="showPassAccountRouting.controls['Password'].valid"
                                class="alert alert-danger">
                                <div>Enter Valid Password</div>
                            </div> -->
                        </div>
                    </div>
                </form>
                <!-- <div class="row mt-2">
                        <div class="col-lg-3">
                          <label style="font-weight: 600; margin-top: 6px">{{filedname}}</label>                      
                          </div>
                          <div class="col-lg-5">
                            <input type="text" class="form-control" 
                            [(ngModel)]="showedString"  disabled/>
                           <label class="label-font mt-2">{{showedString}}</label> -->
                <!-- </div> -->
                <!-- </div>  -->


            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-sm" [disabled]="!showPassAccountRouting.valid"
                    (click)="showRoutingAcct()">
                    Show
                </button>
                <button type="button" class="btn btn-sm" data-bs-dismiss="modal" data-bs-target="#modal"
                    (click)=closeeyeicon()>
                    Cancel
                </button>
            </div>
        </div>
    </div>
</div>